export const sizes = [
	{
		sizeLabel: '10XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '870641966537',
	},
	{
		sizeLabel: '9XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '621074273221',
	},
	{
		sizeLabel: '8XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '566024579575',
	},
	{
		sizeLabel: '7XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '266352647625',
	},
	{
		sizeLabel: '6XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '206643954300',
	},
	{
		sizeLabel: '5XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '790211756462',
	},
	{
		sizeLabel: '4XS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '581985279114',
	},
	{
		sizeLabel: 'XXXS',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '691015277192',
	},
	{
		sizeLabel: 'XXS',
		sizeCategory: 'smlFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '353045265414',
	},
	{
		sizeLabel: 'XS',
		sizeCategory: 'smlFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '585054129897',
	},
	{
		sizeLabel: 'S',
		sizeCategory: 'smlFormat, ukRingsFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '601278803908',
	},
	{
		sizeLabel: 'M',
		sizeCategory: 'smlFormat, ukRingsFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '192103518870',
	},
	{
		sizeLabel: 'L',
		sizeCategory: 'smlFormat, ukRingsFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '893705820303',
	},
	{
		sizeLabel: 'XL',
		sizeCategory: 'smlFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '080362435771',
	},
	{
		sizeLabel: 'XXL',
		sizeCategory: 'smlFormat, usGlovesFormat',
		sizeCategoryValue: 'S/M/L, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '370967764814',
	},
	{
		sizeLabel: 'XXXL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '729306161506',
	},
	{
		sizeLabel: '4XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '953449548808',
	},
	{
		sizeLabel: '5XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '043421520217',
	},
	{
		sizeLabel: '6XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '140364963454',
	},
	{
		sizeLabel: '7XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '650965857574',
	},
	{
		sizeLabel: '8XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '720449332667',
	},
	{
		sizeLabel: '9XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '899034440543',
	},
	{
		sizeLabel: '10XL',
		sizeCategory: 'smlFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '623903505369',
	},
	{
		sizeLabel: 'XXXS-XXS',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '253355307395',
	},
	{
		sizeLabel: 'XXS-XS',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '891870121507',
	},
	{
		sizeLabel: 'XS-S',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '814536969140',
	},
	{
		sizeLabel: 'S-M',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '574829366918',
	},
	{
		sizeLabel: 'M-L',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '515630212534',
	},
	{
		sizeLabel: 'L-XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '878483916606',
	},
	{
		sizeLabel: 'XL-XXL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '594183757455',
	},
	{
		sizeLabel: 'XXL-XXXL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '981822590408',
	},
	{
		sizeLabel: 'XXXL-4XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '769846146643',
	},
	{
		sizeLabel: '4XL-5XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '761987858122',
	},
	{
		sizeLabel: '5XL-6XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '997712409589',
	},
	{
		sizeLabel: '6XL-7XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '140625191710',
	},
	{
		sizeLabel: '7XL-8XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '126379282035',
	},
	{
		sizeLabel: '8XL-9XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '320519406184',
	},
	{
		sizeLabel: '9XL-10XL',
		sizeCategory: 'smlDoubleFormat',
		sizeCategoryValue: 'S/M/L',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '858012481401',
	},
	{
		sizeLabel: '32',
		sizeCategory: 'euFormat, alternateShoesFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, Alternate, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '374664984268',
	},
	{
		sizeLabel: '34',
		sizeCategory: 'euFormat, euShoesFormat, alternateShoesFormat, outerwearGeneralFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, Alternate, General, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '793040488868',
	},
	{
		sizeLabel: '36',
		sizeCategory: 'euFormat, euShoesFormat, euShirtFormat, outerwearGeneralFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, General, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '733473125399',
	},
	{
		sizeLabel: '38',
		sizeCategory: 'euFormat, euShirtFormat, outerwearGeneralFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, General, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '029223801792',
	},
	{
		sizeLabel: '40',
		sizeCategory: 'euFormat, euShirtFormat, outerwearGeneralFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, General, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '644240695961',
	},
	{
		sizeLabel: '42',
		sizeCategory: 'euFormat, euShirtFormat, outerwearGeneralFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, General, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '926532683451',
	},
	{
		sizeLabel: '44',
		sizeCategory: 'euFormat, euRingsFormat, euShirtFormat, outerwearGeneralFormat, ukBeltFormat',
		sizeCategoryValue: 'EU, General, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '480666890512',
	},
	{
		sizeLabel: '46',
		sizeCategory: 'euFormat, euRingsFormat, euShirtFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '455035694504',
	},
	{
		sizeLabel: '48',
		sizeCategory: 'euFormat, euRingsFormat, euShirtFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '075852196019',
	},
	{
		sizeLabel: '50',
		sizeCategory: 'euFormat, euRingsFormat, euShirtFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '330308398907',
	},
	{
		sizeLabel: '52',
		sizeCategory: 'euFormat, euRingsFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '288022463983',
	},
	{
		sizeLabel: '54',
		sizeCategory: 'euFormat, euHatFormat, euRingsFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '378995587381',
	},
	{
		sizeLabel: '56',
		sizeCategory: 'euFormat, euHatFormat, euRingsFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '667853668326',
	},
	{
		sizeLabel: '60',
		sizeCategory: 'euFormat, euHatFormat, euRingsFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '205553215314',
	},
	{
		sizeLabel: '32-34',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '200720418025',
	},
	{
		sizeLabel: '34-36',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '985513204822',
	},
	{
		sizeLabel: '36-38',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '027447139445',
	},
	{
		sizeLabel: '38-40',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '632655228299',
	},
	{
		sizeLabel: '40-42',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '605297800628',
	},
	{
		sizeLabel: '42-44',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '411326921865',
	},
	{
		sizeLabel: '44-46',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '173643842090',
	},
	{
		sizeLabel: '46-48',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '332570821003',
	},
	{
		sizeLabel: '48-50',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '504213977222',
	},
	{
		sizeLabel: '50-52',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '166277493648',
	},
	{
		sizeLabel: '52-54',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '984275127874',
	},
	{
		sizeLabel: '54-56',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '179335915229',
	},
	{
		sizeLabel: '56-60',
		sizeCategory: 'euDoubleFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '676205589706',
	},
	{
		sizeLabel: 'TU',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '660108722877',
	},
	{
		sizeLabel: 'T0',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '178134916972',
	},
	{
		sizeLabel: 'T1',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '526272572571',
	},
	{
		sizeLabel: 'T2',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '428131911555',
	},
	{
		sizeLabel: 'T3',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '718225662352',
	},
	{
		sizeLabel: 'T4',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '161265406555',
	},
	{
		sizeLabel: 'T5',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '743315248795',
	},
	{
		sizeLabel: 'T6',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '684574742571',
	},
	{
		sizeLabel: 'T7',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '083480494623',
	},
	{
		sizeLabel: 'T8',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '202795239271',
	},
	{
		sizeLabel: 'T9',
		sizeCategory: 'tFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '582608998922',
	},
	{
		sizeLabel: 'T10',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '273862681403',
	},
	{
		sizeLabel: 'T0-T1',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '742471561364',
	},
	{
		sizeLabel: 'T1-T2',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '123399197213',
	},
	{
		sizeLabel: 'T2-T3',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '536680732823',
	},
	{
		sizeLabel: 'T3-T4',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '719675022922',
	},
	{
		sizeLabel: 'T4-T5',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '372029195867',
	},
	{
		sizeLabel: 'T5-T6',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '602045358689',
	},
	{
		sizeLabel: 'T6-T7',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '446828192539',
	},
	{
		sizeLabel: 'T7-T8',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '393681054040',
	},
	{
		sizeLabel: 'T8-T9',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '174530942765',
	},
	{
		sizeLabel: 'T9-T10',
		sizeCategory: 'tDoubleFormat',
		sizeCategoryValue: 'Tx',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '091506671673',
	},
	{
		sizeLabel: '0',
		sizeCategory:
			'AlternateFormat, , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , ,',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '763667879009',
	},
	{
		sizeLabel: '1',
		sizeCategory: 'AlternateFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '702956414216',
	},
	{
		sizeLabel: '2',
		sizeCategory: 'AlternateFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, Alternative',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '476199839418',
	},
	{
		sizeLabel: '3',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat',
		sizeCategoryValue: 'Alternate, UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '991042478910',
	},
	{
		sizeLabel: '4',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, jpRingsFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '466978098315',
	},
	{
		sizeLabel: '5',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, jpRingsFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '018138278085',
	},
	{
		sizeLabel: '6',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '462242433748',
	},
	{
		sizeLabel: '7',
		sizeCategory: 'AlternateFormat, usShoesFormat, ukHatFormat, usRingsFormat, jpRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '267860743542',
	},
	{
		sizeLabel: '8',
		sizeCategory: 'AlternateFormat, usShoesFormat, ukHatFormat, usRingsFormat, jpRingsFormat, outerwearAlternateFormat, euGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '383081847629',
	},
	{
		sizeLabel: '9',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, jpRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '675392025813',
	},
	{
		sizeLabel: '10',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, jpRingsFormat, outerwearAlternateFormat, euGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '402757105942',
	},
	{
		sizeLabel: '11',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '657869892706',
	},
	{
		sizeLabel: '12',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, jpRingsFormat, outerwearAlternateFormat, euGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '562681139986',
	},
	{
		sizeLabel: '13',
		sizeCategory: 'AlternateFormat, usShoesFormat, usRingsFormat, jpRingsFormat, usShirtFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '432126677308',
	},
	{
		sizeLabel: '14',
		sizeCategory: 'AlternateFormat, usShoesFormat, jpRingsFormat, usShirtFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan, Australia',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '837498022624',
	},
	{
		sizeLabel: '15',
		sizeCategory: 'AlternateFormat, jpRingsFormat, usShirtFormat',
		sizeCategoryValue: 'Alternate, Japan, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '305561983663',
	},
	{
		sizeLabel: '16',
		sizeCategory: 'AlternateFormat, jpRingsFormat, usShirtFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, Japan, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '624451063248',
	},
	{
		sizeLabel: '17',
		sizeCategory: 'AlternateFormat, jpRingsFormat, usShirtFormat',
		sizeCategoryValue: 'Alternate, Japan, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '048776177608',
	},
	{
		sizeLabel: '18',
		sizeCategory: 'AlternateFormat, jpRingsFormat, usShirtFormat, outerwearAlternateFormat, jpGlovesFormat',
		sizeCategoryValue: 'Alternate, Japan, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '672235357185',
	},
	{
		sizeLabel: '19',
		sizeCategory: 'AlternateFormat, jpRingsFormat, usShirtFormat',
		sizeCategoryValue: 'Alternate, Japan, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '010665948760',
	},
	{
		sizeLabel: '20',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat, usShirtFormat, outerwearAlternateFormat, jpGlovesFormat',
		sizeCategoryValue: 'Alternate, Japan, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '830527480570',
	},
	{
		sizeLabel: '21',
		sizeCategory: 'AlternateFormat, alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '158142636522',
	},
	{
		sizeLabel: '22',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '087018038327',
	},
	{
		sizeLabel: '23',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat, jpGlovesFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '548243369736',
	},
	{
		sizeLabel: '24',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '794928619456',
	},
	{
		sizeLabel: '25',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat, jpGlovesFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '446321692300',
	},
	{
		sizeLabel: '26',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat, outerwearAlternateFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '831120566654',
	},
	{
		sizeLabel: '27',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, jpRingsFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '643742111308',
	},
	{
		sizeLabel: '28',
		sizeCategory: 'AlternateFormat, alternateShoesFormat, outerwearAlternateFormat, jpGlovesFormat',
		sizeCategoryValue: 'Alternate, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '413352008263',
	},
	{
		sizeLabel: '29',
		sizeCategory: 'AlternateFormat, alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '616000028711',
	},
	{
		sizeLabel: '30',
		sizeCategory: 'AlternateDoubleFormat, alternateShoesFormat, outerwearAlternateFormat, ukBeltFormat, jpGlovesFormat',
		sizeCategoryValue: 'Alternate, UK, US, Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '446594256180',
	},
	{
		sizeLabel: '0-1',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '283623852397',
	},
	{
		sizeLabel: '01-02',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '718739490498',
	},
	{
		sizeLabel: '02-03',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '274282330979',
	},
	{
		sizeLabel: '03-04',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '377315543355',
	},
	{
		sizeLabel: '04-05',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '088548718185',
	},
	{
		sizeLabel: '05-06',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '162612294255',
	},
	{
		sizeLabel: '06-07',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '711192630504',
	},
	{
		sizeLabel: '07-08',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '815944368907',
	},
	{
		sizeLabel: '08-09',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '880018963093',
	},
	{
		sizeLabel: '09-10',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '268321162393',
	},
	{
		sizeLabel: '10-11',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '014891508505',
	},
	{
		sizeLabel: '11-12',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '366220977543',
	},
	{
		sizeLabel: '12-13',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '337638373905',
	},
	{
		sizeLabel: '13-14',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '294341065130',
	},
	{
		sizeLabel: '14-15',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '998040483653',
	},
	{
		sizeLabel: '15-16',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '743606824654',
	},
	{
		sizeLabel: '16-17',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '785893822814',
	},
	{
		sizeLabel: '17-18',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '691303182210',
	},
	{
		sizeLabel: '18-19',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '457235408407',
	},
	{
		sizeLabel: '19-20',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '376340193607',
	},
	{
		sizeLabel: '20-21',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '388624223916',
	},
	{
		sizeLabel: '21-22',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '048572923954',
	},
	{
		sizeLabel: '22-23',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '302327810553',
	},
	{
		sizeLabel: '23-24',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '947829797900',
	},
	{
		sizeLabel: '24-25',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '753625490406',
	},
	{
		sizeLabel: '25-26',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '908868058071',
	},
	{
		sizeLabel: '26-27',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '787688843143',
	},
	{
		sizeLabel: '27-28',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '303856323628',
	},
	{
		sizeLabel: '28-29',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '365171601619',
	},
	{
		sizeLabel: '29-30',
		sizeCategory: 'AlternateDoubleFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '771323041282',
	},
	{
		sizeLabel: '65A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '173928737202',
	},
	{
		sizeLabel: '65B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '249643468179',
	},
	{
		sizeLabel: '65C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '344687199604',
	},
	{
		sizeLabel: '65D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '704270833071',
	},
	{
		sizeLabel: '65E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '433572366943',
	},
	{
		sizeLabel: '65F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '864524681324',
	},
	{
		sizeLabel: '65G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '960747314582',
	},
	{
		sizeLabel: '65H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '65',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '805030266068',
	},
	{
		sizeLabel: '70A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '962394230680',
	},
	{
		sizeLabel: '70B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '514915219934',
	},
	{
		sizeLabel: '70C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '100260912058',
	},
	{
		sizeLabel: '70D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '311960510974',
	},
	{
		sizeLabel: '70E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '801523012994',
	},
	{
		sizeLabel: '70F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '147417237655',
	},
	{
		sizeLabel: '70G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '465521737273',
	},
	{
		sizeLabel: '70H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '70',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '019880200256',
	},
	{
		sizeLabel: '75A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '686439916483',
	},
	{
		sizeLabel: '75B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '811033184474',
	},
	{
		sizeLabel: '75C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '620429691118',
	},
	{
		sizeLabel: '75D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '753159033744',
	},
	{
		sizeLabel: '75E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '658147682192',
	},
	{
		sizeLabel: '75F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '176802757203',
	},
	{
		sizeLabel: '75G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '161951916640',
	},
	{
		sizeLabel: '75H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '75',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '254786173992',
	},
	{
		sizeLabel: '80A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '572633206437',
	},
	{
		sizeLabel: '80B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '730106150127',
	},
	{
		sizeLabel: '80C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '043090499214',
	},
	{
		sizeLabel: '80D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '865318595525',
	},
	{
		sizeLabel: '80E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '836498953894',
	},
	{
		sizeLabel: '80F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '267851353835',
	},
	{
		sizeLabel: '80G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '781902686444',
	},
	{
		sizeLabel: '80H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '80',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '843298478195',
	},
	{
		sizeLabel: '85A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '992111127688',
	},
	{
		sizeLabel: '85B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '271654015490',
	},
	{
		sizeLabel: '85C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '250415893062',
	},
	{
		sizeLabel: '85D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '443720224551',
	},
	{
		sizeLabel: '85E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '403645414022',
	},
	{
		sizeLabel: '85F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '330717798526',
	},
	{
		sizeLabel: '85G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '312260802918',
	},
	{
		sizeLabel: '85H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '85',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '933927658914',
	},
	{
		sizeLabel: '90A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '934196877649',
	},
	{
		sizeLabel: '90B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '088357710096',
	},
	{
		sizeLabel: '90C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '423356451406',
	},
	{
		sizeLabel: '90D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '970485929687',
	},
	{
		sizeLabel: '90E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '466465774139',
	},
	{
		sizeLabel: '90F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '193373391755',
	},
	{
		sizeLabel: '90G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '042491115498',
	},
	{
		sizeLabel: '90H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '90',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '322166054078',
	},
	{
		sizeLabel: '95A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '869357891477',
	},
	{
		sizeLabel: '95B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '668553296361',
	},
	{
		sizeLabel: '95C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '830465845011',
	},
	{
		sizeLabel: '95D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '990229439094',
	},
	{
		sizeLabel: '95E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '856915630970',
	},
	{
		sizeLabel: '95F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '706085003681',
	},
	{
		sizeLabel: '95G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '587263597778',
	},
	{
		sizeLabel: '95H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '95',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '821640697539',
	},
	{
		sizeLabel: '100A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '343276590829',
	},
	{
		sizeLabel: '100B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '965161245693',
	},
	{
		sizeLabel: '100C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '797260097637',
	},
	{
		sizeLabel: '100D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '889447089255',
	},
	{
		sizeLabel: '100E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '491748903702',
	},
	{
		sizeLabel: '100F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '811719318852',
	},
	{
		sizeLabel: '100G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '105904190662',
	},
	{
		sizeLabel: '100H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '100',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '352383734280',
	},
	{
		sizeLabel: '105A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '898983432172',
	},
	{
		sizeLabel: '105B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '527037619521',
	},
	{
		sizeLabel: '105C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '743965215757',
	},
	{
		sizeLabel: '105D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '035674431408',
	},
	{
		sizeLabel: '105E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '349042237186',
	},
	{
		sizeLabel: '105F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '951841144181',
	},
	{
		sizeLabel: '105G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '505354318321',
	},
	{
		sizeLabel: '105H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '105',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '189368897744',
	},
	{
		sizeLabel: '110A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '672031737255',
	},
	{
		sizeLabel: '110B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '950847405629',
	},
	{
		sizeLabel: '110C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '401094145102',
	},
	{
		sizeLabel: '110D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '559386905904',
	},
	{
		sizeLabel: '110E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '821246029176',
	},
	{
		sizeLabel: '110F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '068071580697',
	},
	{
		sizeLabel: '110G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '256770603401',
	},
	{
		sizeLabel: '110H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '110',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '419802215256',
	},
	{
		sizeLabel: '115A',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '352974232809',
	},
	{
		sizeLabel: '115B',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '347590997968',
	},
	{
		sizeLabel: '115C',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '024272219355',
	},
	{
		sizeLabel: '115D',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '521250689463',
	},
	{
		sizeLabel: '115E',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '491343020148',
	},
	{
		sizeLabel: '115F',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '673703984332',
	},
	{
		sizeLabel: '115G',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '717980189743',
	},
	{
		sizeLabel: '115H',
		sizeCategory: 'chestHipNumAlphaFormat',
		sizeCategoryValue: 'Chest & Hip',
		sizeSubcategory: '115',
		sizeSubcategoryValue: 'chestHipAlphaFormat',
		sizeCode: '588377477706',
	},
	{
		sizeLabel: 'W23L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '910333984133',
	},
	{
		sizeLabel: 'W23L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '474351588120',
	},
	{
		sizeLabel: 'W23L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '025494146944',
	},
	{
		sizeLabel: 'W23L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '910389726172',
	},
	{
		sizeLabel: 'W23L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '016709707590',
	},
	{
		sizeLabel: 'W23L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '996560848903',
	},
	{
		sizeLabel: 'W23L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '419237980684',
	},
	{
		sizeLabel: 'W23L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '767894580920',
	},
	{
		sizeLabel: 'W23L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '033252324135',
	},
	{
		sizeLabel: 'W23L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '893359563185',
	},
	{
		sizeLabel: 'W23L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '735885800413',
	},
	{
		sizeLabel: 'W23L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '968339616201',
	},
	{
		sizeLabel: 'W23L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '129637847784',
	},
	{
		sizeLabel: 'W23L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '460043702530',
	},
	{
		sizeLabel: 'W23L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '895502071405',
	},
	{
		sizeLabel: 'W23L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '233854924599',
	},
	{
		sizeLabel: 'W23L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '208926167840',
	},
	{
		sizeLabel: 'W23L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '981907907614',
	},
	{
		sizeLabel: 'W23Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W23',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '398416138920',
	},
	{
		sizeLabel: 'W24L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '361400660558',
	},
	{
		sizeLabel: 'W24L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '715082826704',
	},
	{
		sizeLabel: 'W24L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '262643883956',
	},
	{
		sizeLabel: 'W24L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '193392288151',
	},
	{
		sizeLabel: 'W24L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '847437026396',
	},
	{
		sizeLabel: 'W24L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '443015425015',
	},
	{
		sizeLabel: 'W24L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '896456941846',
	},
	{
		sizeLabel: 'W24L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '533716359467',
	},
	{
		sizeLabel: 'W24L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '210052954499',
	},
	{
		sizeLabel: 'W24L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '055795682882',
	},
	{
		sizeLabel: 'W24L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '167389643966',
	},
	{
		sizeLabel: 'W24L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '852040529173',
	},
	{
		sizeLabel: 'W24L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '565927797528',
	},
	{
		sizeLabel: 'W24L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '553954173138',
	},
	{
		sizeLabel: 'W24L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '904094758858',
	},
	{
		sizeLabel: 'W24L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '232258779188',
	},
	{
		sizeLabel: 'W24L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '613140269453',
	},
	{
		sizeLabel: 'W24L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '918740610094',
	},
	{
		sizeLabel: 'W24Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W24',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '474057092558',
	},
	{
		sizeLabel: 'W25L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '108624474906',
	},
	{
		sizeLabel: 'W25L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '756396880404',
	},
	{
		sizeLabel: 'W25L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '116089081142',
	},
	{
		sizeLabel: 'W25L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '517582586113',
	},
	{
		sizeLabel: 'W25L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '539150068025',
	},
	{
		sizeLabel: 'W25L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '758757312081',
	},
	{
		sizeLabel: 'W25L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '932815730567',
	},
	{
		sizeLabel: 'W25L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '614026684120',
	},
	{
		sizeLabel: 'W25L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '968500166213',
	},
	{
		sizeLabel: 'W25L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '706407858877',
	},
	{
		sizeLabel: 'W25L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '209736968814',
	},
	{
		sizeLabel: 'W25L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '689514230494',
	},
	{
		sizeLabel: 'W25L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '065571757767',
	},
	{
		sizeLabel: 'W25L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '272092218917',
	},
	{
		sizeLabel: 'W25L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '790062555153',
	},
	{
		sizeLabel: 'W25L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '024030215072',
	},
	{
		sizeLabel: 'W25L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '570267610462',
	},
	{
		sizeLabel: 'W25L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '960148687708',
	},
	{
		sizeLabel: 'W25Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W25',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '546073632029',
	},
	{
		sizeLabel: 'W26L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '924422432927',
	},
	{
		sizeLabel: 'W26L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '600403530124',
	},
	{
		sizeLabel: 'W26L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '161412781191',
	},
	{
		sizeLabel: 'W26L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '063714889612',
	},
	{
		sizeLabel: 'W26L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '867356482531',
	},
	{
		sizeLabel: 'W26L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '389247493182',
	},
	{
		sizeLabel: 'W26L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '199428571467',
	},
	{
		sizeLabel: 'W26L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '068862947847',
	},
	{
		sizeLabel: 'W26L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '333034550022',
	},
	{
		sizeLabel: 'W26L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '407414724830',
	},
	{
		sizeLabel: 'W26L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '072421667628',
	},
	{
		sizeLabel: 'W26L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '607450743709',
	},
	{
		sizeLabel: 'W26L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '375274871121',
	},
	{
		sizeLabel: 'W26L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '867009104531',
	},
	{
		sizeLabel: 'W26L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '191211248880',
	},
	{
		sizeLabel: 'W26L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '325565254626',
	},
	{
		sizeLabel: 'W26L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '406035673279',
	},
	{
		sizeLabel: 'W26L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '829984484811',
	},
	{
		sizeLabel: 'W26Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W26',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '394424920076',
	},
	{
		sizeLabel: 'W27L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '066768436062',
	},
	{
		sizeLabel: 'W27L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '680527080726',
	},
	{
		sizeLabel: 'W27L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '555847570440',
	},
	{
		sizeLabel: 'W27L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '659189871358',
	},
	{
		sizeLabel: 'W27L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '594190715221',
	},
	{
		sizeLabel: 'W27L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '827268691191',
	},
	{
		sizeLabel: 'W27L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '470857705676',
	},
	{
		sizeLabel: 'W27L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '393543142036',
	},
	{
		sizeLabel: 'W27L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '228702624835',
	},
	{
		sizeLabel: 'W27L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '161526363787',
	},
	{
		sizeLabel: 'W27L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '872771450337',
	},
	{
		sizeLabel: 'W27L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '303099125226',
	},
	{
		sizeLabel: 'W27L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '673883127401',
	},
	{
		sizeLabel: 'W27L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '354227627635',
	},
	{
		sizeLabel: 'W27L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '129537681636',
	},
	{
		sizeLabel: 'W27L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '282126949723',
	},
	{
		sizeLabel: 'W27L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '311620876864',
	},
	{
		sizeLabel: 'W27L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '980491417916',
	},
	{
		sizeLabel: 'W27Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W27',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '100574169904',
	},
	{
		sizeLabel: 'W28L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '643259474761',
	},
	{
		sizeLabel: 'W28L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '000586156069',
	},
	{
		sizeLabel: 'W28L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '941282321945',
	},
	{
		sizeLabel: 'W28L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '995249956378',
	},
	{
		sizeLabel: 'W28L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '902711998529',
	},
	{
		sizeLabel: 'W28L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '842145068242',
	},
	{
		sizeLabel: 'W28L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '088173781467',
	},
	{
		sizeLabel: 'W28L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '005118990066',
	},
	{
		sizeLabel: 'W28L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '750790126455',
	},
	{
		sizeLabel: 'W28L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '951360533613',
	},
	{
		sizeLabel: 'W28L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '264423732061',
	},
	{
		sizeLabel: 'W28L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '919441584799',
	},
	{
		sizeLabel: 'W28L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '963976668185',
	},
	{
		sizeLabel: 'W28L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '920781613446',
	},
	{
		sizeLabel: 'W28L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '385873238388',
	},
	{
		sizeLabel: 'W28L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '441447788989',
	},
	{
		sizeLabel: 'W28L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '045307869052',
	},
	{
		sizeLabel: 'W28L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '597254065382',
	},
	{
		sizeLabel: 'W28Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W28',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '437850767234',
	},
	{
		sizeLabel: 'W29L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '788680903232',
	},
	{
		sizeLabel: 'W29L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '250585878579',
	},
	{
		sizeLabel: 'W29L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '983994627544',
	},
	{
		sizeLabel: 'W29L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '298254506326',
	},
	{
		sizeLabel: 'W29L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '915752393770',
	},
	{
		sizeLabel: 'W29L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '394211695836',
	},
	{
		sizeLabel: 'W29L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '815973997431',
	},
	{
		sizeLabel: 'W29L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '211713756379',
	},
	{
		sizeLabel: 'W29L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '752717590359',
	},
	{
		sizeLabel: 'W29L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '315964217404',
	},
	{
		sizeLabel: 'W29L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '035548338895',
	},
	{
		sizeLabel: 'W29L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '399900226628',
	},
	{
		sizeLabel: 'W29L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '993101584602',
	},
	{
		sizeLabel: 'W29L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '120926131431',
	},
	{
		sizeLabel: 'W29L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '953013858122',
	},
	{
		sizeLabel: 'W29L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '137081870814',
	},
	{
		sizeLabel: 'W29L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '046670527099',
	},
	{
		sizeLabel: 'W29L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '592146980112',
	},
	{
		sizeLabel: 'W29Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W29',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '342112730339',
	},
	{
		sizeLabel: 'W30L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '644035056487',
	},
	{
		sizeLabel: 'W30L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '823847327076',
	},
	{
		sizeLabel: 'W30L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '917239556885',
	},
	{
		sizeLabel: 'W30L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '273768325350',
	},
	{
		sizeLabel: 'W30L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '951995872037',
	},
	{
		sizeLabel: 'W30L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '950529218860',
	},
	{
		sizeLabel: 'W30L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '440599548825',
	},
	{
		sizeLabel: 'W30L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '648809674879',
	},
	{
		sizeLabel: 'W30L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '890412035706',
	},
	{
		sizeLabel: 'W30L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '541686879427',
	},
	{
		sizeLabel: 'W30L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '928583786871',
	},
	{
		sizeLabel: 'W30L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '845050336746',
	},
	{
		sizeLabel: 'W30L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '272261548212',
	},
	{
		sizeLabel: 'W30L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '266049056531',
	},
	{
		sizeLabel: 'W30L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '410699176384',
	},
	{
		sizeLabel: 'W30L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '368472845091',
	},
	{
		sizeLabel: 'W30L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '155038366226',
	},
	{
		sizeLabel: 'W30L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '012653211476',
	},
	{
		sizeLabel: 'W30Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W30',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '062718320789',
	},
	{
		sizeLabel: 'W31L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '464628412865',
	},
	{
		sizeLabel: 'W31L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '275269010394',
	},
	{
		sizeLabel: 'W31L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '720484688143',
	},
	{
		sizeLabel: 'W31L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '350414111882',
	},
	{
		sizeLabel: 'W31L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '749701841573',
	},
	{
		sizeLabel: 'W31L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '133031523697',
	},
	{
		sizeLabel: 'W31L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '419465478246',
	},
	{
		sizeLabel: 'W31L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '792082485994',
	},
	{
		sizeLabel: 'W31L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '152595906151',
	},
	{
		sizeLabel: 'W31L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '335198317449',
	},
	{
		sizeLabel: 'W31L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '413793200049',
	},
	{
		sizeLabel: 'W31L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '654583922981',
	},
	{
		sizeLabel: 'W31L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '386659624015',
	},
	{
		sizeLabel: 'W31L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '340267017273',
	},
	{
		sizeLabel: 'W31L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '795881274855',
	},
	{
		sizeLabel: 'W31L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '662100247342',
	},
	{
		sizeLabel: 'W31L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '866642930956',
	},
	{
		sizeLabel: 'W31L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '705349499376',
	},
	{
		sizeLabel: 'W31Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W31',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '333526221595',
	},
	{
		sizeLabel: 'W32L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '679199688246',
	},
	{
		sizeLabel: 'W32L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '470981090299',
	},
	{
		sizeLabel: 'W32L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '583050207805',
	},
	{
		sizeLabel: 'W32L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '869018142089',
	},
	{
		sizeLabel: 'W32L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '276946394775',
	},
	{
		sizeLabel: 'W32L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '612446611390',
	},
	{
		sizeLabel: 'W32L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '783636757592',
	},
	{
		sizeLabel: 'W32L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '162989701698',
	},
	{
		sizeLabel: 'W32L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '906317551590',
	},
	{
		sizeLabel: 'W32L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '544719281722',
	},
	{
		sizeLabel: 'W32L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '288825982988',
	},
	{
		sizeLabel: 'W32L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '153013594301',
	},
	{
		sizeLabel: 'W32L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '400175750271',
	},
	{
		sizeLabel: 'W32L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '730860210683',
	},
	{
		sizeLabel: 'W32L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '931342660911',
	},
	{
		sizeLabel: 'W32L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '457535057587',
	},
	{
		sizeLabel: 'W32L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '884281667919',
	},
	{
		sizeLabel: 'W32L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '374732716790',
	},
	{
		sizeLabel: 'W32Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W32',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '258058834857',
	},
	{
		sizeLabel: 'W33L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '032453286385',
	},
	{
		sizeLabel: 'W33L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '266661505179',
	},
	{
		sizeLabel: 'W33L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '255502316674',
	},
	{
		sizeLabel: 'W33L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '953488963804',
	},
	{
		sizeLabel: 'W33L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '811672498742',
	},
	{
		sizeLabel: 'W33L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '003589826243',
	},
	{
		sizeLabel: 'W33L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '155575407676',
	},
	{
		sizeLabel: 'W33L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '445056703679',
	},
	{
		sizeLabel: 'W33L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '965325486093',
	},
	{
		sizeLabel: 'W33L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '775417874989',
	},
	{
		sizeLabel: 'W33L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '741665351716',
	},
	{
		sizeLabel: 'W33L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '518740695412',
	},
	{
		sizeLabel: 'W33L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '505954717174',
	},
	{
		sizeLabel: 'W33L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '981775497168',
	},
	{
		sizeLabel: 'W33L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '140184231223',
	},
	{
		sizeLabel: 'W33L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '742496745919',
	},
	{
		sizeLabel: 'W33L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '695524689699',
	},
	{
		sizeLabel: 'W33L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '593953987775',
	},
	{
		sizeLabel: 'W33Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W33',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '426773867991',
	},
	{
		sizeLabel: 'W34L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '911169197686',
	},
	{
		sizeLabel: 'W34L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '308589256322',
	},
	{
		sizeLabel: 'W34L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '160035489992',
	},
	{
		sizeLabel: 'W34L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '664629894975',
	},
	{
		sizeLabel: 'W34L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '565163418883',
	},
	{
		sizeLabel: 'W34L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '136577642921',
	},
	{
		sizeLabel: 'W34L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '371690148098',
	},
	{
		sizeLabel: 'W34L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '209523280763',
	},
	{
		sizeLabel: 'W34L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '248007221361',
	},
	{
		sizeLabel: 'W34L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '401853123896',
	},
	{
		sizeLabel: 'W34L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '402493127467',
	},
	{
		sizeLabel: 'W34L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '593221697263',
	},
	{
		sizeLabel: 'W34L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '584344825494',
	},
	{
		sizeLabel: 'W34L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '293023925642',
	},
	{
		sizeLabel: 'W34L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '036018766120',
	},
	{
		sizeLabel: 'W34L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '862020616688',
	},
	{
		sizeLabel: 'W34L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '244718722115',
	},
	{
		sizeLabel: 'W34L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '086233750622',
	},
	{
		sizeLabel: 'W34Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W34',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '237400571537',
	},
	{
		sizeLabel: 'W36L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '694739548687',
	},
	{
		sizeLabel: 'W36L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '622019377810',
	},
	{
		sizeLabel: 'W36L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '033854057109',
	},
	{
		sizeLabel: 'W36L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '998904758145',
	},
	{
		sizeLabel: 'W36L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '806775665384',
	},
	{
		sizeLabel: 'W36L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '104632606591',
	},
	{
		sizeLabel: 'W36L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '194271121660',
	},
	{
		sizeLabel: 'W36L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '491397002374',
	},
	{
		sizeLabel: 'W36L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '818490715155',
	},
	{
		sizeLabel: 'W36L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '247868081639',
	},
	{
		sizeLabel: 'W36L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '607573933978',
	},
	{
		sizeLabel: 'W36L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '540015528699',
	},
	{
		sizeLabel: 'W36L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '167168910780',
	},
	{
		sizeLabel: 'W36L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '797047417500',
	},
	{
		sizeLabel: 'W36L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '083969308445',
	},
	{
		sizeLabel: 'W36L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '930224064204',
	},
	{
		sizeLabel: 'W36L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '531417906768',
	},
	{
		sizeLabel: 'W36L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '707882624685',
	},
	{
		sizeLabel: 'W36Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W36',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '444091794934',
	},
	{
		sizeLabel: 'W38L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '605101473327',
	},
	{
		sizeLabel: 'W38L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '051474993109',
	},
	{
		sizeLabel: 'W38L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '982940581065',
	},
	{
		sizeLabel: 'W38L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '871538139573',
	},
	{
		sizeLabel: 'W38L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '791480150178',
	},
	{
		sizeLabel: 'W38L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '509733058815',
	},
	{
		sizeLabel: 'W38L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '465446140626',
	},
	{
		sizeLabel: 'W38L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '238430465358',
	},
	{
		sizeLabel: 'W38L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '338246642150',
	},
	{
		sizeLabel: 'W38L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '296436145810',
	},
	{
		sizeLabel: 'W38L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '275021464928',
	},
	{
		sizeLabel: 'W38L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '247839231057',
	},
	{
		sizeLabel: 'W38L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '102529321129',
	},
	{
		sizeLabel: 'W38L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '489286833145',
	},
	{
		sizeLabel: 'W38L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '855139149968',
	},
	{
		sizeLabel: 'W38L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '698224540796',
	},
	{
		sizeLabel: 'W38L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '067772167411',
	},
	{
		sizeLabel: 'W38L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '637180436157',
	},
	{
		sizeLabel: 'W38Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W38',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '927617595719',
	},
	{
		sizeLabel: 'W40L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '126394600329',
	},
	{
		sizeLabel: 'W40L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '582416291086',
	},
	{
		sizeLabel: 'W40L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '820914883784',
	},
	{
		sizeLabel: 'W40L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '574654445434',
	},
	{
		sizeLabel: 'W40L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '997664426359',
	},
	{
		sizeLabel: 'W40L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '618084573575',
	},
	{
		sizeLabel: 'W40L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '058019484184',
	},
	{
		sizeLabel: 'W40L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '056289381035',
	},
	{
		sizeLabel: 'W40L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '370492870243',
	},
	{
		sizeLabel: 'W40L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '948341539278',
	},
	{
		sizeLabel: 'W40L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '031985269223',
	},
	{
		sizeLabel: 'W40L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '615183992368',
	},
	{
		sizeLabel: 'W40L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '956864162559',
	},
	{
		sizeLabel: 'W40L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '868172648479',
	},
	{
		sizeLabel: 'W40L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '760985123882',
	},
	{
		sizeLabel: 'W40L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '883151251765',
	},
	{
		sizeLabel: 'W40L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '619033532783',
	},
	{
		sizeLabel: 'W40L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '006291145848',
	},
	{
		sizeLabel: 'W40Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W40',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '623942309673',
	},
	{
		sizeLabel: 'W42L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '777486627202',
	},
	{
		sizeLabel: 'W42L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '217897869046',
	},
	{
		sizeLabel: 'W42L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '113100676608',
	},
	{
		sizeLabel: 'W42L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '309468004716',
	},
	{
		sizeLabel: 'W42L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '927080396636',
	},
	{
		sizeLabel: 'W42L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '110285446280',
	},
	{
		sizeLabel: 'W42L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '271877326223',
	},
	{
		sizeLabel: 'W42L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '848065868866',
	},
	{
		sizeLabel: 'W42L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '241265105863',
	},
	{
		sizeLabel: 'W42L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '140483845948',
	},
	{
		sizeLabel: 'W42L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '551203101587',
	},
	{
		sizeLabel: 'W42L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '539595940133',
	},
	{
		sizeLabel: 'W42L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '659998154272',
	},
	{
		sizeLabel: 'W42L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '377543877991',
	},
	{
		sizeLabel: 'W42L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '811003498353',
	},
	{
		sizeLabel: 'W42L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '683508655384',
	},
	{
		sizeLabel: 'W42L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '519425412981',
	},
	{
		sizeLabel: 'W42L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '671892670305',
	},
	{
		sizeLabel: 'W42Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W42',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '325941129700',
	},
	{
		sizeLabel: 'W44L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '359507821833',
	},
	{
		sizeLabel: 'W44L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '469343904855',
	},
	{
		sizeLabel: 'W44L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '113543431060',
	},
	{
		sizeLabel: 'W44L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '669427227408',
	},
	{
		sizeLabel: 'W44L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '777352752861',
	},
	{
		sizeLabel: 'W44L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '777816398722',
	},
	{
		sizeLabel: 'W44L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '630956375065',
	},
	{
		sizeLabel: 'W44L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '551989829516',
	},
	{
		sizeLabel: 'W44L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '884963187260',
	},
	{
		sizeLabel: 'W44L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '917812692047',
	},
	{
		sizeLabel: 'W44L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '072782071968',
	},
	{
		sizeLabel: 'W44L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '644052173287',
	},
	{
		sizeLabel: 'W44L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '501929346791',
	},
	{
		sizeLabel: 'W44L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '306761211753',
	},
	{
		sizeLabel: 'W44L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '086329392738',
	},
	{
		sizeLabel: 'W44L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '679405192107',
	},
	{
		sizeLabel: 'W44L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '367336906918',
	},
	{
		sizeLabel: 'W44L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '597416925236',
	},
	{
		sizeLabel: 'W44Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W44',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '069571508210',
	},
	{
		sizeLabel: 'W46L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '609920954393',
	},
	{
		sizeLabel: 'W46L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '701930892686',
	},
	{
		sizeLabel: 'W46L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '430104475536',
	},
	{
		sizeLabel: 'W46L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '726993778256',
	},
	{
		sizeLabel: 'W46L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '034513615821',
	},
	{
		sizeLabel: 'W46L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '643745208568',
	},
	{
		sizeLabel: 'W46L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '825201665985',
	},
	{
		sizeLabel: 'W46L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '306611993125',
	},
	{
		sizeLabel: 'W46L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '397422802216',
	},
	{
		sizeLabel: 'W46L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '092187780122',
	},
	{
		sizeLabel: 'W46L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '367826562971',
	},
	{
		sizeLabel: 'W46L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '519599117586',
	},
	{
		sizeLabel: 'W46L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '264896701905',
	},
	{
		sizeLabel: 'W46L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '506341547768',
	},
	{
		sizeLabel: 'W46L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '163400544554',
	},
	{
		sizeLabel: 'W46L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '314603049274',
	},
	{
		sizeLabel: 'W46L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '279769775122',
	},
	{
		sizeLabel: 'W46L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '302924738211',
	},
	{
		sizeLabel: 'W46Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W46',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '844730463762',
	},
	{
		sizeLabel: 'W48L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '759521817230',
	},
	{
		sizeLabel: 'W48L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '370967757328',
	},
	{
		sizeLabel: 'W48L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '958516468629',
	},
	{
		sizeLabel: 'W48L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '946471871118',
	},
	{
		sizeLabel: 'W48L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '625990537414',
	},
	{
		sizeLabel: 'W48L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '627846195573',
	},
	{
		sizeLabel: 'W48L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '004364973582',
	},
	{
		sizeLabel: 'W48L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '340570612293',
	},
	{
		sizeLabel: 'W48L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '264197203856',
	},
	{
		sizeLabel: 'W48L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '749527285955',
	},
	{
		sizeLabel: 'W48L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '044629965500',
	},
	{
		sizeLabel: 'W48L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '568556457365',
	},
	{
		sizeLabel: 'W48L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '800328939596',
	},
	{
		sizeLabel: 'W48L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '641508089355',
	},
	{
		sizeLabel: 'W48L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '606040558724',
	},
	{
		sizeLabel: 'W48L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '314432212455',
	},
	{
		sizeLabel: 'W48L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '339628290227',
	},
	{
		sizeLabel: 'W48L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '007490827278',
	},
	{
		sizeLabel: 'W48Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W48',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '041492133852',
	},
	{
		sizeLabel: 'W50L23',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '294033119425',
	},
	{
		sizeLabel: 'W50L24',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '534945129793',
	},
	{
		sizeLabel: 'W50L25',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '079579774916',
	},
	{
		sizeLabel: 'W50L26',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '300444620943',
	},
	{
		sizeLabel: 'W50L27',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '130962976361',
	},
	{
		sizeLabel: 'W50L28',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '882274172842',
	},
	{
		sizeLabel: 'W50L29',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '552722734389',
	},
	{
		sizeLabel: 'W50L30',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '325870063808',
	},
	{
		sizeLabel: 'W50L31',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '739081148498',
	},
	{
		sizeLabel: 'W50L32',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '740368539349',
	},
	{
		sizeLabel: 'W50L33',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '219208618271',
	},
	{
		sizeLabel: 'W50L34',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '925874451599',
	},
	{
		sizeLabel: 'W50L35',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '571284706822',
	},
	{
		sizeLabel: 'W50L36',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '857540440627',
	},
	{
		sizeLabel: 'W50L37',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '659512616908',
	},
	{
		sizeLabel: 'W50L38',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '863564375428',
	},
	{
		sizeLabel: 'W50L39',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '484659794200',
	},
	{
		sizeLabel: 'W50L40',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '951975950729',
	},
	{
		sizeLabel: 'W50 / Standard / NA',
		sizeCategory: 'usPantsWLFormat',
		sizeCategoryValue: 'US Pants - Waist & Length',
		sizeSubcategory: 'W50',
		sizeSubcategoryValue: 'usPantsLFormat',
		sizeCode: '063534888733',
	},
	{
		sizeLabel: '35',
		sizeCategory: 'euShoesFormat, alternateShoesFormat',
		sizeCategoryValue: 'EU, Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '095703387565',
	},
	{
		sizeLabel: '36 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '218372960296',
	},
	{
		sizeLabel: '36 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '446058359470',
	},
	{
		sizeLabel: '37',
		sizeCategory: 'euShoesFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '110294173344',
	},
	{
		sizeLabel: '37 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '082370617632',
	},
	{
		sizeLabel: '38 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '267283681049',
	},
	{
		sizeLabel: '39',
		sizeCategory: 'euShoesFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '603557463155',
	},
	{
		sizeLabel: '39 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '018021940947',
	},
	{
		sizeLabel: '40 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '163138852602',
	},
	{
		sizeLabel: '41',
		sizeCategory: 'euShoesFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '840780487276',
	},
	{
		sizeLabel: '41 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '407869653778',
	},
	{
		sizeLabel: '42 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '969007828871',
	},
	{
		sizeLabel: '43',
		sizeCategory: 'euShoesFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '410364851704',
	},
	{
		sizeLabel: '43 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '371456204892',
	},
	{
		sizeLabel: '44 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '477853611849',
	},
	{
		sizeLabel: '45',
		sizeCategory: 'euShoesFormat, euRingsFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '214185898102',
	},
	{
		sizeLabel: '46 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '090814081312',
	},
	{
		sizeLabel: '47 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '680885822566',
	},
	{
		sizeLabel: '47',
		sizeCategory: 'euShoesFormat, euRingsFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '822647266930',
	},
	{
		sizeLabel: '48 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '516907382063',
	},
	{
		sizeLabel: '49 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '999046461032',
	},
	{
		sizeLabel: '49',
		sizeCategory: 'euShoesFormat, euRingsFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '541149403322',
	},
	{
		sizeLabel: '49 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '431025728133',
	},
	{
		sizeLabel: '50 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '762918890856',
	},
	{
		sizeLabel: '51',
		sizeCategory: 'euShoesFormat, euRingsFormat, euShirtFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '441122768214',
	},
	{
		sizeLabel: '51 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '084363882993',
	},
	{
		sizeLabel: '52 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '202893554269',
	},
	{
		sizeLabel: '53',
		sizeCategory: 'euShoesFormat, euHatFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '703841362089',
	},
	{
		sizeLabel: '53 ⅓',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '460059988223',
	},
	{
		sizeLabel: '54 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '257269029531',
	},
	{
		sizeLabel: '55',
		sizeCategory: 'euShoesFormat, euHatFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '543833294559',
	},
	{
		sizeLabel: '55 ⅔',
		sizeCategory: 'euShoesFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '333996697502',
	},
	{
		sizeLabel: '56.5',
		sizeCategory: 'euShoesFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '350161158490',
	},
	{
		sizeLabel: '2.5',
		sizeCategory: 'usShoesFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '618409651487',
	},
	{
		sizeLabel: '3.5',
		sizeCategory: 'usShoesFormat, usRingsFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '834290725776',
	},
	{
		sizeLabel: '4.5',
		sizeCategory: 'usShoesFormat, usRingsFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '170595248242',
	},
	{
		sizeLabel: '5.5',
		sizeCategory: 'usShoesFormat, usRingsFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '568402003897',
	},
	{
		sizeLabel: '6.5',
		sizeCategory: 'usShoesFormat, usRingsFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '950533065277',
	},
	{
		sizeLabel: '7.5',
		sizeCategory: 'usShoesFormat, usRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'UK, US, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '525715348009',
	},
	{
		sizeLabel: '8.5',
		sizeCategory: 'usShoesFormat, usRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'UK, US, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '263923407400',
	},
	{
		sizeLabel: '9.5',
		sizeCategory: 'usShoesFormat, usRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'UK, US, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '212408347878',
	},
	{
		sizeLabel: '10.5',
		sizeCategory: 'usShoesFormat, usRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'UK, US, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '354063367437',
	},
	{
		sizeLabel: '11.5',
		sizeCategory: 'usShoesFormat, usRingsFormat, euGlovesFormat',
		sizeCategoryValue: 'UK, US, EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '414376351756',
	},
	{
		sizeLabel: '12.5',
		sizeCategory: 'usShoesFormat, usRingsFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '530062279451',
	},
	{
		sizeLabel: '13.5',
		sizeCategory: 'usShoesFormat, usShirtFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '778546757951',
	},
	{
		sizeLabel: '20.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '665372935114',
	},
	{
		sizeLabel: '21.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '521678386748',
	},
	{
		sizeLabel: '22.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '770212583867',
	},
	{
		sizeLabel: '23.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '722165844959',
	},
	{
		sizeLabel: '24.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '600820666300',
	},
	{
		sizeLabel: '25.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '000544312734',
	},
	{
		sizeLabel: '26.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '511911596473',
	},
	{
		sizeLabel: '27.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '241522648127',
	},
	{
		sizeLabel: '28.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '312417383243',
	},
	{
		sizeLabel: '29.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '260011098321',
	},
	{
		sizeLabel: '30.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '709893237928',
	},
	{
		sizeLabel: '31',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '798590363932',
	},
	{
		sizeLabel: '31.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '910989625645',
	},
	{
		sizeLabel: '32.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '838300966930',
	},
	{
		sizeLabel: '33',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '583424022830',
	},
	{
		sizeLabel: '33.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '468970576702',
	},
	{
		sizeLabel: '34.5',
		sizeCategory: 'alternateShoesFormat',
		sizeCategoryValue: 'Alternate',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '540874951040',
	},
	{
		sizeLabel: '6 ½',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '209334665350',
	},
	{
		sizeLabel: '6 ⅝',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '618343484859',
	},
	{
		sizeLabel: '6 ¾',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '295367646435',
	},
	{
		sizeLabel: '6 ⅞',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '633983064637',
	},
	{
		sizeLabel: '7 ⅛',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '279193080041',
	},
	{
		sizeLabel: '7 ¼',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '350219999161',
	},
	{
		sizeLabel: '7 ⅜',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '959438794083',
	},
	{
		sizeLabel: '7 ½',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '741530912598',
	},
	{
		sizeLabel: '7 ⅝',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '446332407507',
	},
	{
		sizeLabel: '7 ¾',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '628358439247',
	},
	{
		sizeLabel: '7 ⅞',
		sizeCategory: 'ukHatFormat',
		sizeCategoryValue: 'UK, US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '908740305494',
	},
	{
		sizeLabel: '57',
		sizeCategory: 'euHatFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '086734140882',
	},
	{
		sizeLabel: '58',
		sizeCategory: 'euHatFormat, euRingsFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '757860389867',
	},
	{
		sizeLabel: '59',
		sizeCategory: 'euHatFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '446479204980',
	},
	{
		sizeLabel: '61',
		sizeCategory: 'euHatFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '323336581037',
	},
	{
		sizeLabel: '62',
		sizeCategory: 'euHatFormat, euRingsFormat, outerwearGeneralFormat',
		sizeCategoryValue: 'EU, General',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '992969218426',
	},
	{
		sizeLabel: '63',
		sizeCategory: 'euHatFormat, euRingsFormat',
		sizeCategoryValue: 'Eu',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '908090257537',
	},
	{
		sizeLabel: '64',
		sizeCategory: 'euHatFormat, euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '827033052004',
	},
	{
		sizeLabel: '50.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '352982501918',
	},
	{
		sizeLabel: '51.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '072916267633',
	},
	{
		sizeLabel: '52.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '595739579417',
	},
	{
		sizeLabel: '53.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '249199099953',
	},
	{
		sizeLabel: '54.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '049594603258',
	},
	{
		sizeLabel: '55.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '730899214708',
	},
	{
		sizeLabel: '57.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '532441894562',
	},
	{
		sizeLabel: '58.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '406339604134',
	},
	{
		sizeLabel: '59.5',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '674006380986',
	},
	{
		sizeLabel: '65',
		sizeCategory: 'euRingsFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '903569112160',
	},
	{
		sizeLabel: 'F',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '496073990683',
	},
	{
		sizeLabel: 'H',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '695883187601',
	},
	{
		sizeLabel: 'I',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '715814978556',
	},
	{
		sizeLabel: 'J',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '295110513084',
	},
	{
		sizeLabel: 'J ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '930322669470',
	},
	{
		sizeLabel: 'K',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '149196941897',
	},
	{
		sizeLabel: 'K ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '021742296460',
	},
	{
		sizeLabel: 'L ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '112372681356',
	},
	{
		sizeLabel: 'M ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '624259472315',
	},
	{
		sizeLabel: 'N',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '748034220220',
	},
	{
		sizeLabel: 'N ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '127441490175',
	},
	{
		sizeLabel: 'O',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '190007343641',
	},
	{
		sizeLabel: 'O ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '642001731795',
	},
	{
		sizeLabel: 'P',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '769973640707',
	},
	{
		sizeLabel: 'P ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '999638846178',
	},
	{
		sizeLabel: 'Q',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '407415630828',
	},
	{
		sizeLabel: 'Q ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '645372207888',
	},
	{
		sizeLabel: 'R',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '757179097086',
	},
	{
		sizeLabel: 'R ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '273254824697',
	},
	{
		sizeLabel: 'S ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '903587830049',
	},
	{
		sizeLabel: 'T',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '334485229108',
	},
	{
		sizeLabel: 'T ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '127000884707',
	},
	{
		sizeLabel: 'U',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '147182031444',
	},
	{
		sizeLabel: 'U ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '474352267072',
	},
	{
		sizeLabel: 'V',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '218378934627',
	},
	{
		sizeLabel: 'V ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '614009740856',
	},
	{
		sizeLabel: 'W',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '288712585701',
	},
	{
		sizeLabel: 'W ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '898889501911',
	},
	{
		sizeLabel: 'X',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '494688162247',
	},
	{
		sizeLabel: 'X ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '051338200753',
	},
	{
		sizeLabel: 'Y',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '353968734815',
	},
	{
		sizeLabel: 'Y ½',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '516498589810',
	},
	{
		sizeLabel: 'Z',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '167349447644',
	},
	{
		sizeLabel: 'Z+1',
		sizeCategory: 'ukRingsFormat',
		sizeCategoryValue: 'UK',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '501416604828',
	},
	{
		sizeLabel: '14.5',
		sizeCategory: 'usShirtFormat',
		sizeCategoryValue: 'US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '236728539820',
	},
	{
		sizeLabel: '15.5',
		sizeCategory: 'usShirtFormat',
		sizeCategoryValue: 'US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '943632355935',
	},
	{
		sizeLabel: '16.5',
		sizeCategory: 'usShirtFormat',
		sizeCategoryValue: 'US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '938224374006',
	},
	{
		sizeLabel: '17.5',
		sizeCategory: 'usShirtFormat',
		sizeCategoryValue: 'US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '404673749230',
	},
	{
		sizeLabel: '18.5',
		sizeCategory: 'usShirtFormat',
		sizeCategoryValue: 'US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '994430905822',
	},
	{
		sizeLabel: '19.5',
		sizeCategory: 'usShirtFormat',
		sizeCategoryValue: 'US',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '533092207365',
	},
	{
		sizeLabel: '75',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '050163995684',
	},
	{
		sizeLabel: '80',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '595387947209',
	},
	{
		sizeLabel: '85',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '597559224412',
	},
	{
		sizeLabel: '90',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '489195232436',
	},
	{
		sizeLabel: '95',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '307957111354',
	},
	{
		sizeLabel: '100',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '044870412218',
	},
	{
		sizeLabel: '105',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '698200795530',
	},
	{
		sizeLabel: '110',
		sizeCategory: 'euBeltFormat',
		sizeCategoryValue: 'EU',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '956629197667',
	},
	{
		sizeLabel: '76',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '550495914397',
	},
	{
		sizeLabel: '81',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '632487708743',
	},
	{
		sizeLabel: '86',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '371437262875',
	},
	{
		sizeLabel: '91',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '734922677254',
	},
	{
		sizeLabel: '96',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '392486363841',
	},
	{
		sizeLabel: '101',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '791528947376',
	},
	{
		sizeLabel: '106',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '826076315451',
	},
	{
		sizeLabel: '111',
		sizeCategory: 'jpBeltFormat',
		sizeCategoryValue: 'Japan',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '150196914921',
	},
	{
		sizeLabel: 'N/A',
		sizeCategory: 'N/A',
		sizeCategoryValue: 'N/A',
		sizeSubcategory: 'N/A',
		sizeSubcategoryValue: 'N/A',
		sizeCode: '113231369659',
	},
	{
		sizeLabel: '2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919464184733',
	},
	{
		sizeLabel: '35 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889964952235',
	},
	{
		sizeLabel: '3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839323173335',
	},
	{
		sizeLabel: '36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573990012914',
	},
	{
		sizeLabel: '4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118255906697',
	},
	{
		sizeLabel: '37 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138031264224',
	},
	{
		sizeLabel: '5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '501466021251',
	},
	{
		sizeLabel: '38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837193516566',
	},
	{
		sizeLabel: '6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992894028246',
	},
	{
		sizeLabel: '39 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237864383175',
	},
	{
		sizeLabel: '7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416975092626',
	},
	{
		sizeLabel: '40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912573868541',
	},
	{
		sizeLabel: '8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276351227475',
	},
	{
		sizeLabel: '41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885607748482',
	},
	{
		sizeLabel: '9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '387536282146',
	},
	{
		sizeLabel: '42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916453849834',
	},
	{
		sizeLabel: '32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773283060000',
	},
	{
		sizeLabel: '34 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289190522810',
	},
	{
		sizeLabel: '36 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847228894880',
	},
	{
		sizeLabel: '34 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535596801138',
	},
	{
		sizeLabel: '34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884474739277',
	},
	{
		sizeLabel: '36 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656697389310',
	},
	{
		sizeLabel: '38 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244073779655',
	},
	{
		sizeLabel: '36 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230294806653',
	},
	{
		sizeLabel: '38 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '258546940263',
	},
	{
		sizeLabel: '40 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225768489247',
	},
	{
		sizeLabel: '38 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015032522133',
	},
	{
		sizeLabel: '10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116212906932',
	},
	{
		sizeLabel: '40 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485999903942',
	},
	{
		sizeLabel: '42 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610783419141',
	},
	{
		sizeLabel: '40 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162654344790',
	},
	{
		sizeLabel: '12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537303407549',
	},
	{
		sizeLabel: '42 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545803648127',
	},
	{
		sizeLabel: '44 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937436738608',
	},
	{
		sizeLabel: '42 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651157346531',
	},
	{
		sizeLabel: '14 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579434695388',
	},
	{
		sizeLabel: '44 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176477821561',
	},
	{
		sizeLabel: '46 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784687877392',
	},
	{
		sizeLabel: '44 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961752914377',
	},
	{
		sizeLabel: '16 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045478468096',
	},
	{
		sizeLabel: '44 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611597319714',
	},
	{
		sizeLabel: '46 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633726912929',
	},
	{
		sizeLabel: '48 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398154505228',
	},
	{
		sizeLabel: '46 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207311253933',
	},
	{
		sizeLabel: '24-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336233345309',
	},
	{
		sizeLabel: '25-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904406061533',
	},
	{
		sizeLabel: '26-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415777417991',
	},
	{
		sizeLabel: '28-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021173658371',
	},
	{
		sizeLabel: '29-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278431655862',
	},
	{
		sizeLabel: '30-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295883026080',
	},
	{
		sizeLabel: '31-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749458248640',
	},
	{
		sizeLabel: '32-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128284700433',
	},
	{
		sizeLabel: '24-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758605853170',
	},
	{
		sizeLabel: '25-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '848503599835',
	},
	{
		sizeLabel: '26-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173208980791',
	},
	{
		sizeLabel: '27-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518154314606',
	},
	{
		sizeLabel: '28-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682281311511',
	},
	{
		sizeLabel: '30-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '125755066652',
	},
	{
		sizeLabel: '31-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '486264081346',
	},
	{
		sizeLabel: '32-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751702202019',
	},
	{
		sizeLabel: '24-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573881279110',
	},
	{
		sizeLabel: '25-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098633655455',
	},
	{
		sizeLabel: '26-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940076918191',
	},
	{
		sizeLabel: '27-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523474661783',
	},
	{
		sizeLabel: '28-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209349676841',
	},
	{
		sizeLabel: '29-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492350263939',
	},
	{
		sizeLabel: '30-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087209453924',
	},
	{
		sizeLabel: '31-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538772761756',
	},
	{
		sizeLabel: '32-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478365953932',
	},
	{
		sizeLabel: '43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099257106178',
	},
	{
		sizeLabel: '45 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027737062143',
	},
	{
		sizeLabel: 'G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712764606946',
	},
	{
		sizeLabel: 'GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805438128788',
	},
	{
		sizeLabel: 'G1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560272791019',
	},
	{
		sizeLabel: 'G2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616759663129',
	},
	{
		sizeLabel: 'G3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915660193638',
	},
	{
		sizeLabel: 'G4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923526981928',
	},
	{
		sizeLabel: 'XG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185943490521',
	},
	{
		sizeLabel: '4 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581243360495',
	},
	{
		sizeLabel: '5 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506051565218',
	},
	{
		sizeLabel: '6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556676716754',
	},
	{
		sizeLabel: '7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859306772836',
	},
	{
		sizeLabel: '8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087549223569',
	},
	{
		sizeLabel: '9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693260477121',
	},
	{
		sizeLabel: '10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667336486121',
	},
	{
		sizeLabel: '11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998581411791',
	},
	{
		sizeLabel: '5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440645450772',
	},
	{
		sizeLabel: '6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398967483053',
	},
	{
		sizeLabel: '11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726240124455',
	},
	{
		sizeLabel: '46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185785987605',
	},
	{
		sizeLabel: '12 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690265298142',
	},
	{
		sizeLabel: '13 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343496446306',
	},
	{
		sizeLabel: '47 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335834370426',
	},
	{
		sizeLabel: '13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717677083646',
	},
	{
		sizeLabel: '14 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '150815742231',
	},
	{
		sizeLabel: '48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415275443842',
	},
	{
		sizeLabel: '15 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970300588942',
	},
	{
		sizeLabel: '15 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325391503962',
	},
	{
		sizeLabel: '49 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875659307379',
	},
	{
		sizeLabel: '16 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610703052869',
	},
	{
		sizeLabel: '16 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011998288767',
	},
	{
		sizeLabel: '50 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461519473968',
	},
	{
		sizeLabel: '17 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149218633862',
	},
	{
		sizeLabel: '17 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565017187020',
	},
	{
		sizeLabel: '51 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569497635545',
	},
	{
		sizeLabel: '18 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809804326773',
	},
	{
		sizeLabel: '18 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979859346797',
	},
	{
		sizeLabel: '52 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222964325560',
	},
	{
		sizeLabel: '19 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275104311378',
	},
	{
		sizeLabel: 'XL-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608163722858',
	},
	{
		sizeLabel: '3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213365168417',
	},
	{
		sizeLabel: '0 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899575173646',
	},
	{
		sizeLabel: '34 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802464873301',
	},
	{
		sizeLabel: '- (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912728149653',
	},
	{
		sizeLabel: '2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756331962670',
	},
	{
		sizeLabel: '4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624348334582',
	},
	{
		sizeLabel: '8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105556119719',
	},
	{
		sizeLabel: '10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871506368097',
	},
	{
		sizeLabel: '12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374296869537',
	},
	{
		sizeLabel: '5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641688325979',
	},
	{
		sizeLabel: '2 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557350131405',
	},
	{
		sizeLabel: '35 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438634531461',
	},
	{
		sizeLabel: '3 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878308440348',
	},
	{
		sizeLabel: '36 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965820533235',
	},
	{
		sizeLabel: '7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608978586873',
	},
	{
		sizeLabel: '4 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155808586003',
	},
	{
		sizeLabel: '37 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283404724370',
	},
	{
		sizeLabel: '38 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988053052963',
	},
	{
		sizeLabel: '9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925826120141',
	},
	{
		sizeLabel: '6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579492249282',
	},
	{
		sizeLabel: '39 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342547753578',
	},
	{
		sizeLabel: '7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202393451315',
	},
	{
		sizeLabel: '40 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634375020325',
	},
	{
		sizeLabel: '11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952153654294',
	},
	{
		sizeLabel: '28 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228196394445',
	},
	{
		sizeLabel: '29 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969929140701',
	},
	{
		sizeLabel: '30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373034957647',
	},
	{
		sizeLabel: '31 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764023021139',
	},
	{
		sizeLabel: '33 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155708991152',
	},
	{
		sizeLabel: '2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087883920798',
	},
	{
		sizeLabel: '85A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855606074589',
	},
	{
		sizeLabel: '85B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013841460139',
	},
	{
		sizeLabel: '85C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736289875393',
	},
	{
		sizeLabel: '90A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154658161134',
	},
	{
		sizeLabel: '90B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674633586005',
	},
	{
		sizeLabel: '90C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669504976537',
	},
	{
		sizeLabel: '90D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638948241063',
	},
	{
		sizeLabel: '90E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939532696316',
	},
	{
		sizeLabel: '90F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549674663281',
	},
	{
		sizeLabel: '95A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056819264649',
	},
	{
		sizeLabel: '95B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617837279457',
	},
	{
		sizeLabel: '95C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479285444264',
	},
	{
		sizeLabel: '95D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008793886568',
	},
	{
		sizeLabel: '95E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578937977732',
	},
	{
		sizeLabel: '95F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409817404895',
	},
	{
		sizeLabel: '100A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483399543381',
	},
	{
		sizeLabel: '100B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236814578143',
	},
	{
		sizeLabel: '100C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051938517348',
	},
	{
		sizeLabel: '100D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790094802254',
	},
	{
		sizeLabel: '100E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324170339180',
	},
	{
		sizeLabel: '100F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '359841880446',
	},
	{
		sizeLabel: '105B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903647633907',
	},
	{
		sizeLabel: '105C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950147357142',
	},
	{
		sizeLabel: '105D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237417224482',
	},
	{
		sizeLabel: '105E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643743174989',
	},
	{
		sizeLabel: '105F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264904160535',
	},
	{
		sizeLabel: '110B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394505401538',
	},
	{
		sizeLabel: '110C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357689684620',
	},
	{
		sizeLabel: '110D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790092089678',
	},
	{
		sizeLabel: '110E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531363702716',
	},
	{
		sizeLabel: '110F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350914958637',
	},
	{
		sizeLabel: '115B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998588808678',
	},
	{
		sizeLabel: '115C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '501315380693',
	},
	{
		sizeLabel: '115D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887467518735',
	},
	{
		sizeLabel: '115E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611274590450',
	},
	{
		sizeLabel: '115F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405606838966',
	},
	{
		sizeLabel: '120B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129694924455',
	},
	{
		sizeLabel: '120C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184046026228',
	},
	{
		sizeLabel: '120D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480725212601',
	},
	{
		sizeLabel: '120E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626648278130',
	},
	{
		sizeLabel: '120F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705882239321',
	},
	{
		sizeLabel: '125B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347837123324',
	},
	{
		sizeLabel: '125C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354551024157',
	},
	{
		sizeLabel: '125D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115168449053',
	},
	{
		sizeLabel: '125E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001487570120',
	},
	{
		sizeLabel: '125F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671948540208',
	},
	{
		sizeLabel: '130B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '462490854601',
	},
	{
		sizeLabel: '130C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013675092859',
	},
	{
		sizeLabel: '130D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164661704009',
	},
	{
		sizeLabel: '130E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704429421121',
	},
	{
		sizeLabel: '130F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045826038464',
	},
	{
		sizeLabel: '32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069825853622',
	},
	{
		sizeLabel: '32 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678566028704',
	},
	{
		sizeLabel: '- (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224659297773',
	},
	{
		sizeLabel: '34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525862591925',
	},
	{
		sizeLabel: '34 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672221928701',
	},
	{
		sizeLabel: '1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752852435501',
	},
	{
		sizeLabel: '36 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610224189209',
	},
	{
		sizeLabel: '36 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796936252329',
	},
	{
		sizeLabel: '2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025444177265',
	},
	{
		sizeLabel: '38 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023712368313',
	},
	{
		sizeLabel: '38 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '369305311478',
	},
	{
		sizeLabel: '3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212265350789',
	},
	{
		sizeLabel: '40 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '332921320545',
	},
	{
		sizeLabel: '40 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748302396557',
	},
	{
		sizeLabel: '50 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '976096730237',
	},
	{
		sizeLabel: '4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152641076779',
	},
	{
		sizeLabel: '42 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064708961994',
	},
	{
		sizeLabel: '42 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088961139285',
	},
	{
		sizeLabel: '52 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329362100533',
	},
	{
		sizeLabel: '5 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507735766085',
	},
	{
		sizeLabel: '44 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067019124913',
	},
	{
		sizeLabel: '44 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585961105255',
	},
	{
		sizeLabel: '54 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483452736859',
	},
	{
		sizeLabel: '6 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385950739861',
	},
	{
		sizeLabel: '46 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876364939967',
	},
	{
		sizeLabel: '46 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107703691197',
	},
	{
		sizeLabel: '56 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '421608024435',
	},
	{
		sizeLabel: '7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695054063423',
	},
	{
		sizeLabel: '2-4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975053244367',
	},
	{
		sizeLabel: '4-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690910067307',
	},
	{
		sizeLabel: '8-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952582302616',
	},
	{
		sizeLabel: '12-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '829932498118',
	},
	{
		sizeLabel: '8 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612951644775',
	},
	{
		sizeLabel: '9 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091362254534',
	},
	{
		sizeLabel: '10 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921313729276',
	},
	{
		sizeLabel: '19 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209662899011',
	},
	{
		sizeLabel: '20 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467811559915',
	},
	{
		sizeLabel: '21 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422782721360',
	},
	{
		sizeLabel: '22 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776823853573',
	},
	{
		sizeLabel: '23 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534457206332',
	},
	{
		sizeLabel: '24 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721076176301',
	},
	{
		sizeLabel: '25 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729060680724',
	},
	{
		sizeLabel: '26 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395449506093',
	},
	{
		sizeLabel: '27 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909421940219',
	},
	{
		sizeLabel: '35 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '768208893269',
	},
	{
		sizeLabel: '36 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128084487646',
	},
	{
		sizeLabel: '37 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134470407069',
	},
	{
		sizeLabel: '37 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134100960720',
	},
	{
		sizeLabel: '38 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292046292518',
	},
	{
		sizeLabel: '39 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718572337141',
	},
	{
		sizeLabel: '39 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197516031886',
	},
	{
		sizeLabel: '41 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568237202295',
	},
	{
		sizeLabel: '- (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888821692466',
	},
	{
		sizeLabel: '- (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '387891140078',
	},
	{
		sizeLabel: '40 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599585485842',
	},
	{
		sizeLabel: '41 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605795106757',
	},
	{
		sizeLabel: '42 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559348907390',
	},
	{
		sizeLabel: '42 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113319814367',
	},
	{
		sizeLabel: '43 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468863863360',
	},
	{
		sizeLabel: '8 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236343027239',
	},
	{
		sizeLabel: '43 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524174823332',
	},
	{
		sizeLabel: '9 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '274261803079',
	},
	{
		sizeLabel: '44 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504225045378',
	},
	{
		sizeLabel: '44 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426581854932',
	},
	{
		sizeLabel: '45 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '844763981018',
	},
	{
		sizeLabel: '10 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751099107956',
	},
	{
		sizeLabel: '45 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717765561735',
	},
	{
		sizeLabel: '45 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805005610760',
	},
	{
		sizeLabel: '12 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060876341269',
	},
	{
		sizeLabel: '47 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262415293211',
	},
	{
		sizeLabel: '47 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452192700717',
	},
	{
		sizeLabel: '13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605895607255',
	},
	{
		sizeLabel: '48 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080675099677',
	},
	{
		sizeLabel: '48 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656660194959',
	},
	{
		sizeLabel: '14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528031658284',
	},
	{
		sizeLabel: '49 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623519765856',
	},
	{
		sizeLabel: '- (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015062505849',
	},
	{
		sizeLabel: '0-2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815851367780',
	},
	{
		sizeLabel: '16-18 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466609553610',
	},
	{
		sizeLabel: '14-16 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569995297605',
	},
	{
		sizeLabel: '42 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948948424562',
	},
	{
		sizeLabel: '44 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989485315181',
	},
	{
		sizeLabel: '46 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '269657417379',
	},
	{
		sizeLabel: '48 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624764119003',
	},
	{
		sizeLabel: '50 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040812393903',
	},
	{
		sizeLabel: '52 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757447328248',
	},
	{
		sizeLabel: '54 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790381923605',
	},
	{
		sizeLabel: '56 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '274732515907',
	},
	{
		sizeLabel: '58 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203907009203',
	},
	{
		sizeLabel: '60 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '955719578985',
	},
	{
		sizeLabel: '-',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062149722610',
	},
	{
		sizeLabel: '18 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652858361314',
	},
	{
		sizeLabel: '65A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173935363737',
	},
	{
		sizeLabel: '65B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '627438622426',
	},
	{
		sizeLabel: '65C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405672935156',
	},
	{
		sizeLabel: '65D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690493605105',
	},
	{
		sizeLabel: '65E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957647242439',
	},
	{
		sizeLabel: '70A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774656969272',
	},
	{
		sizeLabel: '70B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606908841333',
	},
	{
		sizeLabel: '70C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133767735705',
	},
	{
		sizeLabel: '70D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461588614226',
	},
	{
		sizeLabel: '70E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624667157977',
	},
	{
		sizeLabel: '70F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981434125472',
	},
	{
		sizeLabel: '70G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422107319190',
	},
	{
		sizeLabel: '70H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695505943846',
	},
	{
		sizeLabel: '75A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383292694798',
	},
	{
		sizeLabel: '75B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774936598237',
	},
	{
		sizeLabel: '75C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166365191997',
	},
	{
		sizeLabel: '75D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222552835010',
	},
	{
		sizeLabel: '75E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052039568615',
	},
	{
		sizeLabel: '75F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667549150447',
	},
	{
		sizeLabel: '75G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658869184162',
	},
	{
		sizeLabel: '75H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934609654003',
	},
	{
		sizeLabel: '80A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133097855101',
	},
	{
		sizeLabel: '80B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559104399032',
	},
	{
		sizeLabel: '80C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373887342292',
	},
	{
		sizeLabel: '80D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000970730955',
	},
	{
		sizeLabel: '80E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685030588099',
	},
	{
		sizeLabel: '80F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882921825797',
	},
	{
		sizeLabel: '80G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748173626021',
	},
	{
		sizeLabel: '80H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '003096474752',
	},
	{
		sizeLabel: '85A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428117690821',
	},
	{
		sizeLabel: '85B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239566030031',
	},
	{
		sizeLabel: '85C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688751310568',
	},
	{
		sizeLabel: '85D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547938102362',
	},
	{
		sizeLabel: '85E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297015804997',
	},
	{
		sizeLabel: '85F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426685093904',
	},
	{
		sizeLabel: '85G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235387738230',
	},
	{
		sizeLabel: '85H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '482699405443',
	},
	{
		sizeLabel: '90A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363676622843',
	},
	{
		sizeLabel: '90B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456869978587',
	},
	{
		sizeLabel: '90C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398279445916',
	},
	{
		sizeLabel: '90D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537488311881',
	},
	{
		sizeLabel: '90E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970020366750',
	},
	{
		sizeLabel: '90F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767954902273',
	},
	{
		sizeLabel: '90G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463505080888',
	},
	{
		sizeLabel: '90H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297056015527',
	},
	{
		sizeLabel: '95A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145799532666',
	},
	{
		sizeLabel: '95B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413116057127',
	},
	{
		sizeLabel: '95C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531007643518',
	},
	{
		sizeLabel: '95D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087053240373',
	},
	{
		sizeLabel: '95E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158476122954',
	},
	{
		sizeLabel: '95F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785700300247',
	},
	{
		sizeLabel: '95G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748469668585',
	},
	{
		sizeLabel: '95H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991812375715',
	},
	{
		sizeLabel: '100A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500500413006',
	},
	{
		sizeLabel: '100B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678121967740',
	},
	{
		sizeLabel: '100C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902061691444',
	},
	{
		sizeLabel: '100D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707963810238',
	},
	{
		sizeLabel: '100E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624930368120',
	},
	{
		sizeLabel: '100F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834312295348',
	},
	{
		sizeLabel: '100G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649360143890',
	},
	{
		sizeLabel: '100H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040522809895',
	},
	{
		sizeLabel: '105A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086671796427',
	},
	{
		sizeLabel: '105B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885354941322',
	},
	{
		sizeLabel: '105C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727159990529',
	},
	{
		sizeLabel: '105D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566730970086',
	},
	{
		sizeLabel: '105E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839990993656',
	},
	{
		sizeLabel: '105F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236177064869',
	},
	{
		sizeLabel: '105G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958266358193',
	},
	{
		sizeLabel: '105H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192431400053',
	},
	{
		sizeLabel: '110A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231246173719',
	},
	{
		sizeLabel: '110B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '486872480314',
	},
	{
		sizeLabel: '110C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307165008787',
	},
	{
		sizeLabel: '110D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750741142479',
	},
	{
		sizeLabel: '110E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749788318483',
	},
	{
		sizeLabel: '110F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560883283914',
	},
	{
		sizeLabel: '110G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095817765078',
	},
	{
		sizeLabel: '110H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352532743806',
	},
	{
		sizeLabel: '115A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253505885168',
	},
	{
		sizeLabel: '115B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228338883934',
	},
	{
		sizeLabel: '115C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514656838642',
	},
	{
		sizeLabel: '115D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824274031546',
	},
	{
		sizeLabel: '115E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686959744222',
	},
	{
		sizeLabel: '115F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995246864674',
	},
	{
		sizeLabel: '32-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728155264820',
	},
	{
		sizeLabel: '42-44 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347373577347',
	},
	{
		sizeLabel: '42-44 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703273358253',
	},
	{
		sizeLabel: 'XS (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '465075129376',
	},
	{
		sizeLabel: '90 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314369775407',
	},
	{
		sizeLabel: 'S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192079057365',
	},
	{
		sizeLabel: '95 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105742451242',
	},
	{
		sizeLabel: '38-40 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862100730459',
	},
	{
		sizeLabel: '48-50 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276209564116',
	},
	{
		sizeLabel: '48-50 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803029196396',
	},
	{
		sizeLabel: 'M (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999746748504',
	},
	{
		sizeLabel: '100 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447966941759',
	},
	{
		sizeLabel: 'L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898980508718',
	},
	{
		sizeLabel: '105 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '274324225977',
	},
	{
		sizeLabel: '44-46 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637717490839',
	},
	{
		sizeLabel: '54-56 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038253156962',
	},
	{
		sizeLabel: '54-56 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832521990432',
	},
	{
		sizeLabel: 'LL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975387075536',
	},
	{
		sizeLabel: '110 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605174527086',
	},
	{
		sizeLabel: '48 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '838340651892',
	},
	{
		sizeLabel: '58 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813447388058',
	},
	{
		sizeLabel: '58 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537491578543',
	},
	{
		sizeLabel: 'LLL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522058069815',
	},
	{
		sizeLabel: '115 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903857308583',
	},
	{
		sizeLabel: '50 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146245658588',
	},
	{
		sizeLabel: '60 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '698469899890',
	},
	{
		sizeLabel: '60 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457887451123',
	},
	{
		sizeLabel: '4L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888034645232',
	},
	{
		sizeLabel: '120 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '552417332893',
	},
	{
		sizeLabel: '35-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373617193316',
	},
	{
		sizeLabel: '36-37 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213307221535',
	},
	{
		sizeLabel: '37-38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029141650499',
	},
	{
		sizeLabel: '38-39 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885482627771',
	},
	{
		sizeLabel: '39-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879611437517',
	},
	{
		sizeLabel: '40-41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935966070726',
	},
	{
		sizeLabel: '41-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018841312814',
	},
	{
		sizeLabel: '42-43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '816030762825',
	},
	{
		sizeLabel: '43-44 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973615781906',
	},
	{
		sizeLabel: '44-45 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319386097267',
	},
	{
		sizeLabel: '33 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382479940474',
	},
	{
		sizeLabel: '160-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584566415070',
	},
	{
		sizeLabel: '44 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441801396359',
	},
	{
		sizeLabel: '160-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165540455545',
	},
	{
		sizeLabel: '9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754475692608',
	},
	{
		sizeLabel: '55 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '745392147819',
	},
	{
		sizeLabel: '165-92A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562668455304',
	},
	{
		sizeLabel: '11 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609366163053',
	},
	{
		sizeLabel: '66 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000621256113',
	},
	{
		sizeLabel: '165-96A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399596027045',
	},
	{
		sizeLabel: '13 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331723170061',
	},
	{
		sizeLabel: '77 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872840639707',
	},
	{
		sizeLabel: '165-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '493295813206',
	},
	{
		sizeLabel: '17 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956324120136',
	},
	{
		sizeLabel: '88 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604373478364',
	},
	{
		sizeLabel: '170-112A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859987195342',
	},
	{
		sizeLabel: '22 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220609392627',
	},
	{
		sizeLabel: '19 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962243125939',
	},
	{
		sizeLabel: '99 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840602289437',
	},
	{
		sizeLabel: '170-128A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157001032815',
	},
	{
		sizeLabel: '26 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632094409207',
	},
	{
		sizeLabel: '54 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881273526573',
	},
	{
		sizeLabel: '21 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110499636328',
	},
	{
		sizeLabel: '170-136A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '256056162999',
	},
	{
		sizeLabel: '30 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865471695652',
	},
	{
		sizeLabel: 'XXS (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424297639986',
	},
	{
		sizeLabel: '85 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '302946444436',
	},
	{
		sizeLabel: '165-76A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581656694488',
	},
	{
		sizeLabel: '170-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982296780498',
	},
	{
		sizeLabel: '175-92A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027121814379',
	},
	{
		sizeLabel: '180-100A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551195011214',
	},
	{
		sizeLabel: '180-108A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046363341984',
	},
	{
		sizeLabel: '180-116A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163027244244',
	},
	{
		sizeLabel: '185-124A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813435225479',
	},
	{
		sizeLabel: '185-132A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813589317978',
	},
	{
		sizeLabel: '4-6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257966163181',
	},
	{
		sizeLabel: '32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518480256945',
	},
	{
		sizeLabel: '36-38 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097010988336',
	},
	{
		sizeLabel: '3-5 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097841842481',
	},
	{
		sizeLabel: '14-16 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681134507408',
	},
	{
		sizeLabel: '46-48 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676572233035',
	},
	{
		sizeLabel: '13-15 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863612322174',
	},
	{
		sizeLabel: '18-20 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453044108817',
	},
	{
		sizeLabel: '46-48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135682073809',
	},
	{
		sizeLabel: '50-52 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032734240230',
	},
	{
		sizeLabel: '22-24 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416402330226',
	},
	{
		sizeLabel: '50-52 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267144122597',
	},
	{
		sizeLabel: '20-22 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684403402774',
	},
	{
		sizeLabel: '24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964454549861',
	},
	{
		sizeLabel: '101 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800912015577',
	},
	{
		sizeLabel: '160-60A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '258414190180',
	},
	{
		sizeLabel: '160-66A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405021352247',
	},
	{
		sizeLabel: '165-72A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884685441562',
	},
	{
		sizeLabel: '165-86A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804416267929',
	},
	{
		sizeLabel: '170-98A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305843575783',
	},
	{
		sizeLabel: '170-120A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181556362199',
	},
	{
		sizeLabel: '160-58A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016992294707',
	},
	{
		sizeLabel: '160-64A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460148069708',
	},
	{
		sizeLabel: '165-68A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354982435776',
	},
	{
		sizeLabel: '165-74A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596634703123',
	},
	{
		sizeLabel: '165-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914332061726',
	},
	{
		sizeLabel: '15 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183695158274',
	},
	{
		sizeLabel: '170-90A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783950740354',
	},
	{
		sizeLabel: '20 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918775322746',
	},
	{
		sizeLabel: '20 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244103771917',
	},
	{
		sizeLabel: '170-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470255857613',
	},
	{
		sizeLabel: '24 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070759069408',
	},
	{
		sizeLabel: '22 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184048424670',
	},
	{
		sizeLabel: '23EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697194542701',
	},
	{
		sizeLabel: '24EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591152688676',
	},
	{
		sizeLabel: '25EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381460640584',
	},
	{
		sizeLabel: '26EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315645641232',
	},
	{
		sizeLabel: '27EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157256558843',
	},
	{
		sizeLabel: '28EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621453537255',
	},
	{
		sizeLabel: '29EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500617339121',
	},
	{
		sizeLabel: '30EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430789336799',
	},
	{
		sizeLabel: '31EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277430701240',
	},
	{
		sizeLabel: '32EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494967909391',
	},
	{
		sizeLabel: '33EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978601060546',
	},
	{
		sizeLabel: '34EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500373779719',
	},
	{
		sizeLabel: '35EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132214316946',
	},
	{
		sizeLabel: '36EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066785575789',
	},
	{
		sizeLabel: '37EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792570571633',
	},
	{
		sizeLabel: '23SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830799902656',
	},
	{
		sizeLabel: '24SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '332745176974',
	},
	{
		sizeLabel: '25SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '296201171049',
	},
	{
		sizeLabel: '26SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '332708711483',
	},
	{
		sizeLabel: '27SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693993714927',
	},
	{
		sizeLabel: '28SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571269619479',
	},
	{
		sizeLabel: '29SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717398367854',
	},
	{
		sizeLabel: '30SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681675905333',
	},
	{
		sizeLabel: '31SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276403778201',
	},
	{
		sizeLabel: '32SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931832280960',
	},
	{
		sizeLabel: '33SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779964399187',
	},
	{
		sizeLabel: '34SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940255143219',
	},
	{
		sizeLabel: '35SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591042449953',
	},
	{
		sizeLabel: '36SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273153606585',
	},
	{
		sizeLabel: '37SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977083681227',
	},
	{
		sizeLabel: '23REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784365678910',
	},
	{
		sizeLabel: '24REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845972903831',
	},
	{
		sizeLabel: '25REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376874839433',
	},
	{
		sizeLabel: '26REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424407541508',
	},
	{
		sizeLabel: '27REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642897865122',
	},
	{
		sizeLabel: '28REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736457868357',
	},
	{
		sizeLabel: '29REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273849520296',
	},
	{
		sizeLabel: '30REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334875105516',
	},
	{
		sizeLabel: '31REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674608526402',
	},
	{
		sizeLabel: '32REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438773257568',
	},
	{
		sizeLabel: '33REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543468803821',
	},
	{
		sizeLabel: '34REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354327505487',
	},
	{
		sizeLabel: '35REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508993173802',
	},
	{
		sizeLabel: '36REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089995203461',
	},
	{
		sizeLabel: '37REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039028045850',
	},
	{
		sizeLabel: '23LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654140990131',
	},
	{
		sizeLabel: '24LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824349365502',
	},
	{
		sizeLabel: '25LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699609316720',
	},
	{
		sizeLabel: '26LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953909559972',
	},
	{
		sizeLabel: '27LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528240406459',
	},
	{
		sizeLabel: '28LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '125284952632',
	},
	{
		sizeLabel: '29LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202531091743',
	},
	{
		sizeLabel: '30LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273623230112',
	},
	{
		sizeLabel: '31LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380612796889',
	},
	{
		sizeLabel: '32LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '465394734770',
	},
	{
		sizeLabel: '33LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417187751750',
	},
	{
		sizeLabel: '34LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987639216995',
	},
	{
		sizeLabel: '35LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '850807756569',
	},
	{
		sizeLabel: '36LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144406462701',
	},
	{
		sizeLabel: '37LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833381340933',
	},
	{
		sizeLabel: '23EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336968036273',
	},
	{
		sizeLabel: '24EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117138371540',
	},
	{
		sizeLabel: '25EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969375143834',
	},
	{
		sizeLabel: '26EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825671028177',
	},
	{
		sizeLabel: '27EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807102481173',
	},
	{
		sizeLabel: '28EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300590533894',
	},
	{
		sizeLabel: '29EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023495194569',
	},
	{
		sizeLabel: '30EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188038684917',
	},
	{
		sizeLabel: '31EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314796299344',
	},
	{
		sizeLabel: '32EXTRALONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430909127007',
	},
	{
		sizeLabel: '33EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '423855153787',
	},
	{
		sizeLabel: '34EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404430114146',
	},
	{
		sizeLabel: '35EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636140663585',
	},
	{
		sizeLabel: '36EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866283356046',
	},
	{
		sizeLabel: '37EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665149215747',
	},
	{
		sizeLabel: '28-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361219045032',
	},
	{
		sizeLabel: '30-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '419545385645',
	},
	{
		sizeLabel: '30-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903841772135',
	},
	{
		sizeLabel: '31-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292133600699',
	},
	{
		sizeLabel: '31-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039740865978',
	},
	{
		sizeLabel: '32-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096583445636',
	},
	{
		sizeLabel: '33-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888616890451',
	},
	{
		sizeLabel: '33-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119774813425',
	},
	{
		sizeLabel: '33-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238090584096',
	},
	{
		sizeLabel: '34-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143592544872',
	},
	{
		sizeLabel: '34-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159080611676',
	},
	{
		sizeLabel: '34-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522662490943',
	},
	{
		sizeLabel: '36-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999461128988',
	},
	{
		sizeLabel: '36-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822264431274',
	},
	{
		sizeLabel: '36-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '816060268125',
	},
	{
		sizeLabel: '36-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244540368992',
	},
	{
		sizeLabel: '38-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '131514535167',
	},
	{
		sizeLabel: '38-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086157158464',
	},
	{
		sizeLabel: '38-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757291090800',
	},
	{
		sizeLabel: '38-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056158132154',
	},
	{
		sizeLabel: 'XSSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695109076005',
	},
	{
		sizeLabel: 'SSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839954059652',
	},
	{
		sizeLabel: 'MSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308467042059',
	},
	{
		sizeLabel: 'LSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710555356739',
	},
	{
		sizeLabel: 'XLSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738749795605',
	},
	{
		sizeLabel: '2XLSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420041975344',
	},
	{
		sizeLabel: '3XLSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711887574093',
	},
	{
		sizeLabel: 'XSREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070467505433',
	},
	{
		sizeLabel: 'SREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726158782038',
	},
	{
		sizeLabel: 'MREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456294960157',
	},
	{
		sizeLabel: 'LREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641833545014',
	},
	{
		sizeLabel: 'XLREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587386404430',
	},
	{
		sizeLabel: '2XLREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680035783219',
	},
	{
		sizeLabel: '3XLREGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309182207996',
	},
	{
		sizeLabel: 'XSLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041113973595',
	},
	{
		sizeLabel: 'SLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090556849745',
	},
	{
		sizeLabel: 'MLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742347892255',
	},
	{
		sizeLabel: 'LLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566956531900',
	},
	{
		sizeLabel: 'XLLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774337811773',
	},
	{
		sizeLabel: '2XLLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208484132853',
	},
	{
		sizeLabel: '3XLLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636326120684',
	},
	{
		sizeLabel: '26-28 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353427756732',
	},
	{
		sizeLabel: '36-38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587474654425',
	},
	{
		sizeLabel: '66-71 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629714569594',
	},
	{
		sizeLabel: '29-30 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631661880662',
	},
	{
		sizeLabel: '74-76 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212930951215',
	},
	{
		sizeLabel: '31-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032413974522',
	},
	{
		sizeLabel: '79-81 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933890080157',
	},
	{
		sizeLabel: '33-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113066300804',
	},
	{
		sizeLabel: '84-88 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095829844848',
	},
	{
		sizeLabel: '36-38 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309520873113',
	},
	{
		sizeLabel: '52-54 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090429945696',
	},
	{
		sizeLabel: '93-98 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021877155644',
	},
	{
		sizeLabel: '104 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726454759293',
	},
	{
		sizeLabel: '110 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941789567121',
	},
	{
		sizeLabel: '30A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930918470366',
	},
	{
		sizeLabel: '30A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817998981957',
	},
	{
		sizeLabel: '80A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '679923513305',
	},
	{
		sizeLabel: '0A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693455583374',
	},
	{
		sizeLabel: '65A (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158151191481',
	},
	{
		sizeLabel: '8A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929298898700',
	},
	{
		sizeLabel: 'B65 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914550125215',
	},
	{
		sizeLabel: 'B65 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771375558479',
	},
	{
		sizeLabel: '30B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366747830418',
	},
	{
		sizeLabel: '30B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072878775865',
	},
	{
		sizeLabel: '80B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367924924860',
	},
	{
		sizeLabel: '0B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496424171892',
	},
	{
		sizeLabel: '65B (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086051911878',
	},
	{
		sizeLabel: '8B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652114107620',
	},
	{
		sizeLabel: 'C65 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009811426616',
	},
	{
		sizeLabel: 'C65 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397085036864',
	},
	{
		sizeLabel: '30C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014561551944',
	},
	{
		sizeLabel: '30C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083909131463',
	},
	{
		sizeLabel: '80C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978756918706',
	},
	{
		sizeLabel: '0C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951540321173',
	},
	{
		sizeLabel: '65C (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453454825023',
	},
	{
		sizeLabel: '8C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371815421208',
	},
	{
		sizeLabel: 'D65 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104228643010',
	},
	{
		sizeLabel: 'D65 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480999756892',
	},
	{
		sizeLabel: '30D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535267830747',
	},
	{
		sizeLabel: '30D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '735047964151',
	},
	{
		sizeLabel: '80D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624889262390',
	},
	{
		sizeLabel: '0D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948982406285',
	},
	{
		sizeLabel: '65D (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596335041314',
	},
	{
		sizeLabel: '8D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991412808696',
	},
	{
		sizeLabel: 'E65 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188446660270',
	},
	{
		sizeLabel: 'E65 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833398665098',
	},
	{
		sizeLabel: '30DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940155410430',
	},
	{
		sizeLabel: '30DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '731930003075',
	},
	{
		sizeLabel: '80DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '180872037513',
	},
	{
		sizeLabel: '0DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130852097577',
	},
	{
		sizeLabel: '65E (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656239017710',
	},
	{
		sizeLabel: '8DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983199789149',
	},
	{
		sizeLabel: 'F65 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517061609060',
	},
	{
		sizeLabel: 'F65 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145001403779',
	},
	{
		sizeLabel: '32AA',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951310208043',
	},
	{
		sizeLabel: '32AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544890282250',
	},
	{
		sizeLabel: '70AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240620854346',
	},
	{
		sizeLabel: '85AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185913095439',
	},
	{
		sizeLabel: '1A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107874994286',
	},
	{
		sizeLabel: '70AA (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '458903245280',
	},
	{
		sizeLabel: '10AA (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089464655189',
	},
	{
		sizeLabel: 'A70 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408371262247',
	},
	{
		sizeLabel: 'A70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989521612369',
	},
	{
		sizeLabel: '32A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532318936999',
	},
	{
		sizeLabel: '32A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740897867934',
	},
	{
		sizeLabel: '70A (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159970816068',
	},
	{
		sizeLabel: '10A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581213656173',
	},
	{
		sizeLabel: 'B70 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630878252969',
	},
	{
		sizeLabel: 'B70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891872929209',
	},
	{
		sizeLabel: '32B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589056465843',
	},
	{
		sizeLabel: '32B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639338551143',
	},
	{
		sizeLabel: '1B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846325676199',
	},
	{
		sizeLabel: '70B (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500886464511',
	},
	{
		sizeLabel: '10B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435286354396',
	},
	{
		sizeLabel: 'C70 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520846941816',
	},
	{
		sizeLabel: 'C70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738430332212',
	},
	{
		sizeLabel: '32C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693365318564',
	},
	{
		sizeLabel: '32C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '026790730107',
	},
	{
		sizeLabel: '1C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704350344410',
	},
	{
		sizeLabel: '70C (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '762894850326',
	},
	{
		sizeLabel: '10C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '843382510362',
	},
	{
		sizeLabel: 'D70 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134699849870',
	},
	{
		sizeLabel: 'D70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488040559411',
	},
	{
		sizeLabel: '32D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016844989205',
	},
	{
		sizeLabel: '32D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041389288796',
	},
	{
		sizeLabel: '85D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727072287086',
	},
	{
		sizeLabel: '1D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046547860421',
	},
	{
		sizeLabel: '70D (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428460994578',
	},
	{
		sizeLabel: '10D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693413211401',
	},
	{
		sizeLabel: 'E70 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472267370368',
	},
	{
		sizeLabel: 'E70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581239369621',
	},
	{
		sizeLabel: '32DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259494305640',
	},
	{
		sizeLabel: '32DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475827130527',
	},
	{
		sizeLabel: '85DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '195617593244',
	},
	{
		sizeLabel: '1DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867068849284',
	},
	{
		sizeLabel: '70E (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980218302558',
	},
	{
		sizeLabel: '10DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500874750311',
	},
	{
		sizeLabel: 'F70 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012741740832',
	},
	{
		sizeLabel: 'F70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230839741604',
	},
	{
		sizeLabel: '34A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885987344105',
	},
	{
		sizeLabel: '34A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265016914385',
	},
	{
		sizeLabel: '2A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319246349439',
	},
	{
		sizeLabel: '75A (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611369655615',
	},
	{
		sizeLabel: '12A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '848457776411',
	},
	{
		sizeLabel: 'B75 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721725279821',
	},
	{
		sizeLabel: 'B75 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363009374444',
	},
	{
		sizeLabel: '34B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101946978765',
	},
	{
		sizeLabel: '34B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025116553602',
	},
	{
		sizeLabel: '2B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186488756369',
	},
	{
		sizeLabel: '75B (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738951829181',
	},
	{
		sizeLabel: '12B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160269989662',
	},
	{
		sizeLabel: 'C75 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948563389431',
	},
	{
		sizeLabel: 'C75 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583350228129',
	},
	{
		sizeLabel: '34C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940655318315',
	},
	{
		sizeLabel: '34C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078163286873',
	},
	{
		sizeLabel: '2C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352830966151',
	},
	{
		sizeLabel: '75C (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767058627848',
	},
	{
		sizeLabel: '12C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282496313815',
	},
	{
		sizeLabel: 'D75 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546290690026',
	},
	{
		sizeLabel: 'D75 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650536758676',
	},
	{
		sizeLabel: '34D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '873905092191',
	},
	{
		sizeLabel: '34D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262334319192',
	},
	{
		sizeLabel: '2D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833283486955',
	},
	{
		sizeLabel: '75D (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981971612739',
	},
	{
		sizeLabel: '12D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542705098337',
	},
	{
		sizeLabel: 'E75 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459865806735',
	},
	{
		sizeLabel: 'E75 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906324348390',
	},
	{
		sizeLabel: '34DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129655402014',
	},
	{
		sizeLabel: '34DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294596880145',
	},
	{
		sizeLabel: '90DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342456319400',
	},
	{
		sizeLabel: '2DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916811546284',
	},
	{
		sizeLabel: '75E (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811511127272',
	},
	{
		sizeLabel: '12DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333892448476',
	},
	{
		sizeLabel: 'F75 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624625998388',
	},
	{
		sizeLabel: 'F75 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732488570230',
	},
	{
		sizeLabel: '36A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620643743644',
	},
	{
		sizeLabel: '36A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425326605107',
	},
	{
		sizeLabel: '3A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '180942702591',
	},
	{
		sizeLabel: '80A (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514231406221',
	},
	{
		sizeLabel: '14A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064839579182',
	},
	{
		sizeLabel: 'B80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672063927907',
	},
	{
		sizeLabel: 'B80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230323820496',
	},
	{
		sizeLabel: '36B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990996107595',
	},
	{
		sizeLabel: '36B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409768165435',
	},
	{
		sizeLabel: '3B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286735183817',
	},
	{
		sizeLabel: '80B (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472407288895',
	},
	{
		sizeLabel: '14B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527525079363',
	},
	{
		sizeLabel: 'C80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744458159498',
	},
	{
		sizeLabel: 'C80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669482312194',
	},
	{
		sizeLabel: '36C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087383786459',
	},
	{
		sizeLabel: '36C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171164576785',
	},
	{
		sizeLabel: '3C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082754329359',
	},
	{
		sizeLabel: '80C (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487353152745',
	},
	{
		sizeLabel: '14C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565305376095',
	},
	{
		sizeLabel: 'D80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528777745820',
	},
	{
		sizeLabel: 'D80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188743055823',
	},
	{
		sizeLabel: '36D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179030447082',
	},
	{
		sizeLabel: '36D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882531551686',
	},
	{
		sizeLabel: '3D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447592982704',
	},
	{
		sizeLabel: '80D (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505713315360',
	},
	{
		sizeLabel: '14D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201397063454',
	},
	{
		sizeLabel: 'E80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795192359221',
	},
	{
		sizeLabel: 'E80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834118138566',
	},
	{
		sizeLabel: '36DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '266899760183',
	},
	{
		sizeLabel: '36DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309333008093',
	},
	{
		sizeLabel: '95DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290582007715',
	},
	{
		sizeLabel: '3DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227890912634',
	},
	{
		sizeLabel: '80E (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587118196069',
	},
	{
		sizeLabel: '14DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557373122685',
	},
	{
		sizeLabel: 'F80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970483715919',
	},
	{
		sizeLabel: 'F80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309962190680',
	},
	{
		sizeLabel: '3XS-2XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196550196741',
	},
	{
		sizeLabel: '1A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620514524898',
	},
	{
		sizeLabel: '2A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072395913077',
	},
	{
		sizeLabel: '45-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499249622682',
	},
	{
		sizeLabel: '47-48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790420157352',
	},
	{
		sizeLabel: '34-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633576562369',
	},
	{
		sizeLabel: '3 ½-5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594540120365',
	},
	{
		sizeLabel: '21-22 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189089746387',
	},
	{
		sizeLabel: '37-39 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325713288134',
	},
	{
		sizeLabel: '5 ½-7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '266520708196',
	},
	{
		sizeLabel: '23-24 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098354252614',
	},
	{
		sizeLabel: 'II',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556681724326',
	},
	{
		sizeLabel: '39-41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058630586451',
	},
	{
		sizeLabel: '7-8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785436110370',
	},
	{
		sizeLabel: '24 ½-26 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598914961066',
	},
	{
		sizeLabel: 'III',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523454694338',
	},
	{
		sizeLabel: '9-11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928602829099',
	},
	{
		sizeLabel: '26 ½-28 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420150101564',
	},
	{
		sizeLabel: 'IV',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585645513803',
	},
	{
		sizeLabel: '45-47 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417939614380',
	},
	{
		sizeLabel: '12-13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733821377425',
	},
	{
		sizeLabel: '28 ½-29 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630391651180',
	},
	{
		sizeLabel: '3XS-XXS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796381621515',
	},
	{
		sizeLabel: '3XL-4XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777483800582',
	},
	{
		sizeLabel: '8-10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738126581325',
	},
	{
		sizeLabel: '52-54 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176958855266',
	},
	{
		sizeLabel: '12-14 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405245348530',
	},
	{
		sizeLabel: '40-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550809617606',
	},
	{
		sizeLabel: '16-18 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301921929978',
	},
	{
		sizeLabel: '44-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805750118691',
	},
	{
		sizeLabel: '20-22 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944252466858',
	},
	{
		sizeLabel: '3-4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761632230888',
	},
	{
		sizeLabel: '5-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248856373495',
	},
	{
		sizeLabel: '5-6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189366108179',
	},
	{
		sizeLabel: '7-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321449096708',
	},
	{
		sizeLabel: '7-8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100614974235',
	},
	{
		sizeLabel: '9-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479644641141',
	},
	{
		sizeLabel: '9-10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081749174885',
	},
	{
		sizeLabel: '11-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543197719930',
	},
	{
		sizeLabel: '23 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061821746106',
	},
	{
		sizeLabel: '230 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449716761365',
	},
	{
		sizeLabel: '36 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818565420386',
	},
	{
		sizeLabel: '24 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801218201681',
	},
	{
		sizeLabel: '235 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '313485266621',
	},
	{
		sizeLabel: '37 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467735791026',
	},
	{
		sizeLabel: '25 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144409636661',
	},
	{
		sizeLabel: '245 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760706927561',
	},
	{
		sizeLabel: '38 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852721983978',
	},
	{
		sizeLabel: '26 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097246171006',
	},
	{
		sizeLabel: '255 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227259159255',
	},
	{
		sizeLabel: '39 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438380338811',
	},
	{
		sizeLabel: '27 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938172619123',
	},
	{
		sizeLabel: '260 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997300878461',
	},
	{
		sizeLabel: '40 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427863549750',
	},
	{
		sizeLabel: '28 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409359915518',
	},
	{
		sizeLabel: '265 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673630872013',
	},
	{
		sizeLabel: '41 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388195897634',
	},
	{
		sizeLabel: '250 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479120249934',
	},
	{
		sizeLabel: '270 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244809104328',
	},
	{
		sizeLabel: '42 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813053655123',
	},
	{
		sizeLabel: '280 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601716977726',
	},
	{
		sizeLabel: '43 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695676460659',
	},
	{
		sizeLabel: '29 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436909462641',
	},
	{
		sizeLabel: '290 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408167822880',
	},
	{
		sizeLabel: '44 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739617190899',
	},
	{
		sizeLabel: '30 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555854074374',
	},
	{
		sizeLabel: '300 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232466530515',
	},
	{
		sizeLabel: '45 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672089122264',
	},
	{
		sizeLabel: '160-76A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138645071638',
	},
	{
		sizeLabel: '175-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533807771108',
	},
	{
		sizeLabel: '175-96A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715478327141',
	},
	{
		sizeLabel: '36 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995591078387',
	},
	{
		sizeLabel: '37 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506142100353',
	},
	{
		sizeLabel: '180-92A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520705526315',
	},
	{
		sizeLabel: '38 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519167040460',
	},
	{
		sizeLabel: '180-96A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499926336771',
	},
	{
		sizeLabel: '50 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521406413839',
	},
	{
		sizeLabel: '39 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057534045727',
	},
	{
		sizeLabel: '185-100A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995893155791',
	},
	{
		sizeLabel: '52 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412951577308',
	},
	{
		sizeLabel: '41 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420286807119',
	},
	{
		sizeLabel: '185-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025213100522',
	},
	{
		sizeLabel: '54 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384143270195',
	},
	{
		sizeLabel: '42 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405219495473',
	},
	{
		sizeLabel: '185-108A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776473594609',
	},
	{
		sizeLabel: '165-64A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749409775668',
	},
	{
		sizeLabel: '170-68A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941888071899',
	},
	{
		sizeLabel: '175-72A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264712084735',
	},
	{
		sizeLabel: '175-76A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '772637680259',
	},
	{
		sizeLabel: '175-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373076081784',
	},
	{
		sizeLabel: '22-24',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580260844736',
	},
	{
		sizeLabel: '30-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039025782115',
	},
	{
		sizeLabel: '32-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438514938108',
	},
	{
		sizeLabel: '34-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063077920350',
	},
	{
		sizeLabel: '35-37',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507284783488',
	},
	{
		sizeLabel: '180-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952506194362',
	},
	{
		sizeLabel: '180-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862221443101',
	},
	{
		sizeLabel: '185-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196393318931',
	},
	{
		sizeLabel: '185-92A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014354381365',
	},
	{
		sizeLabel: '185-96A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575928303895',
	},
	{
		sizeLabel: '40 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894823646148',
	},
	{
		sizeLabel: '41 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609326033905',
	},
	{
		sizeLabel: '43 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817017112834',
	},
	{
		sizeLabel: '45 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426770344793',
	},
	{
		sizeLabel: '36 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079169251922',
	},
	{
		sizeLabel: '37 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533806623717',
	},
	{
		sizeLabel: '38 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538770307266',
	},
	{
		sizeLabel: '39 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123248768398',
	},
	{
		sizeLabel: '47 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '737153610155',
	},
	{
		sizeLabel: '55-56',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835571709074',
	},
	{
		sizeLabel: '57-58',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303243770940',
	},
	{
		sizeLabel: '59-60',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235158712562',
	},
	{
		sizeLabel: '0-2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366719997021',
	},
	{
		sizeLabel: '28-30 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371883390468',
	},
	{
		sizeLabel: '26-28 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876028196031',
	},
	{
		sizeLabel: '32-34 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237071186002',
	},
	{
		sizeLabel: '32-34 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438158903303',
	},
	{
		sizeLabel: '30-32 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099598447558',
	},
	{
		sizeLabel: '36-38 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127658027010',
	},
	{
		sizeLabel: '34-36 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176430526066',
	},
	{
		sizeLabel: '40-42 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294900344561',
	},
	{
		sizeLabel: '40-42 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085817295883',
	},
	{
		sizeLabel: '38-40 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298977813161',
	},
	{
		sizeLabel: '44-46 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476713174892',
	},
	{
		sizeLabel: '44-46 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208901853272',
	},
	{
		sizeLabel: '42-44 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228589589171',
	},
	{
		sizeLabel: '48-50 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141825095871',
	},
	{
		sizeLabel: '46-48 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127512764973',
	},
	{
		sizeLabel: '24-26 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257962515327',
	},
	{
		sizeLabel: '52-54 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147077239022',
	},
	{
		sizeLabel: '50-52 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249484616112',
	},
	{
		sizeLabel: '56-58 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752202664656',
	},
	{
		sizeLabel: 'S TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164923996621',
	},
	{
		sizeLabel: 'M TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156161731895',
	},
	{
		sizeLabel: 'L TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946201487398',
	},
	{
		sizeLabel: 'XL TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '745390721932',
	},
	{
		sizeLabel: '2XL TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087310593073',
	},
	{
		sizeLabel: 'XXS PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554559370209',
	},
	{
		sizeLabel: 'XS PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549775182451',
	},
	{
		sizeLabel: 'S PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957683215824',
	},
	{
		sizeLabel: 'M PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700263871305',
	},
	{
		sizeLabel: 'L PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730576406835',
	},
	{
		sizeLabel: 'XL PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739600150138',
	},
	{
		sizeLabel: '2XL PETITE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890423108344',
	},
	{
		sizeLabel: '1X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641060230436',
	},
	{
		sizeLabel: 'W14-W16 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996364876085',
	},
	{
		sizeLabel: '2X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289070314694',
	},
	{
		sizeLabel: 'W18-W20 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867823862954',
	},
	{
		sizeLabel: '3X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893407155922',
	},
	{
		sizeLabel: '28-30 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649714280123',
	},
	{
		sizeLabel: '56-58 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888960736035',
	},
	{
		sizeLabel: '54-56 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173802570483',
	},
	{
		sizeLabel: 'W22-W24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199825359839',
	},
	{
		sizeLabel: '60-62 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071983190370',
	},
	{
		sizeLabel: '4X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517407778593',
	},
	{
		sizeLabel: '60-62 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299349420116',
	},
	{
		sizeLabel: '58-60 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016316135974',
	},
	{
		sizeLabel: 'W26-W28 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208414426318',
	},
	{
		sizeLabel: '64-66 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628327105310',
	},
	{
		sizeLabel: '42 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867669331140',
	},
	{
		sizeLabel: '26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997223044389',
	},
	{
		sizeLabel: '28 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '458122593414',
	},
	{
		sizeLabel: '44 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609631565171',
	},
	{
		sizeLabel: '28 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '031701869325',
	},
	{
		sizeLabel: '46 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751431587694',
	},
	{
		sizeLabel: '30 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288954920419',
	},
	{
		sizeLabel: '48 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362785124526',
	},
	{
		sizeLabel: '50 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782605851155',
	},
	{
		sizeLabel: '52 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445039002466',
	},
	{
		sizeLabel: '54 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210541242305',
	},
	{
		sizeLabel: '56 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039694128855',
	},
	{
		sizeLabel: '58 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110566538391',
	},
	{
		sizeLabel: '60 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887497601306',
	},
	{
		sizeLabel: '56 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '850253923737',
	},
	{
		sizeLabel: '62 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607412230401',
	},
	{
		sizeLabel: '62 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487461224510',
	},
	{
		sizeLabel: '2XL-3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810985570411',
	},
	{
		sizeLabel: '58 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215227200506',
	},
	{
		sizeLabel: '64 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831149430990',
	},
	{
		sizeLabel: '48 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932850824657',
	},
	{
		sizeLabel: '64 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206003665661',
	},
	{
		sizeLabel: '60 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368806999033',
	},
	{
		sizeLabel: '66 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601587085231',
	},
	{
		sizeLabel: '50 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '003392388054',
	},
	{
		sizeLabel: '66 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769429485910',
	},
	{
		sizeLabel: '36 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318029787921',
	},
	{
		sizeLabel: '37 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830138659886',
	},
	{
		sizeLabel: '38 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067029063792',
	},
	{
		sizeLabel: '39 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357504506046',
	},
	{
		sizeLabel: '40 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189597714800',
	},
	{
		sizeLabel: '41 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414455410572',
	},
	{
		sizeLabel: '42 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289277060801',
	},
	{
		sizeLabel: '43 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618507466158',
	},
	{
		sizeLabel: '44 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550911157217',
	},
	{
		sizeLabel: '45 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563882883012',
	},
	{
		sizeLabel: '11 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537562735494',
	},
	{
		sizeLabel: '46 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '829523384804',
	},
	{
		sizeLabel: '47 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043427498821',
	},
	{
		sizeLabel: '48 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290888552725',
	},
	{
		sizeLabel: '14 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713579477439',
	},
	{
		sizeLabel: '13 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660576994035',
	},
	{
		sizeLabel: '49 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311691944781',
	},
	{
		sizeLabel: '15 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887402017119',
	},
	{
		sizeLabel: '50 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429602609329',
	},
	{
		sizeLabel: '15 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360215330979',
	},
	{
		sizeLabel: '51 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427415629533',
	},
	{
		sizeLabel: '52 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441220194038',
	},
	{
		sizeLabel: '17 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039746560905',
	},
	{
		sizeLabel: '53 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277074206600',
	},
	{
		sizeLabel: '54 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626752120192',
	},
	{
		sizeLabel: '19 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '242100624190',
	},
	{
		sizeLabel: '55 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764337132908',
	},
	{
		sizeLabel: '3XL TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000959018028',
	},
	{
		sizeLabel: '4XL TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971109040165',
	},
	{
		sizeLabel: 'XS SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825433398995',
	},
	{
		sizeLabel: 'S SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307474246546',
	},
	{
		sizeLabel: 'M SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686988501375',
	},
	{
		sizeLabel: 'L SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985027843120',
	},
	{
		sizeLabel: 'XL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751599546538',
	},
	{
		sizeLabel: '2XL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191221874483',
	},
	{
		sizeLabel: '3XL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379894595310',
	},
	{
		sizeLabel: '16 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885854106566',
	},
	{
		sizeLabel: '1K-3 ½K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038504277884',
	},
	{
		sizeLabel: '4K-5 ½K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743898362158',
	},
	{
		sizeLabel: '6K-7 ½K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074586649535',
	},
	{
		sizeLabel: '8K-10K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015618979756',
	},
	{
		sizeLabel: '10 ½K-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370145294221',
	},
	{
		sizeLabel: '13K-1 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614902336591',
	},
	{
		sizeLabel: '1-2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310006296049',
	},
	{
		sizeLabel: '3-4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333131243176',
	},
	{
		sizeLabel: '1-XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900860965890',
	},
	{
		sizeLabel: '2-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813607108803',
	},
	{
		sizeLabel: '3-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652457245325',
	},
	{
		sizeLabel: '4-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169559182490',
	},
	{
		sizeLabel: '5-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947791751774',
	},
	{
		sizeLabel: '6-XXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029630721435',
	},
	{
		sizeLabel: '0-2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425597072438',
	},
	{
		sizeLabel: '04-06',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715350635229',
	},
	{
		sizeLabel: '08-10',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667475998635',
	},
	{
		sizeLabel: '12-14',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385142539154',
	},
	{
		sizeLabel: '16-18',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044181314687',
	},
	{
		sizeLabel: 'W14',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763031956431',
	},
	{
		sizeLabel: 'W16',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995708309134',
	},
	{
		sizeLabel: 'W18',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964480374759',
	},
	{
		sizeLabel: 'W20',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253807687651',
	},
	{
		sizeLabel: 'W22',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407181133923',
	},
	{
		sizeLabel: 'W24',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264404780107',
	},
	{
		sizeLabel: 'W26',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341675031359',
	},
	{
		sizeLabel: 'W28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741379358950',
	},
	{
		sizeLabel: 'W30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839077545001',
	},
	{
		sizeLabel: '00-0 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521976732152',
	},
	{
		sizeLabel: '6-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998908866793',
	},
	{
		sizeLabel: '10-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '586663902185',
	},
	{
		sizeLabel: '26-28 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238561725005',
	},
	{
		sizeLabel: '29-31 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '092314705522',
	},
	{
		sizeLabel: '32-34 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447040366480',
	},
	{
		sizeLabel: '35-37 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005216862272',
	},
	{
		sizeLabel: '38-40 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057931887462',
	},
	{
		sizeLabel: '41-43 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739918725648',
	},
	{
		sizeLabel: '44-46 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696230595767',
	},
	{
		sizeLabel: '32A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888147179269',
	},
	{
		sizeLabel: '32B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '359818432123',
	},
	{
		sizeLabel: '32C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109153966332',
	},
	{
		sizeLabel: '34A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453654003266',
	},
	{
		sizeLabel: '34B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710378559802',
	},
	{
		sizeLabel: '34C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172375747207',
	},
	{
		sizeLabel: '34D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733793591938',
	},
	{
		sizeLabel: '36A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691231240105',
	},
	{
		sizeLabel: '36B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734283626888',
	},
	{
		sizeLabel: '36C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049044252352',
	},
	{
		sizeLabel: '36D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769923692052',
	},
	{
		sizeLabel: '38D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906395393852',
	},
	{
		sizeLabel: '38C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555088620434',
	},
	{
		sizeLabel: '38DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537331083632',
	},
	{
		sizeLabel: '38D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567638990680',
	},
	{
		sizeLabel: '8 ½-9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559808830158',
	},
	{
		sizeLabel: '10 ½-11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799146575479',
	},
	{
		sizeLabel: '34A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153823968792',
	},
	{
		sizeLabel: '34B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427628195591',
	},
	{
		sizeLabel: '34C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378368374504',
	},
	{
		sizeLabel: '34D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312905563096',
	},
	{
		sizeLabel: '34E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777966083565',
	},
	{
		sizeLabel: '34F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294674062220',
	},
	{
		sizeLabel: '34G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492839386160',
	},
	{
		sizeLabel: '34H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341882025653',
	},
	{
		sizeLabel: '36A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441218511685',
	},
	{
		sizeLabel: '36B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946959113387',
	},
	{
		sizeLabel: '36C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961746167692',
	},
	{
		sizeLabel: '36D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '261832163261',
	},
	{
		sizeLabel: '36E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681806269491',
	},
	{
		sizeLabel: '36F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864693749196',
	},
	{
		sizeLabel: '36G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711757066538',
	},
	{
		sizeLabel: '36H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350267040773',
	},
	{
		sizeLabel: '38A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481337173238',
	},
	{
		sizeLabel: '38B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952797693401',
	},
	{
		sizeLabel: '38C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117903672688',
	},
	{
		sizeLabel: '38D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066437864167',
	},
	{
		sizeLabel: '38E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022287380693',
	},
	{
		sizeLabel: '38F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440792355966',
	},
	{
		sizeLabel: '38G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885943487979',
	},
	{
		sizeLabel: '38H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975603268456',
	},
	{
		sizeLabel: '40A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876512238939',
	},
	{
		sizeLabel: '40B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467659540258',
	},
	{
		sizeLabel: '40C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568244407542',
	},
	{
		sizeLabel: '40D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315204763883',
	},
	{
		sizeLabel: '40E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410133865063',
	},
	{
		sizeLabel: '40F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459924376931',
	},
	{
		sizeLabel: '40G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546104143922',
	},
	{
		sizeLabel: '40H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505888857321',
	},
	{
		sizeLabel: '42A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073217532897',
	},
	{
		sizeLabel: '42B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472875514576',
	},
	{
		sizeLabel: '42C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688473688470',
	},
	{
		sizeLabel: '42D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346013663759',
	},
	{
		sizeLabel: '42E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018099325743',
	},
	{
		sizeLabel: '42F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '006009621123',
	},
	{
		sizeLabel: '42G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117619019748',
	},
	{
		sizeLabel: '42H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691456430340',
	},
	{
		sizeLabel: '44A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295793554626',
	},
	{
		sizeLabel: '44B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600183263246',
	},
	{
		sizeLabel: '44C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832317707499',
	},
	{
		sizeLabel: '44D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406944546268',
	},
	{
		sizeLabel: '44E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410784730028',
	},
	{
		sizeLabel: '44F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924531309964',
	},
	{
		sizeLabel: '44G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049598891474',
	},
	{
		sizeLabel: '44H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381999836857',
	},
	{
		sizeLabel: '46A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '195388621600',
	},
	{
		sizeLabel: '46B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667273204508',
	},
	{
		sizeLabel: '46C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027991313250',
	},
	{
		sizeLabel: '46D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373867347945',
	},
	{
		sizeLabel: '46E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334673887318',
	},
	{
		sizeLabel: '46F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084765899531',
	},
	{
		sizeLabel: '46G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557060384840',
	},
	{
		sizeLabel: '46H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563174782355',
	},
	{
		sizeLabel: '48A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558362131318',
	},
	{
		sizeLabel: '48B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771258125152',
	},
	{
		sizeLabel: '48C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784035842680',
	},
	{
		sizeLabel: '48D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065572480492',
	},
	{
		sizeLabel: '48E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222191770623',
	},
	{
		sizeLabel: '48F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461253588683',
	},
	{
		sizeLabel: '48G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353852523418',
	},
	{
		sizeLabel: '48H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046402110530',
	},
	{
		sizeLabel: '6-8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354336793285',
	},
	{
		sizeLabel: '10-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052831122462',
	},
	{
		sizeLabel: '48 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061696381493',
	},
	{
		sizeLabel: '50 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477670601073',
	},
	{
		sizeLabel: '52 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133967242267',
	},
	{
		sizeLabel: '54 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994333667067',
	},
	{
		sizeLabel: '56 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335807664514',
	},
	{
		sizeLabel: '58 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834320336940',
	},
	{
		sizeLabel: '60 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335355836347',
	},
	{
		sizeLabel: '62 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044652197722',
	},
	{
		sizeLabel: '65F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523999116939',
	},
	{
		sizeLabel: '65G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365263610743',
	},
	{
		sizeLabel: '2 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072939097153',
	},
	{
		sizeLabel: '35 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733149168916',
	},
	{
		sizeLabel: '3 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744205486192',
	},
	{
		sizeLabel: '37 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790911123873',
	},
	{
		sizeLabel: '39 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431473933890',
	},
	{
		sizeLabel: '41 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624692093094',
	},
	{
		sizeLabel: '43 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310060422250',
	},
	{
		sizeLabel: '45 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090192123142',
	},
	{
		sizeLabel: '32 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '731551240044',
	},
	{
		sizeLabel: '30 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823710137070',
	},
	{
		sizeLabel: '32 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288466035126',
	},
	{
		sizeLabel: '34 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027623553157',
	},
	{
		sizeLabel: '36 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739649915634',
	},
	{
		sizeLabel: '38 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335973249517',
	},
	{
		sizeLabel: '40 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '870089494438',
	},
	{
		sizeLabel: '70',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597871165766',
	},
	{
		sizeLabel: '35 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301367244128',
	},
	{
		sizeLabel: '37 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248543952463',
	},
	{
		sizeLabel: '39 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706999838937',
	},
	{
		sizeLabel: '41 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078408199044',
	},
	{
		sizeLabel: '43 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950398142577',
	},
	{
		sizeLabel: '45 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020639407730',
	},
	{
		sizeLabel: '47 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032800626972',
	},
	{
		sizeLabel: '49 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340030770505',
	},
	{
		sizeLabel: '49 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '482447733648',
	},
	{
		sizeLabel: '42-44 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '285644980984',
	},
	{
		sizeLabel: '46-48 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783772500449',
	},
	{
		sizeLabel: '36-38 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102410397723',
	},
	{
		sizeLabel: '40-42 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405592806170',
	},
	{
		sizeLabel: '50-52 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427571722672',
	},
	{
		sizeLabel: '40-42 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683116866100',
	},
	{
		sizeLabel: '54-56 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711808667033',
	},
	{
		sizeLabel: '48-50 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138556277222',
	},
	{
		sizeLabel: '58-60 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071578688189',
	},
	{
		sizeLabel: '48-50 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776610338617',
	},
	{
		sizeLabel: '52-54 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353512797031',
	},
	{
		sizeLabel: '62-64 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753961838620',
	},
	{
		sizeLabel: '62-64 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907290209214',
	},
	{
		sizeLabel: '52-54 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508370680265',
	},
	{
		sizeLabel: '37-38 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015093167240',
	},
	{
		sizeLabel: '37-38 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886285188327',
	},
	{
		sizeLabel: '39-40 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220745415844',
	},
	{
		sizeLabel: '39-40 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477364619303',
	},
	{
		sizeLabel: '41-42 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441379964035',
	},
	{
		sizeLabel: '41-42 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303785774380',
	},
	{
		sizeLabel: '43-44 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686326892149',
	},
	{
		sizeLabel: '43-44 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511034786603',
	},
	{
		sizeLabel: '45-46 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655534987170',
	},
	{
		sizeLabel: '45-46 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947864231093',
	},
	{
		sizeLabel: '47-48 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327553347844',
	},
	{
		sizeLabel: '47-48 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109705444291',
	},
	{
		sizeLabel: '6 ⅜-6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060674142159',
	},
	{
		sizeLabel: '52-53 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797395304366',
	},
	{
		sizeLabel: '52-53 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798542006339',
	},
	{
		sizeLabel: '6 ½-6 ⅝ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311586238625',
	},
	{
		sizeLabel: '6 ⅝-6 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982073844057',
	},
	{
		sizeLabel: '54-55 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598948032388',
	},
	{
		sizeLabel: '54-55 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '150736605149',
	},
	{
		sizeLabel: '6 ¾-6 ⅞ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744001715708',
	},
	{
		sizeLabel: '6 ⅞-7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598234583407',
	},
	{
		sizeLabel: '56-57 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945928444620',
	},
	{
		sizeLabel: '56-57 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382205837731',
	},
	{
		sizeLabel: '7-7 ⅛ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485413253649',
	},
	{
		sizeLabel: '7 ⅛-7 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '645695193170',
	},
	{
		sizeLabel: '58-59 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '892494654475',
	},
	{
		sizeLabel: '58-59 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248124698799',
	},
	{
		sizeLabel: '7 ¼-7 ⅜ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094424201514',
	},
	{
		sizeLabel: '7 ⅜-7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866778188742',
	},
	{
		sizeLabel: '60-61 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775975172023',
	},
	{
		sizeLabel: '60-61 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651716301038',
	},
	{
		sizeLabel: '7 ½-7 ⅝ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546255702784',
	},
	{
		sizeLabel: '7 ⅝-7 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959870236998',
	},
	{
		sizeLabel: '62-63 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943738833307',
	},
	{
		sizeLabel: '62-63 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147317227976',
	},
	{
		sizeLabel: '7 ¾-7 ⅞ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374248455438',
	},
	{
		sizeLabel: '4 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051108670176',
	},
	{
		sizeLabel: '6 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '692776424063',
	},
	{
		sizeLabel: '8 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759827184294',
	},
	{
		sizeLabel: '10 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '497795104253',
	},
	{
		sizeLabel: '12 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361528331385',
	},
	{
		sizeLabel: '42-44 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516448557430',
	},
	{
		sizeLabel: '44-46 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191199476154',
	},
	{
		sizeLabel: '46-48 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '150317093411',
	},
	{
		sizeLabel: 'XXXXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141132016556',
	},
	{
		sizeLabel: '30A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688532288844',
	},
	{
		sizeLabel: '65A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196678986660',
	},
	{
		sizeLabel: '30B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817636028752',
	},
	{
		sizeLabel: '65B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253304472851',
	},
	{
		sizeLabel: '30C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466030702217',
	},
	{
		sizeLabel: '65C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085311165382',
	},
	{
		sizeLabel: '30D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742218053756',
	},
	{
		sizeLabel: '65D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834543391220',
	},
	{
		sizeLabel: '80E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736986861340',
	},
	{
		sizeLabel: '30E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365586217155',
	},
	{
		sizeLabel: '65E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '493477625639',
	},
	{
		sizeLabel: '80F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324542092790',
	},
	{
		sizeLabel: '30F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208190111426',
	},
	{
		sizeLabel: '65F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033966417592',
	},
	{
		sizeLabel: '70A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257168868112',
	},
	{
		sizeLabel: '70B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049429480190',
	},
	{
		sizeLabel: '70C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872667524981',
	},
	{
		sizeLabel: '32D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865471942608',
	},
	{
		sizeLabel: '70D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174680295572',
	},
	{
		sizeLabel: '85E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979239332749',
	},
	{
		sizeLabel: '32E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186967213492',
	},
	{
		sizeLabel: '70E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715340802000',
	},
	{
		sizeLabel: '85F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210061256084',
	},
	{
		sizeLabel: '32F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235165001646',
	},
	{
		sizeLabel: '70F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209843911924',
	},
	{
		sizeLabel: '75A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '615296197576',
	},
	{
		sizeLabel: '75B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110256038135',
	},
	{
		sizeLabel: '75C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073950615029',
	},
	{
		sizeLabel: '75D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643126154239',
	},
	{
		sizeLabel: '34E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174564080515',
	},
	{
		sizeLabel: '75E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722952379236',
	},
	{
		sizeLabel: '34F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324249218007',
	},
	{
		sizeLabel: '75F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '194395381456',
	},
	{
		sizeLabel: '80A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833296003414',
	},
	{
		sizeLabel: '80B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158690335940',
	},
	{
		sizeLabel: '80C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660916664097',
	},
	{
		sizeLabel: '80D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297659426913',
	},
	{
		sizeLabel: '36E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515677292990',
	},
	{
		sizeLabel: '80E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963195583030',
	},
	{
		sizeLabel: '36F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887454100057',
	},
	{
		sizeLabel: '80F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132152858723',
	},
	{
		sizeLabel: '38A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231603661369',
	},
	{
		sizeLabel: '85A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487728469544',
	},
	{
		sizeLabel: '38B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028591503073',
	},
	{
		sizeLabel: '85B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252651240678',
	},
	{
		sizeLabel: '85C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799650636339',
	},
	{
		sizeLabel: '85D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007389760511',
	},
	{
		sizeLabel: '38E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079560421852',
	},
	{
		sizeLabel: '85E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388079160850',
	},
	{
		sizeLabel: '38F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329638993587',
	},
	{
		sizeLabel: '85F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019127191970',
	},
	{
		sizeLabel: '105A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634021988149',
	},
	{
		sizeLabel: '40A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640065923476',
	},
	{
		sizeLabel: '90A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598790038934',
	},
	{
		sizeLabel: '40B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922042305396',
	},
	{
		sizeLabel: '90B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084979537926',
	},
	{
		sizeLabel: '40C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515733212159',
	},
	{
		sizeLabel: '90C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934867972186',
	},
	{
		sizeLabel: '40D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135270020219',
	},
	{
		sizeLabel: '90D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166035056756',
	},
	{
		sizeLabel: '40E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456891428795',
	},
	{
		sizeLabel: '90E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276043741605',
	},
	{
		sizeLabel: '40F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232855431208',
	},
	{
		sizeLabel: '90F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265156895131',
	},
	{
		sizeLabel: '110A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347910167510',
	},
	{
		sizeLabel: '42A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008535289007',
	},
	{
		sizeLabel: '95A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449337817842',
	},
	{
		sizeLabel: '42B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992938956749',
	},
	{
		sizeLabel: '95B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265039877120',
	},
	{
		sizeLabel: '42C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757600206747',
	},
	{
		sizeLabel: '95C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079564228923',
	},
	{
		sizeLabel: '42D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350763042346',
	},
	{
		sizeLabel: '95D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985232803406',
	},
	{
		sizeLabel: '42E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340215374435',
	},
	{
		sizeLabel: '95E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '670463139584',
	},
	{
		sizeLabel: '42F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048581893684',
	},
	{
		sizeLabel: '95F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440012082234',
	},
	{
		sizeLabel: '115A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477034722740',
	},
	{
		sizeLabel: '44A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453000998400',
	},
	{
		sizeLabel: '100A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188064315223',
	},
	{
		sizeLabel: '44B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '359297348071',
	},
	{
		sizeLabel: '100B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676870192382',
	},
	{
		sizeLabel: '44C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205935125993',
	},
	{
		sizeLabel: '100C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678552765616',
	},
	{
		sizeLabel: '44D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145298713562',
	},
	{
		sizeLabel: '100D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651777548131',
	},
	{
		sizeLabel: '44E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717889279452',
	},
	{
		sizeLabel: '100E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120130578445',
	},
	{
		sizeLabel: '44F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499410171119',
	},
	{
		sizeLabel: '100F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771327590283',
	},
	{
		sizeLabel: '41 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761189426697',
	},
	{
		sizeLabel: '46 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597931898051',
	},
	{
		sizeLabel: '14 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574076033654',
	},
	{
		sizeLabel: '16 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248115946535',
	},
	{
		sizeLabel: '18 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706688858664',
	},
	{
		sizeLabel: '20 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '627819381831',
	},
	{
		sizeLabel: '22 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591520793406',
	},
	{
		sizeLabel: '35 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754997409759',
	},
	{
		sizeLabel: '35 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951168284206',
	},
	{
		sizeLabel: '22 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656533764432',
	},
	{
		sizeLabel: '36 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '258659721698',
	},
	{
		sizeLabel: '36 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696010960250',
	},
	{
		sizeLabel: '23 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409694644478',
	},
	{
		sizeLabel: '24 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117433298971',
	},
	{
		sizeLabel: '38 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '359273186604',
	},
	{
		sizeLabel: '38 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671669125958',
	},
	{
		sizeLabel: '25 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562502628440',
	},
	{
		sizeLabel: '49 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709567539836',
	},
	{
		sizeLabel: '26 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349491200413',
	},
	{
		sizeLabel: '1 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '454429108845',
	},
	{
		sizeLabel: '35 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643765793314',
	},
	{
		sizeLabel: '34 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170844435954',
	},
	{
		sizeLabel: '21 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067254537220',
	},
	{
		sizeLabel: '215 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431499661072',
	},
	{
		sizeLabel: '220-88 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505527827388',
	},
	{
		sizeLabel: '220 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '588566759490',
	},
	{
		sizeLabel: '225-88 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201319318633',
	},
	{
		sizeLabel: '225 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184628957227',
	},
	{
		sizeLabel: '225-89 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '092038658249',
	},
	{
		sizeLabel: '230-90 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453471298964',
	},
	{
		sizeLabel: '230-91 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052501631514',
	},
	{
		sizeLabel: '240 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930735495927',
	},
	{
		sizeLabel: '235-91 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605073505598',
	},
	{
		sizeLabel: '37 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985014167575',
	},
	{
		sizeLabel: '235-92 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583415408116',
	},
	{
		sizeLabel: '240-93 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160198450610',
	},
	{
		sizeLabel: '240-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824493936027',
	},
	{
		sizeLabel: '245-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096906877821',
	},
	{
		sizeLabel: '39 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075187271192',
	},
	{
		sizeLabel: '245-95 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592005266829',
	},
	{
		sizeLabel: '250-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146505286180',
	},
	{
		sizeLabel: '40 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265397160152',
	},
	{
		sizeLabel: '27 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859270829791',
	},
	{
		sizeLabel: '275 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565946694057',
	},
	{
		sizeLabel: '255-97 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098708937419',
	},
	{
		sizeLabel: '41 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198948252367',
	},
	{
		sizeLabel: '28 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864579203258',
	},
	{
		sizeLabel: '285 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294515764299',
	},
	{
		sizeLabel: '255-98 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750092971938',
	},
	{
		sizeLabel: '43 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238575438023',
	},
	{
		sizeLabel: '5-5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128279013436',
	},
	{
		sizeLabel: '39-39 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453420742790',
	},
	{
		sizeLabel: '6-6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159251888296',
	},
	{
		sizeLabel: '6-6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184724034911',
	},
	{
		sizeLabel: '40-40 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328920066555',
	},
	{
		sizeLabel: '7-7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542078296684',
	},
	{
		sizeLabel: '7-7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249539636246',
	},
	{
		sizeLabel: '41-41 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075697261679',
	},
	{
		sizeLabel: '8-8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599540832229',
	},
	{
		sizeLabel: '8-8 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086017818513',
	},
	{
		sizeLabel: '42-42 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935390562684',
	},
	{
		sizeLabel: '9-9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707482397641',
	},
	{
		sizeLabel: '9-9 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191959135351',
	},
	{
		sizeLabel: '10-10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583036286551',
	},
	{
		sizeLabel: '10-10 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683036412329',
	},
	{
		sizeLabel: '44-44 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724564291634',
	},
	{
		sizeLabel: '11-11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077688170505',
	},
	{
		sizeLabel: '2-2 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204511061581',
	},
	{
		sizeLabel: '35-35 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477054328383',
	},
	{
		sizeLabel: '5-5 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298246569894',
	},
	{
		sizeLabel: '3-3 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459386123372',
	},
	{
		sizeLabel: '36-36 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054875778130',
	},
	{
		sizeLabel: '4-4 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677872810916',
	},
	{
		sizeLabel: '37-37 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402338489012',
	},
	{
		sizeLabel: '38-38 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878779569490',
	},
	{
		sizeLabel: '9 ½-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032759912837',
	},
	{
		sizeLabel: '11 ½-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958803038774',
	},
	{
		sizeLabel: '62 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690628234552',
	},
	{
		sizeLabel: '1 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '296218487761',
	},
	{
		sizeLabel: '210 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529798188424',
	},
	{
		sizeLabel: '34 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440757839205',
	},
	{
		sizeLabel: '42 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479690498425',
	},
	{
		sizeLabel: '43 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208649303335',
	},
	{
		sizeLabel: '29 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319982314060',
	},
	{
		sizeLabel: '295 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689102840231',
	},
	{
		sizeLabel: '44 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739265829098',
	},
	{
		sizeLabel: '30 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801701006727',
	},
	{
		sizeLabel: '305 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319159857587',
	},
	{
		sizeLabel: '31 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640792820347',
	},
	{
		sizeLabel: '310 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542563116825',
	},
	{
		sizeLabel: '45 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254015918808',
	},
	{
		sizeLabel: '31 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749831746044',
	},
	{
		sizeLabel: '315 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537800717376',
	},
	{
		sizeLabel: '32 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346339600032',
	},
	{
		sizeLabel: '320 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654241157639',
	},
	{
		sizeLabel: '46 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470848159611',
	},
	{
		sizeLabel: '32 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028429304242',
	},
	{
		sizeLabel: '325 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995654352073',
	},
	{
		sizeLabel: '47 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888880901166',
	},
	{
		sizeLabel: '33 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518060070502',
	},
	{
		sizeLabel: '330 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881650283628',
	},
	{
		sizeLabel: '47 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613172431045',
	},
	{
		sizeLabel: '33 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179350973926',
	},
	{
		sizeLabel: '335 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904424696528',
	},
	{
		sizeLabel: '34 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943195961463',
	},
	{
		sizeLabel: '340 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908741541227',
	},
	{
		sizeLabel: 'XL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '844806459865',
	},
	{
		sizeLabel: 'XXL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915107109735',
	},
	{
		sizeLabel: 'XXXL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628702041200',
	},
	{
		sizeLabel: '35-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082959860435',
	},
	{
		sizeLabel: '36-37',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144534601929',
	},
	{
		sizeLabel: '37-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487637699577',
	},
	{
		sizeLabel: '64 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637471072016',
	},
	{
		sizeLabel: '66 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418226547610',
	},
	{
		sizeLabel: '68 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279560689834',
	},
	{
		sizeLabel: '70 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968447347474',
	},
	{
		sizeLabel: '40 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398197546706',
	},
	{
		sizeLabel: '42 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310886381253',
	},
	{
		sizeLabel: '44 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504479633548',
	},
	{
		sizeLabel: '46 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069001232506',
	},
	{
		sizeLabel: '48 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '180161174998',
	},
	{
		sizeLabel: '50 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753253383942',
	},
	{
		sizeLabel: '52 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160475288721',
	},
	{
		sizeLabel: '54 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011378454372',
	},
	{
		sizeLabel: '56 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431337685498',
	},
	{
		sizeLabel: '58 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451352846313',
	},
	{
		sizeLabel: '60 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888618910490',
	},
	{
		sizeLabel: '62 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103703429319',
	},
	{
		sizeLabel: '64 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869778630237',
	},
	{
		sizeLabel: '66 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604977122803',
	},
	{
		sizeLabel: '68 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340928031634',
	},
	{
		sizeLabel: '56 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612322650293',
	},
	{
		sizeLabel: '65H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631342061613',
	},
	{
		sizeLabel: '65I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887575269134',
	},
	{
		sizeLabel: '65J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '745354767874',
	},
	{
		sizeLabel: '65K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840365703619',
	},
	{
		sizeLabel: '65L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781229099042',
	},
	{
		sizeLabel: '65M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547511153638',
	},
	{
		sizeLabel: '70I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546992113971',
	},
	{
		sizeLabel: '70J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417221295236',
	},
	{
		sizeLabel: '70K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352773551070',
	},
	{
		sizeLabel: '70L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909076311960',
	},
	{
		sizeLabel: '70M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197324155488',
	},
	{
		sizeLabel: '75I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033881172063',
	},
	{
		sizeLabel: '75J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650324663179',
	},
	{
		sizeLabel: '75K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123361584481',
	},
	{
		sizeLabel: '75L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812278625865',
	},
	{
		sizeLabel: '75M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937873977436',
	},
	{
		sizeLabel: '80I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177889051760',
	},
	{
		sizeLabel: '80J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650485145247',
	},
	{
		sizeLabel: '80K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330379282437',
	},
	{
		sizeLabel: '80L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834962848315',
	},
	{
		sizeLabel: '80M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196026476980',
	},
	{
		sizeLabel: '85I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813230593943',
	},
	{
		sizeLabel: '85J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299684426630',
	},
	{
		sizeLabel: '85K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990988773837',
	},
	{
		sizeLabel: '85L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664273764079',
	},
	{
		sizeLabel: '85M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292222028756',
	},
	{
		sizeLabel: '90I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758734125602',
	},
	{
		sizeLabel: '90J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089375207499',
	},
	{
		sizeLabel: '90K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257802449105',
	},
	{
		sizeLabel: '90L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239652515044',
	},
	{
		sizeLabel: '90M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202161431663',
	},
	{
		sizeLabel: '95I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005216920920',
	},
	{
		sizeLabel: '95J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155149190548',
	},
	{
		sizeLabel: '95K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758225075521',
	},
	{
		sizeLabel: '95L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364240338891',
	},
	{
		sizeLabel: '95M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222535943529',
	},
	{
		sizeLabel: '100I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137179753885',
	},
	{
		sizeLabel: '100J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044784265921',
	},
	{
		sizeLabel: '100K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840936164983',
	},
	{
		sizeLabel: '100L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '245659892303',
	},
	{
		sizeLabel: '105I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570977865574',
	},
	{
		sizeLabel: '105J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505578624152',
	},
	{
		sizeLabel: '105K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064170469572',
	},
	{
		sizeLabel: '110I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691792548146',
	},
	{
		sizeLabel: '110J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635983949413',
	},
	{
		sizeLabel: '115G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801818767736',
	},
	{
		sizeLabel: '115H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956215900036',
	},
	{
		sizeLabel: '115I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521143909118',
	},
	{
		sizeLabel: '120A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895651584587',
	},
	{
		sizeLabel: '120B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517959858879',
	},
	{
		sizeLabel: '120C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915544523175',
	},
	{
		sizeLabel: '120D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560249910112',
	},
	{
		sizeLabel: '120E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172277987296',
	},
	{
		sizeLabel: '120F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889791625083',
	},
	{
		sizeLabel: '120G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730427792364',
	},
	{
		sizeLabel: '120H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587965433966',
	},
	{
		sizeLabel: '4 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '111834842385',
	},
	{
		sizeLabel: '225 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715781030863',
	},
	{
		sizeLabel: '5 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '454391564732',
	},
	{
		sizeLabel: '230 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777351475147',
	},
	{
		sizeLabel: '6 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572560494985',
	},
	{
		sizeLabel: '235 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '552739125494',
	},
	{
		sizeLabel: '7 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317758643352',
	},
	{
		sizeLabel: '240 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556249226754',
	},
	{
		sizeLabel: '8 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286881969339',
	},
	{
		sizeLabel: '245 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964414834123',
	},
	{
		sizeLabel: '9 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398290412124',
	},
	{
		sizeLabel: '250 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761376711708',
	},
	{
		sizeLabel: '10 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887045558358',
	},
	{
		sizeLabel: '255 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609764293750',
	},
	{
		sizeLabel: '7 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649570778009',
	},
	{
		sizeLabel: '260 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371002054975',
	},
	{
		sizeLabel: '9 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336191072638',
	},
	{
		sizeLabel: '265 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '323265950955',
	},
	{
		sizeLabel: '270 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397405063827',
	},
	{
		sizeLabel: '11 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378636969247',
	},
	{
		sizeLabel: '275 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597216441828',
	},
	{
		sizeLabel: '280 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249745209607',
	},
	{
		sizeLabel: '33 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973935788147',
	},
	{
		sizeLabel: '33 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115377279080',
	},
	{
		sizeLabel: '3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533613151589',
	},
	{
		sizeLabel: '2 ⅓ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021355796673',
	},
	{
		sizeLabel: '3 ⅔ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112486867435',
	},
	{
		sizeLabel: '3 ⅔ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '949511601425',
	},
	{
		sizeLabel: '5 ⅓ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386991849110',
	},
	{
		sizeLabel: '5 ⅓ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583238062241',
	},
	{
		sizeLabel: '6 ⅔ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973946575787',
	},
	{
		sizeLabel: '7 ⅔ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782742111383',
	},
	{
		sizeLabel: '9 ⅓ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '716474402392',
	},
	{
		sizeLabel: '9 ⅓ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806429876670',
	},
	{
		sizeLabel: '10 ⅔ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967749249286',
	},
	{
		sizeLabel: '11 ⅔ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374768640336',
	},
	{
		sizeLabel: '5 ⅔ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858633791658',
	},
	{
		sizeLabel: '8 ⅓ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543615417890',
	},
	{
		sizeLabel: '9 ⅔ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095998121189',
	},
	{
		sizeLabel: '12 ⅓ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276333866702',
	},
	{
		sizeLabel: '13 ⅓ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429314891190',
	},
	{
		sizeLabel: '13 ⅔ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '735787580183',
	},
	{
		sizeLabel: '58-60',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177893206246',
	},
	{
		sizeLabel: '35-38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685093806129',
	},
	{
		sizeLabel: '39-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507202057352',
	},
	{
		sizeLabel: '43-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897500443005',
	},
	{
		sizeLabel: '64 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120630278909',
	},
	{
		sizeLabel: 'P-XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748599245916',
	},
	{
		sizeLabel: '32E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446481555716',
	},
	{
		sizeLabel: '2E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878555565889',
	},
	{
		sizeLabel: '32F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605491800415',
	},
	{
		sizeLabel: '2F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '377379657177',
	},
	{
		sizeLabel: '32G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891714761386',
	},
	{
		sizeLabel: '85G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736571009118',
	},
	{
		sizeLabel: '2G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '772523917652',
	},
	{
		sizeLabel: '34E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596611711722',
	},
	{
		sizeLabel: '3E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212962740349',
	},
	{
		sizeLabel: '34F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547616720790',
	},
	{
		sizeLabel: '3F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939742297821',
	},
	{
		sizeLabel: '34G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334853865846',
	},
	{
		sizeLabel: '90G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925128106365',
	},
	{
		sizeLabel: '3G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467018737504',
	},
	{
		sizeLabel: '4A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393334713858',
	},
	{
		sizeLabel: '4B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324517931035',
	},
	{
		sizeLabel: '4C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175510073490',
	},
	{
		sizeLabel: '4D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927090103266',
	},
	{
		sizeLabel: '36E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702789368513',
	},
	{
		sizeLabel: '4E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366968383716',
	},
	{
		sizeLabel: '36F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743691091548',
	},
	{
		sizeLabel: '4F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635806138545',
	},
	{
		sizeLabel: '36G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524660767513',
	},
	{
		sizeLabel: '95G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650593698367',
	},
	{
		sizeLabel: '4G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643425230469',
	},
	{
		sizeLabel: '38A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009376849235',
	},
	{
		sizeLabel: '5A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578865709903',
	},
	{
		sizeLabel: '38B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170119947184',
	},
	{
		sizeLabel: '5B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999736138412',
	},
	{
		sizeLabel: '38C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743346291399',
	},
	{
		sizeLabel: '5C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819080468527',
	},
	{
		sizeLabel: '5D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705621722960',
	},
	{
		sizeLabel: '38E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088797622276',
	},
	{
		sizeLabel: '5E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706321450808',
	},
	{
		sizeLabel: '38F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314314561659',
	},
	{
		sizeLabel: '5F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884166601880',
	},
	{
		sizeLabel: '38G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374983083690',
	},
	{
		sizeLabel: '100G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077649785798',
	},
	{
		sizeLabel: '5G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998494151839',
	},
	{
		sizeLabel: '40D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554471739050',
	},
	{
		sizeLabel: '6D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680564843062',
	},
	{
		sizeLabel: '40E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033270661270',
	},
	{
		sizeLabel: '6E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383067883577',
	},
	{
		sizeLabel: '40F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232262526327',
	},
	{
		sizeLabel: '6F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305276415738',
	},
	{
		sizeLabel: '40G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734655280477',
	},
	{
		sizeLabel: '105G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612325724864',
	},
	{
		sizeLabel: '6G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351546374082',
	},
	{
		sizeLabel: 'XS (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '387402821803',
	},
	{
		sizeLabel: '1 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720511745600',
	},
	{
		sizeLabel: 'S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613387596212',
	},
	{
		sizeLabel: '2 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629747011667',
	},
	{
		sizeLabel: 'M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875532443704',
	},
	{
		sizeLabel: '3 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517128020567',
	},
	{
		sizeLabel: 'L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345006487635',
	},
	{
		sizeLabel: '4 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224514790583',
	},
	{
		sizeLabel: 'XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651739686511',
	},
	{
		sizeLabel: '5 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470599006227',
	},
	{
		sizeLabel: 'XXL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900107531168',
	},
	{
		sizeLabel: '6 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794310506836',
	},
	{
		sizeLabel: '22 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649640258434',
	},
	{
		sizeLabel: '5 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706840110860',
	},
	{
		sizeLabel: '220(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136221370750',
	},
	{
		sizeLabel: '23 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277540150676',
	},
	{
		sizeLabel: '6 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875784593068',
	},
	{
		sizeLabel: '230(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957904080501',
	},
	{
		sizeLabel: '23 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686604859904',
	},
	{
		sizeLabel: '6 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694489432487',
	},
	{
		sizeLabel: '235(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383534468120',
	},
	{
		sizeLabel: '24 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354480248529',
	},
	{
		sizeLabel: '7 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958333956953',
	},
	{
		sizeLabel: '240(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182259903061',
	},
	{
		sizeLabel: '24 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672226751691',
	},
	{
		sizeLabel: '7 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985972127241',
	},
	{
		sizeLabel: '245(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '645086347528',
	},
	{
		sizeLabel: '25 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409805698598',
	},
	{
		sizeLabel: '8 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805263366305',
	},
	{
		sizeLabel: '250(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704437643403',
	},
	{
		sizeLabel: '8 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701853044079',
	},
	{
		sizeLabel: '255(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185049369246',
	},
	{
		sizeLabel: '26 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '647901658265',
	},
	{
		sizeLabel: '9 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051024475038',
	},
	{
		sizeLabel: '260(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477239510062',
	},
	{
		sizeLabel: '26 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262609335562',
	},
	{
		sizeLabel: '9 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206023486126',
	},
	{
		sizeLabel: '265 (1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602534923373',
	},
	{
		sizeLabel: '27 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '142392181386',
	},
	{
		sizeLabel: '10 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304749185818',
	},
	{
		sizeLabel: '270 (1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276385561757',
	},
	{
		sizeLabel: '28 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319834296653',
	},
	{
		sizeLabel: '11 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520283127248',
	},
	{
		sizeLabel: '280(1 ½) (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164462969027',
	},
	{
		sizeLabel: '251 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505999065241',
	},
	{
		sizeLabel: '257 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232073978678',
	},
	{
		sizeLabel: '264 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684698905505',
	},
	{
		sizeLabel: '267 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233197957325',
	},
	{
		sizeLabel: '28 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630602041210',
	},
	{
		sizeLabel: '29 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389488548238',
	},
	{
		sizeLabel: '273 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396298828349',
	},
	{
		sizeLabel: '29 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881574849498',
	},
	{
		sizeLabel: '10 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805976067841',
	},
	{
		sizeLabel: '276 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257710450315',
	},
	{
		sizeLabel: '30 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263023045852',
	},
	{
		sizeLabel: '285 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201373635901',
	},
	{
		sizeLabel: '283 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136238447020',
	},
	{
		sizeLabel: '31 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753106607251',
	},
	{
		sizeLabel: '12 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416948509370',
	},
	{
		sizeLabel: '289 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116637916223',
	},
	{
		sizeLabel: '32 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315125577405',
	},
	{
		sizeLabel: '13 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248135759939',
	},
	{
		sizeLabel: '305 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598392206041',
	},
	{
		sizeLabel: '33 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803146226383',
	},
	{
		sizeLabel: '14 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547443107496',
	},
	{
		sizeLabel: '310 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247038496303',
	},
	{
		sizeLabel: 'XXCH (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241653585098',
	},
	{
		sizeLabel: 'TTP (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177034338420',
	},
	{
		sizeLabel: '150-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050877980318',
	},
	{
		sizeLabel: 'EXCH (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846227317507',
	},
	{
		sizeLabel: 'TP (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810278721297',
	},
	{
		sizeLabel: '155-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451119444029',
	},
	{
		sizeLabel: 'CH (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921367694720',
	},
	{
		sizeLabel: 'P (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052057201668',
	},
	{
		sizeLabel: 'M (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028433277390',
	},
	{
		sizeLabel: 'M (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809124410701',
	},
	{
		sizeLabel: 'G (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962000195043',
	},
	{
		sizeLabel: 'G (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455461568597',
	},
	{
		sizeLabel: '170-100A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991266614005',
	},
	{
		sizeLabel: 'EXG (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453970198614',
	},
	{
		sizeLabel: 'TG (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '268237738151',
	},
	{
		sizeLabel: '175-108A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944129026313',
	},
	{
		sizeLabel: 'XXG (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764555197509',
	},
	{
		sizeLabel: 'TXG (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448171732916',
	},
	{
		sizeLabel: '180-112A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030895080232',
	},
	{
		sizeLabel: '165-60A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001969707839',
	},
	{
		sizeLabel: '160-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550163470741',
	},
	{
		sizeLabel: 'M ALTO (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825993511171',
	},
	{
		sizeLabel: 'MTE (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364353442600',
	},
	{
		sizeLabel: '175-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279466449865',
	},
	{
		sizeLabel: '175-112A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012490076771',
	},
	{
		sizeLabel: 'G ALTO (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694860069216',
	},
	{
		sizeLabel: 'GTE (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005140715919',
	},
	{
		sizeLabel: '180-120A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715315417752',
	},
	{
		sizeLabel: 'EXG ALTO (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '595559102739',
	},
	{
		sizeLabel: 'TGTE (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '338494252401',
	},
	{
		sizeLabel: '185-120A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522266571478',
	},
	{
		sizeLabel: 'XXXG (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960140006319',
	},
	{
		sizeLabel: 'TTTG (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012187185482',
	},
	{
		sizeLabel: '185-128A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459046185441',
	},
	{
		sizeLabel: 'TTG (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159667554271',
	},
	{
		sizeLabel: '190-136A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790763048668',
	},
	{
		sizeLabel: '0 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906601787096',
	},
	{
		sizeLabel: '0 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483510660382',
	},
	{
		sizeLabel: '- (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699592879632',
	},
	{
		sizeLabel: '- (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101807058360',
	},
	{
		sizeLabel: '2 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123266664179',
	},
	{
		sizeLabel: '2 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732971116758',
	},
	{
		sizeLabel: '4 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450675286090',
	},
	{
		sizeLabel: '4 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431538462372',
	},
	{
		sizeLabel: '6 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404364844121',
	},
	{
		sizeLabel: '8 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862676869111',
	},
	{
		sizeLabel: '10 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677934060068',
	},
	{
		sizeLabel: '12 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626986558015',
	},
	{
		sizeLabel: '14 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637367836072',
	},
	{
		sizeLabel: '16 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345344713567',
	},
	{
		sizeLabel: '16 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171613890375',
	},
	{
		sizeLabel: '18 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032797601645',
	},
	{
		sizeLabel: '18 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '287227984824',
	},
	{
		sizeLabel: '000 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563508633959',
	},
	{
		sizeLabel: '000SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761512627248',
	},
	{
		sizeLabel: '000 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118653727166',
	},
	{
		sizeLabel: '000 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325711157053',
	},
	{
		sizeLabel: '000 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109487324497',
	},
	{
		sizeLabel: '00 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460353667108',
	},
	{
		sizeLabel: '00SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413913252972',
	},
	{
		sizeLabel: '00 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862797632952',
	},
	{
		sizeLabel: '00 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '242604032888',
	},
	{
		sizeLabel: '00 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999360562382',
	},
	{
		sizeLabel: '0 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767791825645',
	},
	{
		sizeLabel: '0SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960694789047',
	},
	{
		sizeLabel: '0 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270256942064',
	},
	{
		sizeLabel: '0 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995915855433',
	},
	{
		sizeLabel: '0 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121486568808',
	},
	{
		sizeLabel: '2 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284380285855',
	},
	{
		sizeLabel: '2SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404672712190',
	},
	{
		sizeLabel: '2 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795373440860',
	},
	{
		sizeLabel: '2 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289564911014',
	},
	{
		sizeLabel: '2 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317660934793',
	},
	{
		sizeLabel: '4 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019711429785',
	},
	{
		sizeLabel: '4SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301588919353',
	},
	{
		sizeLabel: '4 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '316403700686',
	},
	{
		sizeLabel: '4 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352940511687',
	},
	{
		sizeLabel: '4 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626077040659',
	},
	{
		sizeLabel: '6 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707476588138',
	},
	{
		sizeLabel: '6SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490221008975',
	},
	{
		sizeLabel: '6 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974064746126',
	},
	{
		sizeLabel: '6 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589857321635',
	},
	{
		sizeLabel: '6 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393232579926',
	},
	{
		sizeLabel: '8 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693262478370',
	},
	{
		sizeLabel: '8SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919493912462',
	},
	{
		sizeLabel: '8 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264522810210',
	},
	{
		sizeLabel: '8 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235197117324',
	},
	{
		sizeLabel: '8 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319147758050',
	},
	{
		sizeLabel: '10 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112599530854',
	},
	{
		sizeLabel: '10SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933260055756',
	},
	{
		sizeLabel: '10 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324452694079',
	},
	{
		sizeLabel: '10 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214541407833',
	},
	{
		sizeLabel: '10 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391243762480',
	},
	{
		sizeLabel: '12 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069597764795',
	},
	{
		sizeLabel: '12SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683470150385',
	},
	{
		sizeLabel: '12 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770328054293',
	},
	{
		sizeLabel: '12 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283208680105',
	},
	{
		sizeLabel: '12 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '444188274380',
	},
	{
		sizeLabel: '14 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306012038496',
	},
	{
		sizeLabel: '14SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726657798255',
	},
	{
		sizeLabel: '14 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980427320992',
	},
	{
		sizeLabel: '14 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470133924748',
	},
	{
		sizeLabel: '14 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046931614694',
	},
	{
		sizeLabel: '16 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755127480472',
	},
	{
		sizeLabel: '16SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487327495632',
	},
	{
		sizeLabel: '16 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172259267664',
	},
	{
		sizeLabel: '16 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292062766620',
	},
	{
		sizeLabel: '16 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659912107687',
	},
	{
		sizeLabel: '18 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891435735412',
	},
	{
		sizeLabel: '18SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350244491255',
	},
	{
		sizeLabel: '18 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '302158225679',
	},
	{
		sizeLabel: '18 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210168190268',
	},
	{
		sizeLabel: '18 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528596551982',
	},
	{
		sizeLabel: '20 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835769959022',
	},
	{
		sizeLabel: '20SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255538710744',
	},
	{
		sizeLabel: '20 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492794222877',
	},
	{
		sizeLabel: '20 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589840762047',
	},
	{
		sizeLabel: '20 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440207667461',
	},
	{
		sizeLabel: '22 X-SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367061838370',
	},
	{
		sizeLabel: '22SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653261673916',
	},
	{
		sizeLabel: '22 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370757366352',
	},
	{
		sizeLabel: '22 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '615124079938',
	},
	{
		sizeLabel: '22 X-LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677363329015',
	},
	{
		sizeLabel: '40-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '369526195585',
	},
	{
		sizeLabel: '40-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640130414854',
	},
	{
		sizeLabel: '40-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958326894530',
	},
	{
		sizeLabel: '42-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084759299412',
	},
	{
		sizeLabel: '42-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155269643042',
	},
	{
		sizeLabel: '44-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954634894099',
	},
	{
		sizeLabel: '44-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943574949641',
	},
	{
		sizeLabel: '46-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499838316844',
	},
	{
		sizeLabel: '48-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248534868450',
	},
	{
		sizeLabel: '30-32 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914712636798',
	},
	{
		sizeLabel: '26-28 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767345207400',
	},
	{
		sizeLabel: '38-40 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278899779274',
	},
	{
		sizeLabel: '34-36 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253835052170',
	},
	{
		sizeLabel: '29-31 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192524141060',
	},
	{
		sizeLabel: '42-44 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212512676428',
	},
	{
		sizeLabel: '38-42 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742265094508',
	},
	{
		sizeLabel: '46-50 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199798372462',
	},
	{
		sizeLabel: '32-34 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818479042733',
	},
	{
		sizeLabel: '46-50 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126081515342',
	},
	{
		sizeLabel: '52-54 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551300522187',
	},
	{
		sizeLabel: '36-38 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789935571870',
	},
	{
		sizeLabel: '52-54 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492696501750',
	},
	{
		sizeLabel: '56-58 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951375505411',
	},
	{
		sizeLabel: '40-42 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120670490822',
	},
	{
		sizeLabel: '56-58 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288212527557',
	},
	{
		sizeLabel: '44 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159534751172',
	},
	{
		sizeLabel: '60 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143421639050',
	},
	{
		sizeLabel: '46 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190941286503',
	},
	{
		sizeLabel: '62 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730372840176',
	},
	{
		sizeLabel: '38-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300677281973',
	},
	{
		sizeLabel: '175-78A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505794449729',
	},
	{
		sizeLabel: '175-82A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507048949269',
	},
	{
		sizeLabel: '175-86A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259706456824',
	},
	{
		sizeLabel: '180-90A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528133201476',
	},
	{
		sizeLabel: '180-98A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871146467104',
	},
	{
		sizeLabel: '185-102A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787261972263',
	},
	{
		sizeLabel: '150-76A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000007203597',
	},
	{
		sizeLabel: '165-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025613675225',
	},
	{
		sizeLabel: '170-92A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378031260663',
	},
	{
		sizeLabel: '52 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168843788467',
	},
	{
		sizeLabel: '54 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732318718916',
	},
	{
		sizeLabel: '56 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388507411098',
	},
	{
		sizeLabel: '58 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973426708761',
	},
	{
		sizeLabel: '180-94A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791113944468',
	},
	{
		sizeLabel: '65AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206934114200',
	},
	{
		sizeLabel: '30AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154064357972',
	},
	{
		sizeLabel: '30DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468782905616',
	},
	{
		sizeLabel: '30DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853670929525',
	},
	{
		sizeLabel: '30G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563749984187',
	},
	{
		sizeLabel: '32AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910081645608',
	},
	{
		sizeLabel: '32DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515436650932',
	},
	{
		sizeLabel: '32DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724584608049',
	},
	{
		sizeLabel: '32G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251464983401',
	},
	{
		sizeLabel: '75AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044534902664',
	},
	{
		sizeLabel: '34AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '269854402019',
	},
	{
		sizeLabel: '34DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347439775522',
	},
	{
		sizeLabel: '34DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '261613163224',
	},
	{
		sizeLabel: '34G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673163434651',
	},
	{
		sizeLabel: '80AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162699078008',
	},
	{
		sizeLabel: '36AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749687576093',
	},
	{
		sizeLabel: '36DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342918671973',
	},
	{
		sizeLabel: '36DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182783156477',
	},
	{
		sizeLabel: '36G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463475486849',
	},
	{
		sizeLabel: '85AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094995173495',
	},
	{
		sizeLabel: '38AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619962546681',
	},
	{
		sizeLabel: '38DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494766876243',
	},
	{
		sizeLabel: '38DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702562446801',
	},
	{
		sizeLabel: '38G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505833726454',
	},
	{
		sizeLabel: '90AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883807307125',
	},
	{
		sizeLabel: '40AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '880173863661',
	},
	{
		sizeLabel: '40DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153998673969',
	},
	{
		sizeLabel: '40DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983613932753',
	},
	{
		sizeLabel: '40G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136369253360',
	},
	{
		sizeLabel: '95AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352178214016',
	},
	{
		sizeLabel: '42AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273330923854',
	},
	{
		sizeLabel: '42DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997024875555',
	},
	{
		sizeLabel: '42DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499752110420',
	},
	{
		sizeLabel: '42G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671996954177',
	},
	{
		sizeLabel: '100AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416450983175',
	},
	{
		sizeLabel: '44AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409385928482',
	},
	{
		sizeLabel: '44DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649001720964',
	},
	{
		sizeLabel: '44DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833141315583',
	},
	{
		sizeLabel: '44G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127594043555',
	},
	{
		sizeLabel: '105AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390407281273',
	},
	{
		sizeLabel: '46AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937821697595',
	},
	{
		sizeLabel: '46A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007206935514',
	},
	{
		sizeLabel: '46B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190786080722',
	},
	{
		sizeLabel: '46C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207191300984',
	},
	{
		sizeLabel: '46D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310755314067',
	},
	{
		sizeLabel: '46DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808171795848',
	},
	{
		sizeLabel: '46DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540786067995',
	},
	{
		sizeLabel: '46G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278659669383',
	},
	{
		sizeLabel: '110AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352505857234',
	},
	{
		sizeLabel: '48AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961976512064',
	},
	{
		sizeLabel: '48A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381886230483',
	},
	{
		sizeLabel: '48B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '509404749787',
	},
	{
		sizeLabel: '48C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933779530579',
	},
	{
		sizeLabel: '48D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718977234122',
	},
	{
		sizeLabel: '48DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906393648141',
	},
	{
		sizeLabel: '48DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329503683268',
	},
	{
		sizeLabel: '48G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488527546498',
	},
	{
		sizeLabel: '115AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083105948828',
	},
	{
		sizeLabel: '50AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005500278740',
	},
	{
		sizeLabel: '50A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651315432030',
	},
	{
		sizeLabel: '50B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169132927808',
	},
	{
		sizeLabel: '50C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954571700550',
	},
	{
		sizeLabel: '50D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834793342522',
	},
	{
		sizeLabel: '50DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '495572040972',
	},
	{
		sizeLabel: '50DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678639731924',
	},
	{
		sizeLabel: '50G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263521993497',
	},
	{
		sizeLabel: '120AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065599697347',
	},
	{
		sizeLabel: '52AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016097809304',
	},
	{
		sizeLabel: '52A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602981579702',
	},
	{
		sizeLabel: '52B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667745641835',
	},
	{
		sizeLabel: '52C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618644726188',
	},
	{
		sizeLabel: '52D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422638851633',
	},
	{
		sizeLabel: '52DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580212222950',
	},
	{
		sizeLabel: '52DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193279693631',
	},
	{
		sizeLabel: '52G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064816744080',
	},
	{
		sizeLabel: '48-50-52 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238241144071',
	},
	{
		sizeLabel: '70B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353006348446',
	},
	{
		sizeLabel: '70C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351284217182',
	},
	{
		sizeLabel: '70D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839865678631',
	},
	{
		sizeLabel: '1E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568779909118',
	},
	{
		sizeLabel: '70E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '648240009039',
	},
	{
		sizeLabel: '1F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091658025183',
	},
	{
		sizeLabel: '70F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811046392480',
	},
	{
		sizeLabel: '1G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349602762316',
	},
	{
		sizeLabel: '70G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470643413428',
	},
	{
		sizeLabel: '75B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059531578531',
	},
	{
		sizeLabel: '75C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743355080019',
	},
	{
		sizeLabel: '75D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '647944553393',
	},
	{
		sizeLabel: '75E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756069060158',
	},
	{
		sizeLabel: '75F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143874722165',
	},
	{
		sizeLabel: '80G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754699404316',
	},
	{
		sizeLabel: '80B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817379394582',
	},
	{
		sizeLabel: '80C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232671130432',
	},
	{
		sizeLabel: '80D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403999771426',
	},
	{
		sizeLabel: '80E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718296700976',
	},
	{
		sizeLabel: '80F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046261664616',
	},
	{
		sizeLabel: '85G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697752491716',
	},
	{
		sizeLabel: '85B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353330133962',
	},
	{
		sizeLabel: '85C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059493304947',
	},
	{
		sizeLabel: '85D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '150970553701',
	},
	{
		sizeLabel: '85E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548198796863',
	},
	{
		sizeLabel: '85F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '338575303084',
	},
	{
		sizeLabel: '40B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524691645178',
	},
	{
		sizeLabel: '90B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075227605027',
	},
	{
		sizeLabel: '40C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '344714781304',
	},
	{
		sizeLabel: '90C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308380563287',
	},
	{
		sizeLabel: '90D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056449603492',
	},
	{
		sizeLabel: '90E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109035349989',
	},
	{
		sizeLabel: '90F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034567421824',
	},
	{
		sizeLabel: '90G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656529903518',
	},
	{
		sizeLabel: '42B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393234582722',
	},
	{
		sizeLabel: '6B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968101654456',
	},
	{
		sizeLabel: '95B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868309418924',
	},
	{
		sizeLabel: '42C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996806399858',
	},
	{
		sizeLabel: '6C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631668882283',
	},
	{
		sizeLabel: '95C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806028975222',
	},
	{
		sizeLabel: '42D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426001262175',
	},
	{
		sizeLabel: '95D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639706306528',
	},
	{
		sizeLabel: '42E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '148750290296',
	},
	{
		sizeLabel: '95E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485342455866',
	},
	{
		sizeLabel: '42F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963502704875',
	},
	{
		sizeLabel: '95F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902224851436',
	},
	{
		sizeLabel: '42G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607401630820',
	},
	{
		sizeLabel: '110G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430332318729',
	},
	{
		sizeLabel: '95G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755858917051',
	},
	{
		sizeLabel: '44B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041593065469',
	},
	{
		sizeLabel: '7B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770522239449',
	},
	{
		sizeLabel: '100B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267533625205',
	},
	{
		sizeLabel: '44C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110668189132',
	},
	{
		sizeLabel: '7C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283918606140',
	},
	{
		sizeLabel: '100C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602012719278',
	},
	{
		sizeLabel: '44D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942538577255',
	},
	{
		sizeLabel: '7D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901184127838',
	},
	{
		sizeLabel: '100D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810491604767',
	},
	{
		sizeLabel: '44E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174115499378',
	},
	{
		sizeLabel: '7E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '984620104334',
	},
	{
		sizeLabel: '100E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997417027605',
	},
	{
		sizeLabel: '44F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270684688467',
	},
	{
		sizeLabel: '7F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740179708567',
	},
	{
		sizeLabel: '100F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741220300732',
	},
	{
		sizeLabel: '44G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143333559086',
	},
	{
		sizeLabel: '115G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '857936498928',
	},
	{
		sizeLabel: '7G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572461406653',
	},
	{
		sizeLabel: '100G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751982237279',
	},
	{
		sizeLabel: '46B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '593030848638',
	},
	{
		sizeLabel: '8B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103175354067',
	},
	{
		sizeLabel: '105B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818257319937',
	},
	{
		sizeLabel: '46C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '437546824429',
	},
	{
		sizeLabel: '8C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320335925367',
	},
	{
		sizeLabel: '105C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728423914417',
	},
	{
		sizeLabel: '46D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310326546089',
	},
	{
		sizeLabel: '8D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347783227196',
	},
	{
		sizeLabel: '105D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406926402072',
	},
	{
		sizeLabel: '46E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373484230606',
	},
	{
		sizeLabel: '46E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066335454651',
	},
	{
		sizeLabel: '8E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201158002544',
	},
	{
		sizeLabel: '105E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757781803686',
	},
	{
		sizeLabel: '46F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507086608249',
	},
	{
		sizeLabel: '46F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676222041253',
	},
	{
		sizeLabel: '8F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054168378742',
	},
	{
		sizeLabel: '105F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671495089366',
	},
	{
		sizeLabel: '46G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913492657677',
	},
	{
		sizeLabel: '120G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060820015421',
	},
	{
		sizeLabel: '8G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021285263841',
	},
	{
		sizeLabel: '105G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '444059325987',
	},
	{
		sizeLabel: '48B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420299173558',
	},
	{
		sizeLabel: '9B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136399508385',
	},
	{
		sizeLabel: '110B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126252044960',
	},
	{
		sizeLabel: '48C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040007085348',
	},
	{
		sizeLabel: '9C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374924280245',
	},
	{
		sizeLabel: '110C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521175342120',
	},
	{
		sizeLabel: '48D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349935094819',
	},
	{
		sizeLabel: '9D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513830848228',
	},
	{
		sizeLabel: '110D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693756885243',
	},
	{
		sizeLabel: '48E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321873991035',
	},
	{
		sizeLabel: '48E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304135403621',
	},
	{
		sizeLabel: '9E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '993838496314',
	},
	{
		sizeLabel: '110E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995815420399',
	},
	{
		sizeLabel: '48F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919385351518',
	},
	{
		sizeLabel: '48F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750746374685',
	},
	{
		sizeLabel: '9F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '731428897442',
	},
	{
		sizeLabel: '110F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812128454219',
	},
	{
		sizeLabel: '48G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '473864783744',
	},
	{
		sizeLabel: '125G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '047448269508',
	},
	{
		sizeLabel: '9G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446826720393',
	},
	{
		sizeLabel: '110G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466089734100',
	},
	{
		sizeLabel: '48-50 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '242749347237',
	},
	{
		sizeLabel: '52-54 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741708456180',
	},
	{
		sizeLabel: '56-58 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784545953614',
	},
	{
		sizeLabel: '60-62 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305679383081',
	},
	{
		sizeLabel: 'XXL-3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '150363923883',
	},
	{
		sizeLabel: '50-52 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440238681491',
	},
	{
		sizeLabel: '54-56 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340114504996',
	},
	{
		sizeLabel: '58-60 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988650959304',
	},
	{
		sizeLabel: '40 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181186855160',
	},
	{
		sizeLabel: '42 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623495416055',
	},
	{
		sizeLabel: '44 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126317051230',
	},
	{
		sizeLabel: '46 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527041763504',
	},
	{
		sizeLabel: '38 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306724756428',
	},
	{
		sizeLabel: '6-6 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738037546052',
	},
	{
		sizeLabel: '6-6 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510517502351',
	},
	{
		sizeLabel: '7-7 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431190466890',
	},
	{
		sizeLabel: '7-7 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108309120003',
	},
	{
		sizeLabel: '8-8 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516557073826',
	},
	{
		sizeLabel: '8-8 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389167575540',
	},
	{
		sizeLabel: '9-9 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720979585461',
	},
	{
		sizeLabel: '9-9 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673713855978',
	},
	{
		sizeLabel: '43-43 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161409538546',
	},
	{
		sizeLabel: '10-10 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '423957411516',
	},
	{
		sizeLabel: '10-10 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962818635773',
	},
	{
		sizeLabel: '11-11 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901953729652',
	},
	{
		sizeLabel: '11-11 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548721915564',
	},
	{
		sizeLabel: '45-45 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193503398129',
	},
	{
		sizeLabel: '12-12 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985833953128',
	},
	{
		sizeLabel: '11-11 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559891116885',
	},
	{
		sizeLabel: '12-12 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172846047811',
	},
	{
		sizeLabel: '13 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280327120156',
	},
	{
		sizeLabel: 'S (P)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902824867513',
	},
	{
		sizeLabel: 'L (G)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872304805879',
	},
	{
		sizeLabel: 'XL (TG)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035920997388',
	},
	{
		sizeLabel: '28AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395516508760',
	},
	{
		sizeLabel: '60AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '313488390086',
	},
	{
		sizeLabel: '28AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098334881668',
	},
	{
		sizeLabel: '28A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569356730040',
	},
	{
		sizeLabel: '60A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579515186594',
	},
	{
		sizeLabel: '28A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220390312043',
	},
	{
		sizeLabel: '28B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875581524396',
	},
	{
		sizeLabel: '60B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038296374384',
	},
	{
		sizeLabel: '28B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773261988980',
	},
	{
		sizeLabel: '28C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120398948350',
	},
	{
		sizeLabel: '60C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915693703197',
	},
	{
		sizeLabel: '28C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021159907566',
	},
	{
		sizeLabel: '28D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403941856771',
	},
	{
		sizeLabel: '60D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750238146737',
	},
	{
		sizeLabel: '28D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '421838945531',
	},
	{
		sizeLabel: '28E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170119699928',
	},
	{
		sizeLabel: '60E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342152259579',
	},
	{
		sizeLabel: '28E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865189231468',
	},
	{
		sizeLabel: '28F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335700416241',
	},
	{
		sizeLabel: '60F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869347902174',
	},
	{
		sizeLabel: '28F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950522931096',
	},
	{
		sizeLabel: '28G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696605187877',
	},
	{
		sizeLabel: '60G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225451550564',
	},
	{
		sizeLabel: '28G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443366389881',
	},
	{
		sizeLabel: '28H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424088908582',
	},
	{
		sizeLabel: '60H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413994249517',
	},
	{
		sizeLabel: '28H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259643898349',
	},
	{
		sizeLabel: '28I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291786623088',
	},
	{
		sizeLabel: '60I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754350467692',
	},
	{
		sizeLabel: '28I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280534688518',
	},
	{
		sizeLabel: '28J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570517159749',
	},
	{
		sizeLabel: '60J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204180385201',
	},
	{
		sizeLabel: '28J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175084266736',
	},
	{
		sizeLabel: '30AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775934154465',
	},
	{
		sizeLabel: '30E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310908394566',
	},
	{
		sizeLabel: '30F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865206051318',
	},
	{
		sizeLabel: '30G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232421179707',
	},
	{
		sizeLabel: '30H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903766403696',
	},
	{
		sizeLabel: '30H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165703178941',
	},
	{
		sizeLabel: '30I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '905245558402',
	},
	{
		sizeLabel: '30I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699926349186',
	},
	{
		sizeLabel: '30J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724879494642',
	},
	{
		sizeLabel: '30J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '501406747664',
	},
	{
		sizeLabel: '32H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963322869760',
	},
	{
		sizeLabel: '32H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640707176755',
	},
	{
		sizeLabel: '32I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587648340544',
	},
	{
		sizeLabel: '32I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113784318525',
	},
	{
		sizeLabel: '32J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697293553289',
	},
	{
		sizeLabel: '32J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212939239246',
	},
	{
		sizeLabel: '34AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104761522827',
	},
	{
		sizeLabel: '34H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959245226264',
	},
	{
		sizeLabel: '34H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817763786254',
	},
	{
		sizeLabel: '34I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715320657459',
	},
	{
		sizeLabel: '34I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981578230771',
	},
	{
		sizeLabel: '34J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900364484911',
	},
	{
		sizeLabel: '34J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777863537339',
	},
	{
		sizeLabel: '36AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073396500173',
	},
	{
		sizeLabel: '36H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529654352534',
	},
	{
		sizeLabel: '36H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972060456007',
	},
	{
		sizeLabel: '36I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728570757160',
	},
	{
		sizeLabel: '36I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315958549449',
	},
	{
		sizeLabel: '36J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096839036264',
	},
	{
		sizeLabel: '36J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210177749230',
	},
	{
		sizeLabel: '38AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929513462725',
	},
	{
		sizeLabel: '38H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797396701371',
	},
	{
		sizeLabel: '38H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733905725124',
	},
	{
		sizeLabel: '38I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657912148732',
	},
	{
		sizeLabel: '38I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815086635534',
	},
	{
		sizeLabel: '38J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129588803229',
	},
	{
		sizeLabel: '38J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481235791329',
	},
	{
		sizeLabel: '40AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910828176424',
	},
	{
		sizeLabel: '40A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304246822151',
	},
	{
		sizeLabel: '40H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088938852875',
	},
	{
		sizeLabel: '40H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931226896375',
	},
	{
		sizeLabel: '40I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294925575929',
	},
	{
		sizeLabel: '40I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940185076638',
	},
	{
		sizeLabel: '40J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819647972479',
	},
	{
		sizeLabel: '40J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '993560626576',
	},
	{
		sizeLabel: '42AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365388000523',
	},
	{
		sizeLabel: '42A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979692376026',
	},
	{
		sizeLabel: '42H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753164809939',
	},
	{
		sizeLabel: '42H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712052979148',
	},
	{
		sizeLabel: '42I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099840004420',
	},
	{
		sizeLabel: '42I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874505410930',
	},
	{
		sizeLabel: '42J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '502735550621',
	},
	{
		sizeLabel: '42J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157917020440',
	},
	{
		sizeLabel: '44AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213766305653',
	},
	{
		sizeLabel: '44A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '955214733513',
	},
	{
		sizeLabel: '44H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883284760744',
	},
	{
		sizeLabel: '44H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174005808530',
	},
	{
		sizeLabel: '44I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '285716575183',
	},
	{
		sizeLabel: '44I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426316646233',
	},
	{
		sizeLabel: '44J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935474988998',
	},
	{
		sizeLabel: '44J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477466477430',
	},
	{
		sizeLabel: '46AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643763566172',
	},
	{
		sizeLabel: '46A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090160612825',
	},
	{
		sizeLabel: '46H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '586693425032',
	},
	{
		sizeLabel: '46H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935251801693',
	},
	{
		sizeLabel: '46I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007118739080',
	},
	{
		sizeLabel: '46I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191388281979',
	},
	{
		sizeLabel: '46J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863418466022',
	},
	{
		sizeLabel: '46J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914784210643',
	},
	{
		sizeLabel: '48AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954054043281',
	},
	{
		sizeLabel: '48A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273703526555',
	},
	{
		sizeLabel: '48H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078803429252',
	},
	{
		sizeLabel: '48H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395155256609',
	},
	{
		sizeLabel: '48I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684654065448',
	},
	{
		sizeLabel: '48I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307874941315',
	},
	{
		sizeLabel: '48J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688567721558',
	},
	{
		sizeLabel: '48J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804238564717',
	},
	{
		sizeLabel: '50AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888301025933',
	},
	{
		sizeLabel: '50A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633911471155',
	},
	{
		sizeLabel: '50B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '423503916934',
	},
	{
		sizeLabel: '50C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140940810353',
	},
	{
		sizeLabel: '50D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291300285684',
	},
	{
		sizeLabel: '50E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978356938356',
	},
	{
		sizeLabel: '50E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301056928872',
	},
	{
		sizeLabel: '50F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '026673127083',
	},
	{
		sizeLabel: '50F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714961714165',
	},
	{
		sizeLabel: '50G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318321882980',
	},
	{
		sizeLabel: '50H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803022370933',
	},
	{
		sizeLabel: '50H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '646727832304',
	},
	{
		sizeLabel: '50I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072725610350',
	},
	{
		sizeLabel: '50I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544887431795',
	},
	{
		sizeLabel: '50J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244447868246',
	},
	{
		sizeLabel: '115J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643963747175',
	},
	{
		sizeLabel: '50J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184805897460',
	},
	{
		sizeLabel: '52AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080806811880',
	},
	{
		sizeLabel: '52A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526419784216',
	},
	{
		sizeLabel: '52B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988285711769',
	},
	{
		sizeLabel: '52C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345186932700',
	},
	{
		sizeLabel: '52D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714307271253',
	},
	{
		sizeLabel: '52E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392939260865',
	},
	{
		sizeLabel: '52E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446306099924',
	},
	{
		sizeLabel: '52F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649314888687',
	},
	{
		sizeLabel: '52F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159901133608',
	},
	{
		sizeLabel: '52G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469188456616',
	},
	{
		sizeLabel: '52H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932350100446',
	},
	{
		sizeLabel: '52H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395977703665',
	},
	{
		sizeLabel: '52I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202323420363',
	},
	{
		sizeLabel: '120I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964106033875',
	},
	{
		sizeLabel: '52I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930355617978',
	},
	{
		sizeLabel: '52J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991522124711',
	},
	{
		sizeLabel: '120J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '454875728904',
	},
	{
		sizeLabel: '52J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638737078414',
	},
	{
		sizeLabel: '54AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431842381372',
	},
	{
		sizeLabel: '125AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081354047263',
	},
	{
		sizeLabel: '54AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849440463195',
	},
	{
		sizeLabel: '54A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697315027007',
	},
	{
		sizeLabel: '125A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165277044814',
	},
	{
		sizeLabel: '54A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830504975880',
	},
	{
		sizeLabel: '54B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831762976820',
	},
	{
		sizeLabel: '125B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '272618008207',
	},
	{
		sizeLabel: '54B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894678633992',
	},
	{
		sizeLabel: '54C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200920944930',
	},
	{
		sizeLabel: '125C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079353724261',
	},
	{
		sizeLabel: '54C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084786646919',
	},
	{
		sizeLabel: '54D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657533484502',
	},
	{
		sizeLabel: '125D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634691075582',
	},
	{
		sizeLabel: '54D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237847175781',
	},
	{
		sizeLabel: '54E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682421002703',
	},
	{
		sizeLabel: '125E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789816349608',
	},
	{
		sizeLabel: '54E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301610175920',
	},
	{
		sizeLabel: '54F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697849436075',
	},
	{
		sizeLabel: '125F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897911764572',
	},
	{
		sizeLabel: '54F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680558429611',
	},
	{
		sizeLabel: '54G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930093655026',
	},
	{
		sizeLabel: '125G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511468933099',
	},
	{
		sizeLabel: '54G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868640700818',
	},
	{
		sizeLabel: '54H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960519817704',
	},
	{
		sizeLabel: '125H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115948826989',
	},
	{
		sizeLabel: '54H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126105421882',
	},
	{
		sizeLabel: '54I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178110845800',
	},
	{
		sizeLabel: '125I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610568399274',
	},
	{
		sizeLabel: '54I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817279067040',
	},
	{
		sizeLabel: '54J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371070699411',
	},
	{
		sizeLabel: '125J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904052182062',
	},
	{
		sizeLabel: '54J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305602558068',
	},
	{
		sizeLabel: '56AA (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898320790429',
	},
	{
		sizeLabel: '130AA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866298302147',
	},
	{
		sizeLabel: '56AA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996465092827',
	},
	{
		sizeLabel: '56A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378427881988',
	},
	{
		sizeLabel: '130A (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569070151276',
	},
	{
		sizeLabel: '56A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688169193909',
	},
	{
		sizeLabel: '56B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917420021919',
	},
	{
		sizeLabel: '130B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629100287922',
	},
	{
		sizeLabel: '56B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503923179269',
	},
	{
		sizeLabel: '56C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '348530190807',
	},
	{
		sizeLabel: '130C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988662395191',
	},
	{
		sizeLabel: '56C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869718110271',
	},
	{
		sizeLabel: '56D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900164399046',
	},
	{
		sizeLabel: '130D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297722619669',
	},
	{
		sizeLabel: '56D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317460586254',
	},
	{
		sizeLabel: '56E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667962211689',
	},
	{
		sizeLabel: '130E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761709000849',
	},
	{
		sizeLabel: '56E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118686581793',
	},
	{
		sizeLabel: '56F (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100523285961',
	},
	{
		sizeLabel: '130F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238248170297',
	},
	{
		sizeLabel: '56F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271393419524',
	},
	{
		sizeLabel: '56G (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826141589428',
	},
	{
		sizeLabel: '130G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570757466762',
	},
	{
		sizeLabel: '56G (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134765208476',
	},
	{
		sizeLabel: '56H (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638847069582',
	},
	{
		sizeLabel: '130H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '955603756017',
	},
	{
		sizeLabel: '56H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878697933858',
	},
	{
		sizeLabel: '56I (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163934358001',
	},
	{
		sizeLabel: '130I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845760453035',
	},
	{
		sizeLabel: '56I (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422868109140',
	},
	{
		sizeLabel: '56J (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317390161377',
	},
	{
		sizeLabel: '130J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390414019507',
	},
	{
		sizeLabel: '56J (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479034196825',
	},
	{
		sizeLabel: '52 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110257852819',
	},
	{
		sizeLabel: '54 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320716257609',
	},
	{
		sizeLabel: '65 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663793661297',
	},
	{
		sizeLabel: '70 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659129005212',
	},
	{
		sizeLabel: '75 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815868398816',
	},
	{
		sizeLabel: '80 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164822625436',
	},
	{
		sizeLabel: '85 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '194368971520',
	},
	{
		sizeLabel: '90 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869875986112',
	},
	{
		sizeLabel: '95 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872757055351',
	},
	{
		sizeLabel: '100 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072704961872',
	},
	{
		sizeLabel: '105 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402406758165',
	},
	{
		sizeLabel: '110 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322350877593',
	},
	{
		sizeLabel: '115 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309762015190',
	},
	{
		sizeLabel: '120 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084271526979',
	},
	{
		sizeLabel: '125 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903845511676',
	},
	{
		sizeLabel: '56 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335481914125',
	},
	{
		sizeLabel: '130 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575551896731',
	},
	{
		sizeLabel: '72 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639699082070',
	},
	{
		sizeLabel: '74 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517422634293',
	},
	{
		sizeLabel: '38-40 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089989096553',
	},
	{
		sizeLabel: '40-42 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476076612742',
	},
	{
		sizeLabel: '42-44 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '920676414022',
	},
	{
		sizeLabel: '44-46 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '006837673072',
	},
	{
		sizeLabel: '46-48 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503690109172',
	},
	{
		sizeLabel: '48-50 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018418208722',
	},
	{
		sizeLabel: '50-52 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565269488405',
	},
	{
		sizeLabel: '5-6',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '821805005680',
	},
	{
		sizeLabel: '7-8',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155310632680',
	},
	{
		sizeLabel: '425 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299510289062',
	},
	{
		sizeLabel: '29 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201890470699',
	},
	{
		sizeLabel: '31 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852048399121',
	},
	{
		sizeLabel: '35 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901900333815',
	},
	{
		sizeLabel: '2-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303335900503',
	},
	{
		sizeLabel: '6-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629846107222',
	},
	{
		sizeLabel: '3 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '377709123776',
	},
	{
		sizeLabel: '5 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601116544052',
	},
	{
		sizeLabel: '11 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849628094166',
	},
	{
		sizeLabel: '115',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922470084551',
	},
	{
		sizeLabel: '120',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803949490752',
	},
	{
		sizeLabel: '125',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354297320090',
	},
	{
		sizeLabel: '80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797005536406',
	},
	{
		sizeLabel: '165-90A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535747433671',
	},
	{
		sizeLabel: '165-94A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230494626565',
	},
	{
		sizeLabel: '170-102A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331223723207',
	},
	{
		sizeLabel: '3L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494626768257',
	},
	{
		sizeLabel: '170-122A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563110399397',
	},
	{
		sizeLabel: '85 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834911285650',
	},
	{
		sizeLabel: 'XS (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531478031055',
	},
	{
		sizeLabel: '90 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902298360548',
	},
	{
		sizeLabel: 'S (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390386642205',
	},
	{
		sizeLabel: '95 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571517374839',
	},
	{
		sizeLabel: 'M (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382907216524',
	},
	{
		sizeLabel: '100 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708482678995',
	},
	{
		sizeLabel: 'L (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357296411749',
	},
	{
		sizeLabel: 'LL (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961580420168',
	},
	{
		sizeLabel: '120 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282180375687',
	},
	{
		sizeLabel: '3L (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177777207683',
	},
	{
		sizeLabel: '130 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108156606567',
	},
	{
		sizeLabel: '4L (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330898636654',
	},
	{
		sizeLabel: '62 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278581851668',
	},
	{
		sizeLabel: '140 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207376798823',
	},
	{
		sizeLabel: '5L (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167470676823',
	},
	{
		sizeLabel: '130 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925895797847',
	},
	{
		sizeLabel: '5L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '274339106266',
	},
	{
		sizeLabel: '140 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193964204907',
	},
	{
		sizeLabel: 'XXS-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193874582487',
	},
	{
		sizeLabel: 'S-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878899528710',
	},
	{
		sizeLabel: 'M-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529777122018',
	},
	{
		sizeLabel: 'L-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914606915496',
	},
	{
		sizeLabel: 'XL-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959631130961',
	},
	{
		sizeLabel: 'XXS-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013692511317',
	},
	{
		sizeLabel: 'XS-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033227201692',
	},
	{
		sizeLabel: 'S-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779500345781',
	},
	{
		sizeLabel: 'M-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879931516489',
	},
	{
		sizeLabel: 'L-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086326876174',
	},
	{
		sizeLabel: 'XL-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569155497339',
	},
	{
		sizeLabel: 'XXS-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262843236150',
	},
	{
		sizeLabel: 'XS-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569816448711',
	},
	{
		sizeLabel: 'S-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535703985076',
	},
	{
		sizeLabel: 'M-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540946454606',
	},
	{
		sizeLabel: 'L-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169894647656',
	},
	{
		sizeLabel: 'XL-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455198155645',
	},
	{
		sizeLabel: '00-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886029652979',
	},
	{
		sizeLabel: '0-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740134984958',
	},
	{
		sizeLabel: '2-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123768812750',
	},
	{
		sizeLabel: '4-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825223123148',
	},
	{
		sizeLabel: '6-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702195013846',
	},
	{
		sizeLabel: '8-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891628026098',
	},
	{
		sizeLabel: '10-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826858920059',
	},
	{
		sizeLabel: '12-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573198431353',
	},
	{
		sizeLabel: '00-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438390903320',
	},
	{
		sizeLabel: '0-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094805718936',
	},
	{
		sizeLabel: '2-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442319443467',
	},
	{
		sizeLabel: '4-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834329525423',
	},
	{
		sizeLabel: '6-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368391888451',
	},
	{
		sizeLabel: '8-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854113417617',
	},
	{
		sizeLabel: '10-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424248473477',
	},
	{
		sizeLabel: '12-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364873886709',
	},
	{
		sizeLabel: '14-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400244757964',
	},
	{
		sizeLabel: '16-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425753090763',
	},
	{
		sizeLabel: '4-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054818569953',
	},
	{
		sizeLabel: '6-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891877093417',
	},
	{
		sizeLabel: '8-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556399339293',
	},
	{
		sizeLabel: '10-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658072096443',
	},
	{
		sizeLabel: '12-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436023825069',
	},
	{
		sizeLabel: '14-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '348827138039',
	},
	{
		sizeLabel: '16-T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251310688562',
	},
	{
		sizeLabel: '28-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702438445503',
	},
	{
		sizeLabel: '29-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406293524855',
	},
	{
		sizeLabel: '30-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978814814578',
	},
	{
		sizeLabel: '31-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994714736124',
	},
	{
		sizeLabel: '32-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989792505793',
	},
	{
		sizeLabel: '33-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587691103887',
	},
	{
		sizeLabel: '34-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656563717876',
	},
	{
		sizeLabel: '36-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882246787606',
	},
	{
		sizeLabel: '38-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898980647681',
	},
	{
		sizeLabel: '28-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071577471025',
	},
	{
		sizeLabel: '29-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803063480827',
	},
	{
		sizeLabel: '30-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912695126266',
	},
	{
		sizeLabel: '31-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600259667745',
	},
	{
		sizeLabel: '32-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641222978751',
	},
	{
		sizeLabel: '33-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691648743807',
	},
	{
		sizeLabel: '34-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128954350048',
	},
	{
		sizeLabel: '36-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284957215339',
	},
	{
		sizeLabel: '38-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783532814214',
	},
	{
		sizeLabel: '28-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205646169140',
	},
	{
		sizeLabel: '29-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145021566430',
	},
	{
		sizeLabel: '30-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951154824498',
	},
	{
		sizeLabel: '31-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558929444691',
	},
	{
		sizeLabel: '32-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726178848359',
	},
	{
		sizeLabel: '33-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176360336533',
	},
	{
		sizeLabel: '34-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120929482062',
	},
	{
		sizeLabel: '36-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430972563493',
	},
	{
		sizeLabel: '38-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775078097610',
	},
	{
		sizeLabel: 'XXL-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360520636664',
	},
	{
		sizeLabel: 'XXL-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939816993132',
	},
	{
		sizeLabel: '2XL-T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459852110367',
	},
	{
		sizeLabel: '75 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405885559426',
	},
	{
		sizeLabel: '80 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597128266047',
	},
	{
		sizeLabel: '85 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746928868775',
	},
	{
		sizeLabel: '90 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635259948920',
	},
	{
		sizeLabel: '95 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631277068426',
	},
	{
		sizeLabel: '100 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104498874227',
	},
	{
		sizeLabel: '105 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099500947885',
	},
	{
		sizeLabel: '110 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527742918569',
	},
	{
		sizeLabel: '55 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052200955914',
	},
	{
		sizeLabel: '65 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227539446038',
	},
	{
		sizeLabel: '70 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385682666344',
	},
	{
		sizeLabel: '8JR (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '026958342969',
	},
	{
		sizeLabel: '10JR (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897167023939',
	},
	{
		sizeLabel: '22 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629408656601',
	},
	{
		sizeLabel: '24 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '111580495907',
	},
	{
		sizeLabel: '26 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '003888138894',
	},
	{
		sizeLabel: '28 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705751120110',
	},
	{
		sizeLabel: '32 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '462577180278',
	},
	{
		sizeLabel: '- (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727272427427',
	},
	{
		sizeLabel: '30 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715345156042',
	},
	{
		sizeLabel: '2 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435656277475',
	},
	{
		sizeLabel: '12JR (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582878513199',
	},
	{
		sizeLabel: '33 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922435156490',
	},
	{
		sizeLabel: '34 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136482223665',
	},
	{
		sizeLabel: '34 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926983531581',
	},
	{
		sizeLabel: '35 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329964255722',
	},
	{
		sizeLabel: '35 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411079139558',
	},
	{
		sizeLabel: '36 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948140354829',
	},
	{
		sizeLabel: '37 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933995075105',
	},
	{
		sizeLabel: '37 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157672886333',
	},
	{
		sizeLabel: '38 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219774115059',
	},
	{
		sizeLabel: '39 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '003825005738',
	},
	{
		sizeLabel: '39 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530462306430',
	},
	{
		sizeLabel: '40 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207798528481',
	},
	{
		sizeLabel: '40 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318065454718',
	},
	{
		sizeLabel: 'IA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240397188870',
	},
	{
		sizeLabel: '65A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713991212943',
	},
	{
		sizeLabel: '65A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114743808850',
	},
	{
		sizeLabel: 'IB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363339247858',
	},
	{
		sizeLabel: '65B (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965504444048',
	},
	{
		sizeLabel: '65B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925986620483',
	},
	{
		sizeLabel: 'IC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951076158275',
	},
	{
		sizeLabel: '65C (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297082347381',
	},
	{
		sizeLabel: '65C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310291665085',
	},
	{
		sizeLabel: 'ID (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807656503707',
	},
	{
		sizeLabel: '65D (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '421941568933',
	},
	{
		sizeLabel: '65D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989793846432',
	},
	{
		sizeLabel: 'IIA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592283621303',
	},
	{
		sizeLabel: '70A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710653604766',
	},
	{
		sizeLabel: '70A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995229687612',
	},
	{
		sizeLabel: 'IIB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968412300754',
	},
	{
		sizeLabel: '70B (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890501509422',
	},
	{
		sizeLabel: '70B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710394099665',
	},
	{
		sizeLabel: 'IIC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '002800989428',
	},
	{
		sizeLabel: '70C (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559871413719',
	},
	{
		sizeLabel: '70C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887684222367',
	},
	{
		sizeLabel: 'IID (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621830049304',
	},
	{
		sizeLabel: '70D (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331913022506',
	},
	{
		sizeLabel: '70D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000652965508',
	},
	{
		sizeLabel: 'IIIA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '820953913605',
	},
	{
		sizeLabel: '75A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865090328959',
	},
	{
		sizeLabel: '75A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569972101414',
	},
	{
		sizeLabel: 'IIIB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '692836623543',
	},
	{
		sizeLabel: '75B (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070141201689',
	},
	{
		sizeLabel: '75B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392604428740',
	},
	{
		sizeLabel: 'IIIC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527284785162',
	},
	{
		sizeLabel: '75C (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520674662399',
	},
	{
		sizeLabel: '75C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804052668618',
	},
	{
		sizeLabel: 'IIID (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099347458643',
	},
	{
		sizeLabel: '75D (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403036269266',
	},
	{
		sizeLabel: '75D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878552366294',
	},
	{
		sizeLabel: 'IVA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962967446012',
	},
	{
		sizeLabel: '80A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251622852445',
	},
	{
		sizeLabel: '80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496288134186',
	},
	{
		sizeLabel: 'IVB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370146243664',
	},
	{
		sizeLabel: '80B (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356489180235',
	},
	{
		sizeLabel: '80B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600582805766',
	},
	{
		sizeLabel: 'IVC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825939112093',
	},
	{
		sizeLabel: '80C (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641246877767',
	},
	{
		sizeLabel: '80C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '857564951101',
	},
	{
		sizeLabel: 'IVD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246632085244',
	},
	{
		sizeLabel: '80D (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435455308647',
	},
	{
		sizeLabel: '80D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776217211801',
	},
	{
		sizeLabel: 'VA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899431674171',
	},
	{
		sizeLabel: '85A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118867497763',
	},
	{
		sizeLabel: '85A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956491508747',
	},
	{
		sizeLabel: 'VB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219106220929',
	},
	{
		sizeLabel: '85B (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255337799304',
	},
	{
		sizeLabel: '85B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315979251502',
	},
	{
		sizeLabel: 'VC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553081003173',
	},
	{
		sizeLabel: '85C (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834349284185',
	},
	{
		sizeLabel: '85C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676911221168',
	},
	{
		sizeLabel: 'VD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825499877852',
	},
	{
		sizeLabel: '85D (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760875631673',
	},
	{
		sizeLabel: '85D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013951093745',
	},
	{
		sizeLabel: '48 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734743565815',
	},
	{
		sizeLabel: '185-98A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780649504165',
	},
	{
		sizeLabel: '225-78 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618045322568',
	},
	{
		sizeLabel: '225-78 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362233639785',
	},
	{
		sizeLabel: '34 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192020913314',
	},
	{
		sizeLabel: '22.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310916392144',
	},
	{
		sizeLabel: '228-78 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '358982060182',
	},
	{
		sizeLabel: '228-78 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '590440542504',
	},
	{
		sizeLabel: '34 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306999258003',
	},
	{
		sizeLabel: '23.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934596539759',
	},
	{
		sizeLabel: '231-79 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264423955961',
	},
	{
		sizeLabel: '231-79 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448131531467',
	},
	{
		sizeLabel: '35 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878281635988',
	},
	{
		sizeLabel: '23.4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917490005885',
	},
	{
		sizeLabel: '234-79 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963047359784',
	},
	{
		sizeLabel: '234-79 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049380718472',
	},
	{
		sizeLabel: '35 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709281598816',
	},
	{
		sizeLabel: '23.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599173131083',
	},
	{
		sizeLabel: '237-80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566365948149',
	},
	{
		sizeLabel: '237-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512836422592',
	},
	{
		sizeLabel: '36 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304413493299',
	},
	{
		sizeLabel: '240-80 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663354165019',
	},
	{
		sizeLabel: '240-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784455996909',
	},
	{
		sizeLabel: '36 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885793730011',
	},
	{
		sizeLabel: '24.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636078219571',
	},
	{
		sizeLabel: '243-81 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '434861364163',
	},
	{
		sizeLabel: '243-81 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056437512269',
	},
	{
		sizeLabel: '37 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608495469967',
	},
	{
		sizeLabel: '24.6 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922519529602',
	},
	{
		sizeLabel: '246-81 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581189459800',
	},
	{
		sizeLabel: '246-81 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '627852715620',
	},
	{
		sizeLabel: '37 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517967937456',
	},
	{
		sizeLabel: '24.9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947063087014',
	},
	{
		sizeLabel: '249-82 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219871908109',
	},
	{
		sizeLabel: '249-82 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778192136790',
	},
	{
		sizeLabel: '38 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461644879481',
	},
	{
		sizeLabel: '25.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409154101665',
	},
	{
		sizeLabel: '252-82 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746505221694',
	},
	{
		sizeLabel: '252-82 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448592980537',
	},
	{
		sizeLabel: '38 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919601426016',
	},
	{
		sizeLabel: '255-83 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200050265494',
	},
	{
		sizeLabel: '255-83 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315842590378',
	},
	{
		sizeLabel: '39 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '645824482611',
	},
	{
		sizeLabel: '25.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096873525678',
	},
	{
		sizeLabel: '261-84 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632929200620',
	},
	{
		sizeLabel: '261-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317059686803',
	},
	{
		sizeLabel: '39 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601122589722',
	},
	{
		sizeLabel: '26.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343140454207',
	},
	{
		sizeLabel: '26.4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416263287231',
	},
	{
		sizeLabel: '267-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877290011417',
	},
	{
		sizeLabel: '40 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449677774138',
	},
	{
		sizeLabel: '26.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675973664803',
	},
	{
		sizeLabel: '267-85 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376067420087',
	},
	{
		sizeLabel: '267-86 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '648891782985',
	},
	{
		sizeLabel: '41 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887646290084',
	},
	{
		sizeLabel: '41 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738795994615',
	},
	{
		sizeLabel: '42 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771064396158',
	},
	{
		sizeLabel: '43 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105101321160',
	},
	{
		sizeLabel: '43 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153686950366',
	},
	{
		sizeLabel: '44 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001783003395',
	},
	{
		sizeLabel: '45 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668444038426',
	},
	{
		sizeLabel: '45 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425105738912',
	},
	{
		sizeLabel: '46 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919332399404',
	},
	{
		sizeLabel: '47 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093245260519',
	},
	{
		sizeLabel: '46-47 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399473851398',
	},
	{
		sizeLabel: '13-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036300696094',
	},
	{
		sizeLabel: '130',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177259031810',
	},
	{
		sizeLabel: '135',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192423756637',
	},
	{
		sizeLabel: '1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '076464933146',
	},
	{
		sizeLabel: '66 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117064723353',
	},
	{
		sizeLabel: '34 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666204361578',
	},
	{
		sizeLabel: '50 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228851980465',
	},
	{
		sizeLabel: '2XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '491075750635',
	},
	{
		sizeLabel: '36 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492499647529',
	},
	{
		sizeLabel: '43 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607076651973',
	},
	{
		sizeLabel: '46 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874118869747',
	},
	{
		sizeLabel: '48 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439619051912',
	},
	{
		sizeLabel: '51 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967445117109',
	},
	{
		sizeLabel: '3XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091776269909',
	},
	{
		sizeLabel: '34-36 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573503729178',
	},
	{
		sizeLabel: '38-39 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468833477027',
	},
	{
		sizeLabel: '39-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845874617032',
	},
	{
		sizeLabel: '38-40 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729904947988',
	},
	{
		sizeLabel: '41-42',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597592109811',
	},
	{
		sizeLabel: '40-41 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973723355272',
	},
	{
		sizeLabel: '43-44',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435485567286',
	},
	{
		sizeLabel: '41-42 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732935921859',
	},
	{
		sizeLabel: '45-46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742957417744',
	},
	{
		sizeLabel: '47-48',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435061670748',
	},
	{
		sizeLabel: 'W16-W18 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738676053651',
	},
	{
		sizeLabel: 'W20-W22 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214810003127',
	},
	{
		sizeLabel: 'W24-W26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187993156520',
	},
	{
		sizeLabel: '38-39',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169020514141',
	},
	{
		sizeLabel: '40-41',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331617923535',
	},
	{
		sizeLabel: '42-43',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855379200593',
	},
	{
		sizeLabel: '1 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410086010083',
	},
	{
		sizeLabel: '2 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753467432548',
	},
	{
		sizeLabel: '3 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104822294424',
	},
	{
		sizeLabel: '4 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912186963184',
	},
	{
		sizeLabel: '5 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903859084782',
	},
	{
		sizeLabel: '6 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008676304833',
	},
	{
		sizeLabel: '65A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852113734666',
	},
	{
		sizeLabel: '65B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789903787001',
	},
	{
		sizeLabel: '65C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190378733215',
	},
	{
		sizeLabel: '65D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672591064134',
	},
	{
		sizeLabel: '65DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029176380682',
	},
	{
		sizeLabel: '65DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724231692125',
	},
	{
		sizeLabel: '65E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895682868780',
	},
	{
		sizeLabel: '65F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033787516546',
	},
	{
		sizeLabel: '65FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166221576655',
	},
	{
		sizeLabel: '80FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638792169757',
	},
	{
		sizeLabel: '65FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008738345014',
	},
	{
		sizeLabel: '30FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181044931625',
	},
	{
		sizeLabel: '70A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010750180654',
	},
	{
		sizeLabel: '70B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249109601619',
	},
	{
		sizeLabel: '70C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703949131593',
	},
	{
		sizeLabel: '70D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568165702880',
	},
	{
		sizeLabel: '70DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110338380051',
	},
	{
		sizeLabel: '70DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530799743383',
	},
	{
		sizeLabel: '70E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162720958037',
	},
	{
		sizeLabel: '70F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579667794258',
	},
	{
		sizeLabel: '70FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952764233082',
	},
	{
		sizeLabel: '85FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175079491850',
	},
	{
		sizeLabel: '70FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991718763504',
	},
	{
		sizeLabel: '32FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581210260160',
	},
	{
		sizeLabel: '75A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800355783301',
	},
	{
		sizeLabel: '75B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890591636319',
	},
	{
		sizeLabel: '75C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464481829338',
	},
	{
		sizeLabel: '75D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543834079024',
	},
	{
		sizeLabel: '75DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051233871273',
	},
	{
		sizeLabel: '75DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007967601883',
	},
	{
		sizeLabel: '75E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054347066730',
	},
	{
		sizeLabel: '75F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403509263437',
	},
	{
		sizeLabel: '75FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591889172040',
	},
	{
		sizeLabel: '90FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795060980223',
	},
	{
		sizeLabel: '75FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086709328126',
	},
	{
		sizeLabel: '34FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688151014306',
	},
	{
		sizeLabel: '80A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061522336263',
	},
	{
		sizeLabel: '80B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511770216079',
	},
	{
		sizeLabel: '80C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553463773769',
	},
	{
		sizeLabel: '80D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009368654389',
	},
	{
		sizeLabel: '80DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727952830154',
	},
	{
		sizeLabel: '80DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956168929351',
	},
	{
		sizeLabel: '80E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621490967382',
	},
	{
		sizeLabel: '80F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414018116012',
	},
	{
		sizeLabel: '80FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895823709367',
	},
	{
		sizeLabel: '95FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394328679477',
	},
	{
		sizeLabel: '80FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438344889523',
	},
	{
		sizeLabel: '36FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132783941897',
	},
	{
		sizeLabel: '85A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619089283207',
	},
	{
		sizeLabel: '85B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622610339631',
	},
	{
		sizeLabel: '85C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '462356484776',
	},
	{
		sizeLabel: '85D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613445806795',
	},
	{
		sizeLabel: '85DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237566179783',
	},
	{
		sizeLabel: '100DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639825713067',
	},
	{
		sizeLabel: '85DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865665860184',
	},
	{
		sizeLabel: '85E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411666751284',
	},
	{
		sizeLabel: '85F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739501467736',
	},
	{
		sizeLabel: '85FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407333457290',
	},
	{
		sizeLabel: '100FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442902337072',
	},
	{
		sizeLabel: '85FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801897248496',
	},
	{
		sizeLabel: '38FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259722639909',
	},
	{
		sizeLabel: '90A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481235817800',
	},
	{
		sizeLabel: '90B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853184477053',
	},
	{
		sizeLabel: '90C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267463144949',
	},
	{
		sizeLabel: '90D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874396432170',
	},
	{
		sizeLabel: '90DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877208285735',
	},
	{
		sizeLabel: '105DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689399141825',
	},
	{
		sizeLabel: '90DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352185460446',
	},
	{
		sizeLabel: '90E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430064785434',
	},
	{
		sizeLabel: '90F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657201778295',
	},
	{
		sizeLabel: '90FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381406041602',
	},
	{
		sizeLabel: '105FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642024190175',
	},
	{
		sizeLabel: '90FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830419773706',
	},
	{
		sizeLabel: '40FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '838004314121',
	},
	{
		sizeLabel: '95A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '211002383154',
	},
	{
		sizeLabel: '95B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991134098846',
	},
	{
		sizeLabel: '95C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078279636042',
	},
	{
		sizeLabel: '95D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734726603388',
	},
	{
		sizeLabel: '95DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683800068939',
	},
	{
		sizeLabel: '110DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572984878079',
	},
	{
		sizeLabel: '95DD (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908115843585',
	},
	{
		sizeLabel: '95E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054405290760',
	},
	{
		sizeLabel: '95F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583244677132',
	},
	{
		sizeLabel: '95FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771378661705',
	},
	{
		sizeLabel: '110FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927824542423',
	},
	{
		sizeLabel: '95FF (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649373836325',
	},
	{
		sizeLabel: '42FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807304669743',
	},
	{
		sizeLabel: '18 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704481825205',
	},
	{
		sizeLabel: '31 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '266583066329',
	},
	{
		sizeLabel: '33 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573653161227',
	},
	{
		sizeLabel: '35 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129285303383',
	},
	{
		sizeLabel: '544 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759863620399',
	},
	{
		sizeLabel: '75A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '497088464535',
	},
	{
		sizeLabel: '75B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315514097386',
	},
	{
		sizeLabel: '75C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909547161174',
	},
	{
		sizeLabel: '75D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889405773817',
	},
	{
		sizeLabel: '28DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '725633722522',
	},
	{
		sizeLabel: '75E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528944635221',
	},
	{
		sizeLabel: '28DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851765426178',
	},
	{
		sizeLabel: '75F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046413210038',
	},
	{
		sizeLabel: '75G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849867855806',
	},
	{
		sizeLabel: '28FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604262265730',
	},
	{
		sizeLabel: '75H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448304358346',
	},
	{
		sizeLabel: '28FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460772727603',
	},
	{
		sizeLabel: '80G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307834494506',
	},
	{
		sizeLabel: '30FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957450523404',
	},
	{
		sizeLabel: '80H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770918280417',
	},
	{
		sizeLabel: '80I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972858690706',
	},
	{
		sizeLabel: '30GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903732956624',
	},
	{
		sizeLabel: '80J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362930040211',
	},
	{
		sizeLabel: '30GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874798752153',
	},
	{
		sizeLabel: '32FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298429765450',
	},
	{
		sizeLabel: '85H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202399582063',
	},
	{
		sizeLabel: '85I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192303146585',
	},
	{
		sizeLabel: '32GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '955817130480',
	},
	{
		sizeLabel: '85J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470453444670',
	},
	{
		sizeLabel: '32GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141476538478',
	},
	{
		sizeLabel: '34FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186913692926',
	},
	{
		sizeLabel: '90H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161664434327',
	},
	{
		sizeLabel: '90I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030703117256',
	},
	{
		sizeLabel: '34GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427348522726',
	},
	{
		sizeLabel: '90J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537628309592',
	},
	{
		sizeLabel: '34GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239211209752',
	},
	{
		sizeLabel: '90K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112550131571',
	},
	{
		sizeLabel: '34HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415235807714',
	},
	{
		sizeLabel: '90L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507863377266',
	},
	{
		sizeLabel: '34HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558341027896',
	},
	{
		sizeLabel: '36FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685097859526',
	},
	{
		sizeLabel: '95H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915499794614',
	},
	{
		sizeLabel: '95I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394035527625',
	},
	{
		sizeLabel: '36GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505127228206',
	},
	{
		sizeLabel: '95J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158512651855',
	},
	{
		sizeLabel: '36GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117899846927',
	},
	{
		sizeLabel: '95K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704610253246',
	},
	{
		sizeLabel: '38FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186620015824',
	},
	{
		sizeLabel: '100H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443830977053',
	},
	{
		sizeLabel: '100I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099631572522',
	},
	{
		sizeLabel: '38GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430932991183',
	},
	{
		sizeLabel: '100J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960921579738',
	},
	{
		sizeLabel: '38GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372941911034',
	},
	{
		sizeLabel: '40DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048789341810',
	},
	{
		sizeLabel: '40FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730987776312',
	},
	{
		sizeLabel: '105H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162704955247',
	},
	{
		sizeLabel: '105I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118145764462',
	},
	{
		sizeLabel: '42DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862187996055',
	},
	{
		sizeLabel: '42FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998874141587',
	},
	{
		sizeLabel: '110H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233484903230',
	},
	{
		sizeLabel: '44DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818947143961',
	},
	{
		sizeLabel: '46DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414093331940',
	},
	{
		sizeLabel: '48DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535536182842',
	},
	{
		sizeLabel: '18-20 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524860039608',
	},
	{
		sizeLabel: '22-24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559480597884',
	},
	{
		sizeLabel: '30-32 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854641469444',
	},
	{
		sizeLabel: 'A-B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214392478415',
	},
	{
		sizeLabel: 'C-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206093786736',
	},
	{
		sizeLabel: 'E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054266416086',
	},
	{
		sizeLabel: 'EE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801797260577',
	},
	{
		sizeLabel: 'T24',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859784567710',
	},
	{
		sizeLabel: 'T25',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811849972768',
	},
	{
		sizeLabel: 'T26',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '348203804840',
	},
	{
		sizeLabel: 'T27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273763916182',
	},
	{
		sizeLabel: 'T28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164460723202',
	},
	{
		sizeLabel: 'T29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651121861352',
	},
	{
		sizeLabel: 'T30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '124247356515',
	},
	{
		sizeLabel: 'T31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991353678427',
	},
	{
		sizeLabel: '52-56 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666074391422',
	},
	{
		sizeLabel: '58-60 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020462760263',
	},
	{
		sizeLabel: '40-42 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545407896825',
	},
	{
		sizeLabel: '94',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314420163726',
	},
	{
		sizeLabel: '98',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742194646076',
	},
	{
		sizeLabel: '102',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365154370452',
	},
	{
		sizeLabel: '114',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671071444106',
	},
	{
		sizeLabel: '29-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991900698107',
	},
	{
		sizeLabel: '29-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '838182064946',
	},
	{
		sizeLabel: '33-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626117345308',
	},
	{
		sizeLabel: '35-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056220272919',
	},
	{
		sizeLabel: '35-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780504451711',
	},
	{
		sizeLabel: '35-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '719928579783',
	},
	{
		sizeLabel: '40-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964306693350',
	},
	{
		sizeLabel: '42-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095877127228',
	},
	{
		sizeLabel: '42-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337270776384',
	},
	{
		sizeLabel: '44-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789830034824',
	},
	{
		sizeLabel: '44-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644793301829',
	},
	{
		sizeLabel: '46-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878435051072',
	},
	{
		sizeLabel: '46-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548229719506',
	},
	{
		sizeLabel: '46-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378918533449',
	},
	{
		sizeLabel: '6 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933574104975',
	},
	{
		sizeLabel: '15.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970738058320',
	},
	{
		sizeLabel: '15.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561341420219',
	},
	{
		sizeLabel: '210-70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400478663940',
	},
	{
		sizeLabel: '34 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727209096766',
	},
	{
		sizeLabel: '215-70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729371237717',
	},
	{
		sizeLabel: '220-72 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420015688879',
	},
	{
		sizeLabel: '225-72 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '026097394179',
	},
	{
		sizeLabel: '230-74 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140907964039',
	},
	{
		sizeLabel: '235-74 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175128103943',
	},
	{
		sizeLabel: '240-76 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859763488592',
	},
	{
		sizeLabel: '245-76 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028257361276',
	},
	{
		sizeLabel: '250-78 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264437122764',
	},
	{
		sizeLabel: '255-78 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605380677894',
	},
	{
		sizeLabel: '260-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227574685727',
	},
	{
		sizeLabel: '265-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533087487887',
	},
	{
		sizeLabel: '270-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654234754051',
	},
	{
		sizeLabel: '275-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181173361405',
	},
	{
		sizeLabel: '280-90 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467432325861',
	},
	{
		sizeLabel: '285-90 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309683437954',
	},
	{
		sizeLabel: '290-95 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174331689856',
	},
	{
		sizeLabel: '295-95 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516336540759',
	},
	{
		sizeLabel: '225-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401444622711',
	},
	{
		sizeLabel: '230-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063874989402',
	},
	{
		sizeLabel: '235-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '593613350625',
	},
	{
		sizeLabel: '245-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819180503343',
	},
	{
		sizeLabel: '260-98 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532698952403',
	},
	{
		sizeLabel: '265-100 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415812427123',
	},
	{
		sizeLabel: '270-100 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393145817235',
	},
	{
		sizeLabel: '275-102 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403964905583',
	},
	{
		sizeLabel: '280-102 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906479200423',
	},
	{
		sizeLabel: '285-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833095665048',
	},
	{
		sizeLabel: '290-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758887265332',
	},
	{
		sizeLabel: '295-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798865729443',
	},
	{
		sizeLabel: '300-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914189958976',
	},
	{
		sizeLabel: '305-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070911356176',
	},
	{
		sizeLabel: '28 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488115059414',
	},
	{
		sizeLabel: '155-76A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913933749250',
	},
	{
		sizeLabel: '170-96A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415821327938',
	},
	{
		sizeLabel: '175-100A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907074369296',
	},
	{
		sizeLabel: '180-104B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804165708218',
	},
	{
		sizeLabel: '185-108B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513490541483',
	},
	{
		sizeLabel: '190-112B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '358654751694',
	},
	{
		sizeLabel: '190-112C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800860127105',
	},
	{
		sizeLabel: '190-116C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532722005730',
	},
	{
		sizeLabel: '170-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906077184950',
	},
	{
		sizeLabel: '175-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828890921543',
	},
	{
		sizeLabel: '180-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566982072734',
	},
	{
		sizeLabel: '190-102B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632921044301',
	},
	{
		sizeLabel: '190-106C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897598454471',
	},
	{
		sizeLabel: '190-110C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385831336186',
	},
	{
		sizeLabel: '155-58A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639691563136',
	},
	{
		sizeLabel: '21 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147968657480',
	},
	{
		sizeLabel: '155-60A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170090144225',
	},
	{
		sizeLabel: '155-62A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '843753448312',
	},
	{
		sizeLabel: '23 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732008776746',
	},
	{
		sizeLabel: '155-64A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662017103108',
	},
	{
		sizeLabel: '25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '444002059399',
	},
	{
		sizeLabel: '160-68A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954664007694',
	},
	{
		sizeLabel: '165-70A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049417981669',
	},
	{
		sizeLabel: '27 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545396933350',
	},
	{
		sizeLabel: '170-74A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236454886570',
	},
	{
		sizeLabel: '170-76A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888628401540',
	},
	{
		sizeLabel: '170-78A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038929229866',
	},
	{
		sizeLabel: '175-92B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336579019738',
	},
	{
		sizeLabel: '35 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475996060691',
	},
	{
		sizeLabel: '175-94B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267871782747',
	},
	{
		sizeLabel: '170-94A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327863101782',
	},
	{
		sizeLabel: '175-98A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '590786659136',
	},
	{
		sizeLabel: '180-102A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934270115488',
	},
	{
		sizeLabel: '34 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '218285520742',
	},
	{
		sizeLabel: '37 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766801481302',
	},
	{
		sizeLabel: '39 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038917325711',
	},
	{
		sizeLabel: '40 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566064303544',
	},
	{
		sizeLabel: '41 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223028879505',
	},
	{
		sizeLabel: '42 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024104429030',
	},
	{
		sizeLabel: '37 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694832782853',
	},
	{
		sizeLabel: '37 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353404606241',
	},
	{
		sizeLabel: '38 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216820376254',
	},
	{
		sizeLabel: '39 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001370884327',
	},
	{
		sizeLabel: '39 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226379046625',
	},
	{
		sizeLabel: '40 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246915822444',
	},
	{
		sizeLabel: '41 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580340046005',
	},
	{
		sizeLabel: '41 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248133720737',
	},
	{
		sizeLabel: '42 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059778363513',
	},
	{
		sizeLabel: '43 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750887451455',
	},
	{
		sizeLabel: '43 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066727106134',
	},
	{
		sizeLabel: '43 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994891639770',
	},
	{
		sizeLabel: '44 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044114548528',
	},
	{
		sizeLabel: '44 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081317015988',
	},
	{
		sizeLabel: '45 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461957316818',
	},
	{
		sizeLabel: '45 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283610008778',
	},
	{
		sizeLabel: '45 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487757212171',
	},
	{
		sizeLabel: '46 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084420290827',
	},
	{
		sizeLabel: '46 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688469720989',
	},
	{
		sizeLabel: '46 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630271384601',
	},
	{
		sizeLabel: '47 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253777276441',
	},
	{
		sizeLabel: '47 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514728647019',
	},
	{
		sizeLabel: '47 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '326419569352',
	},
	{
		sizeLabel: '47 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081343466813',
	},
	{
		sizeLabel: '48 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234082449730',
	},
	{
		sizeLabel: '48 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514439175851',
	},
	{
		sizeLabel: '48 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628977019538',
	},
	{
		sizeLabel: '48 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852716828051',
	},
	{
		sizeLabel: '2XL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '423807701328',
	},
	{
		sizeLabel: '3XL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309743803999',
	},
	{
		sizeLabel: '4XL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319104396925',
	},
	{
		sizeLabel: '50 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567442377380',
	},
	{
		sizeLabel: '5XL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476653210240',
	},
	{
		sizeLabel: '125 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136474337666',
	},
	{
		sizeLabel: '52 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408463034946',
	},
	{
		sizeLabel: '54 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852046370345',
	},
	{
		sizeLabel: '56 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625175643613',
	},
	{
		sizeLabel: 'XXS (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122371354752',
	},
	{
		sizeLabel: 'XS (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363291160201',
	},
	{
		sizeLabel: 'S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '509706871835',
	},
	{
		sizeLabel: 'M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135826047446',
	},
	{
		sizeLabel: 'L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404936359296',
	},
	{
		sizeLabel: 'XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286339006029',
	},
	{
		sizeLabel: 'XXL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481384405460',
	},
	{
		sizeLabel: 'XS T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752760191589',
	},
	{
		sizeLabel: '0T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '068535577312',
	},
	{
		sizeLabel: '2T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457723112860',
	},
	{
		sizeLabel: 'S T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713868052446',
	},
	{
		sizeLabel: '4T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862753961505',
	},
	{
		sizeLabel: '6T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923491921543',
	},
	{
		sizeLabel: 'M T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196633799376',
	},
	{
		sizeLabel: '8T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327725807281',
	},
	{
		sizeLabel: '10T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032957706354',
	},
	{
		sizeLabel: 'L T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760486466495',
	},
	{
		sizeLabel: '12T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604084635227',
	},
	{
		sizeLabel: '14T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197208647527',
	},
	{
		sizeLabel: 'XL T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187683808648',
	},
	{
		sizeLabel: '16T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989633269965',
	},
	{
		sizeLabel: '18T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083399971810',
	},
	{
		sizeLabel: '2XL T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644913678058',
	},
	{
		sizeLabel: '20T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504372893821',
	},
	{
		sizeLabel: 'XXS P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213773727778',
	},
	{
		sizeLabel: '00P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192009120233',
	},
	{
		sizeLabel: 'XS P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690885675314',
	},
	{
		sizeLabel: '0P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513499070523',
	},
	{
		sizeLabel: '2P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402592101568',
	},
	{
		sizeLabel: 'S P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546173945184',
	},
	{
		sizeLabel: '4P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331171115218',
	},
	{
		sizeLabel: '6P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943169069723',
	},
	{
		sizeLabel: 'M P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563278710044',
	},
	{
		sizeLabel: '8P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937301670020',
	},
	{
		sizeLabel: '10P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140139126634',
	},
	{
		sizeLabel: 'L P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629242620521',
	},
	{
		sizeLabel: '12P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167294376292',
	},
	{
		sizeLabel: '14P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720177745409',
	},
	{
		sizeLabel: '000P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800085786044',
	},
	{
		sizeLabel: '16P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979504283755',
	},
	{
		sizeLabel: '000T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '564222302471',
	},
	{
		sizeLabel: '00T (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881933606569',
	},
	{
		sizeLabel: '56-58 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210336896116',
	},
	{
		sizeLabel: '60-62 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328861114090',
	},
	{
		sizeLabel: '62-64 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452399275656',
	},
	{
		sizeLabel: '66-68 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160754689278',
	},
	{
		sizeLabel: '30RG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923769143949',
	},
	{
		sizeLabel: '30LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230857521096',
	},
	{
		sizeLabel: '32RG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457066090170',
	},
	{
		sizeLabel: '32LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581104164238',
	},
	{
		sizeLabel: '34RG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084251045847',
	},
	{
		sizeLabel: '34LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968207507046',
	},
	{
		sizeLabel: '36RG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839862664070',
	},
	{
		sizeLabel: '36LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877918051728',
	},
	{
		sizeLabel: '38RG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863271316978',
	},
	{
		sizeLabel: '38LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196369238963',
	},
	{
		sizeLabel: '40RG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583251543324',
	},
	{
		sizeLabel: '40LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489551093891',
	},
	{
		sizeLabel: '5-5 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977916122093',
	},
	{
		sizeLabel: '3 ½-4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416139692185',
	},
	{
		sizeLabel: '5 ½-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672976711506',
	},
	{
		sizeLabel: '6 ½-7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912781906493',
	},
	{
		sizeLabel: '8 ½-9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018384322966',
	},
	{
		sizeLabel: '1 ½-2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181542589572',
	},
	{
		sizeLabel: '4-4 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417840747096',
	},
	{
		sizeLabel: '2 ½-3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801681402026',
	},
	{
		sizeLabel: '7 ½-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605297421941',
	},
	{
		sizeLabel: '6 ½-7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667771283399',
	},
	{
		sizeLabel: '9 ½-10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478279466382',
	},
	{
		sizeLabel: '4 ½-5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804473765591',
	},
	{
		sizeLabel: '5 ½-6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312082264868',
	},
	{
		sizeLabel: '11 ½-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289177628251',
	},
	{
		sizeLabel: '12 ½-13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095889991499',
	},
	{
		sizeLabel: 'LT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062930717950',
	},
	{
		sizeLabel: 'XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138993556737',
	},
	{
		sizeLabel: 'XXLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924345660030',
	},
	{
		sizeLabel: '20 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277146557403',
	},
	{
		sizeLabel: '3C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521339780172',
	},
	{
		sizeLabel: '4C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231142969995',
	},
	{
		sizeLabel: '5C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '434448751218',
	},
	{
		sizeLabel: '6C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '747041614117',
	},
	{
		sizeLabel: '7C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '150072005204',
	},
	{
		sizeLabel: 'XXS (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254839363125',
	},
	{
		sizeLabel: 'XS (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366120890948',
	},
	{
		sizeLabel: 'S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571449431906',
	},
	{
		sizeLabel: 'M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038692515736',
	},
	{
		sizeLabel: 'L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289980524817',
	},
	{
		sizeLabel: 'XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270292939420',
	},
	{
		sizeLabel: '15-17 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520876116745',
	},
	{
		sizeLabel: '16-18 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418195098927',
	},
	{
		sizeLabel: '32 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613094514294',
	},
	{
		sizeLabel: '169-80A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743101951076',
	},
	{
		sizeLabel: '172-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043150573397',
	},
	{
		sizeLabel: '178-96A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628046760850',
	},
	{
		sizeLabel: '178-100A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466378530276',
	},
	{
		sizeLabel: '178-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831350191315',
	},
	{
		sizeLabel: '178-108A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741101931292',
	},
	{
		sizeLabel: '36E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808521589346',
	},
	{
		sizeLabel: '36F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244945440131',
	},
	{
		sizeLabel: '38B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136147640625',
	},
	{
		sizeLabel: '38C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640176430836',
	},
	{
		sizeLabel: '38D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244588257677',
	},
	{
		sizeLabel: '38E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974887390687',
	},
	{
		sizeLabel: '38F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717894288724',
	},
	{
		sizeLabel: '40B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029188147802',
	},
	{
		sizeLabel: '40C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714792162370',
	},
	{
		sizeLabel: '40D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906485011801',
	},
	{
		sizeLabel: '40E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '355110902162',
	},
	{
		sizeLabel: '40F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035599761107',
	},
	{
		sizeLabel: '42B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '786043589028',
	},
	{
		sizeLabel: '42C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177136588254',
	},
	{
		sizeLabel: '42D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021291901732',
	},
	{
		sizeLabel: '42E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852847659897',
	},
	{
		sizeLabel: '42F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252712736216',
	},
	{
		sizeLabel: '44B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858708415530',
	},
	{
		sizeLabel: '44C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089844901872',
	},
	{
		sizeLabel: '44D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288923678760',
	},
	{
		sizeLabel: '44E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408595169414',
	},
	{
		sizeLabel: '44F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025111030499',
	},
	{
		sizeLabel: '11-13 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443474888125',
	},
	{
		sizeLabel: '12-14 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819752492144',
	},
	{
		sizeLabel: '21-23 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733308625700',
	},
	{
		sizeLabel: '18-20 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383955158335',
	},
	{
		sizeLabel: '22-23 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152072270263',
	},
	{
		sizeLabel: '0-2 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706026735157',
	},
	{
		sizeLabel: '24-25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562512467783',
	},
	{
		sizeLabel: '4-6 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498068476344',
	},
	{
		sizeLabel: '26-27 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241036752206',
	},
	{
		sizeLabel: '30-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699600190554',
	},
	{
		sizeLabel: '28-29 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017177163634',
	},
	{
		sizeLabel: '10-12 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818314849019',
	},
	{
		sizeLabel: '30-31 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926993022346',
	},
	{
		sizeLabel: '9-11 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267887246998',
	},
	{
		sizeLabel: '42A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496177129311',
	},
	{
		sizeLabel: '42B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975352972637',
	},
	{
		sizeLabel: '42C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '595241582092',
	},
	{
		sizeLabel: '42D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193879827127',
	},
	{
		sizeLabel: '65DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878210043026',
	},
	{
		sizeLabel: '42DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041273090273',
	},
	{
		sizeLabel: '42F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238138749249',
	},
	{
		sizeLabel: '42G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414358365372',
	},
	{
		sizeLabel: '44A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '229357099169',
	},
	{
		sizeLabel: '44B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '590990724740',
	},
	{
		sizeLabel: '44C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091537442564',
	},
	{
		sizeLabel: '44D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079405160168',
	},
	{
		sizeLabel: '70DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901569092975',
	},
	{
		sizeLabel: '44DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '976289344115',
	},
	{
		sizeLabel: '44F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '355924402910',
	},
	{
		sizeLabel: '44G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010730340288',
	},
	{
		sizeLabel: '46A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609191416489',
	},
	{
		sizeLabel: '46B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846688988017',
	},
	{
		sizeLabel: '46C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305235326236',
	},
	{
		sizeLabel: '46D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114654832657',
	},
	{
		sizeLabel: '75DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325138082149',
	},
	{
		sizeLabel: '46DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154694989232',
	},
	{
		sizeLabel: '46F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979531100620',
	},
	{
		sizeLabel: '46G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714677862499',
	},
	{
		sizeLabel: '48A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992682261786',
	},
	{
		sizeLabel: '48B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428584781987',
	},
	{
		sizeLabel: '48C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185343677356',
	},
	{
		sizeLabel: '48D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265333182754',
	},
	{
		sizeLabel: '80DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215210103518',
	},
	{
		sizeLabel: '48DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365571322804',
	},
	{
		sizeLabel: '48F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881408268760',
	},
	{
		sizeLabel: '48G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602281253299',
	},
	{
		sizeLabel: '50A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098893457400',
	},
	{
		sizeLabel: '50B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168306538120',
	},
	{
		sizeLabel: '50C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903497019280',
	},
	{
		sizeLabel: '50D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693019281731',
	},
	{
		sizeLabel: '85DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972858192157',
	},
	{
		sizeLabel: '50DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374234508380',
	},
	{
		sizeLabel: '50F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657812964515',
	},
	{
		sizeLabel: '50G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057440834972',
	},
	{
		sizeLabel: '52A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204396670783',
	},
	{
		sizeLabel: '52B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759569272569',
	},
	{
		sizeLabel: '52C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275097080531',
	},
	{
		sizeLabel: '52D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652242840087',
	},
	{
		sizeLabel: '90DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655639072816',
	},
	{
		sizeLabel: '52DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052655308814',
	},
	{
		sizeLabel: '52F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525816821356',
	},
	{
		sizeLabel: '52G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086229324939',
	},
	{
		sizeLabel: '54A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775648484500',
	},
	{
		sizeLabel: '54B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847301667598',
	},
	{
		sizeLabel: '54C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827843493843',
	},
	{
		sizeLabel: '54D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '229478974427',
	},
	{
		sizeLabel: '95DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '302114347130',
	},
	{
		sizeLabel: '54DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903087108466',
	},
	{
		sizeLabel: '54F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299428512790',
	},
	{
		sizeLabel: '54G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823174608921',
	},
	{
		sizeLabel: '56A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378286729057',
	},
	{
		sizeLabel: '56B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408325960954',
	},
	{
		sizeLabel: '56C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561244486712',
	},
	{
		sizeLabel: '56D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005550627455',
	},
	{
		sizeLabel: '100DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485928984656',
	},
	{
		sizeLabel: '56DD+E (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774437249618',
	},
	{
		sizeLabel: '56F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606559090997',
	},
	{
		sizeLabel: '56G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034673743763',
	},
	{
		sizeLabel: '1-2 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007492442214',
	},
	{
		sizeLabel: '38-42 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450214186548',
	},
	{
		sizeLabel: '3 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570202793367',
	},
	{
		sizeLabel: '4 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466817279252',
	},
	{
		sizeLabel: '5 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265083454461',
	},
	{
		sizeLabel: '68 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606160107729',
	},
	{
		sizeLabel: '70 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472213080233',
	},
	{
		sizeLabel: '2XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957258749757',
	},
	{
		sizeLabel: '2XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650660907116',
	},
	{
		sizeLabel: '48-52 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446434105052',
	},
	{
		sizeLabel: '3XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742497706255',
	},
	{
		sizeLabel: '3XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167922017311',
	},
	{
		sizeLabel: '52-56 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661574194677',
	},
	{
		sizeLabel: '58-62 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409335990615',
	},
	{
		sizeLabel: '4XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681945841595',
	},
	{
		sizeLabel: '62-66 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186382344811',
	},
	{
		sizeLabel: '3-4 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975270122159',
	},
	{
		sizeLabel: '35-37 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253642279146',
	},
	{
		sizeLabel: '35-37 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '076717341806',
	},
	{
		sizeLabel: '4A5 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '539207699172',
	},
	{
		sizeLabel: '35-37 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681710243749',
	},
	{
		sizeLabel: '5-6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162263259127',
	},
	{
		sizeLabel: '38-40 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033544522343',
	},
	{
		sizeLabel: '6A7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973404926805',
	},
	{
		sizeLabel: '38-40 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399540596677',
	},
	{
		sizeLabel: '7 ½-9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591230162466',
	},
	{
		sizeLabel: '41-43 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950971096148',
	},
	{
		sizeLabel: '41-43 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965293409363',
	},
	{
		sizeLabel: '8 ½A1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198544011196',
	},
	{
		sizeLabel: '41-43 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937262598436',
	},
	{
		sizeLabel: '9 ½-11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525043069793',
	},
	{
		sizeLabel: '44-46 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100830234883',
	},
	{
		sizeLabel: '10 ½A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704088607316',
	},
	{
		sizeLabel: '44-46 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479992880764',
	},
	{
		sizeLabel: '11 ½-A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '552620014188',
	},
	{
		sizeLabel: '12 ½A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107929950731',
	},
	{
		sizeLabel: '47-48 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830427762079',
	},
	{
		sizeLabel: '0 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864048474021',
	},
	{
		sizeLabel: '32 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519386252292',
	},
	{
		sizeLabel: '33 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431440814801',
	},
	{
		sizeLabel: '33 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190362702180',
	},
	{
		sizeLabel: '34 ⅔ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443615696220',
	},
	{
		sizeLabel: '36 ⅓ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015085335507',
	},
	{
		sizeLabel: '38 ⅔ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965985637443',
	},
	{
		sizeLabel: '40 ⅔ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894815252489',
	},
	{
		sizeLabel: '42 ⅔ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388689716711',
	},
	{
		sizeLabel: '43 ⅓ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518369987646',
	},
	{
		sizeLabel: '45 ⅓ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135742221020',
	},
	{
		sizeLabel: '47 ⅔ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090562004050',
	},
	{
		sizeLabel: '68',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319088986990',
	},
	{
		sizeLabel: '29 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777303344608',
	},
	{
		sizeLabel: '0-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553777861517',
	},
	{
		sizeLabel: '8-10 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754968397271',
	},
	{
		sizeLabel: '1X-2X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700761530406',
	},
	{
		sizeLabel: '3X-4X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398228464231',
	},
	{
		sizeLabel: 'ONESIZE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538847530971',
	},
	{
		sizeLabel: 'QUEEN',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608252827907',
	},
	{
		sizeLabel: 'ST',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311217257722',
	},
	{
		sizeLabel: 'MS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120122795622',
	},
	{
		sizeLabel: 'MT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673233916459',
	},
	{
		sizeLabel: 'LS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663371221272',
	},
	{
		sizeLabel: 'XLS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516177326272',
	},
	{
		sizeLabel: '36G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825907089819',
	},
	{
		sizeLabel: '36H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023348081171',
	},
	{
		sizeLabel: '36I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641826330195',
	},
	{
		sizeLabel: '36J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '434103050805',
	},
	{
		sizeLabel: '38G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132668903091',
	},
	{
		sizeLabel: '38H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518650068577',
	},
	{
		sizeLabel: '38I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812463212334',
	},
	{
		sizeLabel: '40G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '816626141090',
	},
	{
		sizeLabel: '46B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570890130827',
	},
	{
		sizeLabel: '46C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668672817444',
	},
	{
		sizeLabel: '46D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041914497933',
	},
	{
		sizeLabel: '46E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446534552763',
	},
	{
		sizeLabel: '52-54 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156500391855',
	},
	{
		sizeLabel: '24-28 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592828114113',
	},
	{
		sizeLabel: '29-33 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711617781596',
	},
	{
		sizeLabel: '34-37 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769781197824',
	},
	{
		sizeLabel: '38-41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '949674821655',
	},
	{
		sizeLabel: '42-45 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153813499248',
	},
	{
		sizeLabel: '46-49 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '339950753550',
	},
	{
		sizeLabel: '49-50',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917886967473',
	},
	{
		sizeLabel: '6 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342480437838',
	},
	{
		sizeLabel: '55 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521074988522',
	},
	{
		sizeLabel: '6 ⅞ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701067660399',
	},
	{
		sizeLabel: '55 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633634270730',
	},
	{
		sizeLabel: '57 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780361327535',
	},
	{
		sizeLabel: '7 ⅛ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428069494660',
	},
	{
		sizeLabel: '57 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037604504452',
	},
	{
		sizeLabel: '7 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688054678125',
	},
	{
		sizeLabel: '59 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518623772329',
	},
	{
		sizeLabel: '7 ⅜ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481679656385',
	},
	{
		sizeLabel: '59 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797270165897',
	},
	{
		sizeLabel: '61 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289745898900',
	},
	{
		sizeLabel: '7 ⅝ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932924267517',
	},
	{
		sizeLabel: '61 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412077483836',
	},
	{
		sizeLabel: '7 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390108415487',
	},
	{
		sizeLabel: '63 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943644586327',
	},
	{
		sizeLabel: '63 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658085013570',
	},
	{
		sizeLabel: '54-57 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353941554855',
	},
	{
		sizeLabel: '58-59 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410822694706',
	},
	{
		sizeLabel: '60-61 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294681026620',
	},
	{
		sizeLabel: '62-63 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309117454770',
	},
	{
		sizeLabel: '14 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585490472449',
	},
	{
		sizeLabel: '15 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025066748573',
	},
	{
		sizeLabel: '16 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317129521106',
	},
	{
		sizeLabel: '17 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174244758614',
	},
	{
		sizeLabel: '18 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201343893712',
	},
	{
		sizeLabel: '19 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090244297420',
	},
	{
		sizeLabel: '20 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037626852040',
	},
	{
		sizeLabel: '26-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871539579376',
	},
	{
		sizeLabel: '27-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705447563001',
	},
	{
		sizeLabel: '26-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931243392507',
	},
	{
		sizeLabel: '27-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582267009472',
	},
	{
		sizeLabel: '28-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032118526871',
	},
	{
		sizeLabel: '30DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '296401229778',
	},
	{
		sizeLabel: '0E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328517196807',
	},
	{
		sizeLabel: '30DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961824813416',
	},
	{
		sizeLabel: '0F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425439778229',
	},
	{
		sizeLabel: '8E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658365590924',
	},
	{
		sizeLabel: '65G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364435095772',
	},
	{
		sizeLabel: '0G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310975252347',
	},
	{
		sizeLabel: '8FG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429513386110',
	},
	{
		sizeLabel: '32DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831028549889',
	},
	{
		sizeLabel: '32DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651352992359',
	},
	{
		sizeLabel: '10E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '762305948129',
	},
	{
		sizeLabel: '70G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024741536815',
	},
	{
		sizeLabel: '10F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875641682494',
	},
	{
		sizeLabel: '34DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '829907532521',
	},
	{
		sizeLabel: '34DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144456287714',
	},
	{
		sizeLabel: '12E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173128025969',
	},
	{
		sizeLabel: '75G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436946558294',
	},
	{
		sizeLabel: '12F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219348585033',
	},
	{
		sizeLabel: '36DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999667578571',
	},
	{
		sizeLabel: '36DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734118722213',
	},
	{
		sizeLabel: '14E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657966611070',
	},
	{
		sizeLabel: '80G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106646483505',
	},
	{
		sizeLabel: '14F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853794398790',
	},
	{
		sizeLabel: '16A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910136933886',
	},
	{
		sizeLabel: '16B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574883362262',
	},
	{
		sizeLabel: '16C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783125921536',
	},
	{
		sizeLabel: '16D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088390945644',
	},
	{
		sizeLabel: '38DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398980095751',
	},
	{
		sizeLabel: '16DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360731942461',
	},
	{
		sizeLabel: '38DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286266296502',
	},
	{
		sizeLabel: '16E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231114568721',
	},
	{
		sizeLabel: '85G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '218062511122',
	},
	{
		sizeLabel: '16F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605425561383',
	},
	{
		sizeLabel: '18A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185516615833',
	},
	{
		sizeLabel: '18B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752504229962',
	},
	{
		sizeLabel: '18C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817990461401',
	},
	{
		sizeLabel: '18D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942377084137',
	},
	{
		sizeLabel: '40DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177728972738',
	},
	{
		sizeLabel: '18DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '936554255517',
	},
	{
		sizeLabel: '40DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803110579994',
	},
	{
		sizeLabel: '18E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605059702139',
	},
	{
		sizeLabel: '90G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153759576801',
	},
	{
		sizeLabel: '18F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581497813870',
	},
	{
		sizeLabel: '6A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535539050201',
	},
	{
		sizeLabel: '20A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '966799087321',
	},
	{
		sizeLabel: '20B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660774506094',
	},
	{
		sizeLabel: '20C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424189283135',
	},
	{
		sizeLabel: '20D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '564944277981',
	},
	{
		sizeLabel: '42DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186486830602',
	},
	{
		sizeLabel: '20DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711263499358',
	},
	{
		sizeLabel: '42DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568432905581',
	},
	{
		sizeLabel: '20E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576725464903',
	},
	{
		sizeLabel: '95G (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283083582767',
	},
	{
		sizeLabel: '20F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020495899517',
	},
	{
		sizeLabel: '3 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037636676470',
	},
	{
		sizeLabel: '43 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043800971762',
	},
	{
		sizeLabel: '64 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '844199809225',
	},
	{
		sizeLabel: '68 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265341669233',
	},
	{
		sizeLabel: 'L4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244701286961',
	},
	{
		sizeLabel: '72 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158149661364',
	},
	{
		sizeLabel: 'L6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033728834630',
	},
	{
		sizeLabel: '76 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391761243776',
	},
	{
		sizeLabel: 'L8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304549895374',
	},
	{
		sizeLabel: 'L10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498970824218',
	},
	{
		sizeLabel: '84 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087416712754',
	},
	{
		sizeLabel: 'L12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340789893330',
	},
	{
		sizeLabel: '88 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985900101625',
	},
	{
		sizeLabel: 'L14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699689386398',
	},
	{
		sizeLabel: '92 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988491999466',
	},
	{
		sizeLabel: 'L16 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943283775211',
	},
	{
		sizeLabel: '96 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868735788221',
	},
	{
		sizeLabel: 'L18 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886422110359',
	},
	{
		sizeLabel: 'L36 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789542889702',
	},
	{
		sizeLabel: '94 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998668689481',
	},
	{
		sizeLabel: 'L38 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582355279358',
	},
	{
		sizeLabel: '98 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104660127924',
	},
	{
		sizeLabel: 'L40 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '004033436156',
	},
	{
		sizeLabel: '102 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116855209210',
	},
	{
		sizeLabel: 'L42 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700967044522',
	},
	{
		sizeLabel: '106 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '211579051604',
	},
	{
		sizeLabel: 'L44 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363476614238',
	},
	{
		sizeLabel: 'L46 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902394599833',
	},
	{
		sizeLabel: 'S36 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799628680771',
	},
	{
		sizeLabel: 'S38 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144385439720',
	},
	{
		sizeLabel: 'S40 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591392915576',
	},
	{
		sizeLabel: 'S42 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470538290332',
	},
	{
		sizeLabel: 'S44 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098535411779',
	},
	{
		sizeLabel: 'S46 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887585918973',
	},
	{
		sizeLabel: 'S48 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '256230779332',
	},
	{
		sizeLabel: 'S50 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526218598980',
	},
	{
		sizeLabel: 'L30 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051311299411',
	},
	{
		sizeLabel: 'L32 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571871258655',
	},
	{
		sizeLabel: 'L34 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921394317353',
	},
	{
		sizeLabel: '114 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824244833402',
	},
	{
		sizeLabel: '118 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049837651392',
	},
	{
		sizeLabel: '27 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113024569202',
	},
	{
		sizeLabel: '56-58',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051799459992',
	},
	{
		sizeLabel: '60-62',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608140744957',
	},
	{
		sizeLabel: '64-66',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765045120457',
	},
	{
		sizeLabel: '66 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452241655125',
	},
	{
		sizeLabel: '68-70',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599293498175',
	},
	{
		sizeLabel: '72-74',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452130810676',
	},
	{
		sizeLabel: '74 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418850260475',
	},
	{
		sizeLabel: '76-78',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346597898715',
	},
	{
		sizeLabel: '78 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350424656794',
	},
	{
		sizeLabel: '51-52',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927872623770',
	},
	{
		sizeLabel: '53-54',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467252940286',
	},
	{
		sizeLabel: '140',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525494075184',
	},
	{
		sizeLabel: '150',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508399340882',
	},
	{
		sizeLabel: '64-66 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749885396054',
	},
	{
		sizeLabel: '68-70 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023941837573',
	},
	{
		sizeLabel: '72-74 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804340194038',
	},
	{
		sizeLabel: '2-4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594447166663',
	},
	{
		sizeLabel: '66',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034912821886',
	},
	{
		sizeLabel: '125 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599232111321',
	},
	{
		sizeLabel: '1-2-XS-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380936180252',
	},
	{
		sizeLabel: '3-4-M-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264239522849',
	},
	{
		sizeLabel: '5-6-XL-XXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722458532752',
	},
	{
		sizeLabel: '35 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457812858259',
	},
	{
		sizeLabel: '32K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058760179975',
	},
	{
		sizeLabel: '34K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545152626963',
	},
	{
		sizeLabel: '36K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431484729451',
	},
	{
		sizeLabel: '38K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294963558030',
	},
	{
		sizeLabel: '40K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259191763490',
	},
	{
		sizeLabel: '42K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575612072740',
	},
	{
		sizeLabel: '44K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149234162357',
	},
	{
		sizeLabel: '46K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385932719132',
	},
	{
		sizeLabel: '48K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898921124962',
	},
	{
		sizeLabel: '50K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633500827252',
	},
	{
		sizeLabel: '52K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885346894981',
	},
	{
		sizeLabel: '54K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '920133189846',
	},
	{
		sizeLabel: '56K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999437020481',
	},
	{
		sizeLabel: '35-37 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212645595365',
	},
	{
		sizeLabel: '6 ½-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095197972004',
	},
	{
		sizeLabel: '7-8 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935973033303',
	},
	{
		sizeLabel: '41-43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526964211326',
	},
	{
		sizeLabel: '8 ½-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633822459473',
	},
	{
		sizeLabel: '3-5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554597703594',
	},
	{
		sizeLabel: '36-39 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798689668430',
	},
	{
		sizeLabel: '4-6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014044842910',
	},
	{
		sizeLabel: '6-8 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416438943756',
	},
	{
		sizeLabel: '40-43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489230813945',
	},
	{
		sizeLabel: '7-9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673854686051',
	},
	{
		sizeLabel: '9-11 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475834052041',
	},
	{
		sizeLabel: '44-47 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '287017837110',
	},
	{
		sizeLabel: '10-12 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429393581460',
	},
	{
		sizeLabel: '12 + (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248099099096',
	},
	{
		sizeLabel: '48 + (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169555008140',
	},
	{
		sizeLabel: '13 + (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890163867192',
	},
	{
		sizeLabel: 'ONE SIZE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196352816258',
	},
	{
		sizeLabel: '58-60 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703659298751',
	},
	{
		sizeLabel: '6 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819602088281',
	},
	{
		sizeLabel: '7 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779078675203',
	},
	{
		sizeLabel: '7 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849430733320',
	},
	{
		sizeLabel: '8 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147151064378',
	},
	{
		sizeLabel: '8 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050815579355',
	},
	{
		sizeLabel: '9 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815963449283',
	},
	{
		sizeLabel: '9 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911814973260',
	},
	{
		sizeLabel: '10 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967152008933',
	},
	{
		sizeLabel: '10 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027090429547',
	},
	{
		sizeLabel: '11 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347049544695',
	},
	{
		sizeLabel: '5-5 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336411244867',
	},
	{
		sizeLabel: '6-6 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174157233013',
	},
	{
		sizeLabel: '7-7 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780087724671',
	},
	{
		sizeLabel: '8-8 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754958279964',
	},
	{
		sizeLabel: '9-9 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '293111091947',
	},
	{
		sizeLabel: '10-10 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600504959446',
	},
	{
		sizeLabel: '14H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558053038787',
	},
	{
		sizeLabel: '15H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549507840500',
	},
	{
		sizeLabel: '16H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721300340614',
	},
	{
		sizeLabel: '17H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065973844432',
	},
	{
		sizeLabel: '18H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961762560094',
	},
	{
		sizeLabel: '19H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190951707688',
	},
	{
		sizeLabel: '2XLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927997033639',
	},
	{
		sizeLabel: '3XLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713210281870',
	},
	{
		sizeLabel: '19-21 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915649321531',
	},
	{
		sizeLabel: '35 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401863840232',
	},
	{
		sizeLabel: '35 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223530557721',
	},
	{
		sizeLabel: '36 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216244323096',
	},
	{
		sizeLabel: '23-23 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808268593142',
	},
	{
		sizeLabel: '37 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557476237180',
	},
	{
		sizeLabel: '25 ½-24 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951802225065',
	},
	{
		sizeLabel: '38 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807929392639',
	},
	{
		sizeLabel: '39 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890504492303',
	},
	{
		sizeLabel: '40 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500086399680',
	},
	{
		sizeLabel: '41 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074931975522',
	},
	{
		sizeLabel: '42 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691935895819',
	},
	{
		sizeLabel: '43 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226962183118',
	},
	{
		sizeLabel: '44 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860855973717',
	},
	{
		sizeLabel: '45 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568234413114',
	},
	{
		sizeLabel: '46 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075130639739',
	},
	{
		sizeLabel: '46 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055775935674',
	},
	{
		sizeLabel: '47 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225996362639',
	},
	{
		sizeLabel: '6 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860943125721',
	},
	{
		sizeLabel: '6 ⅞ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '031252085850',
	},
	{
		sizeLabel: '7 ⅛ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781042617029',
	},
	{
		sizeLabel: '7 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405530081522',
	},
	{
		sizeLabel: '7 ⅜ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060313560282',
	},
	{
		sizeLabel: '7 ⅝ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205606009237',
	},
	{
		sizeLabel: '228 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480023241637',
	},
	{
		sizeLabel: '24.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927283115903',
	},
	{
		sizeLabel: '242 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488963271930',
	},
	{
		sizeLabel: '24.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823808675768',
	},
	{
		sizeLabel: '248 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891389291827',
	},
	{
		sizeLabel: '26.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507747032943',
	},
	{
		sizeLabel: '262 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756224469887',
	},
	{
		sizeLabel: '28.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235550737257',
	},
	{
		sizeLabel: '282 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343003383793',
	},
	{
		sizeLabel: '28.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000636687152',
	},
	{
		sizeLabel: '287 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182230499687',
	},
	{
		sizeLabel: '30 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640347927998',
	},
	{
		sizeLabel: '58 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703964581160',
	},
	{
		sizeLabel: '60 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832361671322',
	},
	{
		sizeLabel: '34-38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '986600362687',
	},
	{
		sizeLabel: '4-7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319363873268',
	},
	{
		sizeLabel: '38-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643272568804',
	},
	{
		sizeLabel: '7-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415944732960',
	},
	{
		sizeLabel: '37-40 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538139277930',
	},
	{
		sizeLabel: '5 ½-7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439380975428',
	},
	{
		sizeLabel: '40 ½-43 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779058981544',
	},
	{
		sizeLabel: '7 ½-10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712261813591',
	},
	{
		sizeLabel: '43 ½-46 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954086047000',
	},
	{
		sizeLabel: '10 ½-13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270723532416',
	},
	{
		sizeLabel: '34S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171161304549',
	},
	{
		sizeLabel: '34R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161990508909',
	},
	{
		sizeLabel: '34L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351007664427',
	},
	{
		sizeLabel: '36S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855169785751',
	},
	{
		sizeLabel: '36R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691594073842',
	},
	{
		sizeLabel: '36L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232578149037',
	},
	{
		sizeLabel: '38S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166441245167',
	},
	{
		sizeLabel: '38R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987773162616',
	},
	{
		sizeLabel: '38L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546505606930',
	},
	{
		sizeLabel: '40S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886520054847',
	},
	{
		sizeLabel: '40R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173811313661',
	},
	{
		sizeLabel: '40L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913178724062',
	},
	{
		sizeLabel: '42S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777916580283',
	},
	{
		sizeLabel: '42R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898885575003',
	},
	{
		sizeLabel: '42L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569566569027',
	},
	{
		sizeLabel: '44S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036748180927',
	},
	{
		sizeLabel: '44R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140929645517',
	},
	{
		sizeLabel: '44L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203144520523',
	},
	{
		sizeLabel: '46S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634908842464',
	},
	{
		sizeLabel: '46R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466130888711',
	},
	{
		sizeLabel: '46L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105544102434',
	},
	{
		sizeLabel: '48S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240207176479',
	},
	{
		sizeLabel: '48R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247088698813',
	},
	{
		sizeLabel: '48L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865379909362',
	},
	{
		sizeLabel: '50S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633665221954',
	},
	{
		sizeLabel: '50R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220576307657',
	},
	{
		sizeLabel: '50L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '004306456718',
	},
	{
		sizeLabel: '52S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642010938039',
	},
	{
		sizeLabel: '52R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438839875365',
	},
	{
		sizeLabel: '52L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563661072636',
	},
	{
		sizeLabel: '19 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642877931417',
	},
	{
		sizeLabel: '20 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354328066560',
	},
	{
		sizeLabel: '28S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582434536652',
	},
	{
		sizeLabel: '28R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118374369975',
	},
	{
		sizeLabel: '28L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544043367379',
	},
	{
		sizeLabel: '30S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901930772055',
	},
	{
		sizeLabel: '30R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740109877737',
	},
	{
		sizeLabel: '30L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309209058111',
	},
	{
		sizeLabel: '32S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706488843226',
	},
	{
		sizeLabel: '32R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122772705467',
	},
	{
		sizeLabel: '32L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225411613508',
	},
	{
		sizeLabel: '150-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251475065684',
	},
	{
		sizeLabel: '155-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923194836988',
	},
	{
		sizeLabel: '160-88 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303621038101',
	},
	{
		sizeLabel: '165-92 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367940923495',
	},
	{
		sizeLabel: '170-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018944602266',
	},
	{
		sizeLabel: '175-100 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371153596457',
	},
	{
		sizeLabel: '180-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742988440814',
	},
	{
		sizeLabel: '150-60 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883687563834',
	},
	{
		sizeLabel: '155-64 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255892911434',
	},
	{
		sizeLabel: '160-68 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '603502637713',
	},
	{
		sizeLabel: '165-72 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106296592019',
	},
	{
		sizeLabel: '170-76 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463090246141',
	},
	{
		sizeLabel: '175-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '377615424029',
	},
	{
		sizeLabel: '180-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159172792944',
	},
	{
		sizeLabel: '46-48 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273064832280',
	},
	{
		sizeLabel: '46-48 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '731686252028',
	},
	{
		sizeLabel: '58-60 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975599210937',
	},
	{
		sizeLabel: '58-60 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825808438722',
	},
	{
		sizeLabel: '62 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764735939247',
	},
	{
		sizeLabel: '62 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380064188613',
	},
	{
		sizeLabel: '30HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161943936760',
	},
	{
		sizeLabel: '32HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657334614636',
	},
	{
		sizeLabel: '36HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978460737327',
	},
	{
		sizeLabel: '38HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879582707794',
	},
	{
		sizeLabel: '40GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128489836483',
	},
	{
		sizeLabel: '40HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897790991606',
	},
	{
		sizeLabel: '42GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034585950778',
	},
	{
		sizeLabel: '42HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145727570714',
	},
	{
		sizeLabel: '44FF (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335966099444',
	},
	{
		sizeLabel: '44GG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787623036637',
	},
	{
		sizeLabel: '44HH (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757903415559',
	},
	{
		sizeLabel: '5-7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933179303251',
	},
	{
		sizeLabel: '6-8 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784525816209',
	},
	{
		sizeLabel: '7-9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673955196953',
	},
	{
		sizeLabel: '32-34 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667539410199',
	},
	{
		sizeLabel: '36-38 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915743269182',
	},
	{
		sizeLabel: '40-42 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024632608491',
	},
	{
		sizeLabel: '48-50 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908744589189',
	},
	{
		sizeLabel: '24-26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '486856568601',
	},
	{
		sizeLabel: '1XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416525582375',
	},
	{
		sizeLabel: '86D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965894666885',
	},
	{
		sizeLabel: '32E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333015606203',
	},
	{
		sizeLabel: '34E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878015341626',
	},
	{
		sizeLabel: '38A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494909860976',
	},
	{
		sizeLabel: '38DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632939612142',
	},
	{
		sizeLabel: '62 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126697983927',
	},
	{
		sizeLabel: '64 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499346665174',
	},
	{
		sizeLabel: '66 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382928324294',
	},
	{
		sizeLabel: '80 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409452996896',
	},
	{
		sizeLabel: '84 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104667994366',
	},
	{
		sizeLabel: '94 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237404318729',
	},
	{
		sizeLabel: '88 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498387210120',
	},
	{
		sizeLabel: '98 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443837326106',
	},
	{
		sizeLabel: '92 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505304141880',
	},
	{
		sizeLabel: '102 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172728924540',
	},
	{
		sizeLabel: '96 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '272511163138',
	},
	{
		sizeLabel: '106 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438880282208',
	},
	{
		sizeLabel: '100 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921045487865',
	},
	{
		sizeLabel: '17.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579512057577',
	},
	{
		sizeLabel: '1-2 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033019511269',
	},
	{
		sizeLabel: '3-4 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '139704076945',
	},
	{
		sizeLabel: '70B-65C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '716538133464',
	},
	{
		sizeLabel: '80A-75B-70C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228324673081',
	},
	{
		sizeLabel: '80B-75C-70D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916526304587',
	},
	{
		sizeLabel: '85B-80C-75D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946602079117',
	},
	{
		sizeLabel: '90B-85C-80D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890845347548',
	},
	{
		sizeLabel: '95B-90C-85D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815774961460',
	},
	{
		sizeLabel: '100B-95C-90D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512663734786',
	},
	{
		sizeLabel: '35 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703185011569',
	},
	{
		sizeLabel: '36 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329406709573',
	},
	{
		sizeLabel: '37 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847924862578',
	},
	{
		sizeLabel: '38 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198654489281',
	},
	{
		sizeLabel: '39 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718242862373',
	},
	{
		sizeLabel: '40 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777396764459',
	},
	{
		sizeLabel: '41 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340514406030',
	},
	{
		sizeLabel: '41 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904343431862',
	},
	{
		sizeLabel: '42 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658950806165',
	},
	{
		sizeLabel: '42 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411527926649',
	},
	{
		sizeLabel: '43 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743711619185',
	},
	{
		sizeLabel: '43 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270473035710',
	},
	{
		sizeLabel: '44 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531000037972',
	},
	{
		sizeLabel: '45 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232572496708',
	},
	{
		sizeLabel: '46 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457221214846',
	},
	{
		sizeLabel: '47 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854646152330',
	},
	{
		sizeLabel: '48 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817376675047',
	},
	{
		sizeLabel: '49 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826692997647',
	},
	{
		sizeLabel: '49 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098103434014',
	},
	{
		sizeLabel: '50 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924088512657',
	},
	{
		sizeLabel: '51 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824655930724',
	},
	{
		sizeLabel: '51 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770649393215',
	},
	{
		sizeLabel: '2-5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862280516479',
	},
	{
		sizeLabel: '5-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '491383452633',
	},
	{
		sizeLabel: '35-38 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416944903006',
	},
	{
		sizeLabel: '6-9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449360107916',
	},
	{
		sizeLabel: '9-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251289232585',
	},
	{
		sizeLabel: '39-42 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974046753947',
	},
	{
		sizeLabel: '10-11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902614663264',
	},
	{
		sizeLabel: '43-44 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598799730459',
	},
	{
		sizeLabel: '4-5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540017211543',
	},
	{
		sizeLabel: '5 ½-8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337322147024',
	},
	{
		sizeLabel: '6 ½-9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '896201103260',
	},
	{
		sizeLabel: '9-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690969093506',
	},
	{
		sizeLabel: '9 ½-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570423790686',
	},
	{
		sizeLabel: '34-36 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906719611141',
	},
	{
		sizeLabel: '34-36 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624990879881',
	},
	{
		sizeLabel: '42-44 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '229869272705',
	},
	{
		sizeLabel: '42-44 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965945566211',
	},
	{
		sizeLabel: '477 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669458242712',
	},
	{
		sizeLabel: 'MB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879426534689',
	},
	{
		sizeLabel: 'LB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255044099249',
	},
	{
		sizeLabel: '25-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609611407961',
	},
	{
		sizeLabel: '25-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '816922509838',
	},
	{
		sizeLabel: '118',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653101752742',
	},
	{
		sizeLabel: '37 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021615944281',
	},
	{
		sizeLabel: '38 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736730945926',
	},
	{
		sizeLabel: '41 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210057774504',
	},
	{
		sizeLabel: '42 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033359978753',
	},
	{
		sizeLabel: '47 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903025163800',
	},
	{
		sizeLabel: 'XS (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889616856275',
	},
	{
		sizeLabel: 'S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634578266151',
	},
	{
		sizeLabel: 'M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851230719327',
	},
	{
		sizeLabel: 'L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717686527342',
	},
	{
		sizeLabel: 'XL (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919320218853',
	},
	{
		sizeLabel: 'XXL (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024091365806',
	},
	{
		sizeLabel: '165-62A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394172612096',
	},
	{
		sizeLabel: '170-66A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202195046464',
	},
	{
		sizeLabel: '175-70A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108538510636',
	},
	{
		sizeLabel: '175-74A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729413361012',
	},
	{
		sizeLabel: '44 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661954762056',
	},
	{
		sizeLabel: '60-62 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835039378909',
	},
	{
		sizeLabel: '64-66 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471353103074',
	},
	{
		sizeLabel: '68-70 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661638058734',
	},
	{
		sizeLabel: '72-74 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503574057284',
	},
	{
		sizeLabel: '76-78 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164453009276',
	},
	{
		sizeLabel: '80 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060688728192',
	},
	{
		sizeLabel: 'LM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140930195050',
	},
	{
		sizeLabel: '98 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578516570319',
	},
	{
		sizeLabel: 'LL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057245453806',
	},
	{
		sizeLabel: '102 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091814705868',
	},
	{
		sizeLabel: 'LXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422194200970',
	},
	{
		sizeLabel: '106 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155597566626',
	},
	{
		sizeLabel: 'L2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767466571214',
	},
	{
		sizeLabel: '110 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742940748005',
	},
	{
		sizeLabel: 'SL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924412574426',
	},
	{
		sizeLabel: '26 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '031063048837',
	},
	{
		sizeLabel: 'SXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198682839898',
	},
	{
		sizeLabel: '27 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133257526406',
	},
	{
		sizeLabel: 'S2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263654639954',
	},
	{
		sizeLabel: '4 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918985244430',
	},
	{
		sizeLabel: '5 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975496062695',
	},
	{
		sizeLabel: '6 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743300879601',
	},
	{
		sizeLabel: '7 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727719844303',
	},
	{
		sizeLabel: '8 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943092977219',
	},
	{
		sizeLabel: '9 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634802803358',
	},
	{
		sizeLabel: '10 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787152348513',
	},
	{
		sizeLabel: '12 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109969516937',
	},
	{
		sizeLabel: '14 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134556496552',
	},
	{
		sizeLabel: '16 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876113430045',
	},
	{
		sizeLabel: '18 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '433062161080',
	},
	{
		sizeLabel: '70 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '316989470580',
	},
	{
		sizeLabel: '72 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301136217318',
	},
	{
		sizeLabel: '74 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '180648680977',
	},
	{
		sizeLabel: '155-68A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553037704295',
	},
	{
		sizeLabel: '46 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569516526233',
	},
	{
		sizeLabel: '160-70A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942742408812',
	},
	{
		sizeLabel: '48 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621761443645',
	},
	{
		sizeLabel: '160-72A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568288222654',
	},
	{
		sizeLabel: '50 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947745383617',
	},
	{
		sizeLabel: '52 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '843768585856',
	},
	{
		sizeLabel: '54 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393467116261',
	},
	{
		sizeLabel: '56 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051438520300',
	},
	{
		sizeLabel: '58 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622839709939',
	},
	{
		sizeLabel: '60 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452930188758',
	},
	{
		sizeLabel: '165-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319389649675',
	},
	{
		sizeLabel: '48-50 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667428140050',
	},
	{
		sizeLabel: '100-105 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701287371025',
	},
	{
		sizeLabel: '170-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913508469409',
	},
	{
		sizeLabel: '34 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530143252069',
	},
	{
		sizeLabel: '170-72A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592721080723',
	},
	{
		sizeLabel: '2-3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060470974638',
	},
	{
		sizeLabel: '36-37 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797266976703',
	},
	{
		sizeLabel: '35-36 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228724164099',
	},
	{
		sizeLabel: '22-24 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849046689950',
	},
	{
		sizeLabel: '220-240 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614537434792',
	},
	{
		sizeLabel: '22-24 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376273192848',
	},
	{
		sizeLabel: '38-39 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898641226722',
	},
	{
		sizeLabel: '37-38 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785159722613',
	},
	{
		sizeLabel: '24-25 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236469053304',
	},
	{
		sizeLabel: '240-250 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599848950373',
	},
	{
		sizeLabel: '24-25 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045500286398',
	},
	{
		sizeLabel: '6-7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052702204823',
	},
	{
		sizeLabel: '40-41 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101275905754',
	},
	{
		sizeLabel: '39-40 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755185848172',
	},
	{
		sizeLabel: '26-27 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389355799889',
	},
	{
		sizeLabel: '260-270 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '857293971935',
	},
	{
		sizeLabel: '26-27 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210593383537',
	},
	{
		sizeLabel: '6-7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761632151189',
	},
	{
		sizeLabel: '24 ½-25 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166434184530',
	},
	{
		sizeLabel: '245-255 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062737308681',
	},
	{
		sizeLabel: '24 ½-25 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916862880978',
	},
	{
		sizeLabel: '8-9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077908312993',
	},
	{
		sizeLabel: '26 ½-27 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702589978155',
	},
	{
		sizeLabel: '265-275 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961211011570',
	},
	{
		sizeLabel: '26 ½-27 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841960069802',
	},
	{
		sizeLabel: '42-43 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947550141216',
	},
	{
		sizeLabel: '28 ½-29 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196776637216',
	},
	{
		sizeLabel: '285-295 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311760574365',
	},
	{
		sizeLabel: '88 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248742875354',
	},
	{
		sizeLabel: '92 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096236110318',
	},
	{
		sizeLabel: '96 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '355344021479',
	},
	{
		sizeLabel: '100 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397742521498',
	},
	{
		sizeLabel: '104 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782481550945',
	},
	{
		sizeLabel: '104 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941573520378',
	},
	{
		sizeLabel: '108 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744188707920',
	},
	{
		sizeLabel: '108 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '848291448433',
	},
	{
		sizeLabel: '112 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097550872320',
	},
	{
		sizeLabel: '112 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926035446522',
	},
	{
		sizeLabel: '116 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081879670594',
	},
	{
		sizeLabel: '116 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530486958042',
	},
	{
		sizeLabel: '120 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '848411590651',
	},
	{
		sizeLabel: '120 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013401671475',
	},
	{
		sizeLabel: 'T1 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544902538894',
	},
	{
		sizeLabel: 'T2 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120838686163',
	},
	{
		sizeLabel: '36-42',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237195106603',
	},
	{
		sizeLabel: '42-46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524813692943',
	},
	{
		sizeLabel: '42-52',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '323947661165',
	},
	{
		sizeLabel: 'T3 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239130010814',
	},
	{
		sizeLabel: '2XB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662693713723',
	},
	{
		sizeLabel: '3XB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957242911128',
	},
	{
		sizeLabel: '4XB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785810944794',
	},
	{
		sizeLabel: '2XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620165674884',
	},
	{
		sizeLabel: '3XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107188390310',
	},
	{
		sizeLabel: '110I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804676092049',
	},
	{
		sizeLabel: '110J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '285850817723',
	},
	{
		sizeLabel: '115H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688533414833',
	},
	{
		sizeLabel: '115I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924617603731',
	},
	{
		sizeLabel: '115J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934372028067',
	},
	{
		sizeLabel: '120A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232946291048',
	},
	{
		sizeLabel: '120H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '465659174489',
	},
	{
		sizeLabel: '120I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797082779891',
	},
	{
		sizeLabel: '120J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867943301591',
	},
	{
		sizeLabel: '125A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197399688857',
	},
	{
		sizeLabel: '125H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '092717757536',
	},
	{
		sizeLabel: '125I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666995346057',
	},
	{
		sizeLabel: '125J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923310067947',
	},
	{
		sizeLabel: '130A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349480644257',
	},
	{
		sizeLabel: '130G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529387395489',
	},
	{
		sizeLabel: '130H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '646903158201',
	},
	{
		sizeLabel: '130I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441472709013',
	},
	{
		sizeLabel: '130J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371960098919',
	},
	{
		sizeLabel: '135A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205692216727',
	},
	{
		sizeLabel: '135B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780046078495',
	},
	{
		sizeLabel: '135C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '217426001695',
	},
	{
		sizeLabel: '135D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598204213747',
	},
	{
		sizeLabel: '135E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232866571835',
	},
	{
		sizeLabel: '135F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766763739515',
	},
	{
		sizeLabel: '135G (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789832169033',
	},
	{
		sizeLabel: '135H (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982224482958',
	},
	{
		sizeLabel: '135I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '829013335450',
	},
	{
		sizeLabel: '135J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935489996923',
	},
	{
		sizeLabel: '408DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932734417561',
	},
	{
		sizeLabel: '105J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693326537857',
	},
	{
		sizeLabel: '44DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957285730410',
	},
	{
		sizeLabel: '44DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '936201126048',
	},
	{
		sizeLabel: '46V (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991732077215',
	},
	{
		sizeLabel: '46DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576164284697',
	},
	{
		sizeLabel: '46DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672300554697',
	},
	{
		sizeLabel: '48DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991327524104',
	},
	{
		sizeLabel: '48DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231169557482',
	},
	{
		sizeLabel: '50DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238188286434',
	},
	{
		sizeLabel: '50DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847568039486',
	},
	{
		sizeLabel: '52DD-E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528063205526',
	},
	{
		sizeLabel: '52DDD-F (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409898822699',
	},
	{
		sizeLabel: '2-3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017139408155',
	},
	{
		sizeLabel: '4-5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '772384568815',
	},
	{
		sizeLabel: '12-13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032920628016',
	},
	{
		sizeLabel: '14-15 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796685433283',
	},
	{
		sizeLabel: '16-17 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460586722419',
	},
	{
		sizeLabel: '38A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056897729139',
	},
	{
		sizeLabel: '38B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418616521627',
	},
	{
		sizeLabel: '38C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414731680722',
	},
	{
		sizeLabel: '38D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551339276623',
	},
	{
		sizeLabel: '38E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982219578520',
	},
	{
		sizeLabel: '38F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386625457191',
	},
	{
		sizeLabel: '40A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381582598053',
	},
	{
		sizeLabel: '40B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729419929329',
	},
	{
		sizeLabel: '40C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620321595809',
	},
	{
		sizeLabel: '40D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241023131699',
	},
	{
		sizeLabel: '40E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971769481407',
	},
	{
		sizeLabel: '40F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033712747539',
	},
	{
		sizeLabel: '42A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '047440329357',
	},
	{
		sizeLabel: '42B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788736406894',
	},
	{
		sizeLabel: '42C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756718939347',
	},
	{
		sizeLabel: '42D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755928169301',
	},
	{
		sizeLabel: '42E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763062771576',
	},
	{
		sizeLabel: '42F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996838738558',
	},
	{
		sizeLabel: '44A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290105490195',
	},
	{
		sizeLabel: '44B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329604317885',
	},
	{
		sizeLabel: '44C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907454915328',
	},
	{
		sizeLabel: '44D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946671858735',
	},
	{
		sizeLabel: '44E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935341517371',
	},
	{
		sizeLabel: '44F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943212764856',
	},
	{
		sizeLabel: '46A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306330875469',
	},
	{
		sizeLabel: '46B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488263082041',
	},
	{
		sizeLabel: '46C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154812986139',
	},
	{
		sizeLabel: '46D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683380697945',
	},
	{
		sizeLabel: '46E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571201172748',
	},
	{
		sizeLabel: '46F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '217034618620',
	},
	{
		sizeLabel: '48A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '272880521744',
	},
	{
		sizeLabel: '48B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812096894756',
	},
	{
		sizeLabel: '48C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895169412703',
	},
	{
		sizeLabel: '48D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981940366287',
	},
	{
		sizeLabel: '48E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485801412337',
	},
	{
		sizeLabel: '48F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '896222143316',
	},
	{
		sizeLabel: '50A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784600928206',
	},
	{
		sizeLabel: '50B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451629779457',
	},
	{
		sizeLabel: '50C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246584881234',
	},
	{
		sizeLabel: '50D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028104527807',
	},
	{
		sizeLabel: '50E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991225352098',
	},
	{
		sizeLabel: '50F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591479642092',
	},
	{
		sizeLabel: '52A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874839463628',
	},
	{
		sizeLabel: '52B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222341584573',
	},
	{
		sizeLabel: '52C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371949419004',
	},
	{
		sizeLabel: '52D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763358812182',
	},
	{
		sizeLabel: '52E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041779630634',
	},
	{
		sizeLabel: '52F (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055756315222',
	},
	{
		sizeLabel: '146',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446754003153',
	},
	{
		sizeLabel: '148',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127464080136',
	},
	{
		sizeLabel: '152',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722187940371',
	},
	{
		sizeLabel: '154',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596928919156',
	},
	{
		sizeLabel: '156',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951629578640',
	},
	{
		sizeLabel: '158',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185042898554',
	},
	{
		sizeLabel: 'D96',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851657161716',
	},
	{
		sizeLabel: 'D100',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081451976765',
	},
	{
		sizeLabel: 'D104',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681173983223',
	},
	{
		sizeLabel: 'D108',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426842759103',
	},
	{
		sizeLabel: 'D112',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925444444731',
	},
	{
		sizeLabel: 'D116',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237811602253',
	},
	{
		sizeLabel: 'D120',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515957547723',
	},
	{
		sizeLabel: '11 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '148539737054',
	},
	{
		sizeLabel: '13 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205325318128',
	},
	{
		sizeLabel: '15 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354636628039',
	},
	{
		sizeLabel: '40 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624131712562',
	},
	{
		sizeLabel: '17 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172112930335',
	},
	{
		sizeLabel: '12 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356892239420',
	},
	{
		sizeLabel: '00-2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109678541016',
	},
	{
		sizeLabel: '10-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974445901892',
	},
	{
		sizeLabel: '18-22 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996655523094',
	},
	{
		sizeLabel: '24-28 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532691862046',
	},
	{
		sizeLabel: '28-30 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946868081979',
	},
	{
		sizeLabel: '20-21 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837441934870',
	},
	{
		sizeLabel: '22-23 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702169972491',
	},
	{
		sizeLabel: '24-25 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683198854554',
	},
	{
		sizeLabel: '26-27 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555397514582',
	},
	{
		sizeLabel: '28-29 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720314846286',
	},
	{
		sizeLabel: '32-33 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071962381497',
	},
	{
		sizeLabel: '3 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468493757531',
	},
	{
		sizeLabel: '4 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630263616721',
	},
	{
		sizeLabel: '5 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '242986715243',
	},
	{
		sizeLabel: '38-40 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214846820642',
	},
	{
		sizeLabel: '33-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318363911303',
	},
	{
		sizeLabel: '34-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785009503491',
	},
	{
		sizeLabel: '36-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123084130408',
	},
	{
		sizeLabel: '38-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664016478539',
	},
	{
		sizeLabel: '1 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '593579232036',
	},
	{
		sizeLabel: '72',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874123297175',
	},
	{
		sizeLabel: '84',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889554012717',
	},
	{
		sizeLabel: '88',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365232007294',
	},
	{
		sizeLabel: 'D34 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049677092128',
	},
	{
		sizeLabel: 'D36 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308257571405',
	},
	{
		sizeLabel: 'D38 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082728350066',
	},
	{
		sizeLabel: 'D40 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '268254604509',
	},
	{
		sizeLabel: 'D42 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009987671873',
	},
	{
		sizeLabel: 'D44 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909845776111',
	},
	{
		sizeLabel: 'D46 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110502530771',
	},
	{
		sizeLabel: 'D48 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183382700333',
	},
	{
		sizeLabel: '48 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963970840390',
	},
	{
		sizeLabel: '155-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852991347358',
	},
	{
		sizeLabel: '155-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324853708268',
	},
	{
		sizeLabel: '160-92A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '645686349801',
	},
	{
		sizeLabel: '175-116A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049669617535',
	},
	{
		sizeLabel: 'XXS (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201622776104',
	},
	{
		sizeLabel: '170-82A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771237769617',
	},
	{
		sizeLabel: '170-86A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693909528625',
	},
	{
		sizeLabel: '180-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924137617881',
	},
	{
		sizeLabel: '185-112A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380600035511',
	},
	{
		sizeLabel: '2XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478669093973',
	},
	{
		sizeLabel: 'XS (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584387946685',
	},
	{
		sizeLabel: 'S (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203285465216',
	},
	{
		sizeLabel: 'M (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '293963799320',
	},
	{
		sizeLabel: 'L (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705706457936',
	},
	{
		sizeLabel: 'XL (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038140295550',
	},
	{
		sizeLabel: '175-94A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249875742767',
	},
	{
		sizeLabel: '185-106A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388233240240',
	},
	{
		sizeLabel: '185-110A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751040936302',
	},
	{
		sizeLabel: '185-114A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989242301146',
	},
	{
		sizeLabel: 'S-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727702672720',
	},
	{
		sizeLabel: '2 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899918274562',
	},
	{
		sizeLabel: '35B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404505901240',
	},
	{
		sizeLabel: '5B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186042201559',
	},
	{
		sizeLabel: '3B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206938195056',
	},
	{
		sizeLabel: '35 ½B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741689590959',
	},
	{
		sizeLabel: '5 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265703698969',
	},
	{
		sizeLabel: '3 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535878801708',
	},
	{
		sizeLabel: '6B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365857017630',
	},
	{
		sizeLabel: '4B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099875539134',
	},
	{
		sizeLabel: '37B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '615367608445',
	},
	{
		sizeLabel: '6 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610189642083',
	},
	{
		sizeLabel: '4 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028017470562',
	},
	{
		sizeLabel: '37 ½B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157708385713',
	},
	{
		sizeLabel: '7B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '002209797010',
	},
	{
		sizeLabel: '5B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826501685048',
	},
	{
		sizeLabel: '7 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940840322354',
	},
	{
		sizeLabel: '5 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519311804277',
	},
	{
		sizeLabel: '38 ½B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923141538505',
	},
	{
		sizeLabel: '8B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877307455052',
	},
	{
		sizeLabel: '6B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '857090298434',
	},
	{
		sizeLabel: '39B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868664660955',
	},
	{
		sizeLabel: '8 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636507387548',
	},
	{
		sizeLabel: '6 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817534079004',
	},
	{
		sizeLabel: '39 ½B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632740726876',
	},
	{
		sizeLabel: '9B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939610098840',
	},
	{
		sizeLabel: '7B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234361846600',
	},
	{
		sizeLabel: '9 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727201678604',
	},
	{
		sizeLabel: '7 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309682111283',
	},
	{
		sizeLabel: '40 ½B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096663933992',
	},
	{
		sizeLabel: '10B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193828060930',
	},
	{
		sizeLabel: '8B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813456192654',
	},
	{
		sizeLabel: '41B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544621942925',
	},
	{
		sizeLabel: '10 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537356609246',
	},
	{
		sizeLabel: '8 ½B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057140040088',
	},
	{
		sizeLabel: '11B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499916289735',
	},
	{
		sizeLabel: '9B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153879552763',
	},
	{
		sizeLabel: '42 ½B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795795525506',
	},
	{
		sizeLabel: '11 ½B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827982675006',
	},
	{
		sizeLabel: '2 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702451351257',
	},
	{
		sizeLabel: '35C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989791025750',
	},
	{
		sizeLabel: '5C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574927203275',
	},
	{
		sizeLabel: '3C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327165322244',
	},
	{
		sizeLabel: '35 ½C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697889844353',
	},
	{
		sizeLabel: '5 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921922603843',
	},
	{
		sizeLabel: '3 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655424692397',
	},
	{
		sizeLabel: '6C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889877095816',
	},
	{
		sizeLabel: '4C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321501498702',
	},
	{
		sizeLabel: '37C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965143890775',
	},
	{
		sizeLabel: '6 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527251096281',
	},
	{
		sizeLabel: '4 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678575077965',
	},
	{
		sizeLabel: '37 ½C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637066145261',
	},
	{
		sizeLabel: '7C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241655644598',
	},
	{
		sizeLabel: '5C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177459928396',
	},
	{
		sizeLabel: '7 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981385307119',
	},
	{
		sizeLabel: '5 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697244027211',
	},
	{
		sizeLabel: '38 ½C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064982199120',
	},
	{
		sizeLabel: '8C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400537078284',
	},
	{
		sizeLabel: '6C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087238912419',
	},
	{
		sizeLabel: '39C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '293300274404',
	},
	{
		sizeLabel: '8 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555515106567',
	},
	{
		sizeLabel: '6 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156441253555',
	},
	{
		sizeLabel: '39 ½C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000440415856',
	},
	{
		sizeLabel: '9C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318959537021',
	},
	{
		sizeLabel: '7C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636482862578',
	},
	{
		sizeLabel: '9 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899684069912',
	},
	{
		sizeLabel: '7 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591670191707',
	},
	{
		sizeLabel: '40 ½C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902673426201',
	},
	{
		sizeLabel: '10C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128117597547',
	},
	{
		sizeLabel: '8C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777826964562',
	},
	{
		sizeLabel: '41C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635354888211',
	},
	{
		sizeLabel: '10 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149540295781',
	},
	{
		sizeLabel: '8 ½C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922566788770',
	},
	{
		sizeLabel: '11C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743226684137',
	},
	{
		sizeLabel: '9C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '131629513222',
	},
	{
		sizeLabel: '42 ½C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420682276020',
	},
	{
		sizeLabel: '11 ½C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519905375175',
	},
	{
		sizeLabel: '5M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653445915677',
	},
	{
		sizeLabel: '39M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367167495386',
	},
	{
		sizeLabel: '6M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382863422752',
	},
	{
		sizeLabel: '5 ½M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967897031966',
	},
	{
		sizeLabel: '39 ½M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178887864665',
	},
	{
		sizeLabel: '6 ½M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070138930390',
	},
	{
		sizeLabel: '6M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665616213637',
	},
	{
		sizeLabel: '40M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715860261381',
	},
	{
		sizeLabel: '7M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '002703755709',
	},
	{
		sizeLabel: '6 ½M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942070690944',
	},
	{
		sizeLabel: '40 ½M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234225935767',
	},
	{
		sizeLabel: '7 ½M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533921920070',
	},
	{
		sizeLabel: '7M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335800230442',
	},
	{
		sizeLabel: '41M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275762263552',
	},
	{
		sizeLabel: '8M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428315818982',
	},
	{
		sizeLabel: '7 ½M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '984176835464',
	},
	{
		sizeLabel: '41 ½M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633270496037',
	},
	{
		sizeLabel: '8 ½M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116957778240',
	},
	{
		sizeLabel: '8M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439581897928',
	},
	{
		sizeLabel: '42M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941112645364',
	},
	{
		sizeLabel: '9M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570714712637',
	},
	{
		sizeLabel: '8 ½M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370756999913',
	},
	{
		sizeLabel: '42 ½M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303533894571',
	},
	{
		sizeLabel: '9 ½M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657297564627',
	},
	{
		sizeLabel: '9M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696855387030',
	},
	{
		sizeLabel: '43M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805109075204',
	},
	{
		sizeLabel: '10M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254556453351',
	},
	{
		sizeLabel: '9 ½M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219575458957',
	},
	{
		sizeLabel: '43 ½M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759965935387',
	},
	{
		sizeLabel: '10 ½M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079987092568',
	},
	{
		sizeLabel: '10M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257710424174',
	},
	{
		sizeLabel: '44M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027846349350',
	},
	{
		sizeLabel: '11M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967604702257',
	},
	{
		sizeLabel: '10 ½M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981897448799',
	},
	{
		sizeLabel: '44 ½M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980773960411',
	},
	{
		sizeLabel: '11 ½M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795065697516',
	},
	{
		sizeLabel: '11M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480798458185',
	},
	{
		sizeLabel: '45M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540326437053',
	},
	{
		sizeLabel: '12M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408857728052',
	},
	{
		sizeLabel: '12M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '369257691149',
	},
	{
		sizeLabel: '46M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155357386021',
	},
	{
		sizeLabel: '13M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871443788133',
	},
	{
		sizeLabel: 'W5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655201545257',
	},
	{
		sizeLabel: 'W39 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291002357440',
	},
	{
		sizeLabel: 'W6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151309007494',
	},
	{
		sizeLabel: 'W5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123538226795',
	},
	{
		sizeLabel: 'W39 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605873215259',
	},
	{
		sizeLabel: 'W6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412204037110',
	},
	{
		sizeLabel: 'W6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100338738405',
	},
	{
		sizeLabel: 'W40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754626441005',
	},
	{
		sizeLabel: 'W7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543729579055',
	},
	{
		sizeLabel: 'W6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445304800998',
	},
	{
		sizeLabel: 'W40 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512997510944',
	},
	{
		sizeLabel: 'W7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463051101450',
	},
	{
		sizeLabel: 'W7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372554423166',
	},
	{
		sizeLabel: 'W41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611585630437',
	},
	{
		sizeLabel: 'W8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542704607541',
	},
	{
		sizeLabel: 'W7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244157033370',
	},
	{
		sizeLabel: 'W41 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621190467746',
	},
	{
		sizeLabel: 'W8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '993821469104',
	},
	{
		sizeLabel: 'W8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621287981798',
	},
	{
		sizeLabel: 'W42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535743536901',
	},
	{
		sizeLabel: 'W9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624409010379',
	},
	{
		sizeLabel: 'W8 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447509421498',
	},
	{
		sizeLabel: 'W42 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520420865824',
	},
	{
		sizeLabel: 'W9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372072675575',
	},
	{
		sizeLabel: 'W9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '359249642094',
	},
	{
		sizeLabel: 'W43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372253606886',
	},
	{
		sizeLabel: 'W10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837686124305',
	},
	{
		sizeLabel: 'W9 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459153976093',
	},
	{
		sizeLabel: 'W43 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '260663306243',
	},
	{
		sizeLabel: 'W10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226019278713',
	},
	{
		sizeLabel: 'W10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403506784570',
	},
	{
		sizeLabel: 'W44 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038499157968',
	},
	{
		sizeLabel: 'W11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676957337049',
	},
	{
		sizeLabel: 'W10 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334742390431',
	},
	{
		sizeLabel: 'W44 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916624816803',
	},
	{
		sizeLabel: 'W11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751806929853',
	},
	{
		sizeLabel: 'W11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310965523655',
	},
	{
		sizeLabel: 'W45 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '588017662166',
	},
	{
		sizeLabel: 'W12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889601460084',
	},
	{
		sizeLabel: 'W12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476902928330',
	},
	{
		sizeLabel: 'W46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254852491998',
	},
	{
		sizeLabel: 'W13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019227183665',
	},
	{
		sizeLabel: 'L-LX',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055116365384',
	},
	{
		sizeLabel: '- (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '323898200125',
	},
	{
		sizeLabel: '46 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018369802012',
	},
	{
		sizeLabel: '48 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193752122629',
	},
	{
		sizeLabel: '50 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009324812534',
	},
	{
		sizeLabel: '52 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840915642794',
	},
	{
		sizeLabel: '54 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '359061722285',
	},
	{
		sizeLabel: '56 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159895960986',
	},
	{
		sizeLabel: '58 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777141186560',
	},
	{
		sizeLabel: '44 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945231646032',
	},
	{
		sizeLabel: '60 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174994919158',
	},
	{
		sizeLabel: '58 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521050314184',
	},
	{
		sizeLabel: '76-78 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411978146217',
	},
	{
		sizeLabel: '82-88 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478049861819',
	},
	{
		sizeLabel: '56-62 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755856274320',
	},
	{
		sizeLabel: '76-78 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530470405619',
	},
	{
		sizeLabel: '82-88 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547057481215',
	},
	{
		sizeLabel: '78-80 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562298538131',
	},
	{
		sizeLabel: '88-94 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133055689511',
	},
	{
		sizeLabel: '62-68 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156732991676',
	},
	{
		sizeLabel: '78-80 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280256985613',
	},
	{
		sizeLabel: '88-94 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874408987054',
	},
	{
		sizeLabel: '80-81 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569063996145',
	},
	{
		sizeLabel: '94-100 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412191214293',
	},
	{
		sizeLabel: '68-74 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '670550901928',
	},
	{
		sizeLabel: '80-81 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185475921391',
	},
	{
		sizeLabel: '94-100 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699689489905',
	},
	{
		sizeLabel: '81-82 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398502996737',
	},
	{
		sizeLabel: '100-106 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247824262775',
	},
	{
		sizeLabel: '74-80 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381829014077',
	},
	{
		sizeLabel: '81-82 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836359173815',
	},
	{
		sizeLabel: '100-106 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363617211535',
	},
	{
		sizeLabel: '106-112 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309727482699',
	},
	{
		sizeLabel: '80-86 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452590602024',
	},
	{
		sizeLabel: '106-112 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '261404096846',
	},
	{
		sizeLabel: '5X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466584900791',
	},
	{
		sizeLabel: '6X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136175225247',
	},
	{
		sizeLabel: '4XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671887635588',
	},
	{
		sizeLabel: '5XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874213495530',
	},
	{
		sizeLabel: 'W16-W18',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '687900870156',
	},
	{
		sizeLabel: 'W20-W22',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252410919979',
	},
	{
		sizeLabel: '45-48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383226245927',
	},
	{
		sizeLabel: '42(170-84-90',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489231408572',
	},
	{
		sizeLabel: '44(170-88-94',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '423639554012',
	},
	{
		sizeLabel: '46(170-92-98',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749023605761',
	},
	{
		sizeLabel: '48(170-96-10',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056438439325',
	},
	{
		sizeLabel: '50(170-100-1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146268655872',
	},
	{
		sizeLabel: '52(170-104-1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114907874808',
	},
	{
		sizeLabel: '54(170-108-1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093513778252',
	},
	{
		sizeLabel: '56(170-112-1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330305761068',
	},
	{
		sizeLabel: '0-1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926821632277',
	},
	{
		sizeLabel: '1-2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507324256399',
	},
	{
		sizeLabel: '3-5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360643631526',
	},
	{
		sizeLabel: '6-9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '068353916980',
	},
	{
		sizeLabel: '10-13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036748349416',
	},
	{
		sizeLabel: '60K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024777102413',
	},
	{
		sizeLabel: '28K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127275670659',
	},
	{
		sizeLabel: '60L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748735589858',
	},
	{
		sizeLabel: '28L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077959786973',
	},
	{
		sizeLabel: '30K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108329591896',
	},
	{
		sizeLabel: '30L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815877262602',
	},
	{
		sizeLabel: '32K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '458989545389',
	},
	{
		sizeLabel: '32L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001245079601',
	},
	{
		sizeLabel: '34K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797735598811',
	},
	{
		sizeLabel: '34L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '211311734407',
	},
	{
		sizeLabel: '36K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431260652693',
	},
	{
		sizeLabel: '36L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837233973084',
	},
	{
		sizeLabel: '38K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257331683304',
	},
	{
		sizeLabel: '38L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733995985184',
	},
	{
		sizeLabel: '40K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623545885988',
	},
	{
		sizeLabel: '40L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448642973245',
	},
	{
		sizeLabel: '42K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667016691139',
	},
	{
		sizeLabel: '42L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773654496361',
	},
	{
		sizeLabel: '44K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188180385172',
	},
	{
		sizeLabel: '44L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255581727139',
	},
	{
		sizeLabel: '46K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075612540376',
	},
	{
		sizeLabel: '105L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928642971994',
	},
	{
		sizeLabel: '46L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998627849747',
	},
	{
		sizeLabel: '110K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267799884285',
	},
	{
		sizeLabel: '48K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839293247247',
	},
	{
		sizeLabel: '110L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632614539435',
	},
	{
		sizeLabel: '48L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834603826699',
	},
	{
		sizeLabel: '115K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883176983415',
	},
	{
		sizeLabel: '50K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472771265877',
	},
	{
		sizeLabel: '115L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760187627996',
	},
	{
		sizeLabel: '50L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118045022779',
	},
	{
		sizeLabel: '120K (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079896450262',
	},
	{
		sizeLabel: '52K (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '326876332799',
	},
	{
		sizeLabel: '120L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276622356260',
	},
	{
		sizeLabel: '52L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958779803070',
	},
	{
		sizeLabel: '34A-34B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084286651558',
	},
	{
		sizeLabel: '75A-75B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '719955130429',
	},
	{
		sizeLabel: '90A-90B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145466559638',
	},
	{
		sizeLabel: '34A-34B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208415317645',
	},
	{
		sizeLabel: '90A-90B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149132830477',
	},
	{
		sizeLabel: '90C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013314786492',
	},
	{
		sizeLabel: '90D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778434450312',
	},
	{
		sizeLabel: '95B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337019510625',
	},
	{
		sizeLabel: '95C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470195764054',
	},
	{
		sizeLabel: '95D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255269584757',
	},
	{
		sizeLabel: '43 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480922636987',
	},
	{
		sizeLabel: '15 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619162151271',
	},
	{
		sizeLabel: '15 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014980233166',
	},
	{
		sizeLabel: '6-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055683307290',
	},
	{
		sizeLabel: '32-38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675383153526',
	},
	{
		sizeLabel: '34-40 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455717488237',
	},
	{
		sizeLabel: '38-44 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982446569675',
	},
	{
		sizeLabel: '34-40 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994040995094',
	},
	{
		sizeLabel: '42-44 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422638074628',
	},
	{
		sizeLabel: '3 ½-5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130974765609',
	},
	{
		sizeLabel: '37-39 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872182460881',
	},
	{
		sizeLabel: '6-7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604375668955',
	},
	{
		sizeLabel: '8-9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912403762346',
	},
	{
		sizeLabel: '43-45 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172434469320',
	},
	{
		sizeLabel: '40-44 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464077180848',
	},
	{
		sizeLabel: '38-42 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899109078518',
	},
	{
		sizeLabel: '54-56 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546695383939',
	},
	{
		sizeLabel: '58-60 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727858897784',
	},
	{
		sizeLabel: '60-62 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594417109234',
	},
	{
		sizeLabel: '32 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225272773386',
	},
	{
		sizeLabel: '34 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881765140554',
	},
	{
		sizeLabel: '36 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255133462733',
	},
	{
		sizeLabel: '38 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904138848925',
	},
	{
		sizeLabel: '40 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624555919071',
	},
	{
		sizeLabel: '42 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202012616908',
	},
	{
		sizeLabel: '44 (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '387760388895',
	},
	{
		sizeLabel: '7 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576095479745',
	},
	{
		sizeLabel: '7A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080301638741',
	},
	{
		sizeLabel: '31-32 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247163453177',
	},
	{
		sizeLabel: '33-34 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827920880303',
	},
	{
		sizeLabel: '33-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106530527994',
	},
	{
		sizeLabel: '34-35 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373755613762',
	},
	{
		sizeLabel: '48-49 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071752908633',
	},
	{
		sizeLabel: '49-50 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '092366555568',
	},
	{
		sizeLabel: '50-51 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836345724317',
	},
	{
		sizeLabel: '51-52 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792289740159',
	},
	{
		sizeLabel: '350 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684157925876',
	},
	{
		sizeLabel: '52-53 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297196140464',
	},
	{
		sizeLabel: '35 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '497871628597',
	},
	{
		sizeLabel: '360 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701256525810',
	},
	{
		sizeLabel: '02-04',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '646415343858',
	},
	{
		sizeLabel: '10-12',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507231229786',
	},
	{
		sizeLabel: '14-16',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860357946051',
	},
	{
		sizeLabel: '18-20',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403157249647',
	},
	{
		sizeLabel: '36 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746216032388',
	},
	{
		sizeLabel: '37 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934173342677',
	},
	{
		sizeLabel: '38 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384805754990',
	},
	{
		sizeLabel: '40 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308344994551',
	},
	{
		sizeLabel: '42 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619482163582',
	},
	{
		sizeLabel: '44 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629495807956',
	},
	{
		sizeLabel: '48 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156057257349',
	},
	{
		sizeLabel: '24-25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568915276328',
	},
	{
		sizeLabel: '30-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114630392147',
	},
	{
		sizeLabel: '50-52 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378999253067',
	},
	{
		sizeLabel: '50-52 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733342536231',
	},
	{
		sizeLabel: '54-56 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655068646268',
	},
	{
		sizeLabel: '54-56 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707786410417',
	},
	{
		sizeLabel: '92',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738105467701',
	},
	{
		sizeLabel: '104',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254671146181',
	},
	{
		sizeLabel: '108',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057540950058',
	},
	{
		sizeLabel: '112',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167340882952',
	},
	{
		sizeLabel: '116',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608193140036',
	},
	{
		sizeLabel: '124',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324961981598',
	},
	{
		sizeLabel: '128',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206651124357',
	},
	{
		sizeLabel: '132',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582150883940',
	},
	{
		sizeLabel: '136',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782315916477',
	},
	{
		sizeLabel: '144',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752256812747',
	},
	{
		sizeLabel: '44-47 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159980397110',
	},
	{
		sizeLabel: '56-62 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '880134599615',
	},
	{
		sizeLabel: '6SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147529682971',
	},
	{
		sizeLabel: '6REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507432162387',
	},
	{
		sizeLabel: '6LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630198312612',
	},
	{
		sizeLabel: '8SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832012963788',
	},
	{
		sizeLabel: '8REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '313327202316',
	},
	{
		sizeLabel: '8LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960710271235',
	},
	{
		sizeLabel: '10SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114456058681',
	},
	{
		sizeLabel: '10REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913472538821',
	},
	{
		sizeLabel: '10LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808436927628',
	},
	{
		sizeLabel: '12SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402430014018',
	},
	{
		sizeLabel: '12REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688780561806',
	},
	{
		sizeLabel: '12LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113971173505',
	},
	{
		sizeLabel: '14SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926371813956',
	},
	{
		sizeLabel: '14REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511469547880',
	},
	{
		sizeLabel: '14LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058884940246',
	},
	{
		sizeLabel: '16SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428820750592',
	},
	{
		sizeLabel: '16REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871288244224',
	},
	{
		sizeLabel: '16LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705248739703',
	},
	{
		sizeLabel: '18SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923462018966',
	},
	{
		sizeLabel: '18REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431154806421',
	},
	{
		sizeLabel: '18LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891470853299',
	},
	{
		sizeLabel: '20SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393781960095',
	},
	{
		sizeLabel: '20REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929693230983',
	},
	{
		sizeLabel: '20LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863070312851',
	},
	{
		sizeLabel: '22SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284902959238',
	},
	{
		sizeLabel: '22REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062606949358',
	},
	{
		sizeLabel: '22LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796453521948',
	},
	{
		sizeLabel: '24SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460406932784',
	},
	{
		sizeLabel: '24REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '194165948681',
	},
	{
		sizeLabel: '24LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '491812892883',
	},
	{
		sizeLabel: '26SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '552398238130',
	},
	{
		sizeLabel: '26REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428915857716',
	},
	{
		sizeLabel: '26LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191150218471',
	},
	{
		sizeLabel: '28SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022446880151',
	},
	{
		sizeLabel: '28REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788844968773',
	},
	{
		sizeLabel: '28LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099085713079',
	},
	{
		sizeLabel: '38SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761920542008',
	},
	{
		sizeLabel: '38REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938706903145',
	},
	{
		sizeLabel: '38LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401325368129',
	},
	{
		sizeLabel: '40SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778798728289',
	},
	{
		sizeLabel: '40REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642329086563',
	},
	{
		sizeLabel: '40LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693037803341',
	},
	{
		sizeLabel: '42SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463916005454',
	},
	{
		sizeLabel: '42REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836065450590',
	},
	{
		sizeLabel: '42LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168519952837',
	},
	{
		sizeLabel: '44SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '856778353593',
	},
	{
		sizeLabel: '44REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '266084843440',
	},
	{
		sizeLabel: '44LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246544608122',
	},
	{
		sizeLabel: '46SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247077431477',
	},
	{
		sizeLabel: '46REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292204319367',
	},
	{
		sizeLabel: '46LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710098003007',
	},
	{
		sizeLabel: '36-37 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635634629064',
	},
	{
		sizeLabel: '53 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713640030931',
	},
	{
		sizeLabel: '55 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948837306079',
	},
	{
		sizeLabel: '36--38 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532101628203',
	},
	{
		sizeLabel: '6-10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182335231436',
	},
	{
		sizeLabel: '10-14 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '564262497100',
	},
	{
		sizeLabel: '14-18 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711696533148',
	},
	{
		sizeLabel: '42-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277898633580',
	},
	{
		sizeLabel: 'XL-2X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580073296139',
	},
	{
		sizeLabel: '24-28 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792911557693',
	},
	{
		sizeLabel: '20-24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754175042550',
	},
	{
		sizeLabel: '0XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234482813748',
	},
	{
		sizeLabel: 'X1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312761099270',
	},
	{
		sizeLabel: 'X2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746898223548',
	},
	{
		sizeLabel: 'X3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '444125933775',
	},
	{
		sizeLabel: 'W5-M3 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158344074926',
	},
	{
		sizeLabel: 'W5 ½-M4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280611516616',
	},
	{
		sizeLabel: 'W6-M4 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918672083091',
	},
	{
		sizeLabel: 'W6 ½-M5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481367935964',
	},
	{
		sizeLabel: 'W7-M5 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200370899227',
	},
	{
		sizeLabel: 'W7 ½-M6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103475264928',
	},
	{
		sizeLabel: 'W8-M6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171919770122',
	},
	{
		sizeLabel: 'W8 ½-M7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811900586447',
	},
	{
		sizeLabel: 'W9-M7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598226026684',
	},
	{
		sizeLabel: 'W9 ½-M8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927152036821',
	},
	{
		sizeLabel: 'W10-M8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972557064098',
	},
	{
		sizeLabel: 'W10 ½-M9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383532574954',
	},
	{
		sizeLabel: 'W11-M9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438044256163',
	},
	{
		sizeLabel: 'W11 ½-M10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065968024722',
	},
	{
		sizeLabel: 'W12-M10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094901473787',
	},
	{
		sizeLabel: 'W12 ½-M11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532301918616',
	},
	{
		sizeLabel: 'W13-M11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020693568513',
	},
	{
		sizeLabel: 'W14-M12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918097593240',
	},
	{
		sizeLabel: 'W15-M13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545492791697',
	},
	{
		sizeLabel: 'W16-M13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635238043732',
	},
	{
		sizeLabel: 'W35L29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '293853071537',
	},
	{
		sizeLabel: 'W35 L31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946721342050',
	},
	{
		sizeLabel: 'W41L29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714957016310',
	},
	{
		sizeLabel: 'W41L31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810667252139',
	},
	{
		sizeLabel: 'W45L29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '484570601812',
	},
	{
		sizeLabel: 'W45L31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099743213320',
	},
	{
		sizeLabel: 'W49L29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566296069976',
	},
	{
		sizeLabel: 'W49L31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308948557777',
	},
	{
		sizeLabel: 'W37L32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957730620655',
	},
	{
		sizeLabel: 'W37L34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008537368788',
	},
	{
		sizeLabel: 'W41L32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996147330707',
	},
	{
		sizeLabel: 'W41L34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427291102328',
	},
	{
		sizeLabel: 'W52L32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451535811516',
	},
	{
		sizeLabel: 'W52L34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426956847837',
	},
	{
		sizeLabel: '6OZ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795228060616',
	},
	{
		sizeLabel: '8OZ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628844806939',
	},
	{
		sizeLabel: '10OZ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082035852448',
	},
	{
		sizeLabel: '12OZ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065054599741',
	},
	{
		sizeLabel: '14OZ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997050205262',
	},
	{
		sizeLabel: '28 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '053967484804',
	},
	{
		sizeLabel: '28 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440482511219',
	},
	{
		sizeLabel: '30 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609100311262',
	},
	{
		sizeLabel: '30 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220292646674',
	},
	{
		sizeLabel: '32 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607852762563',
	},
	{
		sizeLabel: '34 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614089942302',
	},
	{
		sizeLabel: '36 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071868108132',
	},
	{
		sizeLabel: '38 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '142983518788',
	},
	{
		sizeLabel: 'XXS (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422560569108',
	},
	{
		sizeLabel: 'XXS (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958461180821',
	},
	{
		sizeLabel: 'XS (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935326152299',
	},
	{
		sizeLabel: 'XS (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206126062118',
	},
	{
		sizeLabel: 'XS (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890059546641',
	},
	{
		sizeLabel: 'S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373086208128',
	},
	{
		sizeLabel: 'S (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335157646801',
	},
	{
		sizeLabel: 'S (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '647826433552',
	},
	{
		sizeLabel: 'M (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830642271488',
	},
	{
		sizeLabel: 'M (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450851411456',
	},
	{
		sizeLabel: 'L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778315104227',
	},
	{
		sizeLabel: 'L (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987020880886',
	},
	{
		sizeLabel: 'L (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '986675777708',
	},
	{
		sizeLabel: 'XL (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977761216460',
	},
	{
		sizeLabel: 'XL (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336782526610',
	},
	{
		sizeLabel: 'XL (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041412866185',
	},
	{
		sizeLabel: 'XXL (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '603855685266',
	},
	{
		sizeLabel: 'XXL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478348619423',
	},
	{
		sizeLabel: 'PP (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907287174711',
	},
	{
		sizeLabel: 'P (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637282611655',
	},
	{
		sizeLabel: 'M (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831684077076',
	},
	{
		sizeLabel: 'G (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537590839031',
	},
	{
		sizeLabel: 'GG (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720312034584',
	},
	{
		sizeLabel: 'C34-C36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232361494594',
	},
	{
		sizeLabel: 'C34-C38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '590947496503',
	},
	{
		sizeLabel: 'C38-C40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '419804178515',
	},
	{
		sizeLabel: 'C42-C44',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916320996734',
	},
	{
		sizeLabel: 'C44-C46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553084200785',
	},
	{
		sizeLabel: 'C48-C50',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425905251517',
	},
	{
		sizeLabel: '3-5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049694832865',
	},
	{
		sizeLabel: '9-11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390859038552',
	},
	{
		sizeLabel: '47-49 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149511797328',
	},
	{
		sizeLabel: 'SM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380224141608',
	},
	{
		sizeLabel: 'MD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618571775560',
	},
	{
		sizeLabel: 'LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788922930658',
	},
	{
		sizeLabel: '160-65A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '258503643125',
	},
	{
		sizeLabel: '48-50 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863447267214',
	},
	{
		sizeLabel: '06-08',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411956722239',
	},
	{
		sizeLabel: '46-48 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119825741136',
	},
	{
		sizeLabel: '52-54 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014484893625',
	},
	{
		sizeLabel: '54-56 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136482564048',
	},
	{
		sizeLabel: '56-58 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213628625812',
	},
	{
		sizeLabel: '32-34 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945842749262',
	},
	{
		sizeLabel: '36-38 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970704493946',
	},
	{
		sizeLabel: '40-42 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136360728253',
	},
	{
		sizeLabel: '35 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '462548338420',
	},
	{
		sizeLabel: '36 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464802833968',
	},
	{
		sizeLabel: '40 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257476005028',
	},
	{
		sizeLabel: '44 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246544966936',
	},
	{
		sizeLabel: '28-30 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583622618953',
	},
	{
		sizeLabel: '30-32 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040130364550',
	},
	{
		sizeLabel: '36-38 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '541861836351',
	},
	{
		sizeLabel: '0-1 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682224585460',
	},
	{
		sizeLabel: '2-3 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413728874683',
	},
	{
		sizeLabel: '4-5 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550882848083',
	},
	{
		sizeLabel: '6-7 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556994531745',
	},
	{
		sizeLabel: '8-9 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708435615135',
	},
	{
		sizeLabel: '6 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351972217309',
	},
	{
		sizeLabel: '7 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '615026089333',
	},
	{
		sizeLabel: '8 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240540555516',
	},
	{
		sizeLabel: '9 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389782887765',
	},
	{
		sizeLabel: '66 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625828677956',
	},
	{
		sizeLabel: '28 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953033512618',
	},
	{
		sizeLabel: '29 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375447223991',
	},
	{
		sizeLabel: '30 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328853335111',
	},
	{
		sizeLabel: '31 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374370612737',
	},
	{
		sizeLabel: '32 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '462857106099',
	},
	{
		sizeLabel: '33 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866869154022',
	},
	{
		sizeLabel: '20 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660999232598',
	},
	{
		sizeLabel: '32-33 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305916030295',
	},
	{
		sizeLabel: '8F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014812387055',
	},
	{
		sizeLabel: '8G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701745123701',
	},
	{
		sizeLabel: '8H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '344084428855',
	},
	{
		sizeLabel: '30K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632387786502',
	},
	{
		sizeLabel: '80K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697083545792',
	},
	{
		sizeLabel: '8K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720306647403',
	},
	{
		sizeLabel: '10G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088308074837',
	},
	{
		sizeLabel: '10H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '139585531915',
	},
	{
		sizeLabel: '32K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864785112259',
	},
	{
		sizeLabel: '85K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807903782017',
	},
	{
		sizeLabel: '10K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654903305644',
	},
	{
		sizeLabel: '12G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153308387529',
	},
	{
		sizeLabel: '12H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277404974448',
	},
	{
		sizeLabel: '34K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011506922594',
	},
	{
		sizeLabel: '12K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837517219201',
	},
	{
		sizeLabel: '14G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321604682803',
	},
	{
		sizeLabel: '14H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653093397804',
	},
	{
		sizeLabel: '36K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894535267006',
	},
	{
		sizeLabel: '14K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908004129950',
	},
	{
		sizeLabel: '16G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199674660801',
	},
	{
		sizeLabel: '16H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049332716936',
	},
	{
		sizeLabel: '38K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310768157899',
	},
	{
		sizeLabel: '100K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374056401401',
	},
	{
		sizeLabel: '16K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785656167202',
	},
	{
		sizeLabel: '18G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227617150849',
	},
	{
		sizeLabel: '18H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512425462516',
	},
	{
		sizeLabel: '40K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012382352298',
	},
	{
		sizeLabel: '105K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608726331665',
	},
	{
		sizeLabel: '18K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854366226759',
	},
	{
		sizeLabel: '20G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427128381623',
	},
	{
		sizeLabel: '20H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354038424424',
	},
	{
		sizeLabel: '42K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086954331318',
	},
	{
		sizeLabel: '110K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178178816942',
	},
	{
		sizeLabel: '20K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921696951970',
	},
	{
		sizeLabel: '22B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618500629024',
	},
	{
		sizeLabel: '22C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081398579488',
	},
	{
		sizeLabel: '22D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515479733423',
	},
	{
		sizeLabel: '100DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895194559199',
	},
	{
		sizeLabel: '115DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505471225881',
	},
	{
		sizeLabel: '22DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754903776905',
	},
	{
		sizeLabel: '22E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340520275626',
	},
	{
		sizeLabel: '22F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466731891326',
	},
	{
		sizeLabel: '22G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644993207583',
	},
	{
		sizeLabel: '22H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519074577358',
	},
	{
		sizeLabel: '44K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334594741777',
	},
	{
		sizeLabel: '115K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606588634259',
	},
	{
		sizeLabel: '22K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998004028059',
	},
	{
		sizeLabel: '24C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103851409681',
	},
	{
		sizeLabel: '24D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321684749433',
	},
	{
		sizeLabel: '105DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490685265462',
	},
	{
		sizeLabel: '120DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165315388868',
	},
	{
		sizeLabel: '24DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672530179985',
	},
	{
		sizeLabel: '24E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928769894902',
	},
	{
		sizeLabel: '24F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634713158694',
	},
	{
		sizeLabel: '24G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381635304602',
	},
	{
		sizeLabel: '24H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828606982016',
	},
	{
		sizeLabel: '46K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187734865208',
	},
	{
		sizeLabel: '120K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720774213374',
	},
	{
		sizeLabel: '24K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380348588643',
	},
	{
		sizeLabel: '26C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005788860183',
	},
	{
		sizeLabel: '26D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312752960440',
	},
	{
		sizeLabel: '110DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315518280358',
	},
	{
		sizeLabel: '125DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669125269386',
	},
	{
		sizeLabel: '26DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871953541203',
	},
	{
		sizeLabel: '26E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939254471458',
	},
	{
		sizeLabel: '26F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912278062095',
	},
	{
		sizeLabel: '26G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040172160835',
	},
	{
		sizeLabel: '26H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '821524127595',
	},
	{
		sizeLabel: '48K (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481782853363',
	},
	{
		sizeLabel: '125K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560642152211',
	},
	{
		sizeLabel: '26K (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120784503071',
	},
	{
		sizeLabel: '4 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127648339875',
	},
	{
		sizeLabel: '5 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341437030626',
	},
	{
		sizeLabel: '5 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405051708498',
	},
	{
		sizeLabel: '6 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '723490059531',
	},
	{
		sizeLabel: '5 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280502693172',
	},
	{
		sizeLabel: '8 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864652425804',
	},
	{
		sizeLabel: '7 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022533174185',
	},
	{
		sizeLabel: '8 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717745937822',
	},
	{
		sizeLabel: '8 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748311663176',
	},
	{
		sizeLabel: '9 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345707215574',
	},
	{
		sizeLabel: '9 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487791729971',
	},
	{
		sizeLabel: '10 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972639130649',
	},
	{
		sizeLabel: '9 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578291691598',
	},
	{
		sizeLabel: '10 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732818654830',
	},
	{
		sizeLabel: '10 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930857840573',
	},
	{
		sizeLabel: '4 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '905380077237',
	},
	{
		sizeLabel: '11 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159709252094',
	},
	{
		sizeLabel: '11 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157895903987',
	},
	{
		sizeLabel: '12 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507043115831',
	},
	{
		sizeLabel: '12 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '536560952675',
	},
	{
		sizeLabel: '13 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659336175105',
	},
	{
		sizeLabel: '29-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519521727232',
	},
	{
		sizeLabel: '30-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079505626965',
	},
	{
		sizeLabel: '31-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378734463784',
	},
	{
		sizeLabel: '32-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '949974736996',
	},
	{
		sizeLabel: '33-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784563555740',
	},
	{
		sizeLabel: '34-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626713325922',
	},
	{
		sizeLabel: '34-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074325147900',
	},
	{
		sizeLabel: '35-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642425430449',
	},
	{
		sizeLabel: '36-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450260384143',
	},
	{
		sizeLabel: '38-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537745261012',
	},
	{
		sizeLabel: '38-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239242727569',
	},
	{
		sizeLabel: '40-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860983950094',
	},
	{
		sizeLabel: '40-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379421535744',
	},
	{
		sizeLabel: '42-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480467549769',
	},
	{
		sizeLabel: '42-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045813666375',
	},
	{
		sizeLabel: '44-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388255477344',
	},
	{
		sizeLabel: '44-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073422001393',
	},
	{
		sizeLabel: '46-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832089188100',
	},
	{
		sizeLabel: '46-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001477270995',
	},
	{
		sizeLabel: '48-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589351412057',
	},
	{
		sizeLabel: '48-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297872431026',
	},
	{
		sizeLabel: '48-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488499281712',
	},
	{
		sizeLabel: '48-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602338794116',
	},
	{
		sizeLabel: '48-48',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445158962605',
	},
	{
		sizeLabel: '50-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027367041430',
	},
	{
		sizeLabel: '50-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306515287601',
	},
	{
		sizeLabel: '50-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354886237668',
	},
	{
		sizeLabel: '50-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330907529888',
	},
	{
		sizeLabel: '50-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424303264915',
	},
	{
		sizeLabel: '50-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425705763663',
	},
	{
		sizeLabel: '52-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629880124333',
	},
	{
		sizeLabel: '52-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157709154039',
	},
	{
		sizeLabel: '52-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036069394235',
	},
	{
		sizeLabel: '52-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663128332643',
	},
	{
		sizeLabel: '52-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849234425964',
	},
	{
		sizeLabel: '52-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499501132345',
	},
	{
		sizeLabel: '54-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393981585673',
	},
	{
		sizeLabel: '54-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970369991401',
	},
	{
		sizeLabel: '54-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420991596108',
	},
	{
		sizeLabel: '54-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132310178121',
	},
	{
		sizeLabel: '54-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483164779342',
	},
	{
		sizeLabel: '54-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560880230448',
	},
	{
		sizeLabel: '56-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '221648964824',
	},
	{
		sizeLabel: '56-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756637754547',
	},
	{
		sizeLabel: '56-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063498992622',
	},
	{
		sizeLabel: '56-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '844644521435',
	},
	{
		sizeLabel: '56-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538754746956',
	},
	{
		sizeLabel: '56-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871001994887',
	},
	{
		sizeLabel: '58-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760083065495',
	},
	{
		sizeLabel: '58-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183699471911',
	},
	{
		sizeLabel: '58-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788098335579',
	},
	{
		sizeLabel: '58-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233084052283',
	},
	{
		sizeLabel: '58-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130482119340',
	},
	{
		sizeLabel: '58-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877967144633',
	},
	{
		sizeLabel: '60-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '221127926366',
	},
	{
		sizeLabel: '60-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216684186346',
	},
	{
		sizeLabel: '60-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044482904540',
	},
	{
		sizeLabel: '60-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455678372745',
	},
	{
		sizeLabel: '60-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987888853135',
	},
	{
		sizeLabel: '60-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924090202151',
	},
	{
		sizeLabel: '45-46 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366856140825',
	},
	{
		sizeLabel: '155-60 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578762654225',
	},
	{
		sizeLabel: '160-66 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122770342053',
	},
	{
		sizeLabel: '165-68 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392981552237',
	},
	{
		sizeLabel: '170-72 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854566868280',
	},
	{
		sizeLabel: '175-76 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305618934626',
	},
	{
		sizeLabel: '180-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046201325874',
	},
	{
		sizeLabel: '185-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246138661286',
	},
	{
		sizeLabel: '06-02',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453384517125',
	},
	{
		sizeLabel: '07-02',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099814722579',
	},
	{
		sizeLabel: '08-02',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151518661001',
	},
	{
		sizeLabel: '09-02',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576875991896',
	},
	{
		sizeLabel: '10-02',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173560676011',
	},
	{
		sizeLabel: '39 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375120811313',
	},
	{
		sizeLabel: '43 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311152286900',
	},
	{
		sizeLabel: '31-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251205897220',
	},
	{
		sizeLabel: '25-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005491505037',
	},
	{
		sizeLabel: 'OS QUEEN',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '857634372818',
	},
	{
		sizeLabel: '28-29 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806216721081',
	},
	{
		sizeLabel: '30-31 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196749970590',
	},
	{
		sizeLabel: '32-33 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528157868483',
	},
	{
		sizeLabel: '34-35 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110112277332',
	},
	{
		sizeLabel: '34-35 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946246027588',
	},
	{
		sizeLabel: '44-45',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041516941835',
	},
	{
		sizeLabel: '13-13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386190209604',
	},
	{
		sizeLabel: '14-14 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477843717837',
	},
	{
		sizeLabel: '21-23',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306697930685',
	},
	{
		sizeLabel: '23-25',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021159892761',
	},
	{
		sizeLabel: '170-176',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851549764898',
	},
	{
		sizeLabel: '182-188',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351722954767',
	},
	{
		sizeLabel: '27-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '266935340929',
	},
	{
		sizeLabel: '29-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834200798555',
	},
	{
		sizeLabel: '22.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853609165778',
	},
	{
		sizeLabel: '221 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436319694681',
	},
	{
		sizeLabel: '35 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199015469355',
	},
	{
		sizeLabel: '22.9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512058573264',
	},
	{
		sizeLabel: '229 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457920871051',
	},
	{
		sizeLabel: '23.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '355255775885',
	},
	{
		sizeLabel: '233 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703058762934',
	},
	{
		sizeLabel: '23.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839266370913',
	},
	{
		sizeLabel: '238 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277564243821',
	},
	{
		sizeLabel: '242 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254102305060',
	},
	{
		sizeLabel: '24.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402459269302',
	},
	{
		sizeLabel: '247 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706189023691',
	},
	{
		sizeLabel: '25.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126381162553',
	},
	{
		sizeLabel: '251 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781316826759',
	},
	{
		sizeLabel: '26.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '493894345589',
	},
	{
		sizeLabel: '263 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342167716329',
	},
	{
		sizeLabel: '26.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173641651732',
	},
	{
		sizeLabel: '268 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '821224754686',
	},
	{
		sizeLabel: '27.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763116283724',
	},
	{
		sizeLabel: '273 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123558962860',
	},
	{
		sizeLabel: '27.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684910155361',
	},
	{
		sizeLabel: '277 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431405140931',
	},
	{
		sizeLabel: '282 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847000186778',
	},
	{
		sizeLabel: '28.6 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005945700277',
	},
	{
		sizeLabel: '286 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972179672112',
	},
	{
		sizeLabel: '29.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685257501084',
	},
	{
		sizeLabel: '291 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839835482617',
	},
	{
		sizeLabel: '295 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727408537589',
	},
	{
		sizeLabel: '29.9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093601317825',
	},
	{
		sizeLabel: '299 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526816224599',
	},
	{
		sizeLabel: '30.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410505047907',
	},
	{
		sizeLabel: '303 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634814931953',
	},
	{
		sizeLabel: '30.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474853850826',
	},
	{
		sizeLabel: '308 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448308858181',
	},
	{
		sizeLabel: '0-4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619635781216',
	},
	{
		sizeLabel: '10 ½-11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534460695063',
	},
	{
		sizeLabel: '12-12 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396601626780',
	},
	{
		sizeLabel: '13 ½-14 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252139306185',
	},
	{
		sizeLabel: '60 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891132908375',
	},
	{
		sizeLabel: '34-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979842232288',
	},
	{
		sizeLabel: '42-48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611090569213',
	},
	{
		sizeLabel: '105DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184137414485',
	},
	{
		sizeLabel: '110DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861506204600',
	},
	{
		sizeLabel: '115DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466297728760',
	},
	{
		sizeLabel: '120DD+E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469067878270',
	},
	{
		sizeLabel: '17 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508139535089',
	},
	{
		sizeLabel: '16 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087637397925',
	},
	{
		sizeLabel: '17 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204807101460',
	},
	{
		sizeLabel: '16 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135045836798',
	},
	{
		sizeLabel: '17 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767260230684',
	},
	{
		sizeLabel: '18 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391468130086',
	},
	{
		sizeLabel: '19 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398282226647',
	},
	{
		sizeLabel: '20 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651665000645',
	},
	{
		sizeLabel: '19 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331657568605',
	},
	{
		sizeLabel: '20 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416428786016',
	},
	{
		sizeLabel: '21 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496233576463',
	},
	{
		sizeLabel: '22 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441355301735',
	},
	{
		sizeLabel: '23 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189098331579',
	},
	{
		sizeLabel: '22 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349934943817',
	},
	{
		sizeLabel: '23 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806428729304',
	},
	{
		sizeLabel: '24 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071669984996',
	},
	{
		sizeLabel: '25 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '003884461652',
	},
	{
		sizeLabel: '26 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319900028915',
	},
	{
		sizeLabel: '25 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '820689525854',
	},
	{
		sizeLabel: '26 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998777814776',
	},
	{
		sizeLabel: '27 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674830049524',
	},
	{
		sizeLabel: '28 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759706378353',
	},
	{
		sizeLabel: '29 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049243630758',
	},
	{
		sizeLabel: '28 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460194942880',
	},
	{
		sizeLabel: '29 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170781874311',
	},
	{
		sizeLabel: '30 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '873393243010',
	},
	{
		sizeLabel: '31 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132916758857',
	},
	{
		sizeLabel: '32 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791799084713',
	},
	{
		sizeLabel: '31 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418044699837',
	},
	{
		sizeLabel: '32 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138513396256',
	},
	{
		sizeLabel: '33 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438378506411',
	},
	{
		sizeLabel: '34 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102593035724',
	},
	{
		sizeLabel: '43 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676181028230',
	},
	{
		sizeLabel: '11XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947028403840',
	},
	{
		sizeLabel: '12XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684209247301',
	},
	{
		sizeLabel: '145',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020966659231',
	},
	{
		sizeLabel: '122',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '458394397542',
	},
	{
		sizeLabel: '126',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610029021251',
	},
	{
		sizeLabel: '134',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639118142260',
	},
	{
		sizeLabel: '138',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842202992216',
	},
	{
		sizeLabel: '142',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459078850026',
	},
	{
		sizeLabel: '8AA (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854306309647',
	},
	{
		sizeLabel: '12AA (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016432038691',
	},
	{
		sizeLabel: '14AA (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404072317613',
	},
	{
		sizeLabel: '16AA (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556903310338',
	},
	{
		sizeLabel: '185-112B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058467901644',
	},
	{
		sizeLabel: '6XL (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069180664179',
	},
	{
		sizeLabel: '185-114B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849531815893',
	},
	{
		sizeLabel: '258-83 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861897541535',
	},
	{
		sizeLabel: '258-83 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778421905272',
	},
	{
		sizeLabel: '264-84 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524657135434',
	},
	{
		sizeLabel: '264-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551352710265',
	},
	{
		sizeLabel: '51 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247601906450',
	},
	{
		sizeLabel: '36м (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469518357321',
	},
	{
		sizeLabel: '80м (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608450016196',
	},
	{
		sizeLabel: '15 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479382715260',
	},
	{
		sizeLabel: '2 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040743277950',
	},
	{
		sizeLabel: '3 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676246451973',
	},
	{
		sizeLabel: '4 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275932070374',
	},
	{
		sizeLabel: '6 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119512948924',
	},
	{
		sizeLabel: '9 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455953949342',
	},
	{
		sizeLabel: '42-46 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '747469052168',
	},
	{
		sizeLabel: '35-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303453948461',
	},
	{
		sizeLabel: '39-42',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241343548330',
	},
	{
		sizeLabel: '36-41',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '281908860806',
	},
	{
		sizeLabel: '43-46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944543855802',
	},
	{
		sizeLabel: '47-50',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836283462047',
	},
	{
		sizeLabel: '40-46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445065665144',
	},
	{
		sizeLabel: '90-95',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902010063362',
	},
	{
		sizeLabel: '30A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041184709297',
	},
	{
		sizeLabel: '65A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792975268123',
	},
	{
		sizeLabel: '65A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425762126117',
	},
	{
		sizeLabel: '30B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066757597299',
	},
	{
		sizeLabel: '65B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '465669243214',
	},
	{
		sizeLabel: '65B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779667236963',
	},
	{
		sizeLabel: '30C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911056070740',
	},
	{
		sizeLabel: '65C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825220691082',
	},
	{
		sizeLabel: '65C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869700563466',
	},
	{
		sizeLabel: '30D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715649345045',
	},
	{
		sizeLabel: '65D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840640854276',
	},
	{
		sizeLabel: '65D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659347077735',
	},
	{
		sizeLabel: '30DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635564005758',
	},
	{
		sizeLabel: '65E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874162776444',
	},
	{
		sizeLabel: '65E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '285103573173',
	},
	{
		sizeLabel: '30DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900484203028',
	},
	{
		sizeLabel: '30DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917551223961',
	},
	{
		sizeLabel: '65F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370865354073',
	},
	{
		sizeLabel: '65F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097884373111',
	},
	{
		sizeLabel: '30F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429972710151',
	},
	{
		sizeLabel: '65G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797445701201',
	},
	{
		sizeLabel: '65G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624399471554',
	},
	{
		sizeLabel: '32A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357139683224',
	},
	{
		sizeLabel: '70A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675348414635',
	},
	{
		sizeLabel: '70A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715737634053',
	},
	{
		sizeLabel: '32B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616827006829',
	},
	{
		sizeLabel: '70B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926306592250',
	},
	{
		sizeLabel: '70B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '047225414330',
	},
	{
		sizeLabel: '32C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '092789264837',
	},
	{
		sizeLabel: '70C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448647784819',
	},
	{
		sizeLabel: '70C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288248410121',
	},
	{
		sizeLabel: '32D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510084174461',
	},
	{
		sizeLabel: '70D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360795101829',
	},
	{
		sizeLabel: '70D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575255803519',
	},
	{
		sizeLabel: '32DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570031036560',
	},
	{
		sizeLabel: '70E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202542896305',
	},
	{
		sizeLabel: '70E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934441061708',
	},
	{
		sizeLabel: '32DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913992560294',
	},
	{
		sizeLabel: '32DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822124186005',
	},
	{
		sizeLabel: '70F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746871895309',
	},
	{
		sizeLabel: '70F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571786326013',
	},
	{
		sizeLabel: '32F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977225084773',
	},
	{
		sizeLabel: '70G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392203929693',
	},
	{
		sizeLabel: '70G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368022207843',
	},
	{
		sizeLabel: '34A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743288900446',
	},
	{
		sizeLabel: '75A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963802745873',
	},
	{
		sizeLabel: '75A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911904996880',
	},
	{
		sizeLabel: '34B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742642434842',
	},
	{
		sizeLabel: '75B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806962097704',
	},
	{
		sizeLabel: '75B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067969062403',
	},
	{
		sizeLabel: '34C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957065062574',
	},
	{
		sizeLabel: '75C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '434361508641',
	},
	{
		sizeLabel: '75C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '647534671933',
	},
	{
		sizeLabel: '34D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270076881275',
	},
	{
		sizeLabel: '75D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '261938933249',
	},
	{
		sizeLabel: '75D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989333074226',
	},
	{
		sizeLabel: '34DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853969840513',
	},
	{
		sizeLabel: '75E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '986321700500',
	},
	{
		sizeLabel: '75E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503012191508',
	},
	{
		sizeLabel: '34DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759064558854',
	},
	{
		sizeLabel: '34DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073517709876',
	},
	{
		sizeLabel: '75F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '047304673782',
	},
	{
		sizeLabel: '75F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673884312495',
	},
	{
		sizeLabel: '34F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '493852772500',
	},
	{
		sizeLabel: '75G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188431017516',
	},
	{
		sizeLabel: '75G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025784216227',
	},
	{
		sizeLabel: '36A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178322070176',
	},
	{
		sizeLabel: '80A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399598846237',
	},
	{
		sizeLabel: '80A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618846116970',
	},
	{
		sizeLabel: '36B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643936523169',
	},
	{
		sizeLabel: '80B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138521179946',
	},
	{
		sizeLabel: '80B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223458152502',
	},
	{
		sizeLabel: '36C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074671022496',
	},
	{
		sizeLabel: '80C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456753710672',
	},
	{
		sizeLabel: '80C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846243113635',
	},
	{
		sizeLabel: '36D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794796676237',
	},
	{
		sizeLabel: '80D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714634719701',
	},
	{
		sizeLabel: '80D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767085909411',
	},
	{
		sizeLabel: '36DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177005994434',
	},
	{
		sizeLabel: '80E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606519770910',
	},
	{
		sizeLabel: '80E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132532137418',
	},
	{
		sizeLabel: '36DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312190775277',
	},
	{
		sizeLabel: '36DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931682168082',
	},
	{
		sizeLabel: '80F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087571939610',
	},
	{
		sizeLabel: '80F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '725483648271',
	},
	{
		sizeLabel: '36F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136787962134',
	},
	{
		sizeLabel: '80G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545497727544',
	},
	{
		sizeLabel: '80G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702042374838',
	},
	{
		sizeLabel: '38A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760695171995',
	},
	{
		sizeLabel: '85A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299881628593',
	},
	{
		sizeLabel: '85A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958694961915',
	},
	{
		sizeLabel: '38B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765401826808',
	},
	{
		sizeLabel: '85B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554729577694',
	},
	{
		sizeLabel: '85B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294390136701',
	},
	{
		sizeLabel: '38C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935077585253',
	},
	{
		sizeLabel: '85C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649954771597',
	},
	{
		sizeLabel: '85C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420082033746',
	},
	{
		sizeLabel: '38D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715154777221',
	},
	{
		sizeLabel: '85D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867749187523',
	},
	{
		sizeLabel: '85D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868595651670',
	},
	{
		sizeLabel: '38DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498479826506',
	},
	{
		sizeLabel: '85E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342367031503',
	},
	{
		sizeLabel: '85E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534403335236',
	},
	{
		sizeLabel: '38DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489090231072',
	},
	{
		sizeLabel: '38DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324573638400',
	},
	{
		sizeLabel: '85F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275221336158',
	},
	{
		sizeLabel: '85F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055444420570',
	},
	{
		sizeLabel: '38F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968605206426',
	},
	{
		sizeLabel: '85G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127087700420',
	},
	{
		sizeLabel: '85G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317648572280',
	},
	{
		sizeLabel: '40A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476201210294',
	},
	{
		sizeLabel: '90A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442869882718',
	},
	{
		sizeLabel: '90A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089813881585',
	},
	{
		sizeLabel: '40B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704388099219',
	},
	{
		sizeLabel: '90B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445270256355',
	},
	{
		sizeLabel: '90B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479941176662',
	},
	{
		sizeLabel: '40C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034032892138',
	},
	{
		sizeLabel: '90C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953534993353',
	},
	{
		sizeLabel: '90C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093762696083',
	},
	{
		sizeLabel: '40D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428171729790',
	},
	{
		sizeLabel: '90D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584774526930',
	},
	{
		sizeLabel: '90D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226388686918',
	},
	{
		sizeLabel: '40DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104039293933',
	},
	{
		sizeLabel: '90E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527542720719',
	},
	{
		sizeLabel: '90E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312679523272',
	},
	{
		sizeLabel: '40DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '026134541536',
	},
	{
		sizeLabel: '40DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962166678487',
	},
	{
		sizeLabel: '90F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452016819286',
	},
	{
		sizeLabel: '90F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806337431357',
	},
	{
		sizeLabel: '40F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977677304345',
	},
	{
		sizeLabel: '90G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803700951462',
	},
	{
		sizeLabel: '90G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361749567093',
	},
	{
		sizeLabel: '42A (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766585333924',
	},
	{
		sizeLabel: '95A (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '250673627859',
	},
	{
		sizeLabel: '95A (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988607951818',
	},
	{
		sizeLabel: '42B (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861672941143',
	},
	{
		sizeLabel: '95B (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562195294763',
	},
	{
		sizeLabel: '95B (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537538192742',
	},
	{
		sizeLabel: '42C (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964010672014',
	},
	{
		sizeLabel: '95C (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393550264033',
	},
	{
		sizeLabel: '95C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095517515003',
	},
	{
		sizeLabel: '42D (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893852656612',
	},
	{
		sizeLabel: '95D (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633290428563',
	},
	{
		sizeLabel: '95D (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860072314653',
	},
	{
		sizeLabel: '42DD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997627291208',
	},
	{
		sizeLabel: '95E (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653337986839',
	},
	{
		sizeLabel: '95E (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927270457013',
	},
	{
		sizeLabel: '42DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066975990838',
	},
	{
		sizeLabel: '42DDD (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422766149896',
	},
	{
		sizeLabel: '95F (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931619914865',
	},
	{
		sizeLabel: '95F (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597735930430',
	},
	{
		sizeLabel: '42F (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922774946887',
	},
	{
		sizeLabel: '95G (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257627762631',
	},
	{
		sizeLabel: '95G (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676017316028',
	},
	{
		sizeLabel: '14 ½-15',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492271587808',
	},
	{
		sizeLabel: '15 ½-15 ¾',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578612904938',
	},
	{
		sizeLabel: '16-16 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303838534327',
	},
	{
		sizeLabel: '17-17 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963388551739',
	},
	{
		sizeLabel: '17 ¾-18',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566177041785',
	},
	{
		sizeLabel: '18 ½-19',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '142480038154',
	},
	{
		sizeLabel: '19 ¼-19 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649257229707',
	},
	{
		sizeLabel: '21 ¼',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027412297811',
	},
	{
		sizeLabel: '20-20 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169341506623',
	},
	{
		sizeLabel: '21-21 ¼',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566759637971',
	},
	{
		sizeLabel: '6 ⅝ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967628868471',
	},
	{
		sizeLabel: '7 ⅕ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973180385266',
	},
	{
		sizeLabel: 'S-M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673437995583',
	},
	{
		sizeLabel: 'L-XL (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911318551194',
	},
	{
		sizeLabel: '57 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133054792834',
	},
	{
		sizeLabel: '70 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '139464376763',
	},
	{
		sizeLabel: '75 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '745481162258',
	},
	{
		sizeLabel: '80 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097564031409',
	},
	{
		sizeLabel: '85 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374489551841',
	},
	{
		sizeLabel: '90 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334134526378',
	},
	{
		sizeLabel: '95 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995677132141',
	},
	{
		sizeLabel: '100 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141689486510',
	},
	{
		sizeLabel: '105 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736838060987',
	},
	{
		sizeLabel: '110 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787856515630',
	},
	{
		sizeLabel: '50DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237978944236',
	},
	{
		sizeLabel: '0-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388360243437',
	},
	{
		sizeLabel: '16-24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146029266787',
	},
	{
		sizeLabel: 'M-L-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244241374149',
	},
	{
		sizeLabel: 'M-L-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '180647058970',
	},
	{
		sizeLabel: '8 OZ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418355286654',
	},
	{
		sizeLabel: '10-10 OZ XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209508935755',
	},
	{
		sizeLabel: '08-12',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280705638202',
	},
	{
		sizeLabel: '70N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412420916486',
	},
	{
		sizeLabel: '70O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061907488015',
	},
	{
		sizeLabel: '75N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048165343735',
	},
	{
		sizeLabel: '40A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055179169425',
	},
	{
		sizeLabel: '40H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '870425877235',
	},
	{
		sizeLabel: '42G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787874770199',
	},
	{
		sizeLabel: '42H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985271689558',
	},
	{
		sizeLabel: '44G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633060894855',
	},
	{
		sizeLabel: '44H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '068916514132',
	},
	{
		sizeLabel: '46F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568022077201',
	},
	{
		sizeLabel: '46G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885105628215',
	},
	{
		sizeLabel: '46H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153240163586',
	},
	{
		sizeLabel: '48B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767240360512',
	},
	{
		sizeLabel: '48C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714503402202',
	},
	{
		sizeLabel: '48D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233183459092',
	},
	{
		sizeLabel: '48E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535184372938',
	},
	{
		sizeLabel: '48F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227169740722',
	},
	{
		sizeLabel: '50B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629460696303',
	},
	{
		sizeLabel: '50C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757867867071',
	},
	{
		sizeLabel: '50D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226070354712',
	},
	{
		sizeLabel: '50E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991023941134',
	},
	{
		sizeLabel: '7 ½-8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237014555237',
	},
	{
		sizeLabel: '42-164 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505327730237',
	},
	{
		sizeLabel: '44-170 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898235933806',
	},
	{
		sizeLabel: '46-164 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016752842860',
	},
	{
		sizeLabel: '46-170 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638202835056',
	},
	{
		sizeLabel: '46-182 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805144392712',
	},
	{
		sizeLabel: '48-164 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933141960572',
	},
	{
		sizeLabel: '48-176 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969551970509',
	},
	{
		sizeLabel: '48-188 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '984840956897',
	},
	{
		sizeLabel: '52-170 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975428850787',
	},
	{
		sizeLabel: '52-182 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159320989568',
	},
	{
		sizeLabel: 'L-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894285139242',
	},
	{
		sizeLabel: '52-194 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792332896004',
	},
	{
		sizeLabel: '56-170 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138424651461',
	},
	{
		sizeLabel: '56-182 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900018998968',
	},
	{
		sizeLabel: 'XL-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315070373155',
	},
	{
		sizeLabel: '56-194 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616583467913',
	},
	{
		sizeLabel: '60-170 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589565433557',
	},
	{
		sizeLabel: '60-182 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '281174387157',
	},
	{
		sizeLabel: 'XXL-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073284120921',
	},
	{
		sizeLabel: '60-194 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324862964382',
	},
	{
		sizeLabel: 'XXXL-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631655371818',
	},
	{
		sizeLabel: '64-188 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045625963511',
	},
	{
		sizeLabel: '8 ½-9',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438590848176',
	},
	{
		sizeLabel: '9 ½-10',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212977605963',
	},
	{
		sizeLabel: '10 ½-11',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346801438877',
	},
	{
		sizeLabel: 'VI',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774891061970',
	},
	{
		sizeLabel: '14-16 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072063910849',
	},
	{
		sizeLabel: '22-24 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942022139472',
	},
	{
		sizeLabel: '26-28 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022346829108',
	},
	{
		sizeLabel: '72 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498778433799',
	},
	{
		sizeLabel: '74 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868553713691',
	},
	{
		sizeLabel: '76 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033548537548',
	},
	{
		sizeLabel: '38J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524031492027',
	},
	{
		sizeLabel: '40I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136564508776',
	},
	{
		sizeLabel: '40J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240845100145',
	},
	{
		sizeLabel: '42A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158082121533',
	},
	{
		sizeLabel: '42I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '131375585327',
	},
	{
		sizeLabel: '42J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170225391492',
	},
	{
		sizeLabel: '44A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167023749608',
	},
	{
		sizeLabel: '44I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765680722027',
	},
	{
		sizeLabel: '44J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561175026042',
	},
	{
		sizeLabel: '46A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715829444151',
	},
	{
		sizeLabel: '46I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333650033492',
	},
	{
		sizeLabel: '46J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405492456173',
	},
	{
		sizeLabel: '48A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954092161282',
	},
	{
		sizeLabel: '48G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141073095321',
	},
	{
		sizeLabel: '48H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771130430935',
	},
	{
		sizeLabel: '48I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '313496617249',
	},
	{
		sizeLabel: '48J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319398946902',
	},
	{
		sizeLabel: '50A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927466718061',
	},
	{
		sizeLabel: '50F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827680586774',
	},
	{
		sizeLabel: '50G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468980104996',
	},
	{
		sizeLabel: '50H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '593901798964',
	},
	{
		sizeLabel: '50I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939563435328',
	},
	{
		sizeLabel: '50J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104707221786',
	},
	{
		sizeLabel: '52A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634340242993',
	},
	{
		sizeLabel: '52B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375170254409',
	},
	{
		sizeLabel: '52C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '358743832147',
	},
	{
		sizeLabel: '52D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265961088483',
	},
	{
		sizeLabel: '52E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944192952664',
	},
	{
		sizeLabel: '52F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798560136628',
	},
	{
		sizeLabel: '52G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073469803601',
	},
	{
		sizeLabel: '52H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864036177548',
	},
	{
		sizeLabel: '52I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990445518619',
	},
	{
		sizeLabel: '52J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741657932999',
	},
	{
		sizeLabel: '- (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798427564772',
	},
	{
		sizeLabel: '36-37 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418868323364',
	},
	{
		sizeLabel: '38-39 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657183160276',
	},
	{
		sizeLabel: '38-39 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697460036585',
	},
	{
		sizeLabel: '1-2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791066777581',
	},
	{
		sizeLabel: '90-95 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '719508931135',
	},
	{
		sizeLabel: '4-5 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852553129191',
	},
	{
		sizeLabel: '105-110 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273548362290',
	},
	{
		sizeLabel: '6 ¾-6 ⅞',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665823190847',
	},
	{
		sizeLabel: '7-7 ⅛',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978295788885',
	},
	{
		sizeLabel: '7 ¼-7⅜',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849299853822',
	},
	{
		sizeLabel: '7 ½-7 ⅝',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520843966745',
	},
	{
		sizeLabel: '7 ¾-7 ⅞',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '590716633458',
	},
	{
		sizeLabel: '64 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468258130303',
	},
	{
		sizeLabel: '66 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317139413207',
	},
	{
		sizeLabel: '68 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784916512670',
	},
	{
		sizeLabel: 'XS-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133548329436',
	},
	{
		sizeLabel: '32-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373681154381',
	},
	{
		sizeLabel: '42-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531974576933',
	},
	{
		sizeLabel: '34-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981968690409',
	},
	{
		sizeLabel: '44-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373704847279',
	},
	{
		sizeLabel: 'S-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478377469071',
	},
	{
		sizeLabel: '36-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396707868112',
	},
	{
		sizeLabel: '46-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540688618243',
	},
	{
		sizeLabel: 'M-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083952682103',
	},
	{
		sizeLabel: '38-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188157458522',
	},
	{
		sizeLabel: '48-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983242768745',
	},
	{
		sizeLabel: '40-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '419032439360',
	},
	{
		sizeLabel: '50-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787142492657',
	},
	{
		sizeLabel: 'L-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726683361388',
	},
	{
		sizeLabel: '42-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227943639526',
	},
	{
		sizeLabel: '52-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '502602720642',
	},
	{
		sizeLabel: 'XL-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '936238908087',
	},
	{
		sizeLabel: '44-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704304891242',
	},
	{
		sizeLabel: '54-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560569364327',
	},
	{
		sizeLabel: 'XXL-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697165253929',
	},
	{
		sizeLabel: '46-32 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734156946171',
	},
	{
		sizeLabel: '56-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823567077452',
	},
	{
		sizeLabel: 'XS-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504577423620',
	},
	{
		sizeLabel: '42-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413085884542',
	},
	{
		sizeLabel: '34-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234416091755',
	},
	{
		sizeLabel: '44-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795544433717',
	},
	{
		sizeLabel: 'S-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492123970145',
	},
	{
		sizeLabel: '36-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161438090276',
	},
	{
		sizeLabel: '46-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117087513018',
	},
	{
		sizeLabel: 'M-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739311089455',
	},
	{
		sizeLabel: '38-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169643656997',
	},
	{
		sizeLabel: '48-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542681943887',
	},
	{
		sizeLabel: '40-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154738775921',
	},
	{
		sizeLabel: '50-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699523030437',
	},
	{
		sizeLabel: 'L-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445643696607',
	},
	{
		sizeLabel: '42-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888566555885',
	},
	{
		sizeLabel: '52-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252760866326',
	},
	{
		sizeLabel: 'XL-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668589000963',
	},
	{
		sizeLabel: '44-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '148224307600',
	},
	{
		sizeLabel: '54-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096247390402',
	},
	{
		sizeLabel: 'XXL-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810405619611',
	},
	{
		sizeLabel: '46-34 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151543387445',
	},
	{
		sizeLabel: '56-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665150689546',
	},
	{
		sizeLabel: '27-28 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981026427043',
	},
	{
		sizeLabel: '35-36 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842291504518',
	},
	{
		sizeLabel: '37 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249485182035',
	},
	{
		sizeLabel: '27-28 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027322787106',
	},
	{
		sizeLabel: '29" (GB)',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171808703992',
	},
	{
		sizeLabel: '29" (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902502690929',
	},
	{
		sizeLabel: '32" (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714876923954',
	},
	{
		sizeLabel: '32" (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750968575778',
	},
	{
		sizeLabel: '36" (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750718905627',
	},
	{
		sizeLabel: '36" (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328425943769',
	},
	{
		sizeLabel: '37" (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123244778607',
	},
	{
		sizeLabel: '37" (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352536571122',
	},
	{
		sizeLabel: '40" (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '648932823210',
	},
	{
		sizeLabel: '40" (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722327825039',
	},
	{
		sizeLabel: '41-42 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '856068048206',
	},
	{
		sizeLabel: '41-42 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409949796382',
	},
	{
		sizeLabel: 'ML',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263671540366',
	},
	{
		sizeLabel: 'LX',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613795957035',
	},
	{
		sizeLabel: '00-0 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545077259504',
	},
	{
		sizeLabel: '0-2 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861894453956',
	},
	{
		sizeLabel: '2-4 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292123157512',
	},
	{
		sizeLabel: '6-8 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204259644376',
	},
	{
		sizeLabel: '8-10 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805184035132',
	},
	{
		sizeLabel: '10-12 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '261806413557',
	},
	{
		sizeLabel: '12-14 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510095057131',
	},
	{
		sizeLabel: '16-18 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336718233139',
	},
	{
		sizeLabel: '- (DK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079237016615',
	},
	{
		sizeLabel: '65C (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962420897121',
	},
	{
		sizeLabel: '80C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102514576918',
	},
	{
		sizeLabel: '65D (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259559824792',
	},
	{
		sizeLabel: '80D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531398032362',
	},
	{
		sizeLabel: '70A (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954772212687',
	},
	{
		sizeLabel: '85A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581492273267',
	},
	{
		sizeLabel: '70B (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020620446907',
	},
	{
		sizeLabel: '85B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '786766026150',
	},
	{
		sizeLabel: '70C (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520807511268',
	},
	{
		sizeLabel: '85C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940985354170',
	},
	{
		sizeLabel: '70D (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305643995812',
	},
	{
		sizeLabel: '85D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106315811225',
	},
	{
		sizeLabel: 'SDD-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770491165276',
	},
	{
		sizeLabel: '32DD(E) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429933052429',
	},
	{
		sizeLabel: '32DD(E) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '125926557430',
	},
	{
		sizeLabel: '70E (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667472180985',
	},
	{
		sizeLabel: '85E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '092966350126',
	},
	{
		sizeLabel: '75A (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '142961513548',
	},
	{
		sizeLabel: '90A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109489169881',
	},
	{
		sizeLabel: '75B (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050618579299',
	},
	{
		sizeLabel: '90B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859286970149',
	},
	{
		sizeLabel: '75C (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252019839645',
	},
	{
		sizeLabel: '75D (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528337049114',
	},
	{
		sizeLabel: 'SDD-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443080803439',
	},
	{
		sizeLabel: '34DD(E) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822045295598',
	},
	{
		sizeLabel: '34DD(E) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680169308275',
	},
	{
		sizeLabel: '75E (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968720880699',
	},
	{
		sizeLabel: '90E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559797223131',
	},
	{
		sizeLabel: '34DDD(F) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964675834347',
	},
	{
		sizeLabel: '75F (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775876263302',
	},
	{
		sizeLabel: '34DDD(F) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110167304130',
	},
	{
		sizeLabel: '75F (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726217849970',
	},
	{
		sizeLabel: '90F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238984661522',
	},
	{
		sizeLabel: '80B (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226074457815',
	},
	{
		sizeLabel: '80C (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005019501988',
	},
	{
		sizeLabel: '80D (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233578733319',
	},
	{
		sizeLabel: '36DD(E) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364873635708',
	},
	{
		sizeLabel: '36DD(E) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012767019880',
	},
	{
		sizeLabel: '80E (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128251826082',
	},
	{
		sizeLabel: '95E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018427017438',
	},
	{
		sizeLabel: '36DDD(F) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249791332387',
	},
	{
		sizeLabel: '80F (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818707799456',
	},
	{
		sizeLabel: '36DDD(F) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678589930685',
	},
	{
		sizeLabel: '80F (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638721388788',
	},
	{
		sizeLabel: '95F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190159857200',
	},
	{
		sizeLabel: '85B (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291931717699',
	},
	{
		sizeLabel: '85B (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048526583109',
	},
	{
		sizeLabel: '100B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046241373745',
	},
	{
		sizeLabel: '85C (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448999207326',
	},
	{
		sizeLabel: '85C (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849416858436',
	},
	{
		sizeLabel: '100C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '920018100243',
	},
	{
		sizeLabel: '85D (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831643159027',
	},
	{
		sizeLabel: '85D (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351183093686',
	},
	{
		sizeLabel: '100D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346778928904',
	},
	{
		sizeLabel: '38DD(E) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535502732530',
	},
	{
		sizeLabel: '85E (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215977375752',
	},
	{
		sizeLabel: '38DD(E) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424576212266',
	},
	{
		sizeLabel: '85E (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347106909770',
	},
	{
		sizeLabel: '100E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057324821583',
	},
	{
		sizeLabel: '38DDD(F) (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239517391412',
	},
	{
		sizeLabel: '85F (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343594560857',
	},
	{
		sizeLabel: '38DDD(F) (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752435993800',
	},
	{
		sizeLabel: '85F (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073051061719',
	},
	{
		sizeLabel: '100F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427113446401',
	},
	{
		sizeLabel: 'SDD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909665218311',
	},
	{
		sizeLabel: '1-3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831509595687',
	},
	{
		sizeLabel: '2-4 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548432325963',
	},
	{
		sizeLabel: '26-28 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244923571806',
	},
	{
		sizeLabel: '28-30 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455757018597',
	},
	{
		sizeLabel: '26-28 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347418850663',
	},
	{
		sizeLabel: '28-30 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569561646894',
	},
	{
		sizeLabel: '28-30 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618393600988',
	},
	{
		sizeLabel: '30-32 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '068350130083',
	},
	{
		sizeLabel: '30-32 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819354515501',
	},
	{
		sizeLabel: '34-36 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056128771481',
	},
	{
		sizeLabel: '34-36 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999614056574',
	},
	{
		sizeLabel: '36-38 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635382305670',
	},
	{
		sizeLabel: '36-38 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208560130900',
	},
	{
		sizeLabel: '38-40 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759286509038',
	},
	{
		sizeLabel: '38-40 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '595663519640',
	},
	{
		sizeLabel: '40-42 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666688756562',
	},
	{
		sizeLabel: '40-42 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113531608470',
	},
	{
		sizeLabel: '20-22 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800592257815',
	},
	{
		sizeLabel: '44-46 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574139925138',
	},
	{
		sizeLabel: '44-46 (CH)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333501113422',
	},
	{
		sizeLabel: '5 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507293524663',
	},
	{
		sizeLabel: '11 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207314118880',
	},
	{
		sizeLabel: '12 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903315308714',
	},
	{
		sizeLabel: '15 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199194585236',
	},
	{
		sizeLabel: '3-5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587490238436',
	},
	{
		sizeLabel: '7-9',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554159295528',
	},
	{
		sizeLabel: '0X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531794633498',
	},
	{
		sizeLabel: '25-26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151412116684',
	},
	{
		sizeLabel: '29-30 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958491398150',
	},
	{
		sizeLabel: '2X-3X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616555862419',
	},
	{
		sizeLabel: '21.6 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877129154696',
	},
	{
		sizeLabel: '24.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794401918984',
	},
	{
		sizeLabel: '25.9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799048990731',
	},
	{
		sizeLabel: '27.8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476796938573',
	},
	{
		sizeLabel: '113 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630924128611',
	},
	{
		sizeLabel: '29.4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860148303264',
	},
	{
		sizeLabel: '10 ¼ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020814893458',
	},
	{
		sizeLabel: '5+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671825159353',
	},
	{
		sizeLabel: '6+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671082869603',
	},
	{
		sizeLabel: '39+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039977308993',
	},
	{
		sizeLabel: '6+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889645321223',
	},
	{
		sizeLabel: '7+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282077854770',
	},
	{
		sizeLabel: '40+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540653590743',
	},
	{
		sizeLabel: '7+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988237815748',
	},
	{
		sizeLabel: '8+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '434332212503',
	},
	{
		sizeLabel: '41+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537333854788',
	},
	{
		sizeLabel: '8+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975516173567',
	},
	{
		sizeLabel: '9+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058377171937',
	},
	{
		sizeLabel: '42+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063663982264',
	},
	{
		sizeLabel: '9+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066388047949',
	},
	{
		sizeLabel: '10+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852106577166',
	},
	{
		sizeLabel: '43+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523327532322',
	},
	{
		sizeLabel: '10+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271052635037',
	},
	{
		sizeLabel: '11+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547655930218',
	},
	{
		sizeLabel: '44+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703772155776',
	},
	{
		sizeLabel: '11+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200522893978',
	},
	{
		sizeLabel: '12+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021660377516',
	},
	{
		sizeLabel: '45+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775700851954',
	},
	{
		sizeLabel: '2+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203437922815',
	},
	{
		sizeLabel: '5+ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439545608581',
	},
	{
		sizeLabel: '35+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974823476783',
	},
	{
		sizeLabel: '3+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146331665061',
	},
	{
		sizeLabel: '36+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428894796653',
	},
	{
		sizeLabel: '4+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910342974270',
	},
	{
		sizeLabel: '37+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184749250977',
	},
	{
		sizeLabel: '38+ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569516780235',
	},
	{
		sizeLabel: '31-33 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658044275069',
	},
	{
		sizeLabel: '165-88Y (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884837794382',
	},
	{
		sizeLabel: '170-92Y (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411128139957',
	},
	{
		sizeLabel: '32-34 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707819380033',
	},
	{
		sizeLabel: '34-36 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563901520275',
	},
	{
		sizeLabel: '170-96Y (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191338859393',
	},
	{
		sizeLabel: '170-100Y (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612039355405',
	},
	{
		sizeLabel: '39 ½-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172473260342',
	},
	{
		sizeLabel: '165-84Y (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674977977859',
	},
	{
		sizeLabel: '26 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '042801548528',
	},
	{
		sizeLabel: '170-104Y (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823762271448',
	},
	{
		sizeLabel: '44 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349048520453',
	},
	{
		sizeLabel: '28 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680024038059',
	},
	{
		sizeLabel: '30 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051792584087',
	},
	{
		sizeLabel: '32 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396400534898',
	},
	{
		sizeLabel: '34 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537084607745',
	},
	{
		sizeLabel: '36 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654087592790',
	},
	{
		sizeLabel: '38 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932119071637',
	},
	{
		sizeLabel: '40 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872015261592',
	},
	{
		sizeLabel: '42 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580207379469',
	},
	{
		sizeLabel: '46 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887584781769',
	},
	{
		sizeLabel: '24 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811793524168',
	},
	{
		sizeLabel: 'XL-1X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823830551885',
	},
	{
		sizeLabel: '2XL-2X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109427611458',
	},
	{
		sizeLabel: '3XL-3X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697588083317',
	},
	{
		sizeLabel: '5XB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100708361838',
	},
	{
		sizeLabel: 'W30-32W (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005571561250',
	},
	{
		sizeLabel: 'W34-W36 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742322438302',
	},
	{
		sizeLabel: '4-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008710203041',
	},
	{
		sizeLabel: '8-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931281954296',
	},
	{
		sizeLabel: '6-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775923285973',
	},
	{
		sizeLabel: '12-15 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017326719580',
	},
	{
		sizeLabel: '11 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375178065709',
	},
	{
		sizeLabel: '12 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346416211173',
	},
	{
		sizeLabel: '13 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040521275304',
	},
	{
		sizeLabel: '2 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699654703090',
	},
	{
		sizeLabel: 'XXL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776917151362',
	},
	{
		sizeLabel: '8-9',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414163079225',
	},
	{
		sizeLabel: '37-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '541313498647',
	},
	{
		sizeLabel: '37-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802049979178',
	},
	{
		sizeLabel: '37-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135185644261',
	},
	{
		sizeLabel: '37-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461786925850',
	},
	{
		sizeLabel: '000-00 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050700433788',
	},
	{
		sizeLabel: 'XS TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299826709864',
	},
	{
		sizeLabel: '00-24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093914999232',
	},
	{
		sizeLabel: '0-25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839821035638',
	},
	{
		sizeLabel: '2-26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965869262254',
	},
	{
		sizeLabel: '4-27 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '993867368618',
	},
	{
		sizeLabel: '6-28 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578434196364',
	},
	{
		sizeLabel: '8-29 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330318522390',
	},
	{
		sizeLabel: '10-30 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460890212078',
	},
	{
		sizeLabel: '12-31 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '326853193788',
	},
	{
		sizeLabel: '14-32 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558379574178',
	},
	{
		sizeLabel: '16-33 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891506374292',
	},
	{
		sizeLabel: '18-34 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554993338142',
	},
	{
		sizeLabel: '20-35 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284555822121',
	},
	{
		sizeLabel: '38-41',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562438105864',
	},
	{
		sizeLabel: '42-45',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580885020848',
	},
	{
		sizeLabel: '28-29-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957311939287',
	},
	{
		sizeLabel: '28-29-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565598981362',
	},
	{
		sizeLabel: '28-29-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '844349098180',
	},
	{
		sizeLabel: '28-29-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899773344985',
	},
	{
		sizeLabel: '30-31-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941073955462',
	},
	{
		sizeLabel: '30-31-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048861648640',
	},
	{
		sizeLabel: '30-31-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863300896248',
	},
	{
		sizeLabel: '30-31-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724996109105',
	},
	{
		sizeLabel: '32-34-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869695426838',
	},
	{
		sizeLabel: '32-34-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035416066810',
	},
	{
		sizeLabel: '32-34-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137153335227',
	},
	{
		sizeLabel: '32-34-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773730745171',
	},
	{
		sizeLabel: '35-37-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765795310554',
	},
	{
		sizeLabel: '35-37-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763730765785',
	},
	{
		sizeLabel: '35-37-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263763282535',
	},
	{
		sizeLabel: '35-37-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205313310997',
	},
	{
		sizeLabel: '38-41-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304174704154',
	},
	{
		sizeLabel: '38-41-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '936747418746',
	},
	{
		sizeLabel: '38-41-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413147413333',
	},
	{
		sizeLabel: '38-41-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096998063884',
	},
	{
		sizeLabel: '42-45-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639924230482',
	},
	{
		sizeLabel: '42-45-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '243939579689',
	},
	{
		sizeLabel: '42-45-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350307898864',
	},
	{
		sizeLabel: '42-45-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '541822031139',
	},
	{
		sizeLabel: '26-27-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094427671163',
	},
	{
		sizeLabel: '105 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506194056043',
	},
	{
		sizeLabel: '8.25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055834345114',
	},
	{
		sizeLabel: '11.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179269267255',
	},
	{
		sizeLabel: '9.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734025451405',
	},
	{
		sizeLabel: '8.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878767249479',
	},
	{
		sizeLabel: '9.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113578833516',
	},
	{
		sizeLabel: '9.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162057795517',
	},
	{
		sizeLabel: '10.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463040071277',
	},
	{
		sizeLabel: '45 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157920850392',
	},
	{
		sizeLabel: '46 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907599735221',
	},
	{
		sizeLabel: '10.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777766093048',
	},
	{
		sizeLabel: '11.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436406118212',
	},
	{
		sizeLabel: '3-MAX',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935193925935',
	},
	{
		sizeLabel: 'S-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626773798493',
	},
	{
		sizeLabel: 'M-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769745601386',
	},
	{
		sizeLabel: 'L-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425277142401',
	},
	{
		sizeLabel: 'XL-42',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672474675885',
	},
	{
		sizeLabel: '23-24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574580533862',
	},
	{
		sizeLabel: '2.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '857734423119',
	},
	{
		sizeLabel: '7.3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363692247878',
	},
	{
		sizeLabel: 'UN',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524172839168',
	},
	{
		sizeLabel: 'UN (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231785217841',
	},
	{
		sizeLabel: '6.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210516342718',
	},
	{
		sizeLabel: '7.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699805470433',
	},
	{
		sizeLabel: '264-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682736057479',
	},
	{
		sizeLabel: '22 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443787757263',
	},
	{
		sizeLabel: '22 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769197224908',
	},
	{
		sizeLabel: '23 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794964592126',
	},
	{
		sizeLabel: '23 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580024878067',
	},
	{
		sizeLabel: '24 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583743730993',
	},
	{
		sizeLabel: '24 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208894514544',
	},
	{
		sizeLabel: '25 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505484963831',
	},
	{
		sizeLabel: '25 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592344385905',
	},
	{
		sizeLabel: '26 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '976583073119',
	},
	{
		sizeLabel: '26 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294186450328',
	},
	{
		sizeLabel: '27 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855161991076',
	},
	{
		sizeLabel: '27 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322536514783',
	},
	{
		sizeLabel: '28 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738165249232',
	},
	{
		sizeLabel: '28 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784395230014',
	},
	{
		sizeLabel: '29 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662483129088',
	},
	{
		sizeLabel: '29 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824832437076',
	},
	{
		sizeLabel: '30 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492666685912',
	},
	{
		sizeLabel: '30 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517517161789',
	},
	{
		sizeLabel: '31 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383625149970',
	},
	{
		sizeLabel: '31 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758900708037',
	},
	{
		sizeLabel: '32 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728163146638',
	},
	{
		sizeLabel: '32 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431931814980',
	},
	{
		sizeLabel: '33 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115812759729',
	},
	{
		sizeLabel: '5-7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336016927160',
	},
	{
		sizeLabel: '6 ½-8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368882779836',
	},
	{
		sizeLabel: '9 ½-11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072233235766',
	},
	{
		sizeLabel: '11-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418610492481',
	},
	{
		sizeLabel: '12 ½-13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835291795171',
	},
	{
		sizeLabel: '5-8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045516094750',
	},
	{
		sizeLabel: '6 ½-9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '679762220229',
	},
	{
		sizeLabel: '8A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409962277517',
	},
	{
		sizeLabel: '36-39',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630349725770',
	},
	{
		sizeLabel: '41-41',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637963759911',
	},
	{
		sizeLabel: '6 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169917429584',
	},
	{
		sizeLabel: '6 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144208996651',
	},
	{
		sizeLabel: '7 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674886603844',
	},
	{
		sizeLabel: '7 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '454530519334',
	},
	{
		sizeLabel: '8 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752517054560',
	},
	{
		sizeLabel: '8 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834014003734',
	},
	{
		sizeLabel: '9 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089808835600',
	},
	{
		sizeLabel: '9 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167521949919',
	},
	{
		sizeLabel: '10 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083689956897',
	},
	{
		sizeLabel: '25 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837215976935',
	},
	{
		sizeLabel: '27 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062797919135',
	},
	{
		sizeLabel: '29 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666170283514',
	},
	{
		sizeLabel: '33 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874547211874',
	},
	{
		sizeLabel: '1H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271224189911',
	},
	{
		sizeLabel: '1I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862926301186',
	},
	{
		sizeLabel: '1J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179108191177',
	},
	{
		sizeLabel: '2H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227482067188',
	},
	{
		sizeLabel: '2I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408573093201',
	},
	{
		sizeLabel: '2J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '053979849767',
	},
	{
		sizeLabel: '3H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209227362029',
	},
	{
		sizeLabel: '3I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505137008991',
	},
	{
		sizeLabel: '3J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743612776887',
	},
	{
		sizeLabel: '4DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831271903877',
	},
	{
		sizeLabel: '4H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252685223471',
	},
	{
		sizeLabel: '4I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '195432177397',
	},
	{
		sizeLabel: '4J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778606933129',
	},
	{
		sizeLabel: '5DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826501704139',
	},
	{
		sizeLabel: '5H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406577914388',
	},
	{
		sizeLabel: '5I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931228426734',
	},
	{
		sizeLabel: '5J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956627830579',
	},
	{
		sizeLabel: '6DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '747602841135',
	},
	{
		sizeLabel: '6H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183024856990',
	},
	{
		sizeLabel: '6I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689468649407',
	},
	{
		sizeLabel: '6J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127575064830',
	},
	{
		sizeLabel: '7DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889153776764',
	},
	{
		sizeLabel: '7H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597070748220',
	},
	{
		sizeLabel: '7I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305306772310',
	},
	{
		sizeLabel: '7J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354784696860',
	},
	{
		sizeLabel: '8DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650536095521',
	},
	{
		sizeLabel: '8H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '749592996267',
	},
	{
		sizeLabel: '8I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202269685100',
	},
	{
		sizeLabel: '8J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565048633270',
	},
	{
		sizeLabel: '9A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711712208439',
	},
	{
		sizeLabel: '9DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153335434236',
	},
	{
		sizeLabel: '9H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530814809674',
	},
	{
		sizeLabel: '9I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '829889423956',
	},
	{
		sizeLabel: '9J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568368237508',
	},
	{
		sizeLabel: '10A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468771721521',
	},
	{
		sizeLabel: '10B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995671234598',
	},
	{
		sizeLabel: '10C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597656187483',
	},
	{
		sizeLabel: '10D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939075579859',
	},
	{
		sizeLabel: '10DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624020096066',
	},
	{
		sizeLabel: '10E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639486844359',
	},
	{
		sizeLabel: '10F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206376881152',
	},
	{
		sizeLabel: '10G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328643499684',
	},
	{
		sizeLabel: '10H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546527527254',
	},
	{
		sizeLabel: '10I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548037602550',
	},
	{
		sizeLabel: '10J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935869949054',
	},
	{
		sizeLabel: '11A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485980866237',
	},
	{
		sizeLabel: '11B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605025628345',
	},
	{
		sizeLabel: '11C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508701141815',
	},
	{
		sizeLabel: '11D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863795239589',
	},
	{
		sizeLabel: '11DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531934581438',
	},
	{
		sizeLabel: '11E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751413012635',
	},
	{
		sizeLabel: '11F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356191660147',
	},
	{
		sizeLabel: '11G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708038381135',
	},
	{
		sizeLabel: '11H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '723952837936',
	},
	{
		sizeLabel: '11I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809425878171',
	},
	{
		sizeLabel: '130K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831654482265',
	},
	{
		sizeLabel: '11J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754705587664',
	},
	{
		sizeLabel: '12A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212112273754',
	},
	{
		sizeLabel: '12B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805945704010',
	},
	{
		sizeLabel: '12C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469954334100',
	},
	{
		sizeLabel: '12D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927725686349',
	},
	{
		sizeLabel: '52DD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594885256511',
	},
	{
		sizeLabel: '12DD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149862386757',
	},
	{
		sizeLabel: '12E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600788326463',
	},
	{
		sizeLabel: '12F (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126258728414',
	},
	{
		sizeLabel: '12G (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678756072276',
	},
	{
		sizeLabel: '12H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580347971588',
	},
	{
		sizeLabel: '12I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301278848486',
	},
	{
		sizeLabel: '135K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503314133942',
	},
	{
		sizeLabel: '12J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701346380670',
	},
	{
		sizeLabel: '22.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948884579229',
	},
	{
		sizeLabel: '223 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503482425351',
	},
	{
		sizeLabel: '237 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407418230074',
	},
	{
		sizeLabel: '243 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753874072059',
	},
	{
		sizeLabel: '25.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572203386272',
	},
	{
		sizeLabel: '263 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602977632689',
	},
	{
		sizeLabel: '277 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267614369566',
	},
	{
		sizeLabel: '25.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193577119442',
	},
	{
		sizeLabel: '253 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '242733470062',
	},
	{
		sizeLabel: '258 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225102315086',
	},
	{
		sizeLabel: '27.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277727831404',
	},
	{
		sizeLabel: '272 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094998205161',
	},
	{
		sizeLabel: '278 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397043811391',
	},
	{
		sizeLabel: '29.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874276455128',
	},
	{
		sizeLabel: '292 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773913880319',
	},
	{
		sizeLabel: '299 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818172141401',
	},
	{
		sizeLabel: '31.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409853780355',
	},
	{
		sizeLabel: '312 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329194442709',
	},
	{
		sizeLabel: '31.9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363695180388',
	},
	{
		sizeLabel: '319 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411579988093',
	},
	{
		sizeLabel: '32.6 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575692081147',
	},
	{
		sizeLabel: '326 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658127004209',
	},
	{
		sizeLabel: '28.4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008291332888',
	},
	{
		sizeLabel: '284 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100694487731',
	},
	{
		sizeLabel: '29.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950418837384',
	},
	{
		sizeLabel: '297 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701652580527',
	},
	{
		sizeLabel: '30.4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060959158667',
	},
	{
		sizeLabel: '304 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680304579728',
	},
	{
		sizeLabel: '31.7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107480968193',
	},
	{
		sizeLabel: '317 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179975050456',
	},
	{
		sizeLabel: '32.3 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343309225430',
	},
	{
		sizeLabel: '323 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '210467562088',
	},
	{
		sizeLabel: '23.2 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030528084733',
	},
	{
		sizeLabel: '232 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561407854753',
	},
	{
		sizeLabel: '238 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938563288446',
	},
	{
		sizeLabel: '252 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058762593329',
	},
	{
		sizeLabel: '27.1 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384803309991',
	},
	{
		sizeLabel: '271 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121036851392',
	},
	{
		sizeLabel: '6 ⅞-7 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158713480382',
	},
	{
		sizeLabel: 'ONE SIZE (OS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609074387996',
	},
	{
		sizeLabel: '7 ⅞ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397004895851',
	},
	{
		sizeLabel: '7-9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939554985887',
	},
	{
		sizeLabel: '13 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144696869721',
	},
	{
		sizeLabel: '14 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504929285016',
	},
	{
		sizeLabel: '49 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514896855843',
	},
	{
		sizeLabel: '34 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215936593087',
	},
	{
		sizeLabel: '15 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193988422678',
	},
	{
		sizeLabel: '345 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881639880094',
	},
	{
		sizeLabel: '34 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '458853677344',
	},
	{
		sizeLabel: '6 ½-7',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505795678350',
	},
	{
		sizeLabel: '7 ½-8 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864029263497',
	},
	{
		sizeLabel: '9-9 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573088530456',
	},
	{
		sizeLabel: '10-10 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701668933589',
	},
	{
		sizeLabel: '220 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093059024235',
	},
	{
		sizeLabel: 'XS-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566316748850',
	},
	{
		sizeLabel: 'XS-S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175744627032',
	},
	{
		sizeLabel: 'S-M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604372433130',
	},
	{
		sizeLabel: 'S-M (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864033812461',
	},
	{
		sizeLabel: '6-8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050087242508',
	},
	{
		sizeLabel: '19-20 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087771569386',
	},
	{
		sizeLabel: 'XXS-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917487130751',
	},
	{
		sizeLabel: '32-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738158403395',
	},
	{
		sizeLabel: 'XS-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579630359346',
	},
	{
		sizeLabel: '34-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589615512464',
	},
	{
		sizeLabel: 'S-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797707520788',
	},
	{
		sizeLabel: '36-P38-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378330283414',
	},
	{
		sizeLabel: 'M-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628552353369',
	},
	{
		sizeLabel: '40-P42-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307496536751',
	},
	{
		sizeLabel: 'L-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078452345489',
	},
	{
		sizeLabel: '44-P46-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587164959528',
	},
	{
		sizeLabel: 'XL-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426987070000',
	},
	{
		sizeLabel: '48-P50-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767141063915',
	},
	{
		sizeLabel: '2XL-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581301850305',
	},
	{
		sizeLabel: '52-P54-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579609433640',
	},
	{
		sizeLabel: '3XL-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175898739285',
	},
	{
		sizeLabel: '56-P58-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135225671115',
	},
	{
		sizeLabel: '4XL-P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '261230595029',
	},
	{
		sizeLabel: '60-P62-P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851539769397',
	},
	{
		sizeLabel: '33R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474644651481',
	},
	{
		sizeLabel: '54R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619648184133',
	},
	{
		sizeLabel: '56R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030858568976',
	},
	{
		sizeLabel: '33-35 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328494444690',
	},
	{
		sizeLabel: '32R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871518977200',
	},
	{
		sizeLabel: '34R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138267096536',
	},
	{
		sizeLabel: '36R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283326949123',
	},
	{
		sizeLabel: '38R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750668687298',
	},
	{
		sizeLabel: '40R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544241393301',
	},
	{
		sizeLabel: '42R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366906432277',
	},
	{
		sizeLabel: '44R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712131951959',
	},
	{
		sizeLabel: '46R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '269155590704',
	},
	{
		sizeLabel: '32S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292919746410',
	},
	{
		sizeLabel: '34S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259270227020',
	},
	{
		sizeLabel: '36S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819977060162',
	},
	{
		sizeLabel: '38S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900567497953',
	},
	{
		sizeLabel: '40S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203231252388',
	},
	{
		sizeLabel: '42S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035060170874',
	},
	{
		sizeLabel: '44S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059133779804',
	},
	{
		sizeLabel: '46S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099928027372',
	},
	{
		sizeLabel: '32L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921056286327',
	},
	{
		sizeLabel: '34L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633612583724',
	},
	{
		sizeLabel: '36L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927255010575',
	},
	{
		sizeLabel: '38L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545343196676',
	},
	{
		sizeLabel: '40L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371023679709',
	},
	{
		sizeLabel: '42L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565458778562',
	},
	{
		sizeLabel: '44L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186202302715',
	},
	{
		sizeLabel: '46L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379973293075',
	},
	{
		sizeLabel: '44R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048361803802',
	},
	{
		sizeLabel: '46R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583024640360',
	},
	{
		sizeLabel: '48R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411607295108',
	},
	{
		sizeLabel: '50R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086363556637',
	},
	{
		sizeLabel: '52R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639997563161',
	},
	{
		sizeLabel: '54R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093321925761',
	},
	{
		sizeLabel: '56R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051561334768',
	},
	{
		sizeLabel: '58R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227749691538',
	},
	{
		sizeLabel: '60R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928453465374',
	},
	{
		sizeLabel: '44S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342149939018',
	},
	{
		sizeLabel: '46S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025420940627',
	},
	{
		sizeLabel: '48S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453979430133',
	},
	{
		sizeLabel: '50S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394881713370',
	},
	{
		sizeLabel: '52S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169181993057',
	},
	{
		sizeLabel: '54S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '725096009664',
	},
	{
		sizeLabel: '56S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602306796988',
	},
	{
		sizeLabel: '58S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393313803758',
	},
	{
		sizeLabel: '60S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282347108687',
	},
	{
		sizeLabel: '2-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017282708611',
	},
	{
		sizeLabel: 'LOW RISE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345557784893',
	},
	{
		sizeLabel: 'P-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335041973029',
	},
	{
		sizeLabel: '0-6',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451202634188',
	},
	{
		sizeLabel: '08-14',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118253353890',
	},
	{
		sizeLabel: 'W24-W26',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168855527966',
	},
	{
		sizeLabel: '115DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023393026209',
	},
	{
		sizeLabel: '120DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050770235273',
	},
	{
		sizeLabel: '70DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841167731743',
	},
	{
		sizeLabel: '75DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654369761580',
	},
	{
		sizeLabel: '80DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365351048360',
	},
	{
		sizeLabel: '85DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '473955988064',
	},
	{
		sizeLabel: '90DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663520276395',
	},
	{
		sizeLabel: '36-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918938611917',
	},
	{
		sizeLabel: '41-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962967683001',
	},
	{
		sizeLabel: '47-51 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '735746357469',
	},
	{
		sizeLabel: '10.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546489165431',
	},
	{
		sizeLabel: '35-36 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '285273749602',
	},
	{
		sizeLabel: '4-5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736116976002',
	},
	{
		sizeLabel: '37-38 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318224705496',
	},
	{
		sizeLabel: '39-40 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591566836415',
	},
	{
		sizeLabel: '41-42 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585975942748',
	},
	{
		sizeLabel: '43-44 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549191774289',
	},
	{
		sizeLabel: '45-46 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072517658123',
	},
	{
		sizeLabel: '47-48 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088475752942',
	},
	{
		sizeLabel: '33-34 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921020160415',
	},
	{
		sizeLabel: '1-2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644440314177',
	},
	{
		sizeLabel: '50-52 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184128058462',
	},
	{
		sizeLabel: '56-58 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522046145628',
	},
	{
		sizeLabel: '65GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567174236907',
	},
	{
		sizeLabel: '80GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478660086729',
	},
	{
		sizeLabel: '0GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '006824519750',
	},
	{
		sizeLabel: '8GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '698989776888',
	},
	{
		sizeLabel: '0H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736281244344',
	},
	{
		sizeLabel: '30HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899233063032',
	},
	{
		sizeLabel: '65HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382950091984',
	},
	{
		sizeLabel: '80HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169932613256',
	},
	{
		sizeLabel: '0HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651666194447',
	},
	{
		sizeLabel: '8HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361869404268',
	},
	{
		sizeLabel: '0J (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841245346341',
	},
	{
		sizeLabel: '8J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362729509630',
	},
	{
		sizeLabel: '70GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535471227270',
	},
	{
		sizeLabel: '85GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733772019871',
	},
	{
		sizeLabel: '1GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '986272275855',
	},
	{
		sizeLabel: '10GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548412439099',
	},
	{
		sizeLabel: '32HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961491648701',
	},
	{
		sizeLabel: '70HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960598825791',
	},
	{
		sizeLabel: '85HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496703035630',
	},
	{
		sizeLabel: '1HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467768655882',
	},
	{
		sizeLabel: '10HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286545289325',
	},
	{
		sizeLabel: '10J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759328349919',
	},
	{
		sizeLabel: '75GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610215449267',
	},
	{
		sizeLabel: '90GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532377022529',
	},
	{
		sizeLabel: '2GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840146161545',
	},
	{
		sizeLabel: '12GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238202242282',
	},
	{
		sizeLabel: '75HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084602007653',
	},
	{
		sizeLabel: '90HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909891861590',
	},
	{
		sizeLabel: '2HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077001439910',
	},
	{
		sizeLabel: '12HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166132578207',
	},
	{
		sizeLabel: '12J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915858666869',
	},
	{
		sizeLabel: '80GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '493081566280',
	},
	{
		sizeLabel: '95GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405682915730',
	},
	{
		sizeLabel: '3GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '025983698437',
	},
	{
		sizeLabel: '14GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938601635540',
	},
	{
		sizeLabel: '36HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186714080989',
	},
	{
		sizeLabel: '80HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787856655520',
	},
	{
		sizeLabel: '95HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333241436171',
	},
	{
		sizeLabel: '3HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757768019855',
	},
	{
		sizeLabel: '14HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629498310306',
	},
	{
		sizeLabel: '14J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815051240081',
	},
	{
		sizeLabel: '85GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830390650896',
	},
	{
		sizeLabel: '100GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '473411645678',
	},
	{
		sizeLabel: '4GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866385425937',
	},
	{
		sizeLabel: '16GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400600954508',
	},
	{
		sizeLabel: '38HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852755264701',
	},
	{
		sizeLabel: '85HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932273338077',
	},
	{
		sizeLabel: '100HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831848741412',
	},
	{
		sizeLabel: '4HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585469567619',
	},
	{
		sizeLabel: '16HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190146524801',
	},
	{
		sizeLabel: '16J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875458649724',
	},
	{
		sizeLabel: '40GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800311135246',
	},
	{
		sizeLabel: '90GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570919008776',
	},
	{
		sizeLabel: '105GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907684369811',
	},
	{
		sizeLabel: '5GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275640350377',
	},
	{
		sizeLabel: '18GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291824069157',
	},
	{
		sizeLabel: '40HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695828550747',
	},
	{
		sizeLabel: '90HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606395925683',
	},
	{
		sizeLabel: '105HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471647256869',
	},
	{
		sizeLabel: '5HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028612234389',
	},
	{
		sizeLabel: '18HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532111177820',
	},
	{
		sizeLabel: '18J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216487846113',
	},
	{
		sizeLabel: '42GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943053390389',
	},
	{
		sizeLabel: '95GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831184018602',
	},
	{
		sizeLabel: '110GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123353682874',
	},
	{
		sizeLabel: '6GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173940856709',
	},
	{
		sizeLabel: '20GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780273552874',
	},
	{
		sizeLabel: '42HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874655180714',
	},
	{
		sizeLabel: '95HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208920033987',
	},
	{
		sizeLabel: '110HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888613747170',
	},
	{
		sizeLabel: '6HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327661372336',
	},
	{
		sizeLabel: '20HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391662769672',
	},
	{
		sizeLabel: '20J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675075371428',
	},
	{
		sizeLabel: '22A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319224700748',
	},
	{
		sizeLabel: '44GG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691871695689',
	},
	{
		sizeLabel: '100GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712735286326',
	},
	{
		sizeLabel: '115GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178781044762',
	},
	{
		sizeLabel: '7GG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787287446857',
	},
	{
		sizeLabel: '22GG (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500992830132',
	},
	{
		sizeLabel: '44HH (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231737224101',
	},
	{
		sizeLabel: '100HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '737753471200',
	},
	{
		sizeLabel: '115HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314625803094',
	},
	{
		sizeLabel: '7HH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121426465397',
	},
	{
		sizeLabel: '22HH (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158135703028',
	},
	{
		sizeLabel: '22J (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654895745024',
	},
	{
		sizeLabel: '180-88',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415269565237',
	},
	{
		sizeLabel: '180-96',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011066367016',
	},
	{
		sizeLabel: '180-104',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911408321214',
	},
	{
		sizeLabel: '180-112',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734601686677',
	},
	{
		sizeLabel: '180-120',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526480324669',
	},
	{
		sizeLabel: '180-124',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071311275809',
	},
	{
		sizeLabel: '180-128',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154299305424',
	},
	{
		sizeLabel: '180-184',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721140631339',
	},
	{
		sizeLabel: '76-92',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013239900405',
	},
	{
		sizeLabel: '80-96',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544283227432',
	},
	{
		sizeLabel: '84-100',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096061943507',
	},
	{
		sizeLabel: '88-104',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554521416443',
	},
	{
		sizeLabel: '92-108',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336354375072',
	},
	{
		sizeLabel: '96-112',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960917227622',
	},
	{
		sizeLabel: '100-116',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921821622483',
	},
	{
		sizeLabel: '104-120',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061282198734',
	},
	{
		sizeLabel: '108-124',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689449679248',
	},
	{
		sizeLabel: '112-128',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472204697275',
	},
	{
		sizeLabel: '38.7 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178252547291',
	},
	{
		sizeLabel: '39.3 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470609452127',
	},
	{
		sizeLabel: '00-0 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297253154204',
	},
	{
		sizeLabel: '52 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071313075757',
	},
	{
		sizeLabel: '36 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '003951035669',
	},
	{
		sizeLabel: '38 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '004084332809',
	},
	{
		sizeLabel: '43 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '692303753867',
	},
	{
		sizeLabel: '45 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418550709751',
	},
	{
		sizeLabel: '46 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614804253369',
	},
	{
		sizeLabel: '47 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064317810637',
	},
	{
		sizeLabel: '34 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625559848268',
	},
	{
		sizeLabel: '4 ½5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '719158400786',
	},
	{
		sizeLabel: '5 ½+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968910890177',
	},
	{
		sizeLabel: '8 ½+ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418274912857',
	},
	{
		sizeLabel: '290 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190764817914',
	},
	{
		sizeLabel: '300 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305588119406',
	},
	{
		sizeLabel: '315 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695454557130',
	},
	{
		sizeLabel: '320 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '502852872351',
	},
	{
		sizeLabel: '325 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612951980195',
	},
	{
		sizeLabel: 'M5-W6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450447544506',
	},
	{
		sizeLabel: 'M5 ½-W6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138172077976',
	},
	{
		sizeLabel: 'M6-W7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361209854837',
	},
	{
		sizeLabel: 'M6 ½-W7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074474525842',
	},
	{
		sizeLabel: 'M7-W8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119351926588',
	},
	{
		sizeLabel: 'M7 ½-W8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101833782861',
	},
	{
		sizeLabel: 'M8-W9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365805304458',
	},
	{
		sizeLabel: 'M8 ½-W9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298200736819',
	},
	{
		sizeLabel: 'M9-W10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368645599511',
	},
	{
		sizeLabel: 'M9 ½-W10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '326034756450',
	},
	{
		sizeLabel: 'M10-W11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224842081656',
	},
	{
		sizeLabel: 'M10 ½-W11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741591999109',
	},
	{
		sizeLabel: 'M11-W12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085601219800',
	},
	{
		sizeLabel: 'M11 ½-W12 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167321268880',
	},
	{
		sizeLabel: 'M12-W13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399828325413',
	},
	{
		sizeLabel: 'M12 ½-W13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '856504949624',
	},
	{
		sizeLabel: 'M13-W14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827856292646',
	},
	{
		sizeLabel: 'M13 ½-W14 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510346644318',
	},
	{
		sizeLabel: 'M14-W15 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135455933400',
	},
	{
		sizeLabel: '8-9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090834996006',
	},
	{
		sizeLabel: '8 ½-9 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417030712521',
	},
	{
		sizeLabel: '9 ½-10 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998484194259',
	},
	{
		sizeLabel: '10 ½-11 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389016441190',
	},
	{
		sizeLabel: '11 ½-12 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051703299812',
	},
	{
		sizeLabel: 'XXS EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815314476095',
	},
	{
		sizeLabel: 'XS EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '482575810878',
	},
	{
		sizeLabel: 'S EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862129185265',
	},
	{
		sizeLabel: 'M EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342269546118',
	},
	{
		sizeLabel: 'L EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '281822038159',
	},
	{
		sizeLabel: 'XL EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288256518406',
	},
	{
		sizeLabel: 'XXL EXTRA SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538107427204',
	},
	{
		sizeLabel: 'XXS SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128358815400',
	},
	{
		sizeLabel: 'XXS REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300549767228',
	},
	{
		sizeLabel: 'XS REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183132878705',
	},
	{
		sizeLabel: 'S REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606606956534',
	},
	{
		sizeLabel: 'M REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998198899832',
	},
	{
		sizeLabel: 'L REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756095949699',
	},
	{
		sizeLabel: 'XL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207615496278',
	},
	{
		sizeLabel: 'XXL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888054605942',
	},
	{
		sizeLabel: 'XXS LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806048526171',
	},
	{
		sizeLabel: 'XS LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310591828790',
	},
	{
		sizeLabel: 'S LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906474809601',
	},
	{
		sizeLabel: 'M LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540910159044',
	},
	{
		sizeLabel: 'L LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695381446643',
	},
	{
		sizeLabel: 'XL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791224989983',
	},
	{
		sizeLabel: 'XXL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823447609242',
	},
	{
		sizeLabel: '2XL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636670502059',
	},
	{
		sizeLabel: 'XXS TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083027321792',
	},
	{
		sizeLabel: '23-25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073674440795',
	},
	{
		sizeLabel: '39-40 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904641459474',
	},
	{
		sizeLabel: '41-42 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420836818219',
	},
	{
		sizeLabel: '43-44 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '419928677918',
	},
	{
		sizeLabel: '35-36 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450475007756',
	},
	{
		sizeLabel: '37-38 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897199851507',
	},
	{
		sizeLabel: '4-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149476044919',
	},
	{
		sizeLabel: '9-10',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609800916478',
	},
	{
		sizeLabel: '9-5-10 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448525142135',
	},
	{
		sizeLabel: '4-6',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625020060140',
	},
	{
		sizeLabel: '8-10',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346124772478',
	},
	{
		sizeLabel: '80AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525559343582',
	},
	{
		sizeLabel: '90AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529055533100',
	},
	{
		sizeLabel: '95AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028869288439',
	},
	{
		sizeLabel: '100AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238416530828',
	},
	{
		sizeLabel: '105AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452838122384',
	},
	{
		sizeLabel: '110AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515766169667',
	},
	{
		sizeLabel: '115AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926337436462',
	},
	{
		sizeLabel: '120AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254537371081',
	},
	{
		sizeLabel: '125AA (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114300408403',
	},
	{
		sizeLabel: '38-40 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969019363851',
	},
	{
		sizeLabel: '42-44 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759806681393',
	},
	{
		sizeLabel: '2X-2XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417711215115',
	},
	{
		sizeLabel: '3X-3XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506426527235',
	},
	{
		sizeLabel: '4X-4XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744072350638',
	},
	{
		sizeLabel: '5X-5XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452407555422',
	},
	{
		sizeLabel: '35 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '249771285421',
	},
	{
		sizeLabel: '36 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223863357608',
	},
	{
		sizeLabel: '37 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682846750960',
	},
	{
		sizeLabel: '38 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938508631581',
	},
	{
		sizeLabel: '39 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969153432763',
	},
	{
		sizeLabel: '40 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197012276691',
	},
	{
		sizeLabel: '41 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855234757786',
	},
	{
		sizeLabel: '42 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614205323765',
	},
	{
		sizeLabel: '43 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098632414543',
	},
	{
		sizeLabel: '44 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833897245208',
	},
	{
		sizeLabel: '45 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766155687971',
	},
	{
		sizeLabel: '5-6 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '006638483163',
	},
	{
		sizeLabel: '80A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152106502726',
	},
	{
		sizeLabel: '80B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909640730761',
	},
	{
		sizeLabel: '80E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345705746538',
	},
	{
		sizeLabel: '80F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807789993540',
	},
	{
		sizeLabel: '85F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309659231070',
	},
	{
		sizeLabel: '95A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '670259286700',
	},
	{
		sizeLabel: '100A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800710266517',
	},
	{
		sizeLabel: '105A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402749274183',
	},
	{
		sizeLabel: '105B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376438129528',
	},
	{
		sizeLabel: '105C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119853161929',
	},
	{
		sizeLabel: '105D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888295214846',
	},
	{
		sizeLabel: '105E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466932306911',
	},
	{
		sizeLabel: '105F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310199316627',
	},
	{
		sizeLabel: '110A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954280411443',
	},
	{
		sizeLabel: '110B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '986329720127',
	},
	{
		sizeLabel: '110C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '243305366070',
	},
	{
		sizeLabel: '110D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107263548546',
	},
	{
		sizeLabel: '110E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009951524751',
	},
	{
		sizeLabel: '110F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633305459666',
	},
	{
		sizeLabel: '5-7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337682028881',
	},
	{
		sizeLabel: '65AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475453297359',
	},
	{
		sizeLabel: '65E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027595309327',
	},
	{
		sizeLabel: '65G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400107287610',
	},
	{
		sizeLabel: '65H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136942141675',
	},
	{
		sizeLabel: '70AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638399630193',
	},
	{
		sizeLabel: '70E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492325145806',
	},
	{
		sizeLabel: '70G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254596156658',
	},
	{
		sizeLabel: '70H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352901839374',
	},
	{
		sizeLabel: '75AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '723381106478',
	},
	{
		sizeLabel: '75E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701750044974',
	},
	{
		sizeLabel: '75G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023235254362',
	},
	{
		sizeLabel: '75H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807655096564',
	},
	{
		sizeLabel: '80AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447248541857',
	},
	{
		sizeLabel: '80E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672012727898',
	},
	{
		sizeLabel: '80G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289714117030',
	},
	{
		sizeLabel: '80H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516651254420',
	},
	{
		sizeLabel: '85AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680928868017',
	},
	{
		sizeLabel: '85E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174511680236',
	},
	{
		sizeLabel: '85G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582591853072',
	},
	{
		sizeLabel: '85H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888589836037',
	},
	{
		sizeLabel: '90AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224130407196',
	},
	{
		sizeLabel: '90E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '502262281263',
	},
	{
		sizeLabel: '90G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088854103272',
	},
	{
		sizeLabel: '90H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035985325661',
	},
	{
		sizeLabel: '95AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506738743432',
	},
	{
		sizeLabel: '95E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973762471821',
	},
	{
		sizeLabel: '95G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614843570530',
	},
	{
		sizeLabel: '95H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624373302113',
	},
	{
		sizeLabel: '100AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569128991463',
	},
	{
		sizeLabel: '100E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708311553874',
	},
	{
		sizeLabel: '100G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987713228781',
	},
	{
		sizeLabel: '100H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401156108032',
	},
	{
		sizeLabel: '105AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939754375785',
	},
	{
		sizeLabel: '105A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '821659026609',
	},
	{
		sizeLabel: '105B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568992008923',
	},
	{
		sizeLabel: '105C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581087349441',
	},
	{
		sizeLabel: '105D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279951486941',
	},
	{
		sizeLabel: '105E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '896632236564',
	},
	{
		sizeLabel: '105F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310220034607',
	},
	{
		sizeLabel: '105G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822750229597',
	},
	{
		sizeLabel: '105H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944109558676',
	},
	{
		sizeLabel: '110AA (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661778670897',
	},
	{
		sizeLabel: '110A (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425251544804',
	},
	{
		sizeLabel: '110B (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393085346060',
	},
	{
		sizeLabel: '110C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089308415998',
	},
	{
		sizeLabel: '110D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145294029981',
	},
	{
		sizeLabel: '110E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000246684968',
	},
	{
		sizeLabel: '110F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411304139350',
	},
	{
		sizeLabel: '110G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912722932436',
	},
	{
		sizeLabel: '110H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029495137016',
	},
	{
		sizeLabel: '115C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '093798175064',
	},
	{
		sizeLabel: '115D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560536467546',
	},
	{
		sizeLabel: '115E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '139964719622',
	},
	{
		sizeLabel: '115-F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470276282294',
	},
	{
		sizeLabel: '115-G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395170829449',
	},
	{
		sizeLabel: '115H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325208516626',
	},
	{
		sizeLabel: '120C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664588405035',
	},
	{
		sizeLabel: '120D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496818175822',
	},
	{
		sizeLabel: '120E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815954191376',
	},
	{
		sizeLabel: '120F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553329758761',
	},
	{
		sizeLabel: '120G (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847731704313',
	},
	{
		sizeLabel: '120H (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874415578253',
	},
	{
		sizeLabel: '125C (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951454748944',
	},
	{
		sizeLabel: '125D (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087616080469',
	},
	{
		sizeLabel: '125E-DD (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151474204780',
	},
	{
		sizeLabel: '125F (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036819395394',
	},
	{
		sizeLabel: '1-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889167287382',
	},
	{
		sizeLabel: '2-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '269124127557',
	},
	{
		sizeLabel: '3-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894909417229',
	},
	{
		sizeLabel: '5-XXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945359252106',
	},
	{
		sizeLabel: 'XXL-1X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929013851598',
	},
	{
		sizeLabel: '5H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049329804280',
	},
	{
		sizeLabel: '6H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117639938730',
	},
	{
		sizeLabel: '7H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '293371956127',
	},
	{
		sizeLabel: '8H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '541344663367',
	},
	{
		sizeLabel: '9H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064775409835',
	},
	{
		sizeLabel: '10H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942877219412',
	},
	{
		sizeLabel: '11H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965830991525',
	},
	{
		sizeLabel: '7H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '042903515118',
	},
	{
		sizeLabel: '8H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097983063063',
	},
	{
		sizeLabel: '9H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309980946831',
	},
	{
		sizeLabel: '10H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183209506549',
	},
	{
		sizeLabel: '11H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277998231502',
	},
	{
		sizeLabel: '12H (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343803794835',
	},
	{
		sizeLabel: '39-40 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172596312650',
	},
	{
		sizeLabel: '25 ½-26 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237400521355',
	},
	{
		sizeLabel: '27 ½-28 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451797768468',
	},
	{
		sizeLabel: '10-11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '984918564061',
	},
	{
		sizeLabel: '44 ½-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925212673301',
	},
	{
		sizeLabel: '29 ½-30 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471767021678',
	},
	{
		sizeLabel: '31 ½-32 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561671384132',
	},
	{
		sizeLabel: '34A-32B-32D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614815353861',
	},
	{
		sizeLabel: '36A-34B-32C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592277391209',
	},
	{
		sizeLabel: '36B-34C-36D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995276570292',
	},
	{
		sizeLabel: '36C\t-38D-36D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483311559002',
	},
	{
		sizeLabel: '38C\t-40D-38D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014194064944',
	},
	{
		sizeLabel: '42D-40DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792016694803',
	},
	{
		sizeLabel: '44D-42DD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790199920476',
	},
	{
		sizeLabel: '25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225478754151',
	},
	{
		sizeLabel: '39REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118853231714',
	},
	{
		sizeLabel: '41REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610897071885',
	},
	{
		sizeLabel: '43REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728169884784',
	},
	{
		sizeLabel: '45REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384942864098',
	},
	{
		sizeLabel: '39SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271120778080',
	},
	{
		sizeLabel: '41SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551948276896',
	},
	{
		sizeLabel: '43SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524430570999',
	},
	{
		sizeLabel: '45SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814871094119',
	},
	{
		sizeLabel: '39LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492246347247',
	},
	{
		sizeLabel: '41LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116167251940',
	},
	{
		sizeLabel: '43LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831236391619',
	},
	{
		sizeLabel: '45LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624012821457',
	},
	{
		sizeLabel: 'DELICATE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206340118918',
	},
	{
		sizeLabel: 'SUMPTUOUS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684003443945',
	},
	{
		sizeLabel: 'MAGNIFICENT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875588512653',
	},
	{
		sizeLabel: 'LUXURIOUS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356136409830',
	},
	{
		sizeLabel: 'GORGEOUS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101212716458',
	},
	{
		sizeLabel: 'WONDERFUL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865122828326',
	},
	{
		sizeLabel: 'FABULOUS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '772438770933',
	},
	{
		sizeLabel: 'YOU GLOW',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734335803065',
	},
	{
		sizeLabel: 'NICE & CURVY',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '541012831997',
	},
	{
		sizeLabel: '28-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144248574870',
	},
	{
		sizeLabel: '29-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057901766232',
	},
	{
		sizeLabel: '30-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587937442085',
	},
	{
		sizeLabel: '31-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945181587501',
	},
	{
		sizeLabel: '32-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265348588099',
	},
	{
		sizeLabel: '33-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929919528889',
	},
	{
		sizeLabel: 'SHORT XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875532398467',
	},
	{
		sizeLabel: 'SHORT S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568298844471',
	},
	{
		sizeLabel: 'SHORT M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297048316253',
	},
	{
		sizeLabel: 'SHORT L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177083280274',
	},
	{
		sizeLabel: 'SHORT XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752422601330',
	},
	{
		sizeLabel: 'SHORT 2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665526299353',
	},
	{
		sizeLabel: 'SHORT 3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830152487072',
	},
	{
		sizeLabel: '34S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802786215771',
	},
	{
		sizeLabel: '36S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865621014972',
	},
	{
		sizeLabel: '38S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '725060120502',
	},
	{
		sizeLabel: '40S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116663742368',
	},
	{
		sizeLabel: '42S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746413081376',
	},
	{
		sizeLabel: '34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '627419256710',
	},
	{
		sizeLabel: '36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472206282178',
	},
	{
		sizeLabel: '39L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819496968548',
	},
	{
		sizeLabel: '40L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527089939271',
	},
	{
		sizeLabel: '42L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795067261817',
	},
	{
		sizeLabel: '44L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520944559198',
	},
	{
		sizeLabel: '46L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234512291536',
	},
	{
		sizeLabel: '38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049509065132',
	},
	{
		sizeLabel: '48L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701975597508',
	},
	{
		sizeLabel: '50L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802261472672',
	},
	{
		sizeLabel: '52L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461856475949',
	},
	{
		sizeLabel: 'XXS-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414400777105',
	},
	{
		sizeLabel: 'XXS-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163966288815',
	},
	{
		sizeLabel: 'XXS-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386015875398',
	},
	{
		sizeLabel: 'XXS-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '821858975968',
	},
	{
		sizeLabel: 'XS-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420181866170',
	},
	{
		sizeLabel: 'XS-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128786283233',
	},
	{
		sizeLabel: 'S-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570252964791',
	},
	{
		sizeLabel: 'M-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872091835927',
	},
	{
		sizeLabel: 'M-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079418288991',
	},
	{
		sizeLabel: 'L-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271512338277',
	},
	{
		sizeLabel: 'L-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801593359423',
	},
	{
		sizeLabel: 'XL-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450987046293',
	},
	{
		sizeLabel: 'XL-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223898895989',
	},
	{
		sizeLabel: 'XXL-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837074230208',
	},
	{
		sizeLabel: 'XXL-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306098824333',
	},
	{
		sizeLabel: 'S-36 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193306607167',
	},
	{
		sizeLabel: 'S-38 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994911559519',
	},
	{
		sizeLabel: 'M-40 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109077101385',
	},
	{
		sizeLabel: 'M-42 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054704632368',
	},
	{
		sizeLabel: 'L-44 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765086393051',
	},
	{
		sizeLabel: 'L-46 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938410923448',
	},
	{
		sizeLabel: '3XXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147152818699',
	},
	{
		sizeLabel: '24-06',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456247696138',
	},
	{
		sizeLabel: '25-07',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414487888112',
	},
	{
		sizeLabel: '26-08',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '245655747029',
	},
	{
		sizeLabel: '27-09',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518545523524',
	},
	{
		sizeLabel: '28-10',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352290525589',
	},
	{
		sizeLabel: '29-11',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518236993622',
	},
	{
		sizeLabel: '30-12',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424585118050',
	},
	{
		sizeLabel: '31-13',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017718839475',
	},
	{
		sizeLabel: '32-14',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945682193858',
	},
	{
		sizeLabel: '34-16',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010137356107',
	},
	{
		sizeLabel: '36-18',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289502343252',
	},
	{
		sizeLabel: '4-5 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953403143367',
	},
	{
		sizeLabel: '9-10 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557558511083',
	},
	{
		sizeLabel: '11-12 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380872180913',
	},
	{
		sizeLabel: '12 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303078356670',
	},
	{
		sizeLabel: 'A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071417450520',
	},
	{
		sizeLabel: 'B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938430814964',
	},
	{
		sizeLabel: 'C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828545235015',
	},
	{
		sizeLabel: 'D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631292190819',
	},
	{
		sizeLabel: 'XSB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321269255162',
	},
	{
		sizeLabel: 'XSC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '006764877954',
	},
	{
		sizeLabel: 'XSD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511850385378',
	},
	{
		sizeLabel: 'XSE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075572649717',
	},
	{
		sizeLabel: 'SB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921931827296',
	},
	{
		sizeLabel: 'SC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592499616932',
	},
	{
		sizeLabel: 'SD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608297004319',
	},
	{
		sizeLabel: 'SE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327507953067',
	},
	{
		sizeLabel: 'SF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225900425448',
	},
	{
		sizeLabel: 'SG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696011831005',
	},
	{
		sizeLabel: 'MC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112796401921',
	},
	{
		sizeLabel: 'ME',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '949109236166',
	},
	{
		sizeLabel: 'MF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190806152853',
	},
	{
		sizeLabel: 'MG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129818914651',
	},
	{
		sizeLabel: 'LC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067382797802',
	},
	{
		sizeLabel: 'LD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425244481820',
	},
	{
		sizeLabel: 'LE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859619796739',
	},
	{
		sizeLabel: 'LF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971378784002',
	},
	{
		sizeLabel: 'XLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884270338718',
	},
	{
		sizeLabel: 'XLC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080584386012',
	},
	{
		sizeLabel: 'XLD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311812762860',
	},
	{
		sizeLabel: 'XLE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446055240534',
	},
	{
		sizeLabel: 'XLF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422579232559',
	},
	{
		sizeLabel: 'XLG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805319783345',
	},
	{
		sizeLabel: 'XXLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191615330177',
	},
	{
		sizeLabel: 'XXLC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420483910286',
	},
	{
		sizeLabel: 'XXLD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401995215000',
	},
	{
		sizeLabel: 'XXLE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529636904555',
	},
	{
		sizeLabel: '3XLC',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515669589157',
	},
	{
		sizeLabel: '3XLD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623216280722',
	},
	{
		sizeLabel: '3XLE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753738121860',
	},
	{
		sizeLabel: '200 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414689958153',
	},
	{
		sizeLabel: '205 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304605448179',
	},
	{
		sizeLabel: '33 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600997110546',
	},
	{
		sizeLabel: '41 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '761892759100',
	},
	{
		sizeLabel: '42 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459334151978',
	},
	{
		sizeLabel: '44 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521887928175',
	},
	{
		sizeLabel: '231 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341834125987',
	},
	{
		sizeLabel: '241 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518075950276',
	},
	{
		sizeLabel: '254 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324544887503',
	},
	{
		sizeLabel: '279 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975277798908',
	},
	{
		sizeLabel: '160-165 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267761490558',
	},
	{
		sizeLabel: '165-170 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385617487545',
	},
	{
		sizeLabel: '165-172 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835194737924',
	},
	{
		sizeLabel: '168-173 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841868923468',
	},
	{
		sizeLabel: '170-176 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '377707526486',
	},
	{
		sizeLabel: '190-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902186475054',
	},
	{
		sizeLabel: '167-172 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105972127114',
	},
	{
		sizeLabel: '1 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741314550857',
	},
	{
		sizeLabel: '2 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '786155044441',
	},
	{
		sizeLabel: '3 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069405036983',
	},
	{
		sizeLabel: '3 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757245390902',
	},
	{
		sizeLabel: '4 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832262911380',
	},
	{
		sizeLabel: '5 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113687770250',
	},
	{
		sizeLabel: '5 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254383479207',
	},
	{
		sizeLabel: '9,5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297686824543',
	},
	{
		sizeLabel: '6 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275060234891',
	},
	{
		sizeLabel: '7 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193581447667',
	},
	{
		sizeLabel: '10,5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252493866224',
	},
	{
		sizeLabel: '7 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209039925095',
	},
	{
		sizeLabel: '8 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159918800967',
	},
	{
		sizeLabel: '9 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510962459527',
	},
	{
		sizeLabel: '11,5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163972638693',
	},
	{
		sizeLabel: '9 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730187997599',
	},
	{
		sizeLabel: '10 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '719363586049',
	},
	{
		sizeLabel: '11 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530215142818',
	},
	{
		sizeLabel: '11 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233904803140',
	},
	{
		sizeLabel: 'M-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334935610244',
	},
	{
		sizeLabel: 'L-G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472262920775',
	},
	{
		sizeLabel: 'XL-TG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691668670806',
	},
	{
		sizeLabel: 'XXL-TTG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153516947314',
	},
	{
		sizeLabel: '45.6 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067155842354',
	},
	{
		sizeLabel: '48 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662228115114',
	},
	{
		sizeLabel: '40-42R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538986478907',
	},
	{
		sizeLabel: '44-46R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '955617858520',
	},
	{
		sizeLabel: '48-50R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673935201759',
	},
	{
		sizeLabel: '32-34R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810897472630',
	},
	{
		sizeLabel: '36-38R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885588422962',
	},
	{
		sizeLabel: '40-46R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206692614597',
	},
	{
		sizeLabel: '50-56 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899431802714',
	},
	{
		sizeLabel: '50-56 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781006822681',
	},
	{
		sizeLabel: '50-56 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275349356829',
	},
	{
		sizeLabel: '48-52R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518048060792',
	},
	{
		sizeLabel: '58-62 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884432796008',
	},
	{
		sizeLabel: '58-62 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450817343102',
	},
	{
		sizeLabel: '30-33 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660544990655',
	},
	{
		sizeLabel: 'M1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282777187449',
	},
	{
		sizeLabel: '44-46 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015486052911',
	},
	{
		sizeLabel: '13 ½-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701337915204',
	},
	{
		sizeLabel: '33-34 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529723314989',
	},
	{
		sizeLabel: '14 ½-15 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632085907129',
	},
	{
		sizeLabel: '14 ½-15 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510000730347',
	},
	{
		sizeLabel: '35-36 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640234669053',
	},
	{
		sizeLabel: '15 ½-15 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '076692092030',
	},
	{
		sizeLabel: '15 ½-15 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732682158048',
	},
	{
		sizeLabel: '37-38 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732538688832',
	},
	{
		sizeLabel: '16-16 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290294620486',
	},
	{
		sizeLabel: '16-16 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237386802621',
	},
	{
		sizeLabel: '39-40 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948062036517',
	},
	{
		sizeLabel: '17-17 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537518626928',
	},
	{
		sizeLabel: '17-17 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '539460391098',
	},
	{
		sizeLabel: '41-42 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041925350997',
	},
	{
		sizeLabel: '17 ¾-18 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837721879571',
	},
	{
		sizeLabel: '17 ¾-18 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295821330357',
	},
	{
		sizeLabel: '43-44 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038724127772',
	},
	{
		sizeLabel: '4Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409395390806',
	},
	{
		sizeLabel: '6Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048299870925',
	},
	{
		sizeLabel: '8Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803932507881',
	},
	{
		sizeLabel: '10Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '194613443163',
	},
	{
		sizeLabel: '12Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330581044260',
	},
	{
		sizeLabel: '14Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '002301544432',
	},
	{
		sizeLabel: '55-57',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457484441280',
	},
	{
		sizeLabel: '56-57',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657774137049',
	},
	{
		sizeLabel: '56-59',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656930328450',
	},
	{
		sizeLabel: '65BB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953617613264',
	},
	{
		sizeLabel: '70BB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608069218427',
	},
	{
		sizeLabel: '75BB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127568766850',
	},
	{
		sizeLabel: '80BB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203865132509',
	},
	{
		sizeLabel: '54-46 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007914067051',
	},
	{
		sizeLabel: '44-48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275057577920',
	},
	{
		sizeLabel: '80G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709363659211',
	},
	{
		sizeLabel: '80H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950435592287',
	},
	{
		sizeLabel: '85G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958329804666',
	},
	{
		sizeLabel: '85H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781885049760',
	},
	{
		sizeLabel: '90G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830104600681',
	},
	{
		sizeLabel: '90H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918888501177',
	},
	{
		sizeLabel: '95G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '131102326965',
	},
	{
		sizeLabel: '95H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921810706676',
	},
	{
		sizeLabel: '100G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544626424646',
	},
	{
		sizeLabel: '100H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959966264822',
	},
	{
		sizeLabel: '105G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621380694765',
	},
	{
		sizeLabel: '105H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151159256609',
	},
	{
		sizeLabel: '110G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511636136054',
	},
	{
		sizeLabel: '110H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121518579277',
	},
	{
		sizeLabel: '115A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743588032373',
	},
	{
		sizeLabel: '115B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908133951952',
	},
	{
		sizeLabel: '115C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334544569214',
	},
	{
		sizeLabel: '115D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372083459313',
	},
	{
		sizeLabel: '115E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247077009080',
	},
	{
		sizeLabel: '115F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '786620836388',
	},
	{
		sizeLabel: '115G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060810559062',
	},
	{
		sizeLabel: '115H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479250351658',
	},
	{
		sizeLabel: '120A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480474356764',
	},
	{
		sizeLabel: '120B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566432626610',
	},
	{
		sizeLabel: '120C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604734984910',
	},
	{
		sizeLabel: '120D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940349850908',
	},
	{
		sizeLabel: '120E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284412383110',
	},
	{
		sizeLabel: '120F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817248194316',
	},
	{
		sizeLabel: '120G (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '437891205205',
	},
	{
		sizeLabel: '120H (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259644176459',
	},
	{
		sizeLabel: '46(90) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555069428821',
	},
	{
		sizeLabel: '46(22) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891900342941',
	},
	{
		sizeLabel: '48(94) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149908624812',
	},
	{
		sizeLabel: '48(23) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985557698855',
	},
	{
		sizeLabel: '50(98) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860781429656',
	},
	{
		sizeLabel: '50(24) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709042907934',
	},
	{
		sizeLabel: '52(102) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284791351475',
	},
	{
		sizeLabel: '52(25) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825411324625',
	},
	{
		sizeLabel: '54(106) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876366748617',
	},
	{
		sizeLabel: '54(26) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757643709284',
	},
	{
		sizeLabel: '56(110) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699830083894',
	},
	{
		sizeLabel: '56(27) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576466674166',
	},
	{
		sizeLabel: '58(114) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910769374095',
	},
	{
		sizeLabel: '58(28) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983355006948',
	},
	{
		sizeLabel: '60(118) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209549651415',
	},
	{
		sizeLabel: '60(29) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944371607659',
	},
	{
		sizeLabel: '62(122) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371142857091',
	},
	{
		sizeLabel: '62(30) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791506518579',
	},
	{
		sizeLabel: '10 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360530422718',
	},
	{
		sizeLabel: '11 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671025298632',
	},
	{
		sizeLabel: '60M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '229195533250',
	},
	{
		sizeLabel: '60N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699995353139',
	},
	{
		sizeLabel: '65N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282672279604',
	},
	{
		sizeLabel: '80N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105083183859',
	},
	{
		sizeLabel: '85N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445756492945',
	},
	{
		sizeLabel: '90N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244300144658',
	},
	{
		sizeLabel: '95N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304543341876',
	},
	{
		sizeLabel: '100M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '338647478914',
	},
	{
		sizeLabel: '100N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267713844401',
	},
	{
		sizeLabel: '105M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908097035588',
	},
	{
		sizeLabel: '105N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372558280653',
	},
	{
		sizeLabel: '115M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981778879075',
	},
	{
		sizeLabel: '115N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282451025071',
	},
	{
		sizeLabel: '120M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653570132363',
	},
	{
		sizeLabel: '120N (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574662041619',
	},
	{
		sizeLabel: '36-38 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '326358491739',
	},
	{
		sizeLabel: 'S1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557866167943',
	},
	{
		sizeLabel: 'S2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236293696451',
	},
	{
		sizeLabel: 'S3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384061904443',
	},
	{
		sizeLabel: 'S4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360986117008',
	},
	{
		sizeLabel: 'S5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553525909083',
	},
	{
		sizeLabel: 'M2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309628489538',
	},
	{
		sizeLabel: 'M3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717061048475',
	},
	{
		sizeLabel: 'M4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246841250908',
	},
	{
		sizeLabel: 'M5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351480704588',
	},
	{
		sizeLabel: 'L1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951806733480',
	},
	{
		sizeLabel: 'L2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803962415060',
	},
	{
		sizeLabel: 'L3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540092846331',
	},
	{
		sizeLabel: 'L4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386865803800',
	},
	{
		sizeLabel: 'L5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911860033501',
	},
	{
		sizeLabel: 'XL1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526728926442',
	},
	{
		sizeLabel: 'XL2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291219695719',
	},
	{
		sizeLabel: 'XL3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830401737768',
	},
	{
		sizeLabel: 'XL4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963001126387',
	},
	{
		sizeLabel: 'XL5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580352584649',
	},
	{
		sizeLabel: 'XXL1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902894242771',
	},
	{
		sizeLabel: 'XXL2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925251723754',
	},
	{
		sizeLabel: 'XXL3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077401644912',
	},
	{
		sizeLabel: 'XXL4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '731397143937',
	},
	{
		sizeLabel: 'XXL5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963213609743',
	},
	{
		sizeLabel: 'XXXL1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329665267376',
	},
	{
		sizeLabel: 'XXXL2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284065664876',
	},
	{
		sizeLabel: 'XXXL3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447010543595',
	},
	{
		sizeLabel: 'XXXL4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953185194720',
	},
	{
		sizeLabel: 'XXXL5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138026005508',
	},
	{
		sizeLabel: '60A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115891855149',
	},
	{
		sizeLabel: '60B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799899994628',
	},
	{
		sizeLabel: '60C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818976397056',
	},
	{
		sizeLabel: '60D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259899364640',
	},
	{
		sizeLabel: '60DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173016921940',
	},
	{
		sizeLabel: '60DD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702910125889',
	},
	{
		sizeLabel: '75DD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528639461176',
	},
	{
		sizeLabel: '60E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '860158130102',
	},
	{
		sizeLabel: '60F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872840992468',
	},
	{
		sizeLabel: '60FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403132827602',
	},
	{
		sizeLabel: '60FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738813821265',
	},
	{
		sizeLabel: '75FF (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215861136725',
	},
	{
		sizeLabel: '0FF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257447914959',
	},
	{
		sizeLabel: '60G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225789363899',
	},
	{
		sizeLabel: '60GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320783453690',
	},
	{
		sizeLabel: '60GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798950351455',
	},
	{
		sizeLabel: '75GG (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678778091400',
	},
	{
		sizeLabel: '60H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894995839662',
	},
	{
		sizeLabel: '60HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652395867605',
	},
	{
		sizeLabel: '60HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '492724216795',
	},
	{
		sizeLabel: '75HH (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103173148964',
	},
	{
		sizeLabel: '60I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390649582096',
	},
	{
		sizeLabel: '75I (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '905434804029',
	},
	{
		sizeLabel: '0I (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852084055606',
	},
	{
		sizeLabel: '60J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087821360918',
	},
	{
		sizeLabel: '75J (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '973067224473',
	},
	{
		sizeLabel: '60JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270321643371',
	},
	{
		sizeLabel: '60JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459804529010',
	},
	{
		sizeLabel: '75JJ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011960093557',
	},
	{
		sizeLabel: '0JJ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128313386926',
	},
	{
		sizeLabel: '60K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524424366076',
	},
	{
		sizeLabel: '75K (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650137575780',
	},
	{
		sizeLabel: '0K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837730649757',
	},
	{
		sizeLabel: '60KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948084853947',
	},
	{
		sizeLabel: '60KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303474476576',
	},
	{
		sizeLabel: '75KK (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049383901178',
	},
	{
		sizeLabel: '0KK (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711882321149',
	},
	{
		sizeLabel: '60L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876243191420',
	},
	{
		sizeLabel: '75L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851996705441',
	},
	{
		sizeLabel: '0L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965377307964',
	},
	{
		sizeLabel: '60M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392824664421',
	},
	{
		sizeLabel: '75M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050305455818',
	},
	{
		sizeLabel: '0M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072502439685',
	},
	{
		sizeLabel: '60N',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607912295980',
	},
	{
		sizeLabel: '75N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121806672108',
	},
	{
		sizeLabel: '0N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038718534785',
	},
	{
		sizeLabel: '60O',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741522200769',
	},
	{
		sizeLabel: '60O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123467530020',
	},
	{
		sizeLabel: '75O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223865433698',
	},
	{
		sizeLabel: '0O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367237071660',
	},
	{
		sizeLabel: '60P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353698773225',
	},
	{
		sizeLabel: '60P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181321416460',
	},
	{
		sizeLabel: '75P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320777500457',
	},
	{
		sizeLabel: '0P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483054654305',
	},
	{
		sizeLabel: '60R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061819185556',
	},
	{
		sizeLabel: '75R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372368706116',
	},
	{
		sizeLabel: '0R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630986951060',
	},
	{
		sizeLabel: '60S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443012838423',
	},
	{
		sizeLabel: '75S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '178301414807',
	},
	{
		sizeLabel: '0S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413682957177',
	},
	{
		sizeLabel: '60T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760520679038',
	},
	{
		sizeLabel: '60T (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668904724982',
	},
	{
		sizeLabel: '75T (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673745476478',
	},
	{
		sizeLabel: '0T (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804965711489',
	},
	{
		sizeLabel: '65DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544040505905',
	},
	{
		sizeLabel: '65FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127070139851',
	},
	{
		sizeLabel: '1FF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525940786494',
	},
	{
		sizeLabel: '65GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625977524583',
	},
	{
		sizeLabel: '65HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620820645744',
	},
	{
		sizeLabel: '80L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649925957133',
	},
	{
		sizeLabel: '65I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563231638342',
	},
	{
		sizeLabel: '80M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865091932261',
	},
	{
		sizeLabel: '65J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932940573827',
	},
	{
		sizeLabel: '80N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809769475791',
	},
	{
		sizeLabel: '65JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095427323909',
	},
	{
		sizeLabel: '65JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845009758151',
	},
	{
		sizeLabel: '80O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '419745084555',
	},
	{
		sizeLabel: '1JJ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570472549542',
	},
	{
		sizeLabel: '65K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127928005012',
	},
	{
		sizeLabel: '80P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634900343435',
	},
	{
		sizeLabel: '1K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703757360407',
	},
	{
		sizeLabel: '65KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471766153476',
	},
	{
		sizeLabel: '65KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650696654558',
	},
	{
		sizeLabel: '80R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618600061824',
	},
	{
		sizeLabel: '1KK (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152916447126',
	},
	{
		sizeLabel: '65L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000991874545',
	},
	{
		sizeLabel: '80S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448893585854',
	},
	{
		sizeLabel: '1L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734154657819',
	},
	{
		sizeLabel: '65M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '772439359348',
	},
	{
		sizeLabel: '80T (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683097711784',
	},
	{
		sizeLabel: '1M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855272241592',
	},
	{
		sizeLabel: '65N',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397034499907',
	},
	{
		sizeLabel: '80U (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517862354490',
	},
	{
		sizeLabel: '1N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757067061616',
	},
	{
		sizeLabel: '65O',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109573582174',
	},
	{
		sizeLabel: '65O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '260760253696',
	},
	{
		sizeLabel: 'W80 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '245937286090',
	},
	{
		sizeLabel: '1O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513256697024',
	},
	{
		sizeLabel: '65P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181924175156',
	},
	{
		sizeLabel: '65P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487299556002',
	},
	{
		sizeLabel: '1P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060533714648',
	},
	{
		sizeLabel: '65R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874876508977',
	},
	{
		sizeLabel: '65R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407967286679',
	},
	{
		sizeLabel: '1R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418205675139',
	},
	{
		sizeLabel: '65S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782928446318',
	},
	{
		sizeLabel: '65S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812124810714',
	},
	{
		sizeLabel: '1S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375467573803',
	},
	{
		sizeLabel: '70DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628654872605',
	},
	{
		sizeLabel: '70FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019282219521',
	},
	{
		sizeLabel: '2FF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602979590826',
	},
	{
		sizeLabel: '70GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089330560793',
	},
	{
		sizeLabel: '70HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '114960864387',
	},
	{
		sizeLabel: '85L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666640583607',
	},
	{
		sizeLabel: '70I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '437389827710',
	},
	{
		sizeLabel: '85M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376055886158',
	},
	{
		sizeLabel: '70J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952494353118',
	},
	{
		sizeLabel: '85N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959127067087',
	},
	{
		sizeLabel: '70JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744163091731',
	},
	{
		sizeLabel: '70JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079605806927',
	},
	{
		sizeLabel: '85O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732164600430',
	},
	{
		sizeLabel: '2JJ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459885842768',
	},
	{
		sizeLabel: '70K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '002379396304',
	},
	{
		sizeLabel: '85P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089301162284',
	},
	{
		sizeLabel: '2K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979969147995',
	},
	{
		sizeLabel: '70KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175218225882',
	},
	{
		sizeLabel: '70KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043054500038',
	},
	{
		sizeLabel: '85R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386411353639',
	},
	{
		sizeLabel: '2KK (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172436382667',
	},
	{
		sizeLabel: '70L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764386168730',
	},
	{
		sizeLabel: '85S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522927362447',
	},
	{
		sizeLabel: '2L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299680851474',
	},
	{
		sizeLabel: '70M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273289288712',
	},
	{
		sizeLabel: '85T (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828882968430',
	},
	{
		sizeLabel: '2M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540329695023',
	},
	{
		sizeLabel: '70N',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046728769690',
	},
	{
		sizeLabel: '85U (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371304127051',
	},
	{
		sizeLabel: '2N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228058498734',
	},
	{
		sizeLabel: '70O',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893995694526',
	},
	{
		sizeLabel: '2O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965584652193',
	},
	{
		sizeLabel: '70P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659711871912',
	},
	{
		sizeLabel: '70P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674440610426',
	},
	{
		sizeLabel: '2P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633435671141',
	},
	{
		sizeLabel: '70R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861602869780',
	},
	{
		sizeLabel: '70R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183579109233',
	},
	{
		sizeLabel: '2R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724914759764',
	},
	{
		sizeLabel: '75DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617145540096',
	},
	{
		sizeLabel: '75FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '939320372344',
	},
	{
		sizeLabel: '3FF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640586835119',
	},
	{
		sizeLabel: '75GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '107372779448',
	},
	{
		sizeLabel: '75HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553396860701',
	},
	{
		sizeLabel: '75I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717832030905',
	},
	{
		sizeLabel: '90M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758057248379',
	},
	{
		sizeLabel: '75J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205896328955',
	},
	{
		sizeLabel: '90N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005181077366',
	},
	{
		sizeLabel: '75JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424332448516',
	},
	{
		sizeLabel: '75JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189508220670',
	},
	{
		sizeLabel: '90O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357493634225',
	},
	{
		sizeLabel: '3JJ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123554320268',
	},
	{
		sizeLabel: '75K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075150076742',
	},
	{
		sizeLabel: '90P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742009709614',
	},
	{
		sizeLabel: '3K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '966756072358',
	},
	{
		sizeLabel: '75KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516985624872',
	},
	{
		sizeLabel: '75KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996522792870',
	},
	{
		sizeLabel: '90R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806646999681',
	},
	{
		sizeLabel: '3KK (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '735400815175',
	},
	{
		sizeLabel: '75L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '735826776058',
	},
	{
		sizeLabel: '90S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105419352166',
	},
	{
		sizeLabel: '3L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909560391882',
	},
	{
		sizeLabel: '75M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919792594538',
	},
	{
		sizeLabel: '90T (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514660884724',
	},
	{
		sizeLabel: '3M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750646221620',
	},
	{
		sizeLabel: '75N',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298888929996',
	},
	{
		sizeLabel: '3N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468270753946',
	},
	{
		sizeLabel: '75O',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246557866947',
	},
	{
		sizeLabel: '75O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617189231149',
	},
	{
		sizeLabel: '3O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928617849972',
	},
	{
		sizeLabel: '75P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685623917401',
	},
	{
		sizeLabel: '75P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '577462572462',
	},
	{
		sizeLabel: '- (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464468797464',
	},
	{
		sizeLabel: '80DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683043724229',
	},
	{
		sizeLabel: '80FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101149850453',
	},
	{
		sizeLabel: '80GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574465689898',
	},
	{
		sizeLabel: '4K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799833647297',
	},
	{
		sizeLabel: '80HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186625845987',
	},
	{
		sizeLabel: '95L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915297420414',
	},
	{
		sizeLabel: '4L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596775797469',
	},
	{
		sizeLabel: '80I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691861612348',
	},
	{
		sizeLabel: '95M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '888468125523',
	},
	{
		sizeLabel: '4M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584767368659',
	},
	{
		sizeLabel: '80J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378142852905',
	},
	{
		sizeLabel: '95N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881277309140',
	},
	{
		sizeLabel: '4N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '377235784772',
	},
	{
		sizeLabel: '80JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312719961552',
	},
	{
		sizeLabel: '80O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '125128409959',
	},
	{
		sizeLabel: '95O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833647201445',
	},
	{
		sizeLabel: '4O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519212838445',
	},
	{
		sizeLabel: '80K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727916600935',
	},
	{
		sizeLabel: '80P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081066942005',
	},
	{
		sizeLabel: '95P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732725567573',
	},
	{
		sizeLabel: '4P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '269029229510',
	},
	{
		sizeLabel: '80KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151354747127',
	},
	{
		sizeLabel: '80R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767436696350',
	},
	{
		sizeLabel: '95R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656094541948',
	},
	{
		sizeLabel: '4R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538896936775',
	},
	{
		sizeLabel: '80L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644501145339',
	},
	{
		sizeLabel: '80S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240566112673',
	},
	{
		sizeLabel: '95S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576985693192',
	},
	{
		sizeLabel: '4S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252064645818',
	},
	{
		sizeLabel: '80M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357271017404',
	},
	{
		sizeLabel: '80N',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080926860430',
	},
	{
		sizeLabel: '80O',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556501806556',
	},
	{
		sizeLabel: '85DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930858402876',
	},
	{
		sizeLabel: '85FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216216697619',
	},
	{
		sizeLabel: '85GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408699243601',
	},
	{
		sizeLabel: '5K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696354794859',
	},
	{
		sizeLabel: '85HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929905703680',
	},
	{
		sizeLabel: '100L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919750808078',
	},
	{
		sizeLabel: '5L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661157416436',
	},
	{
		sizeLabel: '85I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137711883777',
	},
	{
		sizeLabel: '100M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413573211829',
	},
	{
		sizeLabel: '5M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530742887467',
	},
	{
		sizeLabel: '85J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882069281115',
	},
	{
		sizeLabel: '100N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614064173689',
	},
	{
		sizeLabel: '5N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935339120442',
	},
	{
		sizeLabel: '85JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318959279307',
	},
	{
		sizeLabel: '85O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '989544704429',
	},
	{
		sizeLabel: '100O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069340146956',
	},
	{
		sizeLabel: '5O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526848171788',
	},
	{
		sizeLabel: '85K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '180943742768',
	},
	{
		sizeLabel: '85P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174309018327',
	},
	{
		sizeLabel: '100P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694480554029',
	},
	{
		sizeLabel: '5P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294150325750',
	},
	{
		sizeLabel: '85KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246906157248',
	},
	{
		sizeLabel: '85R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929922287148',
	},
	{
		sizeLabel: '100R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '695007039529',
	},
	{
		sizeLabel: '5R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099579967445',
	},
	{
		sizeLabel: '85L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446870266558',
	},
	{
		sizeLabel: '85M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151465211409',
	},
	{
		sizeLabel: '85N',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770161294702',
	},
	{
		sizeLabel: '90DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494254213220',
	},
	{
		sizeLabel: '90FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277503478835',
	},
	{
		sizeLabel: '90GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119194242959',
	},
	{
		sizeLabel: '6K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625117461056',
	},
	{
		sizeLabel: '90HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017405060159',
	},
	{
		sizeLabel: '105L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812917838794',
	},
	{
		sizeLabel: '6L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883969832539',
	},
	{
		sizeLabel: '90I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182961246756',
	},
	{
		sizeLabel: '105M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675523247312',
	},
	{
		sizeLabel: '6M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '892419498956',
	},
	{
		sizeLabel: '90J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930576241245',
	},
	{
		sizeLabel: '105N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307229604919',
	},
	{
		sizeLabel: '6N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858576555623',
	},
	{
		sizeLabel: '90JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044249598963',
	},
	{
		sizeLabel: '90JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981943063389',
	},
	{
		sizeLabel: '105O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146859453683',
	},
	{
		sizeLabel: '6O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617374310943',
	},
	{
		sizeLabel: '90K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '949106134508',
	},
	{
		sizeLabel: '105P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788960164409',
	},
	{
		sizeLabel: '6P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163109675159',
	},
	{
		sizeLabel: '90KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740696816962',
	},
	{
		sizeLabel: '90KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '077886522169',
	},
	{
		sizeLabel: '90L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625243107754',
	},
	{
		sizeLabel: '90M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506925482518',
	},
	{
		sizeLabel: '95DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607432314891',
	},
	{
		sizeLabel: '95FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '338531579903',
	},
	{
		sizeLabel: '95GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951046161148',
	},
	{
		sizeLabel: '7K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449990616087',
	},
	{
		sizeLabel: '95HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546278911847',
	},
	{
		sizeLabel: '110L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750635796627',
	},
	{
		sizeLabel: '7L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078485653289',
	},
	{
		sizeLabel: '95I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851361974809',
	},
	{
		sizeLabel: '110M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733507163382',
	},
	{
		sizeLabel: '7M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090372585503',
	},
	{
		sizeLabel: '95J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140946825434',
	},
	{
		sizeLabel: '110N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '076456092396',
	},
	{
		sizeLabel: '7N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644762346161',
	},
	{
		sizeLabel: '95JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299822390920',
	},
	{
		sizeLabel: '95JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230005293098',
	},
	{
		sizeLabel: '110O (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650676545840',
	},
	{
		sizeLabel: '7O (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090309014382',
	},
	{
		sizeLabel: '95K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702307102357',
	},
	{
		sizeLabel: '95KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '433702296404',
	},
	{
		sizeLabel: '95KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448078572917',
	},
	{
		sizeLabel: '95L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696114509306',
	},
	{
		sizeLabel: '100DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '768107570162',
	},
	{
		sizeLabel: '100FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962653844582',
	},
	{
		sizeLabel: '100FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612493430617',
	},
	{
		sizeLabel: '100GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395696951996',
	},
	{
		sizeLabel: '8K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '458085535624',
	},
	{
		sizeLabel: '100HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230286709664',
	},
	{
		sizeLabel: '115L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '355482835630',
	},
	{
		sizeLabel: '8L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '207922505776',
	},
	{
		sizeLabel: '100I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545237338002',
	},
	{
		sizeLabel: '115M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660496702771',
	},
	{
		sizeLabel: '8M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696645335740',
	},
	{
		sizeLabel: '100J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054278820708',
	},
	{
		sizeLabel: '115N (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394414528434',
	},
	{
		sizeLabel: '8N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974675162784',
	},
	{
		sizeLabel: '100JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '454114836548',
	},
	{
		sizeLabel: '100JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836017470252',
	},
	{
		sizeLabel: '100K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909982659068',
	},
	{
		sizeLabel: '100KK',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384744627719',
	},
	{
		sizeLabel: '100KK (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '344073928739',
	},
	{
		sizeLabel: '105DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673269459234',
	},
	{
		sizeLabel: '105FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846163398541',
	},
	{
		sizeLabel: '105FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727981764535',
	},
	{
		sizeLabel: '105GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579956761010',
	},
	{
		sizeLabel: '105GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '332143165534',
	},
	{
		sizeLabel: '9K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160504556771',
	},
	{
		sizeLabel: '105HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341479446696',
	},
	{
		sizeLabel: '105HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660960460177',
	},
	{
		sizeLabel: '120L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251578570207',
	},
	{
		sizeLabel: '9L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653624438623',
	},
	{
		sizeLabel: '105I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623193383690',
	},
	{
		sizeLabel: '120M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868182706509',
	},
	{
		sizeLabel: '9M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036329337149',
	},
	{
		sizeLabel: '105J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734807759293',
	},
	{
		sizeLabel: '105JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '245440650914',
	},
	{
		sizeLabel: '105JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712664504757',
	},
	{
		sizeLabel: '105K',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998265385055',
	},
	{
		sizeLabel: '110DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '509979994737',
	},
	{
		sizeLabel: '110FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689865743794',
	},
	{
		sizeLabel: '110FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179237156022',
	},
	{
		sizeLabel: '110GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067965098485',
	},
	{
		sizeLabel: '110GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661379078716',
	},
	{
		sizeLabel: '10K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978016560941',
	},
	{
		sizeLabel: '110HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089309906381',
	},
	{
		sizeLabel: '110HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416644877986',
	},
	{
		sizeLabel: '125L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636289250306',
	},
	{
		sizeLabel: '10L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402033112042',
	},
	{
		sizeLabel: '110I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353434630492',
	},
	{
		sizeLabel: '110J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420396796374',
	},
	{
		sizeLabel: '110JJ',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039206988354',
	},
	{
		sizeLabel: '110JJ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919430171945',
	},
	{
		sizeLabel: '115DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222706409439',
	},
	{
		sizeLabel: '115FF',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728710261457',
	},
	{
		sizeLabel: '115FF (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '691281008316',
	},
	{
		sizeLabel: '115GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135475612506',
	},
	{
		sizeLabel: '115GG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562520666468',
	},
	{
		sizeLabel: '11K (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038295516364',
	},
	{
		sizeLabel: '115HH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222801390533',
	},
	{
		sizeLabel: '115HH (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381148442247',
	},
	{
		sizeLabel: '115I',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715114634054',
	},
	{
		sizeLabel: '115J',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213128278951',
	},
	{
		sizeLabel: 'D CUP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008608591748',
	},
	{
		sizeLabel: 'DD CUP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525205450660',
	},
	{
		sizeLabel: '36 ½-37 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802017534604',
	},
	{
		sizeLabel: '39-39 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902513089347',
	},
	{
		sizeLabel: '41 ½-42 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '221083213690',
	},
	{
		sizeLabel: '41-41 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622087050641',
	},
	{
		sizeLabel: '43-43 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560556426917',
	},
	{
		sizeLabel: '45 ½-46 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153808269296',
	},
	{
		sizeLabel: '64-66 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '692457225555',
	},
	{
		sizeLabel: '68 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773558093023',
	},
	{
		sizeLabel: '39-40 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826587863309',
	},
	{
		sizeLabel: '42-43 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598371136825',
	},
	{
		sizeLabel: '35-36 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609304333525',
	},
	{
		sizeLabel: '3XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067875401028',
	},
	{
		sizeLabel: '4XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568368782842',
	},
	{
		sizeLabel: '49-50 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144200712361',
	},
	{
		sizeLabel: '4XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402578445850',
	},
	{
		sizeLabel: '5XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822500361521',
	},
	{
		sizeLabel: '51-52 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189346517382',
	},
	{
		sizeLabel: '5XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534427244249',
	},
	{
		sizeLabel: '6XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312710810897',
	},
	{
		sizeLabel: '53-54 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507167278043',
	},
	{
		sizeLabel: '6XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783220269141',
	},
	{
		sizeLabel: '7XL (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562737827014',
	},
	{
		sizeLabel: '55-56 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '593784690577',
	},
	{
		sizeLabel: '7XL (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052818535629',
	},
	{
		sizeLabel: 'W25-27W (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542316981164',
	},
	{
		sizeLabel: 'W29 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130095928677',
	},
	{
		sizeLabel: 'W31 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '293924842297',
	},
	{
		sizeLabel: 'W32 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803198759745',
	},
	{
		sizeLabel: 'W34 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090081744318',
	},
	{
		sizeLabel: 'W35 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489446928002',
	},
	{
		sizeLabel: 'W37 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '338086358903',
	},
	{
		sizeLabel: '39 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918295470762',
	},
	{
		sizeLabel: 'W38 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052686149539',
	},
	{
		sizeLabel: 'W40 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972802590946',
	},
	{
		sizeLabel: 'W42 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988349134139',
	},
	{
		sizeLabel: 'W43 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767245833936',
	},
	{
		sizeLabel: 'W45 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029318432316',
	},
	{
		sizeLabel: 'W46 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428239876040',
	},
	{
		sizeLabel: 'W48 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694758521848',
	},
	{
		sizeLabel: 'XS-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '465176821634',
	},
	{
		sizeLabel: 'S-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021046514585',
	},
	{
		sizeLabel: 'M-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120971157206',
	},
	{
		sizeLabel: 'L-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656353876025',
	},
	{
		sizeLabel: 'XL-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992026807869',
	},
	{
		sizeLabel: '2XL-D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240095117136',
	},
	{
		sizeLabel: '40DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521347265545',
	},
	{
		sizeLabel: '42DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282928336100',
	},
	{
		sizeLabel: '1XG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173753133543',
	},
	{
		sizeLabel: '2XG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787560295669',
	},
	{
		sizeLabel: '36-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235593400184',
	},
	{
		sizeLabel: '4-6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251483135418',
	},
	{
		sizeLabel: '41-46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819862749903',
	},
	{
		sizeLabel: '7 ½-11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '118154197350',
	},
	{
		sizeLabel: '2-5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067872620992',
	},
	{
		sizeLabel: '3 ½-6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '647281432603',
	},
	{
		sizeLabel: 'W18 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226370104689',
	},
	{
		sizeLabel: 'W20 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979749847450',
	},
	{
		sizeLabel: 'W22 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009515453507',
	},
	{
		sizeLabel: 'W24 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985663371185',
	},
	{
		sizeLabel: 'W26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563999346231',
	},
	{
		sizeLabel: 'W16 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097423419463',
	},
	{
		sizeLabel: '10-1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309990701251',
	},
	{
		sizeLabel: '8-10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167059923228',
	},
	{
		sizeLabel: '11-13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356018983530',
	},
	{
		sizeLabel: '62-64 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740218154866',
	},
	{
		sizeLabel: '58-60 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977399003898',
	},
	{
		sizeLabel: '66-68 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917641960337',
	},
	{
		sizeLabel: '62-64 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841627784226',
	},
	{
		sizeLabel: '33-35 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233780079141',
	},
	{
		sizeLabel: '39-41 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485177374319',
	},
	{
		sizeLabel: '45-47 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246318655214',
	},
	{
		sizeLabel: '60-62 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '166067762486',
	},
	{
		sizeLabel: '51-53 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970208527168',
	},
	{
		sizeLabel: '68-70 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087579762781',
	},
	{
		sizeLabel: '64-66 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503354029878',
	},
	{
		sizeLabel: '72-74 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682917281487',
	},
	{
		sizeLabel: '68-70 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '377830102112',
	},
	{
		sizeLabel: '57-59 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576315231599',
	},
	{
		sizeLabel: '66-68 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '743607133133',
	},
	{
		sizeLabel: '76-80 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851071059998',
	},
	{
		sizeLabel: '72-74 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238170856609',
	},
	{
		sizeLabel: '26(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227889290054',
	},
	{
		sizeLabel: '26(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618569215861',
	},
	{
		sizeLabel: '26(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978820235068',
	},
	{
		sizeLabel: '27(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236380621537',
	},
	{
		sizeLabel: '27(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794319639396',
	},
	{
		sizeLabel: '27(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215095614408',
	},
	{
		sizeLabel: '28(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490523613686',
	},
	{
		sizeLabel: '28(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '005643741144',
	},
	{
		sizeLabel: '28(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842394679180',
	},
	{
		sizeLabel: '29(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230810903434',
	},
	{
		sizeLabel: '29(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022186399323',
	},
	{
		sizeLabel: '29(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778705994948',
	},
	{
		sizeLabel: '30(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500758069378',
	},
	{
		sizeLabel: '30(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '954211905212',
	},
	{
		sizeLabel: '30(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707365059814',
	},
	{
		sizeLabel: '31(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279110704246',
	},
	{
		sizeLabel: '31(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168509358472',
	},
	{
		sizeLabel: '31(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438925579210',
	},
	{
		sizeLabel: '32(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965603770676',
	},
	{
		sizeLabel: '32(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '920265446209',
	},
	{
		sizeLabel: '32(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885444266129',
	},
	{
		sizeLabel: '33(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952072373292',
	},
	{
		sizeLabel: '33(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392029061819',
	},
	{
		sizeLabel: '34(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967157411456',
	},
	{
		sizeLabel: '34(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012010354445',
	},
	{
		sizeLabel: '36(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599826297670',
	},
	{
		sizeLabel: '36(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283420864917',
	},
	{
		sizeLabel: '38(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607672964506',
	},
	{
		sizeLabel: '38(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067578162886',
	},
	{
		sizeLabel: '40(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '495656263110',
	},
	{
		sizeLabel: '40(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561079579572',
	},
	{
		sizeLabel: '24(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361197067563',
	},
	{
		sizeLabel: '24(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523981365509',
	},
	{
		sizeLabel: '24(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701605439310',
	},
	{
		sizeLabel: '25(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337874923980',
	},
	{
		sizeLabel: '25(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641064754582',
	},
	{
		sizeLabel: '25(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364934013167',
	},
	{
		sizeLabel: '24(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167060719245',
	},
	{
		sizeLabel: '25(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720459878956',
	},
	{
		sizeLabel: '26(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958876144813',
	},
	{
		sizeLabel: '27(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958291178761',
	},
	{
		sizeLabel: '28(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983128516484',
	},
	{
		sizeLabel: '29(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614381777173',
	},
	{
		sizeLabel: '30(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074915533558',
	},
	{
		sizeLabel: '31(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149997303845',
	},
	{
		sizeLabel: '32(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072357098585',
	},
	{
		sizeLabel: '28(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251816851663',
	},
	{
		sizeLabel: '29(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189616668978',
	},
	{
		sizeLabel: '30(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681958997028',
	},
	{
		sizeLabel: '31(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442330405269',
	},
	{
		sizeLabel: '32(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688946889043',
	},
	{
		sizeLabel: '33(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176876211601',
	},
	{
		sizeLabel: '33(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334544082663',
	},
	{
		sizeLabel: '34(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827681543384',
	},
	{
		sizeLabel: '34(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653103140021',
	},
	{
		sizeLabel: '36(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780499725244',
	},
	{
		sizeLabel: '36(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546766242580',
	},
	{
		sizeLabel: '38(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876835864792',
	},
	{
		sizeLabel: '38(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757877289530',
	},
	{
		sizeLabel: '40(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264695216102',
	},
	{
		sizeLabel: '40(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619939937637',
	},
	{
		sizeLabel: '42(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327876587000',
	},
	{
		sizeLabel: '42(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240640665159',
	},
	{
		sizeLabel: '42(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333237112252',
	},
	{
		sizeLabel: '44(30)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311836926124',
	},
	{
		sizeLabel: '44(32)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156968695950',
	},
	{
		sizeLabel: '44(34)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707920702048',
	},
	{
		sizeLabel: '24(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065157659326',
	},
	{
		sizeLabel: '25(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392697039214',
	},
	{
		sizeLabel: '26(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813580540637',
	},
	{
		sizeLabel: '27(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733701724845',
	},
	{
		sizeLabel: '42(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810165396187',
	},
	{
		sizeLabel: '44(36)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760069729539',
	},
	{
		sizeLabel: '33(28)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '892688914741',
	},
	{
		sizeLabel: '2-8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713796030550',
	},
	{
		sizeLabel: '8-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948048520396',
	},
	{
		sizeLabel: '16-20 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371852226221',
	},
	{
		sizeLabel: '22-26 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537237280853',
	},
	{
		sizeLabel: '46-47',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233388919590',
	},
	{
		sizeLabel: 'L (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364131400145',
	},
	{
		sizeLabel: 'M (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894421214928',
	},
	{
		sizeLabel: 'S (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512938442237',
	},
	{
		sizeLabel: 'XL (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082401098762',
	},
	{
		sizeLabel: 'XXXL (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '497037742557',
	},
	{
		sizeLabel: 'XS (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678096119689',
	},
	{
		sizeLabel: 'XXL (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711562662346',
	},
	{
		sizeLabel: '3 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '040408109109',
	},
	{
		sizeLabel: '4 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078783090914',
	},
	{
		sizeLabel: '5 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837525226953',
	},
	{
		sizeLabel: '6 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752844116697',
	},
	{
		sizeLabel: '7 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831073336396',
	},
	{
		sizeLabel: '34R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766581249497',
	},
	{
		sizeLabel: '36R-38R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035370787276',
	},
	{
		sizeLabel: '36R-38R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380838362293',
	},
	{
		sizeLabel: '40R-42R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636940462668',
	},
	{
		sizeLabel: '40R-42R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120677339306',
	},
	{
		sizeLabel: '44R-46R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584404876897',
	},
	{
		sizeLabel: '44R-46R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219374304743',
	},
	{
		sizeLabel: '48R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666489103983',
	},
	{
		sizeLabel: '36R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549373942157',
	},
	{
		sizeLabel: '38R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704618467677',
	},
	{
		sizeLabel: '40R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013128729972',
	},
	{
		sizeLabel: '42R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013458539460',
	},
	{
		sizeLabel: '44R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730980946946',
	},
	{
		sizeLabel: '33 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774362344244',
	},
	{
		sizeLabel: '33 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629784576681',
	},
	{
		sizeLabel: '34 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979702158526',
	},
	{
		sizeLabel: '35 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264583443306',
	},
	{
		sizeLabel: '37 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '326201132850',
	},
	{
		sizeLabel: '38 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127973376814',
	},
	{
		sizeLabel: '39 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908197184342',
	},
	{
		sizeLabel: '40 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201137784175',
	},
	{
		sizeLabel: '41 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '731539865557',
	},
	{
		sizeLabel: '42 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481744435800',
	},
	{
		sizeLabel: '44 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887701368742',
	},
	{
		sizeLabel: '45 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '195949736354',
	},
	{
		sizeLabel: '47 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968375021626',
	},
	{
		sizeLabel: '49 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '725603723143',
	},
	{
		sizeLabel: '49 ⅔ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301884525790',
	},
	{
		sizeLabel: '50 ⅓ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885904361364',
	},
	{
		sizeLabel: '30B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463619493338',
	},
	{
		sizeLabel: '30C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746720375993',
	},
	{
		sizeLabel: '30D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882496735416',
	},
	{
		sizeLabel: 'IE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950545410462',
	},
	{
		sizeLabel: '30E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206864859664',
	},
	{
		sizeLabel: 'IF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841748443845',
	},
	{
		sizeLabel: '30F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494637140129',
	},
	{
		sizeLabel: 'IG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760877633337',
	},
	{
		sizeLabel: '30G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660988600325',
	},
	{
		sizeLabel: 'IH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405811687912',
	},
	{
		sizeLabel: '30H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251725245803',
	},
	{
		sizeLabel: '32B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021319319004',
	},
	{
		sizeLabel: '32C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483988788735',
	},
	{
		sizeLabel: '32D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964161797608',
	},
	{
		sizeLabel: 'IIE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601837799198',
	},
	{
		sizeLabel: '32E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901891517143',
	},
	{
		sizeLabel: 'IIF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170745431749',
	},
	{
		sizeLabel: '32F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957173561060',
	},
	{
		sizeLabel: 'IIG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058967081879',
	},
	{
		sizeLabel: '32G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904709396796',
	},
	{
		sizeLabel: 'IIH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341106020588',
	},
	{
		sizeLabel: '32H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376746149891',
	},
	{
		sizeLabel: '34B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682444458601',
	},
	{
		sizeLabel: '34C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810960533596',
	},
	{
		sizeLabel: '34D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754454140286',
	},
	{
		sizeLabel: 'IIIE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049182723600',
	},
	{
		sizeLabel: '34E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630689141063',
	},
	{
		sizeLabel: 'IIIF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468863727922',
	},
	{
		sizeLabel: '34F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086025652927',
	},
	{
		sizeLabel: 'IIIG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066029463779',
	},
	{
		sizeLabel: '34G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677883634892',
	},
	{
		sizeLabel: 'IIIH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094839886580',
	},
	{
		sizeLabel: '34H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937508067766',
	},
	{
		sizeLabel: '36B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '603750675445',
	},
	{
		sizeLabel: '36C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916555916904',
	},
	{
		sizeLabel: '36D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254438535928',
	},
	{
		sizeLabel: 'IVE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '427743775507',
	},
	{
		sizeLabel: '36E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476301320738',
	},
	{
		sizeLabel: 'IVF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087922917845',
	},
	{
		sizeLabel: '36F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019452982475',
	},
	{
		sizeLabel: 'IVG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544483372023',
	},
	{
		sizeLabel: '36G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022931020244',
	},
	{
		sizeLabel: 'IVH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525993442619',
	},
	{
		sizeLabel: '36H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581201734827',
	},
	{
		sizeLabel: '38B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439205069461',
	},
	{
		sizeLabel: '38C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140404186255',
	},
	{
		sizeLabel: '38D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518079242206',
	},
	{
		sizeLabel: 'VE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520046605950',
	},
	{
		sizeLabel: '38E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363085968104',
	},
	{
		sizeLabel: 'VF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998940307018',
	},
	{
		sizeLabel: '38F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401686357146',
	},
	{
		sizeLabel: 'VG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777646270577',
	},
	{
		sizeLabel: '38G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561010206854',
	},
	{
		sizeLabel: 'VH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008208547305',
	},
	{
		sizeLabel: '38H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225598661157',
	},
	{
		sizeLabel: 'VIB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105970740140',
	},
	{
		sizeLabel: '40B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164711417258',
	},
	{
		sizeLabel: 'VIC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099898249582',
	},
	{
		sizeLabel: '40C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684404290874',
	},
	{
		sizeLabel: 'VID (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117710796750',
	},
	{
		sizeLabel: '40D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757863593382',
	},
	{
		sizeLabel: 'VIE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753104043164',
	},
	{
		sizeLabel: '40E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286167298257',
	},
	{
		sizeLabel: 'VIF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609152621468',
	},
	{
		sizeLabel: '40F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448623421713',
	},
	{
		sizeLabel: 'VIG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487005291833',
	},
	{
		sizeLabel: '40G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703918766905',
	},
	{
		sizeLabel: 'VIH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146543877918',
	},
	{
		sizeLabel: '40H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '790411825211',
	},
	{
		sizeLabel: 'VIIB (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011016686890',
	},
	{
		sizeLabel: '42B (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573875958240',
	},
	{
		sizeLabel: 'VIIC (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938998492667',
	},
	{
		sizeLabel: '42C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017132209513',
	},
	{
		sizeLabel: 'VIID (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407285634871',
	},
	{
		sizeLabel: '42D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008919503866',
	},
	{
		sizeLabel: 'VIIE (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110997553732',
	},
	{
		sizeLabel: '42E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601236803551',
	},
	{
		sizeLabel: 'VIIF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022358331571',
	},
	{
		sizeLabel: '42F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181333121033',
	},
	{
		sizeLabel: 'VIIG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626750574007',
	},
	{
		sizeLabel: '42G (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '787521429427',
	},
	{
		sizeLabel: 'VIIH (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078665369939',
	},
	{
		sizeLabel: '42H (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216735004372',
	},
	{
		sizeLabel: '6 ⅜',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488570882417',
	},
	{
		sizeLabel: '1AA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '281813330079',
	},
	{
		sizeLabel: '2AA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '873794412365',
	},
	{
		sizeLabel: '3AA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783364043117',
	},
	{
		sizeLabel: '4AA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714276633120',
	},
	{
		sizeLabel: '5AA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193708339985',
	},
	{
		sizeLabel: 'I-XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '850340074716',
	},
	{
		sizeLabel: 'II-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911880457507',
	},
	{
		sizeLabel: 'III-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331663829368',
	},
	{
		sizeLabel: 'IV-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457973797789',
	},
	{
		sizeLabel: 'V-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '218285185260',
	},
	{
		sizeLabel: '1B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893747280352',
	},
	{
		sizeLabel: '2B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390341549095',
	},
	{
		sizeLabel: '3B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126947947404',
	},
	{
		sizeLabel: '4B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840359391362',
	},
	{
		sizeLabel: '5B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370478566456',
	},
	{
		sizeLabel: '48-49',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996085894334',
	},
	{
		sizeLabel: 'UNI',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602484257521',
	},
	{
		sizeLabel: '16 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181734684253',
	},
	{
		sizeLabel: '104 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '002394944035',
	},
	{
		sizeLabel: '108 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227604839922',
	},
	{
		sizeLabel: '86 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372267558893',
	},
	{
		sizeLabel: '122 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607822925317',
	},
	{
		sizeLabel: '126 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510336042706',
	},
	{
		sizeLabel: '1-S-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933583454451',
	},
	{
		sizeLabel: '2-L-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640385400630',
	},
	{
		sizeLabel: '8A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233096299020',
	},
	{
		sizeLabel: '8B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165326910050',
	},
	{
		sizeLabel: '8C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921751428483',
	},
	{
		sizeLabel: '8D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726972732862',
	},
	{
		sizeLabel: '8DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806555266943',
	},
	{
		sizeLabel: '8E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724345680695',
	},
	{
		sizeLabel: '8F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200364212092',
	},
	{
		sizeLabel: '8G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063092095080',
	},
	{
		sizeLabel: '10A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661522894651',
	},
	{
		sizeLabel: '10B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374119508641',
	},
	{
		sizeLabel: '10C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '723368963987',
	},
	{
		sizeLabel: '10D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263165286342',
	},
	{
		sizeLabel: '10DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078038218237',
	},
	{
		sizeLabel: '10E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523204475278',
	},
	{
		sizeLabel: '10F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953194754168',
	},
	{
		sizeLabel: '10G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192585273850',
	},
	{
		sizeLabel: '12A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022631034969',
	},
	{
		sizeLabel: '12B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951517415338',
	},
	{
		sizeLabel: '12C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842155549430',
	},
	{
		sizeLabel: '12D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106265078597',
	},
	{
		sizeLabel: '12DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556017099765',
	},
	{
		sizeLabel: '12E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227387929202',
	},
	{
		sizeLabel: '12F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '419901698698',
	},
	{
		sizeLabel: '12G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874667999221',
	},
	{
		sizeLabel: '14A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535489197170',
	},
	{
		sizeLabel: '14B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418096139426',
	},
	{
		sizeLabel: '14C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126542570597',
	},
	{
		sizeLabel: '14D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924546999086',
	},
	{
		sizeLabel: '14DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '486632223145',
	},
	{
		sizeLabel: '14E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663475014365',
	},
	{
		sizeLabel: '14F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311226781358',
	},
	{
		sizeLabel: '16A',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736591277579',
	},
	{
		sizeLabel: '16B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897029395378',
	},
	{
		sizeLabel: '16C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826582033800',
	},
	{
		sizeLabel: '16D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '527469223784',
	},
	{
		sizeLabel: '16DD',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411236455619',
	},
	{
		sizeLabel: '16E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906183773522',
	},
	{
		sizeLabel: 'SX-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756699633648',
	},
	{
		sizeLabel: 'XS-X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043047285281',
	},
	{
		sizeLabel: '31 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777161367660',
	},
	{
		sizeLabel: '32 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315241191847',
	},
	{
		sizeLabel: '34 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967611172903',
	},
	{
		sizeLabel: 'XL (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095773522762',
	},
	{
		sizeLabel: '2XL (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283481288340',
	},
	{
		sizeLabel: '33-34 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286379693584',
	},
	{
		sizeLabel: '47 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381819247063',
	},
	{
		sizeLabel: '60-62 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097607491848',
	},
	{
		sizeLabel: '125-130 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '139679985965',
	},
	{
		sizeLabel: 'XXL (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307113282896',
	},
	{
		sizeLabel: '150-76A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '316597064691',
	},
	{
		sizeLabel: '155-80A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054334739568',
	},
	{
		sizeLabel: '160-84A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225370635419',
	},
	{
		sizeLabel: '165-88A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '553707202811',
	},
	{
		sizeLabel: '170-92A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549596478052',
	},
	{
		sizeLabel: '175-96A (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859727037452',
	},
	{
		sizeLabel: '62 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571180645663',
	},
	{
		sizeLabel: '38-39 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507962856089',
	},
	{
		sizeLabel: '42-43 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889492648347',
	},
	{
		sizeLabel: '44-45 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532808034176',
	},
	{
		sizeLabel: '3XL (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671904416966',
	},
	{
		sizeLabel: '4XL (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408429139458',
	},
	{
		sizeLabel: '59 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276595850183',
	},
	{
		sizeLabel: '61 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422583465797',
	},
	{
		sizeLabel: '63 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456988444927',
	},
	{
		sizeLabel: '1 ½-4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455066455400',
	},
	{
		sizeLabel: '4 ½-7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '459476012241',
	},
	{
		sizeLabel: '7 ½-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865103708789',
	},
	{
		sizeLabel: '2 ½-5 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478943470526',
	},
	{
		sizeLabel: '8 ½-11 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307360533372',
	},
	{
		sizeLabel: '12-14 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438859850418',
	},
	{
		sizeLabel: '47-50 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292568187563',
	},
	{
		sizeLabel: '34 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '745903621015',
	},
	{
		sizeLabel: '35 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406764029758',
	},
	{
		sizeLabel: '35 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169919666929',
	},
	{
		sizeLabel: '36 ½ (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224151497707',
	},
	{
		sizeLabel: '49 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128324168392',
	},
	{
		sizeLabel: '47 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '221429595773',
	},
	{
		sizeLabel: '50 ½ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '083494968330',
	},
	{
		sizeLabel: '49 ½ (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823229305232',
	},
	{
		sizeLabel: '50 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570746160330',
	},
	{
		sizeLabel: '52 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876471064885',
	},
	{
		sizeLabel: '54 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228023742260',
	},
	{
		sizeLabel: '56 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576481735217',
	},
	{
		sizeLabel: '58 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '737387305438',
	},
	{
		sizeLabel: '33 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842182475373',
	},
	{
		sizeLabel: '33 ½ (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366785481508',
	},
	{
		sizeLabel: 'XXS (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '124745316632',
	},
	{
		sizeLabel: '178-78A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032081760118',
	},
	{
		sizeLabel: '218 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782287091459',
	},
	{
		sizeLabel: '222 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684808773971',
	},
	{
		sizeLabel: '226 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607805194630',
	},
	{
		sizeLabel: '230 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070569887897',
	},
	{
		sizeLabel: '235 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500126542120',
	},
	{
		sizeLabel: '239 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677724429398',
	},
	{
		sizeLabel: '243 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '737892920692',
	},
	{
		sizeLabel: '247 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '595040076308',
	},
	{
		sizeLabel: '252 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543341842963',
	},
	{
		sizeLabel: '256 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '650093827914',
	},
	{
		sizeLabel: '260 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675773521013',
	},
	{
		sizeLabel: '265 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '235927867583',
	},
	{
		sizeLabel: '269 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159059137625',
	},
	{
		sizeLabel: '273 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918795668356',
	},
	{
		sizeLabel: '277 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203902454470',
	},
	{
		sizeLabel: '281 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209694970996',
	},
	{
		sizeLabel: 'YOUTH S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136869332914',
	},
	{
		sizeLabel: 'YOUTH M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215354911835',
	},
	{
		sizeLabel: 'YOUTH L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952158218951',
	},
	{
		sizeLabel: 'YOUTH XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351457154745',
	},
	{
		sizeLabel: '1XL-1XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718050596550',
	},
	{
		sizeLabel: '2XL-2XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600285962043',
	},
	{
		sizeLabel: '3XL-3XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755427523786',
	},
	{
		sizeLabel: '4XL-4XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930694973681',
	},
	{
		sizeLabel: '33-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915077802545',
	},
	{
		sizeLabel: 'W14-W16',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538263061676',
	},
	{
		sizeLabel: 'W18-W20',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827481543017',
	},
	{
		sizeLabel: 'W22-W24',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024758519973',
	},
	{
		sizeLabel: '65A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661300255597',
	},
	{
		sizeLabel: '30A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '509824096583',
	},
	{
		sizeLabel: '6A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '413299667148',
	},
	{
		sizeLabel: '65D-70A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440144215923',
	},
	{
		sizeLabel: '30D-32A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757515651328',
	},
	{
		sizeLabel: '6D-8A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059622715030',
	},
	{
		sizeLabel: '70D-75A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864980937361',
	},
	{
		sizeLabel: '32D-34A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951047495219',
	},
	{
		sizeLabel: '8D-10A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251927349446',
	},
	{
		sizeLabel: '75D-80A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811311504224',
	},
	{
		sizeLabel: '34D-36A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '323216197431',
	},
	{
		sizeLabel: '10D-12A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798064211517',
	},
	{
		sizeLabel: '80D-85A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537285022093',
	},
	{
		sizeLabel: '36D-38A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297554516603',
	},
	{
		sizeLabel: '12D-14A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927734214343',
	},
	{
		sizeLabel: '85D-90A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766222107773',
	},
	{
		sizeLabel: '38D-40A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267726608621',
	},
	{
		sizeLabel: '14D-16A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957316253650',
	},
	{
		sizeLabel: '90D-95A-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908372076928',
	},
	{
		sizeLabel: '40D-42A-C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324024271445',
	},
	{
		sizeLabel: '16D-18A-C (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099918776564',
	},
	{
		sizeLabel: '62-64 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752627684485',
	},
	{
		sizeLabel: 'XS-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337377263922',
	},
	{
		sizeLabel: '2XL-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988308665437',
	},
	{
		sizeLabel: '3XL-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019596930894',
	},
	{
		sizeLabel: '2XL-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290850700386',
	},
	{
		sizeLabel: '3XL-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126638467358',
	},
	{
		sizeLabel: '2XL-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665963949420',
	},
	{
		sizeLabel: '3XL-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102818995071',
	},
	{
		sizeLabel: '24-26',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374314200514',
	},
	{
		sizeLabel: '26-26',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306025349159',
	},
	{
		sizeLabel: '28-26',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840395352029',
	},
	{
		sizeLabel: 'XXXL-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290168425371',
	},
	{
		sizeLabel: 'XXXL-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374735692314',
	},
	{
		sizeLabel: '68 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385801817686',
	},
	{
		sizeLabel: '70 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833344210919',
	},
	{
		sizeLabel: '72 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291590619635',
	},
	{
		sizeLabel: '31 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '395806288318',
	},
	{
		sizeLabel: '29 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926202734128',
	},
	{
		sizeLabel: '32 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652169464517',
	},
	{
		sizeLabel: '35 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932342002532',
	},
	{
		sizeLabel: '70DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036040330592',
	},
	{
		sizeLabel: '85DDD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043563960828',
	},
	{
		sizeLabel: '1DDD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932605148992',
	},
	{
		sizeLabel: '75DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982500662125',
	},
	{
		sizeLabel: '90DDD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834156102292',
	},
	{
		sizeLabel: '2DDD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895239065576',
	},
	{
		sizeLabel: '80DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044358118390',
	},
	{
		sizeLabel: '95DDD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '344473742469',
	},
	{
		sizeLabel: '3DDD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032927876534',
	},
	{
		sizeLabel: '85DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969286317240',
	},
	{
		sizeLabel: '100DDD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741697245072',
	},
	{
		sizeLabel: '4DDD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626976905748',
	},
	{
		sizeLabel: '90DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '645694023320',
	},
	{
		sizeLabel: '105DDD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192480678208',
	},
	{
		sizeLabel: '5DDD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016378008387',
	},
	{
		sizeLabel: '95DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602856708698',
	},
	{
		sizeLabel: '110DDD (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393154098670',
	},
	{
		sizeLabel: '6DDD (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744272734862',
	},
	{
		sizeLabel: '155-66A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717452840917',
	},
	{
		sizeLabel: '160-74A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801685895593',
	},
	{
		sizeLabel: '165-78A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769403880504',
	},
	{
		sizeLabel: '175-90A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781085791956',
	},
	{
		sizeLabel: '170-78B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057946256561',
	},
	{
		sizeLabel: '175-82B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '437072766409',
	},
	{
		sizeLabel: '175-86B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097562371049',
	},
	{
		sizeLabel: '180-90B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981149843671',
	},
	{
		sizeLabel: '180-94B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925105167947',
	},
	{
		sizeLabel: '185-98B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219887194060',
	},
	{
		sizeLabel: '185-102B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763966118095',
	},
	{
		sizeLabel: '190-106B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162249631904',
	},
	{
		sizeLabel: 'XS-S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '984155225403',
	},
	{
		sizeLabel: 'M-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985236284737',
	},
	{
		sizeLabel: 'S-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233089638167',
	},
	{
		sizeLabel: 'L-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918244543495',
	},
	{
		sizeLabel: 'XXS-XS (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704366589076',
	},
	{
		sizeLabel: 'ONE SIZE (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704077715173',
	},
	{
		sizeLabel: '12 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968859302820',
	},
	{
		sizeLabel: '34-38 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '648655584965',
	},
	{
		sizeLabel: '32-36 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '155468872125',
	},
	{
		sizeLabel: '38-42 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410748972688',
	},
	{
		sizeLabel: '36-40 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913856880613',
	},
	{
		sizeLabel: '42-46 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050303022950',
	},
	{
		sizeLabel: '3 ½-4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435074046072',
	},
	{
		sizeLabel: '22-22 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573769108105',
	},
	{
		sizeLabel: '23 ½-24 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961116945152',
	},
	{
		sizeLabel: '24-24 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599106997667',
	},
	{
		sizeLabel: '24 ½-25 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158932231904',
	},
	{
		sizeLabel: '25 ½-26 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112182515250',
	},
	{
		sizeLabel: '26-26 ½ (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999526094482',
	},
	{
		sizeLabel: '36A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191121816675',
	},
	{
		sizeLabel: '36B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035068576226',
	},
	{
		sizeLabel: '36C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677137668879',
	},
	{
		sizeLabel: '36D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665965750009',
	},
	{
		sizeLabel: '36E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352069353323',
	},
	{
		sizeLabel: '36F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '884015406587',
	},
	{
		sizeLabel: '38A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137533045329',
	},
	{
		sizeLabel: '38B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213672812991',
	},
	{
		sizeLabel: '38C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797875287406',
	},
	{
		sizeLabel: '38D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808441946068',
	},
	{
		sizeLabel: '38E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113029582326',
	},
	{
		sizeLabel: '38F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259038875524',
	},
	{
		sizeLabel: '40A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503340314629',
	},
	{
		sizeLabel: '40B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253183698464',
	},
	{
		sizeLabel: '40C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931887657788',
	},
	{
		sizeLabel: '40D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461614801902',
	},
	{
		sizeLabel: '40E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981562611843',
	},
	{
		sizeLabel: '40F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655607149484',
	},
	{
		sizeLabel: '42A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957282236713',
	},
	{
		sizeLabel: '42B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '560438840199',
	},
	{
		sizeLabel: '42C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839914664984',
	},
	{
		sizeLabel: '42D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899982608178',
	},
	{
		sizeLabel: '42E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '723752714147',
	},
	{
		sizeLabel: '42F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425324461614',
	},
	{
		sizeLabel: '44A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781006493591',
	},
	{
		sizeLabel: '44B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938813719895',
	},
	{
		sizeLabel: '44C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814113076553',
	},
	{
		sizeLabel: '44D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156341327470',
	},
	{
		sizeLabel: '44E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511462157738',
	},
	{
		sizeLabel: '44F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294926748229',
	},
	{
		sizeLabel: '46A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971877502277',
	},
	{
		sizeLabel: '46B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803863628307',
	},
	{
		sizeLabel: '46C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054042447233',
	},
	{
		sizeLabel: '46D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861793777570',
	},
	{
		sizeLabel: '46E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '848626651757',
	},
	{
		sizeLabel: '46F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971396958039',
	},
	{
		sizeLabel: '48A (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120470203928',
	},
	{
		sizeLabel: '48B (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951691127648',
	},
	{
		sizeLabel: '48C (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137843964881',
	},
	{
		sizeLabel: '48D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '583039863124',
	},
	{
		sizeLabel: '48E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385725062671',
	},
	{
		sizeLabel: '48F (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729976299792',
	},
	{
		sizeLabel: 'W35L30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558255306307',
	},
	{
		sizeLabel: 'W35L32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301539799748',
	},
	{
		sizeLabel: 'W35L34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519495395146',
	},
	{
		sizeLabel: 'W25',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '432702566711',
	},
	{
		sizeLabel: '42-44 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602511089155',
	},
	{
		sizeLabel: 'W27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620725879589',
	},
	{
		sizeLabel: '44-46 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '997987545040',
	},
	{
		sizeLabel: 'W29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538575098060',
	},
	{
		sizeLabel: 'W31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981097737477',
	},
	{
		sizeLabel: '48-50 (BY)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882970692816',
	},
	{
		sizeLabel: 'W32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841511380868',
	},
	{
		sizeLabel: 'W33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508193708937',
	},
	{
		sizeLabel: '50H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343249589562',
	},
	{
		sizeLabel: '3XL-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075518041583',
	},
	{
		sizeLabel: '75B-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889159905049',
	},
	{
		sizeLabel: '75C-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805139293663',
	},
	{
		sizeLabel: '75C-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629170143865',
	},
	{
		sizeLabel: '75D-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236952004644',
	},
	{
		sizeLabel: '75D-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '148746499494',
	},
	{
		sizeLabel: '75E-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833103990567',
	},
	{
		sizeLabel: '75E-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448079862977',
	},
	{
		sizeLabel: '75F-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721840205229',
	},
	{
		sizeLabel: '75F-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371418837242',
	},
	{
		sizeLabel: '75G-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094876289359',
	},
	{
		sizeLabel: '75G-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998149310831',
	},
	{
		sizeLabel: '80C-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675794065593',
	},
	{
		sizeLabel: '80D-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754110559948',
	},
	{
		sizeLabel: '80D-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547501254435',
	},
	{
		sizeLabel: '80E-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463035082285',
	},
	{
		sizeLabel: '80E-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574227699125',
	},
	{
		sizeLabel: '80F-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '856758964783',
	},
	{
		sizeLabel: '80F-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736601314904',
	},
	{
		sizeLabel: '80H-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380385480189',
	},
	{
		sizeLabel: '80G-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739791887784',
	},
	{
		sizeLabel: '80G-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '692207883760',
	},
	{
		sizeLabel: '85D-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736797815853',
	},
	{
		sizeLabel: '85D-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366742055646',
	},
	{
		sizeLabel: '85E-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116460702836',
	},
	{
		sizeLabel: '85E-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399967243460',
	},
	{
		sizeLabel: '85F-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '495575008933',
	},
	{
		sizeLabel: '85F-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102926643632',
	},
	{
		sizeLabel: '85G-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785501844367',
	},
	{
		sizeLabel: '85G-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215891665266',
	},
	{
		sizeLabel: '85H-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115489174262',
	},
	{
		sizeLabel: '90H-3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397713335854',
	},
	{
		sizeLabel: '75D-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134813962074',
	},
	{
		sizeLabel: '75D-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584710052103',
	},
	{
		sizeLabel: '75E-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678546976058',
	},
	{
		sizeLabel: '75E-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915113523621',
	},
	{
		sizeLabel: '75F-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546449810333',
	},
	{
		sizeLabel: '75F-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059846359689',
	},
	{
		sizeLabel: '75G-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632675567911',
	},
	{
		sizeLabel: '75G-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425266927347',
	},
	{
		sizeLabel: '80D-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995961019723',
	},
	{
		sizeLabel: '80D-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383798080431',
	},
	{
		sizeLabel: '80E-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983942668607',
	},
	{
		sizeLabel: '80E-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617545705540',
	},
	{
		sizeLabel: '80F-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507280262796',
	},
	{
		sizeLabel: '80F-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601309045311',
	},
	{
		sizeLabel: '80G-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414968960502',
	},
	{
		sizeLabel: '80G-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175019863206',
	},
	{
		sizeLabel: '80H-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041083447207',
	},
	{
		sizeLabel: '85D-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988836977913',
	},
	{
		sizeLabel: '85D-2XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244202194944',
	},
	{
		sizeLabel: '85E-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555510324838',
	},
	{
		sizeLabel: '85E-2XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048798770431',
	},
	{
		sizeLabel: '85F-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727645794742',
	},
	{
		sizeLabel: '85F-2XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771629672874',
	},
	{
		sizeLabel: '85G-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233733918969',
	},
	{
		sizeLabel: '85G-2XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802278756616',
	},
	{
		sizeLabel: '85H-2XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164302972128',
	},
	{
		sizeLabel: '90H-3XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640983914601',
	},
	{
		sizeLabel: 'XL-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841075272277',
	},
	{
		sizeLabel: '38EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742711079162',
	},
	{
		sizeLabel: '40EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365174283237',
	},
	{
		sizeLabel: '42EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533094662322',
	},
	{
		sizeLabel: '44EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940664787267',
	},
	{
		sizeLabel: '46EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428035050574',
	},
	{
		sizeLabel: '48SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734630037041',
	},
	{
		sizeLabel: '48REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662808627494',
	},
	{
		sizeLabel: '48LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617470494388',
	},
	{
		sizeLabel: '48EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651788107173',
	},
	{
		sizeLabel: '50SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682130880803',
	},
	{
		sizeLabel: '50REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '433110071867',
	},
	{
		sizeLabel: '50LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351080809544',
	},
	{
		sizeLabel: '50EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705950801460',
	},
	{
		sizeLabel: '52SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252167711488',
	},
	{
		sizeLabel: '52REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967754907846',
	},
	{
		sizeLabel: '52LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778175415587',
	},
	{
		sizeLabel: '52EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '250245137336',
	},
	{
		sizeLabel: '54SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291472025960',
	},
	{
		sizeLabel: '54REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '635016223986',
	},
	{
		sizeLabel: '54LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '233821674302',
	},
	{
		sizeLabel: '54EXTRA LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143726207307',
	},
	{
		sizeLabel: '26XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854816737190',
	},
	{
		sizeLabel: '28XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367272481662',
	},
	{
		sizeLabel: '30XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934923918049',
	},
	{
		sizeLabel: '32XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104013732170',
	},
	{
		sizeLabel: '34XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196583897574',
	},
	{
		sizeLabel: '36XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265592968663',
	},
	{
		sizeLabel: '38XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694827543157',
	},
	{
		sizeLabel: '40XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086084100500',
	},
	{
		sizeLabel: '42XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '296577843896',
	},
	{
		sizeLabel: '44XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '443947215137',
	},
	{
		sizeLabel: '46XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785328053356',
	},
	{
		sizeLabel: '48XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559785693911',
	},
	{
		sizeLabel: '50XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375089351518',
	},
	{
		sizeLabel: '52XX LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352695516265',
	},
	{
		sizeLabel: '38-40REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182565981727',
	},
	{
		sizeLabel: '38-40LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '993333954356',
	},
	{
		sizeLabel: '44-46REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '696170217503',
	},
	{
		sizeLabel: '44-46LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392857113796',
	},
	{
		sizeLabel: '48-50REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153099378194',
	},
	{
		sizeLabel: '48-50LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325094550063',
	},
	{
		sizeLabel: '06-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402542685140',
	},
	{
		sizeLabel: '06-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108226890637',
	},
	{
		sizeLabel: '06-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162657002055',
	},
	{
		sizeLabel: '08-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505836234423',
	},
	{
		sizeLabel: '08-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100816654761',
	},
	{
		sizeLabel: '08-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574285359271',
	},
	{
		sizeLabel: '10-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576548103909',
	},
	{
		sizeLabel: '10-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909720100043',
	},
	{
		sizeLabel: '10-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038780789462',
	},
	{
		sizeLabel: '12-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460417580411',
	},
	{
		sizeLabel: '12-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669263217298',
	},
	{
		sizeLabel: '12-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748064006565',
	},
	{
		sizeLabel: '14-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947780435288',
	},
	{
		sizeLabel: '14-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807313502001',
	},
	{
		sizeLabel: '14-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310290968206',
	},
	{
		sizeLabel: '16-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512953008678',
	},
	{
		sizeLabel: '16-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494396069535',
	},
	{
		sizeLabel: '16-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336194724361',
	},
	{
		sizeLabel: '18-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262260037499',
	},
	{
		sizeLabel: '18-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288699958774',
	},
	{
		sizeLabel: '18-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668060029448',
	},
	{
		sizeLabel: '20-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773252663290',
	},
	{
		sizeLabel: '20-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665970440559',
	},
	{
		sizeLabel: '20-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034756616477',
	},
	{
		sizeLabel: '22-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550388280908',
	},
	{
		sizeLabel: '22-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262109323699',
	},
	{
		sizeLabel: '22-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385535431510',
	},
	{
		sizeLabel: '24-29',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '735973281284',
	},
	{
		sizeLabel: '24-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '272534784932',
	},
	{
		sizeLabel: '24-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179096602108',
	},
	{
		sizeLabel: '28-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721163339958',
	},
	{
		sizeLabel: '28-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600359671906',
	},
	{
		sizeLabel: '28-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058214393257',
	},
	{
		sizeLabel: '28-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '339566033766',
	},
	{
		sizeLabel: '30-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447698432508',
	},
	{
		sizeLabel: '30-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '323085213643',
	},
	{
		sizeLabel: '30-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622056390676',
	},
	{
		sizeLabel: '32-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475364398877',
	},
	{
		sizeLabel: '32-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138204566711',
	},
	{
		sizeLabel: '32-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612751583742',
	},
	{
		sizeLabel: '34-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926414423050',
	},
	{
		sizeLabel: '34-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927598541728',
	},
	{
		sizeLabel: '34-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704624570787',
	},
	{
		sizeLabel: '36-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '433656005682',
	},
	{
		sizeLabel: '36-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477322176882',
	},
	{
		sizeLabel: '36-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637281202113',
	},
	{
		sizeLabel: '36-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837820364594',
	},
	{
		sizeLabel: '38-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214768596043',
	},
	{
		sizeLabel: '38-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134148378985',
	},
	{
		sizeLabel: '38-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069843686018',
	},
	{
		sizeLabel: '38-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '880706687671',
	},
	{
		sizeLabel: '40-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '502355437871',
	},
	{
		sizeLabel: '40-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101185359820',
	},
	{
		sizeLabel: '40-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885383632811',
	},
	{
		sizeLabel: '40-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '811053183524',
	},
	{
		sizeLabel: '42-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179571092204',
	},
	{
		sizeLabel: '42-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522144530071',
	},
	{
		sizeLabel: '42-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916839031222',
	},
	{
		sizeLabel: '42-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513844272119',
	},
	{
		sizeLabel: '44-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713409744056',
	},
	{
		sizeLabel: '44-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098413679377',
	},
	{
		sizeLabel: '44-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340644004572',
	},
	{
		sizeLabel: '44-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685116069730',
	},
	{
		sizeLabel: '46-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277776157443',
	},
	{
		sizeLabel: '46-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '287835639080',
	},
	{
		sizeLabel: '46-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469709358137',
	},
	{
		sizeLabel: '46-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228014393432',
	},
	{
		sizeLabel: '48-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240347769585',
	},
	{
		sizeLabel: '48-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729121168157',
	},
	{
		sizeLabel: '48-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '445926730897',
	},
	{
		sizeLabel: '48-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412442423743',
	},
	{
		sizeLabel: '50-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '581873599130',
	},
	{
		sizeLabel: '50-31',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182069171254',
	},
	{
		sizeLabel: '50-33',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662119066840',
	},
	{
		sizeLabel: '50-35',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514175870773',
	},
	{
		sizeLabel: '06-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912428476024',
	},
	{
		sizeLabel: '08-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185381413450',
	},
	{
		sizeLabel: '10-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022963025325',
	},
	{
		sizeLabel: '12-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701145546725',
	},
	{
		sizeLabel: '14-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023811844429',
	},
	{
		sizeLabel: '16-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238760539673',
	},
	{
		sizeLabel: '18-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710016000377',
	},
	{
		sizeLabel: '20-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979652394197',
	},
	{
		sizeLabel: '22-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908995093069',
	},
	{
		sizeLabel: '24-27',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799149521187',
	},
	{
		sizeLabel: '8-12 (S) (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354241712359',
	},
	{
		sizeLabel: '8-12 (M) (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446880637567',
	},
	{
		sizeLabel: '14-16 (M) (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255331057350',
	},
	{
		sizeLabel: '10-14 (L) (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507578001549',
	},
	{
		sizeLabel: '14-16 (L) (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782713781658',
	},
	{
		sizeLabel: '18-24 (XL) (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240575708240',
	},
	{
		sizeLabel: 'ONE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259522229503',
	},
	{
		sizeLabel: '4 ½-5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773856615310',
	},
	{
		sizeLabel: '12 ½-13 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334216493861',
	},
	{
		sizeLabel: '15 ½-16 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438940863143',
	},
	{
		sizeLabel: '16 ½-17 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130607973421',
	},
	{
		sizeLabel: '17 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198688166664',
	},
	{
		sizeLabel: '17 ½-18 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999448926332',
	},
	{
		sizeLabel: '18 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199784798967',
	},
	{
		sizeLabel: '8A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347519600124',
	},
	{
		sizeLabel: '36A (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097760019323',
	},
	{
		sizeLabel: '6A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927840908293',
	},
	{
		sizeLabel: '40A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788912302028',
	},
	{
		sizeLabel: '38A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '902184787113',
	},
	{
		sizeLabel: '36B (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822234392098',
	},
	{
		sizeLabel: '40B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517745276051',
	},
	{
		sizeLabel: '38B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391026739634',
	},
	{
		sizeLabel: '36C (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488382615888',
	},
	{
		sizeLabel: '40C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402826488525',
	},
	{
		sizeLabel: '38C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389638591916',
	},
	{
		sizeLabel: '8D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037906961141',
	},
	{
		sizeLabel: '36D (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '389439737500',
	},
	{
		sizeLabel: '6D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414476535029',
	},
	{
		sizeLabel: '40D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059789098487',
	},
	{
		sizeLabel: '38D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494701823966',
	},
	{
		sizeLabel: '8E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '873656525825',
	},
	{
		sizeLabel: '36E (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836790847795',
	},
	{
		sizeLabel: '6E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181193419877',
	},
	{
		sizeLabel: '40E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315246580249',
	},
	{
		sizeLabel: '38E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610008208587',
	},
	{
		sizeLabel: '10A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842299837697',
	},
	{
		sizeLabel: '8A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304033640338',
	},
	{
		sizeLabel: '42A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347863106022',
	},
	{
		sizeLabel: '40A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105682913645',
	},
	{
		sizeLabel: '10B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794549291941',
	},
	{
		sizeLabel: '42B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774786674083',
	},
	{
		sizeLabel: '40B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899689581540',
	},
	{
		sizeLabel: '10C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728374878406',
	},
	{
		sizeLabel: '42C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707851067535',
	},
	{
		sizeLabel: '40C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '936851345465',
	},
	{
		sizeLabel: '10D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161968707733',
	},
	{
		sizeLabel: '8D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624367296001',
	},
	{
		sizeLabel: '42D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390948490453',
	},
	{
		sizeLabel: '40D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209482833971',
	},
	{
		sizeLabel: '10E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467567815225',
	},
	{
		sizeLabel: '8E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938927840009',
	},
	{
		sizeLabel: '42E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562297111902',
	},
	{
		sizeLabel: '40E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278902812720',
	},
	{
		sizeLabel: '12A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203264511527',
	},
	{
		sizeLabel: '10A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656618096526',
	},
	{
		sizeLabel: '44A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '256438285657',
	},
	{
		sizeLabel: '42A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112438859003',
	},
	{
		sizeLabel: '12B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703093356310',
	},
	{
		sizeLabel: '44B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751352895904',
	},
	{
		sizeLabel: '42B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683327575971',
	},
	{
		sizeLabel: '12C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '607069912513',
	},
	{
		sizeLabel: '44C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '876947559051',
	},
	{
		sizeLabel: '42C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '211876516201',
	},
	{
		sizeLabel: '12D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767569091453',
	},
	{
		sizeLabel: '10D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644833020952',
	},
	{
		sizeLabel: '44D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773295973274',
	},
	{
		sizeLabel: '42D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290780894423',
	},
	{
		sizeLabel: '12E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '482127026625',
	},
	{
		sizeLabel: '10E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868493538337',
	},
	{
		sizeLabel: '44E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738080362109',
	},
	{
		sizeLabel: '42E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985655779544',
	},
	{
		sizeLabel: '14A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931868335988',
	},
	{
		sizeLabel: '12A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498325599329',
	},
	{
		sizeLabel: '46A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '838197059978',
	},
	{
		sizeLabel: '44A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212652129392',
	},
	{
		sizeLabel: '14B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '113759919978',
	},
	{
		sizeLabel: '12B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978767919400',
	},
	{
		sizeLabel: '46B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612091021790',
	},
	{
		sizeLabel: '44BB (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794932021156',
	},
	{
		sizeLabel: '14C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874162740217',
	},
	{
		sizeLabel: '12C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095554729198',
	},
	{
		sizeLabel: '46C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867071588878',
	},
	{
		sizeLabel: '44C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480552083355',
	},
	{
		sizeLabel: '14D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306903096614',
	},
	{
		sizeLabel: '12D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585372210053',
	},
	{
		sizeLabel: '46D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081222077883',
	},
	{
		sizeLabel: '44D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913508645763',
	},
	{
		sizeLabel: '14E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490478257316',
	},
	{
		sizeLabel: '12E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298158845373',
	},
	{
		sizeLabel: '46E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739067531180',
	},
	{
		sizeLabel: '44E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826535649484',
	},
	{
		sizeLabel: '16A (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977899389109',
	},
	{
		sizeLabel: '14A (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710312862535',
	},
	{
		sizeLabel: '48A (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464243333595',
	},
	{
		sizeLabel: '46A (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074009909693',
	},
	{
		sizeLabel: '16B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927283234842',
	},
	{
		sizeLabel: '14B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '415237104261',
	},
	{
		sizeLabel: '48B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898293478680',
	},
	{
		sizeLabel: '46B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665688027217',
	},
	{
		sizeLabel: '16C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781694474634',
	},
	{
		sizeLabel: '14C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140354398060',
	},
	{
		sizeLabel: '48C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642582334847',
	},
	{
		sizeLabel: '46C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990973885798',
	},
	{
		sizeLabel: '16D (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '250638410013',
	},
	{
		sizeLabel: '14D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205725015676',
	},
	{
		sizeLabel: '48D (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106818422129',
	},
	{
		sizeLabel: '46D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037461199909',
	},
	{
		sizeLabel: '16E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '501257466898',
	},
	{
		sizeLabel: '14E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651760000423',
	},
	{
		sizeLabel: '48E (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630223750673',
	},
	{
		sizeLabel: '46E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117716903221',
	},
	{
		sizeLabel: 'XL-GG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '511695133178',
	},
	{
		sizeLabel: '32-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834306233339',
	},
	{
		sizeLabel: '34-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176893995933',
	},
	{
		sizeLabel: '36-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080892670861',
	},
	{
		sizeLabel: '230-83 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942764711744',
	},
	{
		sizeLabel: '235-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '851027507701',
	},
	{
		sizeLabel: '240-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463055482894',
	},
	{
		sizeLabel: '245-86 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133083504125',
	},
	{
		sizeLabel: '255-87 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232448562839',
	},
	{
		sizeLabel: '260-88 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504372586422',
	},
	{
		sizeLabel: '265-89 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686455971687',
	},
	{
		sizeLabel: '275-90 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '097006597481',
	},
	{
		sizeLabel: '250-92 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011164514758',
	},
	{
		sizeLabel: '255-93 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '033548142223',
	},
	{
		sizeLabel: '260-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969829921595',
	},
	{
		sizeLabel: '265-95 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507932088673',
	},
	{
		sizeLabel: '270-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852000576595',
	},
	{
		sizeLabel: '275-97 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385762071449',
	},
	{
		sizeLabel: '285-98 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212510809060',
	},
	{
		sizeLabel: '290-99 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842642923928',
	},
	{
		sizeLabel: '295-100 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544461736929',
	},
	{
		sizeLabel: '165-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883313956300',
	},
	{
		sizeLabel: '44-55 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060198696451',
	},
	{
		sizeLabel: '165-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '873329907493',
	},
	{
		sizeLabel: '170-88 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112245053496',
	},
	{
		sizeLabel: '55-66 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063833439369',
	},
	{
		sizeLabel: '170-92 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416912935719',
	},
	{
		sizeLabel: '175-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642228517600',
	},
	{
		sizeLabel: '52-52 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522797041756',
	},
	{
		sizeLabel: '175-92 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621158683705',
	},
	{
		sizeLabel: '180-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722201048978',
	},
	{
		sizeLabel: '180-100 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208011368255',
	},
	{
		sizeLabel: '185-104 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944244972548',
	},
	{
		sizeLabel: '185-108 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322962691337',
	},
	{
		sizeLabel: '185-112 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '316617335182',
	},
	{
		sizeLabel: '190-116 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '588980656931',
	},
	{
		sizeLabel: '15.8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928172178449',
	},
	{
		sizeLabel: '15.8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815496849345',
	},
	{
		sizeLabel: '190-120 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152731014047',
	},
	{
		sizeLabel: '24 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402435008637',
	},
	{
		sizeLabel: '165-62 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898968315891',
	},
	{
		sizeLabel: '24-26 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796644240750',
	},
	{
		sizeLabel: '165-66 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717857945874',
	},
	{
		sizeLabel: '28 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652060412934',
	},
	{
		sizeLabel: '170-70 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414991305120',
	},
	{
		sizeLabel: '30 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700543980303',
	},
	{
		sizeLabel: '170-74 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220138716558',
	},
	{
		sizeLabel: '175-78 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968330619909',
	},
	{
		sizeLabel: '175-82 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143374246630',
	},
	{
		sizeLabel: '180-86 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623658860427',
	},
	{
		sizeLabel: '30 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430306679803',
	},
	{
		sizeLabel: '31 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910407466663',
	},
	{
		sizeLabel: '31 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800748731202',
	},
	{
		sizeLabel: '32 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271830644112',
	},
	{
		sizeLabel: '38-30(S) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713118708335',
	},
	{
		sizeLabel: '44-30 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '716671584617',
	},
	{
		sizeLabel: '44-30 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487818739957',
	},
	{
		sizeLabel: '40-31(M) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319166928307',
	},
	{
		sizeLabel: '46-31 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999798897555',
	},
	{
		sizeLabel: '180-82 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686363592427',
	},
	{
		sizeLabel: '46-31 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438830696917',
	},
	{
		sizeLabel: '42-32(L) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956497898588',
	},
	{
		sizeLabel: '48-32 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831537731224',
	},
	{
		sizeLabel: '48-32 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200162782032',
	},
	{
		sizeLabel: '44-34(L) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806106012648',
	},
	{
		sizeLabel: '50-34 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899616919897',
	},
	{
		sizeLabel: '185-90 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697775436950',
	},
	{
		sizeLabel: '50-34 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746920981204',
	},
	{
		sizeLabel: '46-36(XL) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461937082280',
	},
	{
		sizeLabel: '52-36 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032145323751',
	},
	{
		sizeLabel: '185-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367203196395',
	},
	{
		sizeLabel: '52-36 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009790639905',
	},
	{
		sizeLabel: '48-38(XL) (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277625493534',
	},
	{
		sizeLabel: '54-38 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891659438089',
	},
	{
		sizeLabel: '185-98 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832901138063',
	},
	{
		sizeLabel: '54-38 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '946860307653',
	},
	{
		sizeLabel: '50-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396493351985',
	},
	{
		sizeLabel: '56-40 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '539191759098',
	},
	{
		sizeLabel: '190-102 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309031454638',
	},
	{
		sizeLabel: '56-40 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368047166174',
	},
	{
		sizeLabel: '2XL-2TG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970343974160',
	},
	{
		sizeLabel: 'OSFA',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334252629757',
	},
	{
		sizeLabel: 'OSFW',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839435822356',
	},
	{
		sizeLabel: '53 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342519287733',
	},
	{
		sizeLabel: '10-M9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750701192467',
	},
	{
		sizeLabel: '11-M10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '162600116073',
	},
	{
		sizeLabel: '12-M11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616875950855',
	},
	{
		sizeLabel: '13-M12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '844611499538',
	},
	{
		sizeLabel: '28-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135992158513',
	},
	{
		sizeLabel: '30-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676519138909',
	},
	{
		sizeLabel: '32-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499358314075',
	},
	{
		sizeLabel: '34-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315232876570',
	},
	{
		sizeLabel: '36-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '188747807278',
	},
	{
		sizeLabel: '38-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992537619735',
	},
	{
		sizeLabel: '28-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295104138808',
	},
	{
		sizeLabel: '30-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429583379497',
	},
	{
		sizeLabel: '32-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978996703202',
	},
	{
		sizeLabel: '34-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791109306362',
	},
	{
		sizeLabel: '36-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104010873851',
	},
	{
		sizeLabel: '38-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091561023651',
	},
	{
		sizeLabel: '28-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685622637975',
	},
	{
		sizeLabel: '30-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801335129941',
	},
	{
		sizeLabel: '32-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028374271944',
	},
	{
		sizeLabel: '34-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237554884392',
	},
	{
		sizeLabel: '36-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231723018287',
	},
	{
		sizeLabel: '38-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '042097509074',
	},
	{
		sizeLabel: '28S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512243882171',
	},
	{
		sizeLabel: '30S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861350080393',
	},
	{
		sizeLabel: '30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826298489619',
	},
	{
		sizeLabel: '32S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652360792212',
	},
	{
		sizeLabel: '32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903147620785',
	},
	{
		sizeLabel: '71-74 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770958481075',
	},
	{
		sizeLabel: '76-79 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967810677773',
	},
	{
		sizeLabel: '81-84 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612384682451',
	},
	{
		sizeLabel: '86-91 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879422563217',
	},
	{
		sizeLabel: '97-102 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858802314925',
	},
	{
		sizeLabel: '107 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '580378143082',
	},
	{
		sizeLabel: '112 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575723843688',
	},
	{
		sizeLabel: '13-13 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809400168309',
	},
	{
		sizeLabel: '14-14 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656633886632',
	},
	{
		sizeLabel: '15-15 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877930357579',
	},
	{
		sizeLabel: '18-18 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '370939875993',
	},
	{
		sizeLabel: '19-19 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460952058305',
	},
	{
		sizeLabel: '0-00 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228126240699',
	},
	{
		sizeLabel: 'W34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674473341033',
	},
	{
		sizeLabel: 'W36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817821068957',
	},
	{
		sizeLabel: '85 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '348482531522',
	},
	{
		sizeLabel: '90 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198548545808',
	},
	{
		sizeLabel: '95 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159405820766',
	},
	{
		sizeLabel: '100 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177989714876',
	},
	{
		sizeLabel: '70S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356547670649',
	},
	{
		sizeLabel: '75R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010756539272',
	},
	{
		sizeLabel: '75S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '679465410813',
	},
	{
		sizeLabel: '85S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542681524041',
	},
	{
		sizeLabel: '90O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '345996445993',
	},
	{
		sizeLabel: '90P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '260719145747',
	},
	{
		sizeLabel: '90R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220970168966',
	},
	{
		sizeLabel: '90S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231362713563',
	},
	{
		sizeLabel: '95O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503819208656',
	},
	{
		sizeLabel: '95P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847975216324',
	},
	{
		sizeLabel: '95R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036131122669',
	},
	{
		sizeLabel: '95S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442146319390',
	},
	{
		sizeLabel: '100O (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982845274113',
	},
	{
		sizeLabel: '100P (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864919422658',
	},
	{
		sizeLabel: '100R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622198721755',
	},
	{
		sizeLabel: '100S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '265114571890',
	},
	{
		sizeLabel: '28 S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718450935488',
	},
	{
		sizeLabel: '30S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711509618883',
	},
	{
		sizeLabel: '32S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163674768456',
	},
	{
		sizeLabel: '34S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375287655225',
	},
	{
		sizeLabel: '36S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963672428954',
	},
	{
		sizeLabel: '38S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625921678957',
	},
	{
		sizeLabel: '40S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802419471293',
	},
	{
		sizeLabel: '42S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519192897206',
	},
	{
		sizeLabel: '28R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802669775289',
	},
	{
		sizeLabel: '30R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566610089481',
	},
	{
		sizeLabel: '32R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '332240291267',
	},
	{
		sizeLabel: '75-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108800780211',
	},
	{
		sizeLabel: '80-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408688209970',
	},
	{
		sizeLabel: '85-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138008619400',
	},
	{
		sizeLabel: '90-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713502424669',
	},
	{
		sizeLabel: '95-XXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037291545421',
	},
	{
		sizeLabel: '100-3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641211746102',
	},
	{
		sizeLabel: '46 (TK)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594824624589',
	},
	{
		sizeLabel: '75 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951409446966',
	},
	{
		sizeLabel: '85 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962994790699',
	},
	{
		sizeLabel: '90 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '911297932931',
	},
	{
		sizeLabel: '95 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380253932183',
	},
	{
		sizeLabel: '115 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106712860163',
	},
	{
		sizeLabel: '100 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '905403032430',
	},
	{
		sizeLabel: '1-3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765869714253',
	},
	{
		sizeLabel: '21-22 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071014950541',
	},
	{
		sizeLabel: '220-233 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965405439552',
	},
	{
		sizeLabel: 'I (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343623859367',
	},
	{
		sizeLabel: '34-36 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812253714664',
	},
	{
		sizeLabel: '38-39 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341997805668',
	},
	{
		sizeLabel: '23-24 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271978604715',
	},
	{
		sizeLabel: '240-246 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '509155482314',
	},
	{
		sizeLabel: 'II (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935587524218',
	},
	{
		sizeLabel: '37-38 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '195473260797',
	},
	{
		sizeLabel: '40-41 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963353858964',
	},
	{
		sizeLabel: '6 ½-7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489819578883',
	},
	{
		sizeLabel: '25-26 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '850336150912',
	},
	{
		sizeLabel: '253-260 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684922760842',
	},
	{
		sizeLabel: 'III (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977265125666',
	},
	{
		sizeLabel: '39-40 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442328975252',
	},
	{
		sizeLabel: '42-43 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232022777712',
	},
	{
		sizeLabel: '42-43 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883917577813',
	},
	{
		sizeLabel: '27-28 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '586687283600',
	},
	{
		sizeLabel: '266-273 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136780710154',
	},
	{
		sizeLabel: 'IV (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436412170697',
	},
	{
		sizeLabel: '41-42 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383992035753',
	},
	{
		sizeLabel: '220-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740538941463',
	},
	{
		sizeLabel: '220-86 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964409558488',
	},
	{
		sizeLabel: '225-85 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '586407943259',
	},
	{
		sizeLabel: '230-88 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '648429887122',
	},
	{
		sizeLabel: '240-92 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '124338725931',
	},
	{
		sizeLabel: '245-93 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690002820518',
	},
	{
		sizeLabel: '250-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631215924407',
	},
	{
		sizeLabel: '250-95 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329580011858',
	},
	{
		sizeLabel: '260-95 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470872687995',
	},
	{
		sizeLabel: '265-96 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030758144270',
	},
	{
		sizeLabel: 'XPP (34) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677900139847',
	},
	{
		sizeLabel: 'PP (36) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685413720570',
	},
	{
		sizeLabel: 'P (38) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297665313290',
	},
	{
		sizeLabel: 'M (40) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748800252900',
	},
	{
		sizeLabel: 'M (42) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400291442777',
	},
	{
		sizeLabel: 'G (44) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510265512541',
	},
	{
		sizeLabel: 'G (46) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664615716987',
	},
	{
		sizeLabel: 'GG (48) (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '252969816987',
	},
	{
		sizeLabel: '24-24S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742302760442',
	},
	{
		sizeLabel: '33-44 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '703496811482',
	},
	{
		sizeLabel: '32-34 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667715148930',
	},
	{
		sizeLabel: '25-25S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '783924925916',
	},
	{
		sizeLabel: '26-26S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924906755572',
	},
	{
		sizeLabel: '27-27S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910336087901',
	},
	{
		sizeLabel: '36-38 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937408442711',
	},
	{
		sizeLabel: '28-28S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791868927725',
	},
	{
		sizeLabel: '29-29S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227338262492',
	},
	{
		sizeLabel: '66-77 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666766090689',
	},
	{
		sizeLabel: '38-40 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '679230756837',
	},
	{
		sizeLabel: '30-30S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449633886266',
	},
	{
		sizeLabel: '77-88 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '531710975998',
	},
	{
		sizeLabel: '40-42 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827550443610',
	},
	{
		sizeLabel: '31-31S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985564014767',
	},
	{
		sizeLabel: '32-32S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '883566834301',
	},
	{
		sizeLabel: '88-99 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024075220583',
	},
	{
		sizeLabel: '42-44 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084843575236',
	},
	{
		sizeLabel: '33-33S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798889516384',
	},
	{
		sizeLabel: '60 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206750908003',
	},
	{
		sizeLabel: '145-73A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050911642222',
	},
	{
		sizeLabel: '65 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967495335125',
	},
	{
		sizeLabel: '70 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798019278255',
	},
	{
		sizeLabel: '75 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157894677801',
	},
	{
		sizeLabel: '80 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776623442799',
	},
	{
		sizeLabel: '85 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574160267474',
	},
	{
		sizeLabel: '78 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '926956492737',
	},
	{
		sizeLabel: '80 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808800217497',
	},
	{
		sizeLabel: '82 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074561250885',
	},
	{
		sizeLabel: '05-07',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '768646414858',
	},
	{
		sizeLabel: '6-7',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533881734420',
	},
	{
		sizeLabel: '3-4 M-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934961541288',
	},
	{
		sizeLabel: '8SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408482688440',
	},
	{
		sizeLabel: '9-10SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079512874594',
	},
	{
		sizeLabel: '233 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400494502496',
	},
	{
		sizeLabel: '268 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060247548766',
	},
	{
		sizeLabel: '288 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657566647740',
	},
	{
		sizeLabel: '293 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079343589094',
	},
	{
		sizeLabel: '33 ½ (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887712357949',
	},
	{
		sizeLabel: '6 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858926401250',
	},
	{
		sizeLabel: '6 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558254754158',
	},
	{
		sizeLabel: '8 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933950891620',
	},
	{
		sizeLabel: '8 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186902238110',
	},
	{
		sizeLabel: '10 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796190452361',
	},
	{
		sizeLabel: '10 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605952372988',
	},
	{
		sizeLabel: '12 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '634155135148',
	},
	{
		sizeLabel: '12 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664730264736',
	},
	{
		sizeLabel: '14 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '495501598169',
	},
	{
		sizeLabel: '14 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '043118906223',
	},
	{
		sizeLabel: '16 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987550839574',
	},
	{
		sizeLabel: '16 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504513349415',
	},
	{
		sizeLabel: '18 REGULAR (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845083727692',
	},
	{
		sizeLabel: '18 LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085080717029',
	},
	{
		sizeLabel: '28 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '216367488942',
	},
	{
		sizeLabel: '28 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734567515160',
	},
	{
		sizeLabel: '30 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321198395154',
	},
	{
		sizeLabel: '30 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625183069153',
	},
	{
		sizeLabel: '32 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '198819561878',
	},
	{
		sizeLabel: '32 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447071812396',
	},
	{
		sizeLabel: '34 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '325434900251',
	},
	{
		sizeLabel: '34 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '948590141393',
	},
	{
		sizeLabel: '36 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994182293116',
	},
	{
		sizeLabel: '36 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909617432389',
	},
	{
		sizeLabel: '38 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '217001790112',
	},
	{
		sizeLabel: '38 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045390301732',
	},
	{
		sizeLabel: '40 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775830485233',
	},
	{
		sizeLabel: '40 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807268099596',
	},
	{
		sizeLabel: '30E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823946949249',
	},
	{
		sizeLabel: '30F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988667174027',
	},
	{
		sizeLabel: '30G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922854615026',
	},
	{
		sizeLabel: '30H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117910562201',
	},
	{
		sizeLabel: '32F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621276331205',
	},
	{
		sizeLabel: '32G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428488003406',
	},
	{
		sizeLabel: '32H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254299292203',
	},
	{
		sizeLabel: '34F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020551207728',
	},
	{
		sizeLabel: '34G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322949062153',
	},
	{
		sizeLabel: '34H',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983059501970',
	},
	{
		sizeLabel: '31-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299155943675',
	},
	{
		sizeLabel: '1-1 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769237814767',
	},
	{
		sizeLabel: '2-2 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915542181498',
	},
	{
		sizeLabel: '2 ½-3 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '217412524380',
	},
	{
		sizeLabel: '3 ½-4 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938185438718',
	},
	{
		sizeLabel: '1-2 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '665781558836',
	},
	{
		sizeLabel: '2-3 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007611432657',
	},
	{
		sizeLabel: '4 ½-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697526488421',
	},
	{
		sizeLabel: '8-9 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '895532313070',
	},
	{
		sizeLabel: '9-10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181713627678',
	},
	{
		sizeLabel: '10 ½-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368937666548',
	},
	{
		sizeLabel: '11 ½-13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440928691194',
	},
	{
		sizeLabel: '3-4 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271915076688',
	},
	{
		sizeLabel: '10-11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980685736115',
	},
	{
		sizeLabel: '12 ½-14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951996697202',
	},
	{
		sizeLabel: '3 ½-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '495221389179',
	},
	{
		sizeLabel: '120 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '454650304515',
	},
	{
		sizeLabel: 'XXS-XS (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197727028416',
	},
	{
		sizeLabel: 'XS-S (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934167471362',
	},
	{
		sizeLabel: 'S-M (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254215843644',
	},
	{
		sizeLabel: 'M-L (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022839872239',
	},
	{
		sizeLabel: 'L-XL (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730258026948',
	},
	{
		sizeLabel: 'XL-XXL (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875827748224',
	},
	{
		sizeLabel: 'XXL-XXXL (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724580840968',
	},
	{
		sizeLabel: '180-79A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855232084587',
	},
	{
		sizeLabel: '180-83A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881132506052',
	},
	{
		sizeLabel: '185-87A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455589391324',
	},
	{
		sizeLabel: '185-91A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788819138036',
	},
	{
		sizeLabel: '185-95A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842427044344',
	},
	{
		sizeLabel: '190-99A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994331539076',
	},
	{
		sizeLabel: '190-103A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049285844628',
	},
	{
		sizeLabel: '24 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673450562534',
	},
	{
		sizeLabel: '25 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825859672408',
	},
	{
		sizeLabel: '25 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115108307537',
	},
	{
		sizeLabel: '26 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544795429142',
	},
	{
		sizeLabel: '26 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788403075312',
	},
	{
		sizeLabel: '27 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901985801556',
	},
	{
		sizeLabel: '27 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '587007225423',
	},
	{
		sizeLabel: '28 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867014261517',
	},
	{
		sizeLabel: '29 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732234522188',
	},
	{
		sizeLabel: '29 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678720608476',
	},
	{
		sizeLabel: '30 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196650621791',
	},
	{
		sizeLabel: '31 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '426861351760',
	},
	{
		sizeLabel: '32 ½ (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985086141772',
	},
	{
		sizeLabel: '190-108A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791368526862',
	},
	{
		sizeLabel: '190-112A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418892607858',
	},
	{
		sizeLabel: '8 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598380119804',
	},
	{
		sizeLabel: '6.6',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130992544728',
	},
	{
		sizeLabel: '6.8',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685926929582',
	},
	{
		sizeLabel: '6.9',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '925838477230',
	},
	{
		sizeLabel: '7-7.1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832802793580',
	},
	{
		sizeLabel: '7.2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605359045955',
	},
	{
		sizeLabel: '7.4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815165833450',
	},
	{
		sizeLabel: '7.6',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452103239105',
	},
	{
		sizeLabel: '7.8',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751340717456',
	},
	{
		sizeLabel: '7.9',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769574000218',
	},
	{
		sizeLabel: '26 REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197696635736',
	},
	{
		sizeLabel: '26 LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878898190147',
	},
	{
		sizeLabel: '2XL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874199950593',
	},
	{
		sizeLabel: '3XL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523696848836',
	},
	{
		sizeLabel: '3XL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507150387222',
	},
	{
		sizeLabel: 'KID S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084441326550',
	},
	{
		sizeLabel: 'KID M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678453847335',
	},
	{
		sizeLabel: 'KID L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756444500564',
	},
	{
		sizeLabel: '4-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712512381308',
	},
	{
		sizeLabel: '74 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877502754500',
	},
	{
		sizeLabel: '76 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999182412114',
	},
	{
		sizeLabel: '78 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664163878165',
	},
	{
		sizeLabel: '82 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298524049973',
	},
	{
		sizeLabel: '24-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766567122381',
	},
	{
		sizeLabel: '24-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '820621226575',
	},
	{
		sizeLabel: '24-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400002064050',
	},
	{
		sizeLabel: '24-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887788806799',
	},
	{
		sizeLabel: '25-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693628142240',
	},
	{
		sizeLabel: '25-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912408160713',
	},
	{
		sizeLabel: '26-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411396515303',
	},
	{
		sizeLabel: '26-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '577828416873',
	},
	{
		sizeLabel: '27-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999031326820',
	},
	{
		sizeLabel: '27-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '501983416421',
	},
	{
		sizeLabel: '28-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422851047654',
	},
	{
		sizeLabel: '29-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827690441554',
	},
	{
		sizeLabel: '30-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574459754504',
	},
	{
		sizeLabel: '31-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715684850052',
	},
	{
		sizeLabel: '32-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970245790983',
	},
	{
		sizeLabel: '33-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115916864603',
	},
	{
		sizeLabel: '34-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202091549797',
	},
	{
		sizeLabel: '35-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885722619008',
	},
	{
		sizeLabel: '40-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295056679215',
	},
	{
		sizeLabel: '42-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585216144644',
	},
	{
		sizeLabel: '44-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879085377394',
	},
	{
		sizeLabel: '46-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '940999936838',
	},
	{
		sizeLabel: '48-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481509790062',
	},
	{
		sizeLabel: '48-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '432028624530',
	},
	{
		sizeLabel: '50-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322360934279',
	},
	{
		sizeLabel: '52-40',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030337654975',
	},
	{
		sizeLabel: '37-40 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '905238296281',
	},
	{
		sizeLabel: '7-9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '105400291745',
	},
	{
		sizeLabel: '9-11 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661082157767',
	},
	{
		sizeLabel: '9 ½-11 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '867167389687',
	},
	{
		sizeLabel: '11 ½-13 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '186726591267',
	},
	{
		sizeLabel: '5-7 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573554254674',
	},
	{
		sizeLabel: '10 ½-12 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085330869977',
	},
	{
		sizeLabel: '30DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681605099671',
	},
	{
		sizeLabel: '65DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '271153827201',
	},
	{
		sizeLabel: '80DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259357942372',
	},
	{
		sizeLabel: '32DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628971707449',
	},
	{
		sizeLabel: '85DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372616450338',
	},
	{
		sizeLabel: '34DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '047095228486',
	},
	{
		sizeLabel: '90DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '498718073929',
	},
	{
		sizeLabel: '36DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '465440801695',
	},
	{
		sizeLabel: '95DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '905038187578',
	},
	{
		sizeLabel: '38DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187623509777',
	},
	{
		sizeLabel: '100DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '808892711928',
	},
	{
		sizeLabel: '40DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961360889621',
	},
	{
		sizeLabel: '105DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173217058270',
	},
	{
		sizeLabel: '42DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '264566515027',
	},
	{
		sizeLabel: '95DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959982908964',
	},
	{
		sizeLabel: '110DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224302567550',
	},
	{
		sizeLabel: '44DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '423202463703',
	},
	{
		sizeLabel: '100DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '254725208242',
	},
	{
		sizeLabel: '115DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941276776411',
	},
	{
		sizeLabel: '46DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822036661534',
	},
	{
		sizeLabel: '105DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346060643926',
	},
	{
		sizeLabel: '120DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630186825345',
	},
	{
		sizeLabel: '48DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189077612052',
	},
	{
		sizeLabel: '110DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241959002942',
	},
	{
		sizeLabel: '125DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038361763444',
	},
	{
		sizeLabel: '50DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396385353600',
	},
	{
		sizeLabel: '115DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '260968731763',
	},
	{
		sizeLabel: '130DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '767952144866',
	},
	{
		sizeLabel: '52DD-E (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '143853467982',
	},
	{
		sizeLabel: '120DD-E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959399688704',
	},
	{
		sizeLabel: '135DD-E (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530700433484',
	},
	{
		sizeLabel: '1XLT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161638520707',
	},
	{
		sizeLabel: 'JUNIOR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149915517093',
	},
	{
		sizeLabel: 'YOUTH',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312072946841',
	},
	{
		sizeLabel: '3XL+',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '579407804714',
	},
	{
		sizeLabel: '4 (XS)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995228961469',
	},
	{
		sizeLabel: '6 (S)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223599365089',
	},
	{
		sizeLabel: '8 (M)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '869261545251',
	},
	{
		sizeLabel: '8T (MT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '910653568370',
	},
	{
		sizeLabel: '10 (L)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451102844558',
	},
	{
		sizeLabel: '10T (LT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402949555605',
	},
	{
		sizeLabel: '12 (XL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608562671450',
	},
	{
		sizeLabel: '12T (XLT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279238900117',
	},
	{
		sizeLabel: '14 (XXL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084329725468',
	},
	{
		sizeLabel: '8 ⅛',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906157616871',
	},
	{
		sizeLabel: 'ONE SIZE FIT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599244364857',
	},
	{
		sizeLabel: '44FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862082976454',
	},
	{
		sizeLabel: '46FF (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088102713626',
	},
	{
		sizeLabel: '4S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734637126072',
	},
	{
		sizeLabel: '0S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '796464523777',
	},
	{
		sizeLabel: '4R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916601088979',
	},
	{
		sizeLabel: '0R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267182558432',
	},
	{
		sizeLabel: '4L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '476534808182',
	},
	{
		sizeLabel: '0L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775506293159',
	},
	{
		sizeLabel: '6S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212410945693',
	},
	{
		sizeLabel: '2S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '584768078319',
	},
	{
		sizeLabel: '6R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519942887019',
	},
	{
		sizeLabel: '2R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400772236954',
	},
	{
		sizeLabel: '6L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '916448368244',
	},
	{
		sizeLabel: '2L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '753827242467',
	},
	{
		sizeLabel: '8S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441440738040',
	},
	{
		sizeLabel: '4S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175972353722',
	},
	{
		sizeLabel: '8R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388689381043',
	},
	{
		sizeLabel: '4R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452234794356',
	},
	{
		sizeLabel: '8L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572021291683',
	},
	{
		sizeLabel: '4L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '136149092020',
	},
	{
		sizeLabel: '10S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467909301961',
	},
	{
		sizeLabel: '6S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238263330385',
	},
	{
		sizeLabel: '10R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238639149170',
	},
	{
		sizeLabel: '6R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483035123554',
	},
	{
		sizeLabel: '10L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611283479567',
	},
	{
		sizeLabel: '6L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372130550510',
	},
	{
		sizeLabel: '12S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921824628426',
	},
	{
		sizeLabel: '8S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046157398638',
	},
	{
		sizeLabel: '12R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070571095577',
	},
	{
		sizeLabel: '8R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248885462493',
	},
	{
		sizeLabel: '12L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673605809717',
	},
	{
		sizeLabel: '8L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990435017512',
	},
	{
		sizeLabel: '14S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510181799906',
	},
	{
		sizeLabel: '10S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515710108033',
	},
	{
		sizeLabel: '14R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '937613340887',
	},
	{
		sizeLabel: '10R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '080101427607',
	},
	{
		sizeLabel: '14L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '358817053140',
	},
	{
		sizeLabel: '10L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322959163769',
	},
	{
		sizeLabel: '16S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456497878483',
	},
	{
		sizeLabel: '12S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '502771042341',
	},
	{
		sizeLabel: '16R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457716243717',
	},
	{
		sizeLabel: '12R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196461160850',
	},
	{
		sizeLabel: '16L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061427197902',
	},
	{
		sizeLabel: '12L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411929334185',
	},
	{
		sizeLabel: '18S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510543646476',
	},
	{
		sizeLabel: '14S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011423257768',
	},
	{
		sizeLabel: '18R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827889686828',
	},
	{
		sizeLabel: '14R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362684842758',
	},
	{
		sizeLabel: '18L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980820244321',
	},
	{
		sizeLabel: '14L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067379439759',
	},
	{
		sizeLabel: '20S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785972409857',
	},
	{
		sizeLabel: '48S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224379361322',
	},
	{
		sizeLabel: '16S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699525706871',
	},
	{
		sizeLabel: '20R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890583181778',
	},
	{
		sizeLabel: '48R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557875736400',
	},
	{
		sizeLabel: '16R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974988708053',
	},
	{
		sizeLabel: '20L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022216668433',
	},
	{
		sizeLabel: '48L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814679348140',
	},
	{
		sizeLabel: '16L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '898569985628',
	},
	{
		sizeLabel: '22S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354303115946',
	},
	{
		sizeLabel: '50S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085360408322',
	},
	{
		sizeLabel: '18S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '824135223579',
	},
	{
		sizeLabel: '22R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842791719497',
	},
	{
		sizeLabel: '50R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410266159077',
	},
	{
		sizeLabel: '18R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '031025518291',
	},
	{
		sizeLabel: '22L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408984377525',
	},
	{
		sizeLabel: '50L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929624180802',
	},
	{
		sizeLabel: '18L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179263180762',
	},
	{
		sizeLabel: '24R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '687232641427',
	},
	{
		sizeLabel: '24R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998138258121',
	},
	{
		sizeLabel: '26R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214721215419',
	},
	{
		sizeLabel: '26R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711545953986',
	},
	{
		sizeLabel: '28R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356797039039',
	},
	{
		sizeLabel: '30S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889530089908',
	},
	{
		sizeLabel: '40 S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479924857909',
	},
	{
		sizeLabel: '30R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845995548511',
	},
	{
		sizeLabel: '30L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '831199734315',
	},
	{
		sizeLabel: '44S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314235480305',
	},
	{
		sizeLabel: '46R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '277573004030',
	},
	{
		sizeLabel: '50R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605205159622',
	},
	{
		sizeLabel: '52R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980551657492',
	},
	{
		sizeLabel: '54R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091216563164',
	},
	{
		sizeLabel: '56R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823222784062',
	},
	{
		sizeLabel: '24S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550288665001',
	},
	{
		sizeLabel: '52S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '966932107626',
	},
	{
		sizeLabel: '20S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651386361682',
	},
	{
		sizeLabel: '52R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '636964480260',
	},
	{
		sizeLabel: '20R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471110703862',
	},
	{
		sizeLabel: '24L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '194215437715',
	},
	{
		sizeLabel: '52L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '882962274466',
	},
	{
		sizeLabel: '20L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582840387198',
	},
	{
		sizeLabel: '26S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591904152154',
	},
	{
		sizeLabel: '54S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759392354785',
	},
	{
		sizeLabel: '22S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942953708064',
	},
	{
		sizeLabel: '54R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '338054638065',
	},
	{
		sizeLabel: '22R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435573392202',
	},
	{
		sizeLabel: '26L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931104764975',
	},
	{
		sizeLabel: '54L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700604019842',
	},
	{
		sizeLabel: '22L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108070771983',
	},
	{
		sizeLabel: '56S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146860860379',
	},
	{
		sizeLabel: '24S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403558535013',
	},
	{
		sizeLabel: '56R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103544622532',
	},
	{
		sizeLabel: '24R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '724631605857',
	},
	{
		sizeLabel: '56L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '024007148305',
	},
	{
		sizeLabel: '24L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410967762322',
	},
	{
		sizeLabel: '58S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165083799003',
	},
	{
		sizeLabel: '26S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887043016507',
	},
	{
		sizeLabel: '58R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400174310637',
	},
	{
		sizeLabel: '26R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '386066113658',
	},
	{
		sizeLabel: '58L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '206992328023',
	},
	{
		sizeLabel: '26L (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '066508805655',
	},
	{
		sizeLabel: '28S (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '675165303732',
	},
	{
		sizeLabel: '19 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797706460772',
	},
	{
		sizeLabel: '20 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404320916538',
	},
	{
		sizeLabel: '54 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713245819294',
	},
	{
		sizeLabel: '21 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616685826725',
	},
	{
		sizeLabel: '21 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390651784693',
	},
	{
		sizeLabel: '55 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734485754227',
	},
	{
		sizeLabel: '22 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474487051565',
	},
	{
		sizeLabel: '56 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890525472900',
	},
	{
		sizeLabel: '38-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934354271550',
	},
	{
		sizeLabel: '40-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343429816933',
	},
	{
		sizeLabel: '42-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755850436665',
	},
	{
		sizeLabel: '0-0 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112621710938',
	},
	{
		sizeLabel: '1-1 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472379534990',
	},
	{
		sizeLabel: '0 ½-1 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441402299743',
	},
	{
		sizeLabel: '1 ½-2 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568959065893',
	},
	{
		sizeLabel: '2 ½-3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '094538895231',
	},
	{
		sizeLabel: '3-4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706052124764',
	},
	{
		sizeLabel: '3 ½-4 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367775642487',
	},
	{
		sizeLabel: '4 ½-5 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519719863510',
	},
	{
		sizeLabel: '4 ½-5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303382983142',
	},
	{
		sizeLabel: '5 ½-6 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960753949345',
	},
	{
		sizeLabel: '7 ½-8 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '110909179955',
	},
	{
		sizeLabel: '7 ½-8 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267391068569',
	},
	{
		sizeLabel: '15-15 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '582670023805',
	},
	{
		sizeLabel: '15 ½-16 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120825475372',
	},
	{
		sizeLabel: '16 ½-17 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841527693663',
	},
	{
		sizeLabel: '6.25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548336636411',
	},
	{
		sizeLabel: '6S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549820030478',
	},
	{
		sizeLabel: '6T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311936679525',
	},
	{
		sizeLabel: '8S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '101148793965',
	},
	{
		sizeLabel: '8T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '549310002843',
	},
	{
		sizeLabel: '10S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '482152438241',
	},
	{
		sizeLabel: '10T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810704389848',
	},
	{
		sizeLabel: 'SS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '966237142000',
	},
	{
		sizeLabel: '37-38 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '510695372281',
	},
	{
		sizeLabel: '38E-DDD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381724800006',
	},
	{
		sizeLabel: '38E-DDD (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957878237143',
	},
	{
		sizeLabel: '22-23 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669493639149',
	},
	{
		sizeLabel: '33 ½-34 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096456954726',
	},
	{
		sizeLabel: '23 ½-25 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545206707844',
	},
	{
		sizeLabel: '36-37 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453035856174',
	},
	{
		sizeLabel: '6 ½-7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '229244782830',
	},
	{
		sizeLabel: '8 ½-9 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020672413641',
	},
	{
		sizeLabel: '38-39 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347627138287',
	},
	{
		sizeLabel: '40-41 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075170522439',
	},
	{
		sizeLabel: '37 ½-39 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782579217034',
	},
	{
		sizeLabel: '39 ½-41 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971344153311',
	},
	{
		sizeLabel: '28-29 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '870699032812',
	},
	{
		sizeLabel: '41 ½-42 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '720275401497',
	},
	{
		sizeLabel: '11 ½-12 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918383546788',
	},
	{
		sizeLabel: '12 ½-13 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832246200937',
	},
	{
		sizeLabel: '31-32 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '266675001436',
	},
	{
		sizeLabel: '46-47 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314502025712',
	},
	{
		sizeLabel: '35-37 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181987827150',
	},
	{
		sizeLabel: '230',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524929248942',
	},
	{
		sizeLabel: '235',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '285349590774',
	},
	{
		sizeLabel: '240',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397082235918',
	},
	{
		sizeLabel: '242',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '142633264442',
	},
	{
		sizeLabel: '245',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099628682266',
	},
	{
		sizeLabel: '250',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601329780277',
	},
	{
		sizeLabel: '252',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921282260890',
	},
	{
		sizeLabel: '255',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '774681147616',
	},
	{
		sizeLabel: '265',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596100552907',
	},
	{
		sizeLabel: '267',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '927349169291',
	},
	{
		sizeLabel: '270',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223055117029',
	},
	{
		sizeLabel: '275',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618974786598',
	},
	{
		sizeLabel: '280',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '706533827530',
	},
	{
		sizeLabel: '285',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362413257879',
	},
	{
		sizeLabel: '290',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '120033724877',
	},
	{
		sizeLabel: '292',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '801213499004',
	},
	{
		sizeLabel: '295',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135639191725',
	},
	{
		sizeLabel: '305',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863380129186',
	},
	{
		sizeLabel: '307',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '541071900245',
	},
	{
		sizeLabel: '310',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412228623047',
	},
	{
		sizeLabel: '312',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '234786342634',
	},
	{
		sizeLabel: '315',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759777154070',
	},
	{
		sizeLabel: '325',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982529937597',
	},
	{
		sizeLabel: '327',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '405509744609',
	},
	{
		sizeLabel: '50.1 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487536571154',
	},
	{
		sizeLabel: '330',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '214984710709',
	},
	{
		sizeLabel: '36-37 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '153171503997',
	},
	{
		sizeLabel: '38-39 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900925465861',
	},
	{
		sizeLabel: '40-41 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649221159904',
	},
	{
		sizeLabel: '80B-C (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '243877245578',
	},
	{
		sizeLabel: 'W26L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288827916277',
	},
	{
		sizeLabel: 'W27L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196106002246',
	},
	{
		sizeLabel: 'W28L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361810222817',
	},
	{
		sizeLabel: 'W29L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676335036819',
	},
	{
		sizeLabel: 'W30L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868906432289',
	},
	{
		sizeLabel: 'W31L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116725355989',
	},
	{
		sizeLabel: 'W25L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450324508555',
	},
	{
		sizeLabel: 'W32L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410832383984',
	},
	{
		sizeLabel: 'W33 L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533734289511',
	},
	{
		sizeLabel: 'W34L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016135952604',
	},
	{
		sizeLabel: 'W28L32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709262562562',
	},
	{
		sizeLabel: 'W29L32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '417731985457',
	},
	{
		sizeLabel: 'W36L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915417789309',
	},
	{
		sizeLabel: 'W38L32-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230838964758',
	},
	{
		sizeLabel: 'W26L32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '718957560033',
	},
	{
		sizeLabel: 'W27L32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506841570727',
	},
	{
		sizeLabel: 'W30L32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573045199243',
	},
	{
		sizeLabel: 'W25 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034205923172',
	},
	{
		sizeLabel: 'W26 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '491024734360',
	},
	{
		sizeLabel: 'W27 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '788579837720',
	},
	{
		sizeLabel: 'W28 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222196017988',
	},
	{
		sizeLabel: 'W29 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657892591536',
	},
	{
		sizeLabel: 'W30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613182268053',
	},
	{
		sizeLabel: 'W31 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '104215923622',
	},
	{
		sizeLabel: 'W32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '716075748061',
	},
	{
		sizeLabel: 'W33 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686319861760',
	},
	{
		sizeLabel: 'W34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020997138285',
	},
	{
		sizeLabel: '23-24 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279263476833',
	},
	{
		sizeLabel: '25-26 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418016961938',
	},
	{
		sizeLabel: '39-41 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532953291995',
	},
	{
		sizeLabel: '15 ½-15 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683576961298',
	},
	{
		sizeLabel: '43-44 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049403969188',
	},
	{
		sizeLabel: '18-18 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '816411627459',
	},
	{
		sizeLabel: '45-46 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '793526151044',
	},
	{
		sizeLabel: '8 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391803562661',
	},
	{
		sizeLabel: '9 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456994816532',
	},
	{
		sizeLabel: '100-105',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736439781135',
	},
	{
		sizeLabel: '110-115',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013099686562',
	},
	{
		sizeLabel: '120-125',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '199302115669',
	},
	{
		sizeLabel: '52-56 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479620500746',
	},
	{
		sizeLabel: '62-66 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '037376946280',
	},
	{
		sizeLabel: '68-72 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773313502564',
	},
	{
		sizeLabel: '54-55 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '015524628210',
	},
	{
		sizeLabel: '56-57 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '932667511159',
	},
	{
		sizeLabel: '58-59 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446551141750',
	},
	{
		sizeLabel: '60-61 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826673624640',
	},
	{
		sizeLabel: '62-63 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262549746879',
	},
	{
		sizeLabel: '64-65 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469147326788',
	},
	{
		sizeLabel: '2(S)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '627902100004',
	},
	{
		sizeLabel: '3(M)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799286405770',
	},
	{
		sizeLabel: '4(L)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707105529907',
	},
	{
		sizeLabel: '1-3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714903147378',
	},
	{
		sizeLabel: '5-7',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '428051741814',
	},
	{
		sizeLabel: '9-11',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '275920041732',
	},
	{
		sizeLabel: 'XS(44)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859616556105',
	},
	{
		sizeLabel: 'S(46)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '972186461806',
	},
	{
		sizeLabel: 'M(48)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799301939823',
	},
	{
		sizeLabel: 'L(50)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956514938174',
	},
	{
		sizeLabel: 'XL(52)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201177904920',
	},
	{
		sizeLabel: 'XXL(54)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988816000910',
	},
	{
		sizeLabel: 'XXXL(56)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375450288653',
	},
	{
		sizeLabel: '4XL(58)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928721892741',
	},
	{
		sizeLabel: '53 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918984097023',
	},
	{
		sizeLabel: '5XL(60)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503495295899',
	},
	{
		sizeLabel: '180-86A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945305741816',
	},
	{
		sizeLabel: '185-90A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988397123151',
	},
	{
		sizeLabel: '185-94B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082632080131',
	},
	{
		sizeLabel: '185-98-B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461771667473',
	},
	{
		sizeLabel: 'P (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963896902797',
	},
	{
		sizeLabel: 'N (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894232686796',
	},
	{
		sizeLabel: '4B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215145419742',
	},
	{
		sizeLabel: '4C (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227138311768',
	},
	{
		sizeLabel: '4D (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161830443394',
	},
	{
		sizeLabel: '4E (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327268522586',
	},
	{
		sizeLabel: '4D (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638723728906',
	},
	{
		sizeLabel: '18B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '985112952423',
	},
	{
		sizeLabel: '50B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710780746430',
	},
	{
		sizeLabel: '18C (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623873710266',
	},
	{
		sizeLabel: '50C (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311748660145',
	},
	{
		sizeLabel: '20B (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239532134350',
	},
	{
		sizeLabel: '16B (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182456244619',
	},
	{
		sizeLabel: '52B (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335786080073',
	},
	{
		sizeLabel: '33 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921530820004',
	},
	{
		sizeLabel: '34 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657656395472',
	},
	{
		sizeLabel: '36 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160846349327',
	},
	{
		sizeLabel: '38 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945629905656',
	},
	{
		sizeLabel: '40 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '239027033030',
	},
	{
		sizeLabel: '42 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '090829100516',
	},
	{
		sizeLabel: '44 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '907525929405',
	},
	{
		sizeLabel: '46 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410574525773',
	},
	{
		sizeLabel: '48 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933827206436',
	},
	{
		sizeLabel: '16 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947537721740',
	},
	{
		sizeLabel: '17 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '497961844521',
	},
	{
		sizeLabel: '17 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499612024136',
	},
	{
		sizeLabel: '28R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642750242214',
	},
	{
		sizeLabel: '28L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654873242243',
	},
	{
		sizeLabel: '29S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '433601091525',
	},
	{
		sizeLabel: '29R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708108979675',
	},
	{
		sizeLabel: '29L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877478507714',
	},
	{
		sizeLabel: '30R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474391481248',
	},
	{
		sizeLabel: '31S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356645574321',
	},
	{
		sizeLabel: '31R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055521691158',
	},
	{
		sizeLabel: '31L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550220614245',
	},
	{
		sizeLabel: '32R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '780106544140',
	},
	{
		sizeLabel: '33S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050314804009',
	},
	{
		sizeLabel: '33R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255774742522',
	},
	{
		sizeLabel: '33L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292225050637',
	},
	{
		sizeLabel: '34R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175239602194',
	},
	{
		sizeLabel: '36R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '374272004218',
	},
	{
		sizeLabel: '38R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778336935028',
	},
	{
		sizeLabel: '22-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '670366921561',
	},
	{
		sizeLabel: '32-33-30',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292091155276',
	},
	{
		sizeLabel: '32-33-32',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '441018937952',
	},
	{
		sizeLabel: '32-33-34',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '157890829404',
	},
	{
		sizeLabel: 'VII',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335392278183',
	},
	{
		sizeLabel: 'A0',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494876819018',
	},
	{
		sizeLabel: 'A1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176366486707',
	},
	{
		sizeLabel: 'A1L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '958481733885',
	},
	{
		sizeLabel: 'A2S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '378259351251',
	},
	{
		sizeLabel: 'A2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755366533108',
	},
	{
		sizeLabel: 'A2L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '747910040762',
	},
	{
		sizeLabel: 'A2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779101313214',
	},
	{
		sizeLabel: 'A3S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295350869877',
	},
	{
		sizeLabel: 'A3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070216107766',
	},
	{
		sizeLabel: 'A4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578843687944',
	},
	{
		sizeLabel: '150-76A-155 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935725561395',
	},
	{
		sizeLabel: '160-84A-165 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652708585971',
	},
	{
		sizeLabel: '170-92A-175 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438722239645',
	},
	{
		sizeLabel: '175-96A-180 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733910193045',
	},
	{
		sizeLabel: '180-100A-185 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '135060904612',
	},
	{
		sizeLabel: '1-2-S-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196187905430',
	},
	{
		sizeLabel: '3-4-M-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975085483543',
	},
	{
		sizeLabel: '1-XS (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191253235013',
	},
	{
		sizeLabel: '1-XS (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '976080529914',
	},
	{
		sizeLabel: '2-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '603511910078',
	},
	{
		sizeLabel: '2-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292701711895',
	},
	{
		sizeLabel: '3-M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '738767475817',
	},
	{
		sizeLabel: '3-M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '486115489429',
	},
	{
		sizeLabel: '4-L-4XL (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621495456497',
	},
	{
		sizeLabel: '4-L-4XL (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '536732144190',
	},
	{
		sizeLabel: '5-XL-5XL (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321604261307',
	},
	{
		sizeLabel: '48-52 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900130715961',
	},
	{
		sizeLabel: '5-XL-5XL (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334042578269',
	},
	{
		sizeLabel: '32-42 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '073420104278',
	},
	{
		sizeLabel: 'S-M-2-3 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554964424398',
	},
	{
		sizeLabel: '40-44 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '221244572937',
	},
	{
		sizeLabel: '2-3-S-M (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815796322448',
	},
	{
		sizeLabel: '42-48 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998449397340',
	},
	{
		sizeLabel: '4-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056243457903',
	},
	{
		sizeLabel: '4-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '751035070647',
	},
	{
		sizeLabel: '36-42 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631846777850',
	},
	{
		sizeLabel: 'S-M-2-3 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654784665123',
	},
	{
		sizeLabel: 'M-L 3-4 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219476541658',
	},
	{
		sizeLabel: '42-48 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575583179733',
	},
	{
		sizeLabel: 'M-L 3-4 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '481465698826',
	},
	{
		sizeLabel: '46N (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '817380432205',
	},
	{
		sizeLabel: '21 ½-22 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320452387078',
	},
	{
		sizeLabel: '49 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '983839509135',
	},
	{
		sizeLabel: '51 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '604545947532',
	},
	{
		sizeLabel: 'S SLIM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832786285805',
	},
	{
		sizeLabel: 'M SLIM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915683180888',
	},
	{
		sizeLabel: 'L SLIM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988515725346',
	},
	{
		sizeLabel: '32-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467366642015',
	},
	{
		sizeLabel: '4-8 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '383990024730',
	},
	{
		sizeLabel: 'O-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677701604466',
	},
	{
		sizeLabel: '0-12 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280673843976',
	},
	{
		sizeLabel: '46 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270094379086',
	},
	{
		sizeLabel: '48 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '132689574580',
	},
	{
		sizeLabel: '50 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138201397519',
	},
	{
		sizeLabel: '52 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523728454765',
	},
	{
		sizeLabel: '54 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722126049010',
	},
	{
		sizeLabel: '56 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702988391797',
	},
	{
		sizeLabel: '58 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567363128674',
	},
	{
		sizeLabel: '60 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730383500145',
	},
	{
		sizeLabel: '52 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '070402599045',
	},
	{
		sizeLabel: '4 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '226223636061',
	},
	{
		sizeLabel: '37 ⅔ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010579288371',
	},
	{
		sizeLabel: '4 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525712081935',
	},
	{
		sizeLabel: '38 ⅓ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625496132395',
	},
	{
		sizeLabel: '5 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '056236983576',
	},
	{
		sizeLabel: '5 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770042937639',
	},
	{
		sizeLabel: '6 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '461564652910',
	},
	{
		sizeLabel: '6 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '096302825826',
	},
	{
		sizeLabel: '40 ⅔ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315511513266',
	},
	{
		sizeLabel: '7 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610529403578',
	},
	{
		sizeLabel: '41 ⅓ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144540491851',
	},
	{
		sizeLabel: '7 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059582607977',
	},
	{
		sizeLabel: '8 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575352602479',
	},
	{
		sizeLabel: '8 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098325836624',
	},
	{
		sizeLabel: '9 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407377885718',
	},
	{
		sizeLabel: '43 ⅔ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750892441788',
	},
	{
		sizeLabel: '9 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351000284219',
	},
	{
		sizeLabel: '44 ⅓ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727361585122',
	},
	{
		sizeLabel: '10 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '698250663131',
	},
	{
		sizeLabel: '10 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '712364325128',
	},
	{
		sizeLabel: '11 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184210447409',
	},
	{
		sizeLabel: '11 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470725907494',
	},
	{
		sizeLabel: '46 ⅔ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809648328617',
	},
	{
		sizeLabel: '12 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693972572535',
	},
	{
		sizeLabel: '47 ⅓ (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227489582096',
	},
	{
		sizeLabel: '12 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418113233232',
	},
	{
		sizeLabel: '13 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833021760626',
	},
	{
		sizeLabel: '13 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '182099433082',
	},
	{
		sizeLabel: '14 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693579339486',
	},
	{
		sizeLabel: '44-46 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474159244860',
	},
	{
		sizeLabel: '48-50 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140144801103',
	},
	{
		sizeLabel: '37 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921872147026',
	},
	{
		sizeLabel: 'XS (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567107648480',
	},
	{
		sizeLabel: 'S (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438494835752',
	},
	{
		sizeLabel: 'L (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152545053754',
	},
	{
		sizeLabel: 'XL (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082668392366',
	},
	{
		sizeLabel: 'XXL (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757678709058',
	},
	{
		sizeLabel: '5 ½-6 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '369392101775',
	},
	{
		sizeLabel: '41-43',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699775238368',
	},
	{
		sizeLabel: 'S L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785589682635',
	},
	{
		sizeLabel: 'M L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346081106108',
	},
	{
		sizeLabel: 'L L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187667159139',
	},
	{
		sizeLabel: 'XL L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '614338574567',
	},
	{
		sizeLabel: '2XL L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760396546664',
	},
	{
		sizeLabel: '3XLL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '599922396538',
	},
	{
		sizeLabel: 'XS R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '355761678569',
	},
	{
		sizeLabel: 'S R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668463341212',
	},
	{
		sizeLabel: 'M R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709433477004',
	},
	{
		sizeLabel: 'L R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863548328572',
	},
	{
		sizeLabel: 'XL R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '339788542085',
	},
	{
		sizeLabel: '2XL R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '956143596671',
	},
	{
		sizeLabel: '3XL R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784731546000',
	},
	{
		sizeLabel: '4XL R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '268364559395',
	},
	{
		sizeLabel: 'S S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '536210602334',
	},
	{
		sizeLabel: 'M S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990783277374',
	},
	{
		sizeLabel: 'L S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361174603511',
	},
	{
		sizeLabel: 'ADULT WOM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803485802525',
	},
	{
		sizeLabel: 'ADULT MEN',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430828802895',
	},
	{
		sizeLabel: '3L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138349580085',
	},
	{
		sizeLabel: '30-AB (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060284075306',
	},
	{
		sizeLabel: '65-AB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280314133038',
	},
	{
		sizeLabel: '30CD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291860669522',
	},
	{
		sizeLabel: '65 CD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '813223013147',
	},
	{
		sizeLabel: '32-AB (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797925209018',
	},
	{
		sizeLabel: '70-AB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721665015717',
	},
	{
		sizeLabel: '32CD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442908539166',
	},
	{
		sizeLabel: '70CD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500230205532',
	},
	{
		sizeLabel: '34-AB (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913586081073',
	},
	{
		sizeLabel: '75-AB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886944806371',
	},
	{
		sizeLabel: '34CD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835850625209',
	},
	{
		sizeLabel: '75CD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468596106008',
	},
	{
		sizeLabel: '36-AB (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '676461825089',
	},
	{
		sizeLabel: '80-AB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029340375214',
	},
	{
		sizeLabel: '36CD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '737412858109',
	},
	{
		sizeLabel: '80CD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879600557029',
	},
	{
		sizeLabel: '38-AB (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '588706309155',
	},
	{
		sizeLabel: '85-AB (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714779780372',
	},
	{
		sizeLabel: '38CD (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127263024076',
	},
	{
		sizeLabel: '85CD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '545372544576',
	},
	{
		sizeLabel: '62 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363479165573',
	},
	{
		sizeLabel: '66 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '432439923249',
	},
	{
		sizeLabel: '32-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039413185752',
	},
	{
		sizeLabel: '34-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '779219995173',
	},
	{
		sizeLabel: '36-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382444707920',
	},
	{
		sizeLabel: '38-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881127017278',
	},
	{
		sizeLabel: '40-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408308221752',
	},
	{
		sizeLabel: '42-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450306757064',
	},
	{
		sizeLabel: '44-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '061988886303',
	},
	{
		sizeLabel: '32-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192034189895',
	},
	{
		sizeLabel: '34-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942205467684',
	},
	{
		sizeLabel: '36-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392238246832',
	},
	{
		sizeLabel: '38-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726440198628',
	},
	{
		sizeLabel: '40-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '190785424821',
	},
	{
		sizeLabel: '34-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009070851183',
	},
	{
		sizeLabel: '36-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019585230210',
	},
	{
		sizeLabel: '38-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '412359372947',
	},
	{
		sizeLabel: '40-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597451112799',
	},
	{
		sizeLabel: '36-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '942859520709',
	},
	{
		sizeLabel: '38-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310960684704',
	},
	{
		sizeLabel: '40-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '084579961634',
	},
	{
		sizeLabel: '42-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663050608550',
	},
	{
		sizeLabel: '44-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622052530856',
	},
	{
		sizeLabel: '32-33-36',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '022536484190',
	},
	{
		sizeLabel: '39 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021955010586',
	},
	{
		sizeLabel: '41 ½ (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959850034398',
	},
	{
		sizeLabel: '40 ½-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '539788736950',
	},
	{
		sizeLabel: '43-44 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802152942896',
	},
	{
		sizeLabel: '44 ½-45 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288429725392',
	},
	{
		sizeLabel: '36.6 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '376525289440',
	},
	{
		sizeLabel: 'W14 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036335045392',
	},
	{
		sizeLabel: 'BIG 1X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '287762259879',
	},
	{
		sizeLabel: 'BIG 2X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559894006958',
	},
	{
		sizeLabel: 'BIG 3X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711013135721',
	},
	{
		sizeLabel: 'BIG 4X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '380923120428',
	},
	{
		sizeLabel: 'BIG 5X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807426731636',
	},
	{
		sizeLabel: 'BIG 6X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776282143342',
	},
	{
		sizeLabel: 'TALL L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '702225912199',
	},
	{
		sizeLabel: 'TALL XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855887206085',
	},
	{
		sizeLabel: 'TALL 2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321452914859',
	},
	{
		sizeLabel: 'TALL 3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575637708581',
	},
	{
		sizeLabel: 'TALL 4XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739424245120',
	},
	{
		sizeLabel: 'XS-1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713799299583',
	},
	{
		sizeLabel: 'S-2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899861065028',
	},
	{
		sizeLabel: 'M-3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '610299042734',
	},
	{
		sizeLabel: 'L-4',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404033098570',
	},
	{
		sizeLabel: 'XL-5',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '570283807452',
	},
	{
		sizeLabel: '36S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144090521983',
	},
	{
		sizeLabel: '46 S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078391349250',
	},
	{
		sizeLabel: '36S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100528815449',
	},
	{
		sizeLabel: '38S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '681812077763',
	},
	{
		sizeLabel: '48S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846475946302',
	},
	{
		sizeLabel: '38S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513235031803',
	},
	{
		sizeLabel: '40S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '595574169862',
	},
	{
		sizeLabel: '50S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543497934003',
	},
	{
		sizeLabel: '40S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018185179657',
	},
	{
		sizeLabel: '42S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204974397041',
	},
	{
		sizeLabel: '52S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452329273486',
	},
	{
		sizeLabel: '42S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '219630422129',
	},
	{
		sizeLabel: '44S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407850177333',
	},
	{
		sizeLabel: '54S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '878120570138',
	},
	{
		sizeLabel: '44S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668070588471',
	},
	{
		sizeLabel: '46S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688045028783',
	},
	{
		sizeLabel: '56S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062534799297',
	},
	{
		sizeLabel: '46S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425160458956',
	},
	{
		sizeLabel: '48S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979176646019',
	},
	{
		sizeLabel: '58S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '677254153534',
	},
	{
		sizeLabel: '48S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756255209681',
	},
	{
		sizeLabel: '50S-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931577944746',
	},
	{
		sizeLabel: '60S-R (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246561532922',
	},
	{
		sizeLabel: '50S-R (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361810763729',
	},
	{
		sizeLabel: '40-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324704334533',
	},
	{
		sizeLabel: '42-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551851499631',
	},
	{
		sizeLabel: '44-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638036413676',
	},
	{
		sizeLabel: '46-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '272446137325',
	},
	{
		sizeLabel: '48-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '044550347452',
	},
	{
		sizeLabel: '50-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327476286218',
	},
	{
		sizeLabel: '52-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559913066232',
	},
	{
		sizeLabel: '54-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130982628420',
	},
	{
		sizeLabel: '56-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379829378470',
	},
	{
		sizeLabel: '58-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596958720881',
	},
	{
		sizeLabel: '40-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633816058477',
	},
	{
		sizeLabel: '42-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504079664004',
	},
	{
		sizeLabel: '44-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308796555914',
	},
	{
		sizeLabel: '46-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947727741348',
	},
	{
		sizeLabel: '48-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674977925852',
	},
	{
		sizeLabel: '50-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572686124385',
	},
	{
		sizeLabel: '52-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '245504393000',
	},
	{
		sizeLabel: '54-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756187754675',
	},
	{
		sizeLabel: '56-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318594517517',
	},
	{
		sizeLabel: '58-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175845991027',
	},
	{
		sizeLabel: '40-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402130951828',
	},
	{
		sizeLabel: '42-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '373007753087',
	},
	{
		sizeLabel: '44-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '976932389737',
	},
	{
		sizeLabel: '46-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319094721138',
	},
	{
		sizeLabel: '48-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '228930930037',
	},
	{
		sizeLabel: '50-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193287180804',
	},
	{
		sizeLabel: '52-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928959876939',
	},
	{
		sizeLabel: '54-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '195843900557',
	},
	{
		sizeLabel: '56-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '509204531824',
	},
	{
		sizeLabel: '58-34L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953494488666',
	},
	{
		sizeLabel: '36-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845624819694',
	},
	{
		sizeLabel: '38-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388898430574',
	},
	{
		sizeLabel: '40-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '798113669426',
	},
	{
		sizeLabel: '42-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103070386657',
	},
	{
		sizeLabel: '44-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209122274717',
	},
	{
		sizeLabel: '46-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038675489839',
	},
	{
		sizeLabel: '48-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '100060549988',
	},
	{
		sizeLabel: '50-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '088386429947',
	},
	{
		sizeLabel: '52-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547010236658',
	},
	{
		sizeLabel: '54-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200210164908',
	},
	{
		sizeLabel: '56-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175155344546',
	},
	{
		sizeLabel: '58-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794724646454',
	},
	{
		sizeLabel: '36-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520701559606',
	},
	{
		sizeLabel: '38-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054934852941',
	},
	{
		sizeLabel: '40-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978929096366',
	},
	{
		sizeLabel: '42-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '651501869096',
	},
	{
		sizeLabel: '44-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865048085780',
	},
	{
		sizeLabel: '46-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406884092920',
	},
	{
		sizeLabel: '48-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158845143177',
	},
	{
		sizeLabel: '50-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '643944942197',
	},
	{
		sizeLabel: '52-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051441520807',
	},
	{
		sizeLabel: '54-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '859823366617',
	},
	{
		sizeLabel: '56-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451406395254',
	},
	{
		sizeLabel: '58-38L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156881730699',
	},
	{
		sizeLabel: '29-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138856648304',
	},
	{
		sizeLabel: '31-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '631494052091',
	},
	{
		sizeLabel: '33-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439799834727',
	},
	{
		sizeLabel: '35-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '139219872804',
	},
	{
		sizeLabel: '37-30L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629388166964',
	},
	{
		sizeLabel: '29-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420626040012',
	},
	{
		sizeLabel: '31-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '951651214246',
	},
	{
		sizeLabel: '33-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996821766815',
	},
	{
		sizeLabel: '35-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '757474902906',
	},
	{
		sizeLabel: '37-32L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400752425482',
	},
	{
		sizeLabel: '28-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '532056985000',
	},
	{
		sizeLabel: '29-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '791164837015',
	},
	{
		sizeLabel: '30-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '934532081175',
	},
	{
		sizeLabel: '31-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086129611917',
	},
	{
		sizeLabel: '32-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938197103823',
	},
	{
		sizeLabel: '33-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402443283886',
	},
	{
		sizeLabel: '34-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633250147086',
	},
	{
		sizeLabel: '35-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908407410650',
	},
	{
		sizeLabel: '37-36L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '241587309856',
	},
	{
		sizeLabel: 'MED',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697533916213',
	},
	{
		sizeLabel: '24.4 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721575416372',
	},
	{
		sizeLabel: 'S (4-6)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519575882190',
	},
	{
		sizeLabel: 'S-SHORT (4-6',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '078360057359',
	},
	{
		sizeLabel: 'M (6-8)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639533414742',
	},
	{
		sizeLabel: 'M-SHORT (6-8',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730818546927',
	},
	{
		sizeLabel: 'M-LONG (6-8)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267879398047',
	},
	{
		sizeLabel: 'M-FULL (10-1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '854253131816',
	},
	{
		sizeLabel: 'L (10-12)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852031272407',
	},
	{
		sizeLabel: 'L-SHORT (10-',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '215140700296',
	},
	{
		sizeLabel: 'XL (14-16)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '283392264313',
	},
	{
		sizeLabel: 'M-SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '890402187412',
	},
	{
		sizeLabel: 'M-LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165413337418',
	},
	{
		sizeLabel: 'M-KING',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119403779398',
	},
	{
		sizeLabel: 'L-SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '065811958702',
	},
	{
		sizeLabel: 'L (9-11)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775997689785',
	},
	{
		sizeLabel: 'L (12-13)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797020367191',
	},
	{
		sizeLabel: 'L-LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528838994060',
	},
	{
		sizeLabel: 'L-KING',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853181792109',
	},
	{
		sizeLabel: 'XL-SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810166666297',
	},
	{
		sizeLabel: 'YOUTH-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '301666880233',
	},
	{
		sizeLabel: '26-28 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639170905458',
	},
	{
		sizeLabel: '22 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '491161001840',
	},
	{
		sizeLabel: '25 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602725039340',
	},
	{
		sizeLabel: '27 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119166494440',
	},
	{
		sizeLabel: '30 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168163143150',
	},
	{
		sizeLabel: '31 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815662671507',
	},
	{
		sizeLabel: '32 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '687318378868',
	},
	{
		sizeLabel: '6SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978484058348',
	},
	{
		sizeLabel: '6REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001959388545',
	},
	{
		sizeLabel: '6LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727794257881',
	},
	{
		sizeLabel: '8REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763834935964',
	},
	{
		sizeLabel: '8LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596148373320',
	},
	{
		sizeLabel: '10SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483870148510',
	},
	{
		sizeLabel: '10REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '028046491367',
	},
	{
		sizeLabel: '10LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086674670812',
	},
	{
		sizeLabel: '12SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629628927702',
	},
	{
		sizeLabel: '12REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877893525283',
	},
	{
		sizeLabel: '12LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '542906284311',
	},
	{
		sizeLabel: '14SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865471569610',
	},
	{
		sizeLabel: '14REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '322731761674',
	},
	{
		sizeLabel: '14LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823661353548',
	},
	{
		sizeLabel: '16SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841035355497',
	},
	{
		sizeLabel: '16REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '400473056204',
	},
	{
		sizeLabel: '16LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713204948035',
	},
	{
		sizeLabel: '18SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '900019768510',
	},
	{
		sizeLabel: '18REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '657257752590',
	},
	{
		sizeLabel: '18LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407366861158',
	},
	{
		sizeLabel: '20SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917687177696',
	},
	{
		sizeLabel: '20REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168519154011',
	},
	{
		sizeLabel: '20LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '644303610467',
	},
	{
		sizeLabel: '22SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '640473118106',
	},
	{
		sizeLabel: '22REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923467334139',
	},
	{
		sizeLabel: '22LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337348154678',
	},
	{
		sizeLabel: '34-36 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623430215188',
	},
	{
		sizeLabel: '155-76A-160 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008890948369',
	},
	{
		sizeLabel: '160-80A-165 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '462794886837',
	},
	{
		sizeLabel: '170-88A-175 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343716908789',
	},
	{
		sizeLabel: '175-92A-175 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893581644405',
	},
	{
		sizeLabel: '46-48 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '892410048255',
	},
	{
		sizeLabel: '175-95A-176 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '082184596681',
	},
	{
		sizeLabel: '50-52 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '334427009052',
	},
	{
		sizeLabel: '176-110A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '447850532031',
	},
	{
		sizeLabel: '2 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '978925806649',
	},
	{
		sizeLabel: '70-75',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '330759430425',
	},
	{
		sizeLabel: '80-85',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361257327648',
	},
	{
		sizeLabel: '38 ½-39 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524377293099',
	},
	{
		sizeLabel: '43 ½-44 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067893776132',
	},
	{
		sizeLabel: '2C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429560898751',
	},
	{
		sizeLabel: '46-50 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172885479303',
	},
	{
		sizeLabel: '50-54 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039063459098',
	},
	{
		sizeLabel: '48-52 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626679118828',
	},
	{
		sizeLabel: '54-58 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483819030125',
	},
	{
		sizeLabel: '58-62 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '516297364665',
	},
	{
		sizeLabel: '1 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611146215084',
	},
	{
		sizeLabel: '2 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '782636975712',
	},
	{
		sizeLabel: '4EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '679854477537',
	},
	{
		sizeLabel: '32EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '765261387011',
	},
	{
		sizeLabel: '0EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921630523299',
	},
	{
		sizeLabel: '36EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666336278371',
	},
	{
		sizeLabel: '6EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062360762086',
	},
	{
		sizeLabel: '34EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841541401633',
	},
	{
		sizeLabel: '2EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396803720980',
	},
	{
		sizeLabel: '38EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708687192852',
	},
	{
		sizeLabel: '8EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518172358256',
	},
	{
		sizeLabel: '36EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '812729023669',
	},
	{
		sizeLabel: '4EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '156649158017',
	},
	{
		sizeLabel: '40EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008431025738',
	},
	{
		sizeLabel: '10EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '282799447383',
	},
	{
		sizeLabel: '38EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280565587373',
	},
	{
		sizeLabel: '6EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609732351061',
	},
	{
		sizeLabel: '42EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '224733635317',
	},
	{
		sizeLabel: '12EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '451725053616',
	},
	{
		sizeLabel: '40EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '356867437463',
	},
	{
		sizeLabel: '8EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637468429697',
	},
	{
		sizeLabel: '44EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810979940623',
	},
	{
		sizeLabel: '14EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '220300010008',
	},
	{
		sizeLabel: '42EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649325993450',
	},
	{
		sizeLabel: '10EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573055628016',
	},
	{
		sizeLabel: '46EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009505288048',
	},
	{
		sizeLabel: '16EXTRA SHORT (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '986327005254',
	},
	{
		sizeLabel: '44EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475114016371',
	},
	{
		sizeLabel: '12EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '646133214249',
	},
	{
		sizeLabel: '48EXTRA SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672524472782',
	},
	{
		sizeLabel: '34SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '238121956882',
	},
	{
		sizeLabel: '38SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456926323650',
	},
	{
		sizeLabel: '36SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944315328449',
	},
	{
		sizeLabel: '40SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559801553488',
	},
	{
		sizeLabel: '38SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815702110994',
	},
	{
		sizeLabel: '42SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994088782856',
	},
	{
		sizeLabel: '40SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '734562808152',
	},
	{
		sizeLabel: '44SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '759034871325',
	},
	{
		sizeLabel: '42SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717598362282',
	},
	{
		sizeLabel: '46SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490232735597',
	},
	{
		sizeLabel: '44SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '414719122337',
	},
	{
		sizeLabel: '48SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707174037748',
	},
	{
		sizeLabel: '46SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398302092066',
	},
	{
		sizeLabel: '50SHORT (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '117969992503',
	},
	{
		sizeLabel: '34REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881661832774',
	},
	{
		sizeLabel: '2REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '050616309810',
	},
	{
		sizeLabel: '38REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970524872725',
	},
	{
		sizeLabel: '36REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013520444412',
	},
	{
		sizeLabel: '4REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836817015937',
	},
	{
		sizeLabel: '40REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213668011471',
	},
	{
		sizeLabel: '38REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959827937674',
	},
	{
		sizeLabel: '6REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923616671749',
	},
	{
		sizeLabel: '42REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '906696333526',
	},
	{
		sizeLabel: '40REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063633296118',
	},
	{
		sizeLabel: '8REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '740588173834',
	},
	{
		sizeLabel: '44REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371482015915',
	},
	{
		sizeLabel: '42REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512409981155',
	},
	{
		sizeLabel: '10REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '175537757054',
	},
	{
		sizeLabel: '46REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474588268063',
	},
	{
		sizeLabel: '44REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '586434743840',
	},
	{
		sizeLabel: '12REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164887712202',
	},
	{
		sizeLabel: '48REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '452599038406',
	},
	{
		sizeLabel: '46REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164683597618',
	},
	{
		sizeLabel: '14REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '295903074269',
	},
	{
		sizeLabel: '50REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '402786131342',
	},
	{
		sizeLabel: '48REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440598713565',
	},
	{
		sizeLabel: '16REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589862743337',
	},
	{
		sizeLabel: '52REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109612131877',
	},
	{
		sizeLabel: '50REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '772713646718',
	},
	{
		sizeLabel: '18REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379406570006',
	},
	{
		sizeLabel: '54REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '420197258288',
	},
	{
		sizeLabel: '52REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849380207466',
	},
	{
		sizeLabel: '20REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102617024227',
	},
	{
		sizeLabel: '56REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297249394311',
	},
	{
		sizeLabel: '54REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '809319550204',
	},
	{
		sizeLabel: '22REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877306433053',
	},
	{
		sizeLabel: '58REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126706016967',
	},
	{
		sizeLabel: '56REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814198707359',
	},
	{
		sizeLabel: '24REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945345664713',
	},
	{
		sizeLabel: '60 REGULAR (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515367743175',
	},
	{
		sizeLabel: '34LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '091891359458',
	},
	{
		sizeLabel: '2LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596392933462',
	},
	{
		sizeLabel: '38LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016798541488',
	},
	{
		sizeLabel: '36LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '995663718659',
	},
	{
		sizeLabel: '4LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '466579347712',
	},
	{
		sizeLabel: '40LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543304276101',
	},
	{
		sizeLabel: '38LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469626177120',
	},
	{
		sizeLabel: '6LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '663359299163',
	},
	{
		sizeLabel: '42LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291242536871',
	},
	{
		sizeLabel: '40LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789813936245',
	},
	{
		sizeLabel: '8LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '232179374345',
	},
	{
		sizeLabel: '44LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729483240256',
	},
	{
		sizeLabel: '42LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658114436637',
	},
	{
		sizeLabel: '10LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933944244085',
	},
	{
		sizeLabel: '46LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270276433057',
	},
	{
		sizeLabel: '44LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '701874865401',
	},
	{
		sizeLabel: '12LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776969117912',
	},
	{
		sizeLabel: '48LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '217902880488',
	},
	{
		sizeLabel: '46LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '349213847992',
	},
	{
		sizeLabel: '14LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '193625423412',
	},
	{
		sizeLabel: '50LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834188673778',
	},
	{
		sizeLabel: '6EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '929073210680',
	},
	{
		sizeLabel: '34EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924197738770',
	},
	{
		sizeLabel: '2EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468323427229',
	},
	{
		sizeLabel: '38EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534254862405',
	},
	{
		sizeLabel: '8EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431394010202',
	},
	{
		sizeLabel: '36EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841142701457',
	},
	{
		sizeLabel: '4EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841518559040',
	},
	{
		sizeLabel: '40EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543646133791',
	},
	{
		sizeLabel: '10EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523773002826',
	},
	{
		sizeLabel: '38EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '317411309271',
	},
	{
		sizeLabel: '6EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694310541897',
	},
	{
		sizeLabel: '42EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '404894260687',
	},
	{
		sizeLabel: '12EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045783095749',
	},
	{
		sizeLabel: '40EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '247173158046',
	},
	{
		sizeLabel: '8EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690240250863',
	},
	{
		sizeLabel: '44EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '245006168797',
	},
	{
		sizeLabel: '14EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '168904284454',
	},
	{
		sizeLabel: '42EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '993437659880',
	},
	{
		sizeLabel: '10EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196020834817',
	},
	{
		sizeLabel: '46EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012956085033',
	},
	{
		sizeLabel: '16EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '708961571890',
	},
	{
		sizeLabel: '44EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849490523582',
	},
	{
		sizeLabel: '12EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262448705733',
	},
	{
		sizeLabel: '48EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '007140106708',
	},
	{
		sizeLabel: '18EXTRA LONG (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '176757376879',
	},
	{
		sizeLabel: '46EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '059692670348',
	},
	{
		sizeLabel: '14EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '666577338267',
	},
	{
		sizeLabel: '50EXTRA LONG (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622711597022',
	},
	{
		sizeLabel: '24EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '072086009394',
	},
	{
		sizeLabel: '46EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877407802312',
	},
	{
		sizeLabel: '26EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058689973042',
	},
	{
		sizeLabel: '48EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278448119747',
	},
	{
		sizeLabel: '28EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '979231756400',
	},
	{
		sizeLabel: '50EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622042326098',
	},
	{
		sizeLabel: '30EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161576947407',
	},
	{
		sizeLabel: '52EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874530712043',
	},
	{
		sizeLabel: '32EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '353547361695',
	},
	{
		sizeLabel: '54EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '536793507165',
	},
	{
		sizeLabel: '34EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365090460688',
	},
	{
		sizeLabel: '56EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660049926067',
	},
	{
		sizeLabel: '36EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362554844313',
	},
	{
		sizeLabel: '58EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714678991720',
	},
	{
		sizeLabel: '38EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010499850551',
	},
	{
		sizeLabel: '60EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442245254540',
	},
	{
		sizeLabel: '40EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628981882125',
	},
	{
		sizeLabel: '62EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '690500705798',
	},
	{
		sizeLabel: '42EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '106849425516',
	},
	{
		sizeLabel: '64EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '999863095146',
	},
	{
		sizeLabel: '44EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733620067693',
	},
	{
		sizeLabel: '66EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562957256572',
	},
	{
		sizeLabel: '46EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103285609976',
	},
	{
		sizeLabel: '68EXTRA SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '535337432632',
	},
	{
		sizeLabel: '48EXTRA SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893580597108',
	},
	{
		sizeLabel: '24SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960109815423',
	},
	{
		sizeLabel: '26SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145038857256',
	},
	{
		sizeLabel: '48SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '717855999325',
	},
	{
		sizeLabel: '28SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449884922277',
	},
	{
		sizeLabel: '50SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '601665442677',
	},
	{
		sizeLabel: '30SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594692436984',
	},
	{
		sizeLabel: '52SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '688044509460',
	},
	{
		sizeLabel: '32SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '263778958229',
	},
	{
		sizeLabel: '54SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363243287432',
	},
	{
		sizeLabel: '34SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045203804038',
	},
	{
		sizeLabel: '56SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975181932893',
	},
	{
		sizeLabel: '36SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '517937221461',
	},
	{
		sizeLabel: '58SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '628282352360',
	},
	{
		sizeLabel: '38SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '730957869588',
	},
	{
		sizeLabel: '60SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686498080708',
	},
	{
		sizeLabel: '40SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551939762697',
	},
	{
		sizeLabel: '62SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029746551968',
	},
	{
		sizeLabel: '42SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375070243537',
	},
	{
		sizeLabel: '64SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858808885212',
	},
	{
		sizeLabel: '44SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792102542862',
	},
	{
		sizeLabel: '66SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '205110943815',
	},
	{
		sizeLabel: '46SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020733903506',
	},
	{
		sizeLabel: '68SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455674002429',
	},
	{
		sizeLabel: '48SHORT (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '963526243577',
	},
	{
		sizeLabel: '26REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027456230717',
	},
	{
		sizeLabel: '28REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969956664218',
	},
	{
		sizeLabel: '30REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '723745655906',
	},
	{
		sizeLabel: '32REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '486782285578',
	},
	{
		sizeLabel: '34REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333165851948',
	},
	{
		sizeLabel: '36REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746863460611',
	},
	{
		sizeLabel: '58REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807369187326',
	},
	{
		sizeLabel: '38REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828748776890',
	},
	{
		sizeLabel: '60REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '421593806964',
	},
	{
		sizeLabel: '40REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '292800034541',
	},
	{
		sizeLabel: '62REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '894134041973',
	},
	{
		sizeLabel: '42REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '269280679115',
	},
	{
		sizeLabel: '64REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '432134644851',
	},
	{
		sizeLabel: '44REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485202232512',
	},
	{
		sizeLabel: '66REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505213373804',
	},
	{
		sizeLabel: '46REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '048566472278',
	},
	{
		sizeLabel: '68REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '311378472085',
	},
	{
		sizeLabel: '48REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '627196970609',
	},
	{
		sizeLabel: '24LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '941956970548',
	},
	{
		sizeLabel: '26LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '600167524204',
	},
	{
		sizeLabel: '48LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030550416700',
	},
	{
		sizeLabel: '28LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '834936255793',
	},
	{
		sizeLabel: '50LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827894936795',
	},
	{
		sizeLabel: '30LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '280197945165',
	},
	{
		sizeLabel: '52LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '678275164709',
	},
	{
		sizeLabel: '32LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '339740851714',
	},
	{
		sizeLabel: '54LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167395327598',
	},
	{
		sizeLabel: '34LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '896980433560',
	},
	{
		sizeLabel: '56LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886382095500',
	},
	{
		sizeLabel: '36LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499290621150',
	},
	{
		sizeLabel: '58LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '401012305827',
	},
	{
		sizeLabel: '38LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '588142424054',
	},
	{
		sizeLabel: '60LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '964073444347',
	},
	{
		sizeLabel: '40LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760229590133',
	},
	{
		sizeLabel: '62LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912552185756',
	},
	{
		sizeLabel: '42LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039015784601',
	},
	{
		sizeLabel: '64LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213023789812',
	},
	{
		sizeLabel: '44LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '086149299108',
	},
	{
		sizeLabel: '66LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713504332517',
	},
	{
		sizeLabel: '46LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '656130284729',
	},
	{
		sizeLabel: '68LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '348951320957',
	},
	{
		sizeLabel: '48LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773182745437',
	},
	{
		sizeLabel: '24EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823190793340',
	},
	{
		sizeLabel: '26EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191969494794',
	},
	{
		sizeLabel: '48EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '125216793742',
	},
	{
		sizeLabel: '28EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '561199394872',
	},
	{
		sizeLabel: '50EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '281877295435',
	},
	{
		sizeLabel: '30EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519253945605',
	},
	{
		sizeLabel: '52EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273195094419',
	},
	{
		sizeLabel: '32EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866353397962',
	},
	{
		sizeLabel: '54EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769261033650',
	},
	{
		sizeLabel: '34EXTRALONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '569000648694',
	},
	{
		sizeLabel: '56EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '596915136669',
	},
	{
		sizeLabel: '36EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '642026950062',
	},
	{
		sizeLabel: '58EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '967431937215',
	},
	{
		sizeLabel: '38EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '260778390085',
	},
	{
		sizeLabel: '60EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877976567551',
	},
	{
		sizeLabel: '40EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803694880090',
	},
	{
		sizeLabel: '62EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909514643574',
	},
	{
		sizeLabel: '42EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054049705480',
	},
	{
		sizeLabel: '64EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '480943141837',
	},
	{
		sizeLabel: '44EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '203893996574',
	},
	{
		sizeLabel: '66EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305189742735',
	},
	{
		sizeLabel: '46EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347051869162',
	},
	{
		sizeLabel: '68EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '630542369652',
	},
	{
		sizeLabel: '48EXTRA LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '058195138572',
	},
	{
		sizeLabel: '44EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '849012810230',
	},
	{
		sizeLabel: '24EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639036005197',
	},
	{
		sizeLabel: '46EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '213736161785',
	},
	{
		sizeLabel: '26EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '357550843758',
	},
	{
		sizeLabel: '48EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '670216931939',
	},
	{
		sizeLabel: '28EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '935416083899',
	},
	{
		sizeLabel: '50EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478546835421',
	},
	{
		sizeLabel: '30EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515802291702',
	},
	{
		sizeLabel: '52EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163829271318',
	},
	{
		sizeLabel: '32EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300162790468',
	},
	{
		sizeLabel: '54EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '613337165736',
	},
	{
		sizeLabel: '34EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '308490170414',
	},
	{
		sizeLabel: '56EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519943995624',
	},
	{
		sizeLabel: '36EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968329499399',
	},
	{
		sizeLabel: '58EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085842615467',
	},
	{
		sizeLabel: '38EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '346008881619',
	},
	{
		sizeLabel: '60EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '618032204431',
	},
	{
		sizeLabel: '40EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '075564642622',
	},
	{
		sizeLabel: '62EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273341821987',
	},
	{
		sizeLabel: '42EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766731351328',
	},
	{
		sizeLabel: '64EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835829103271',
	},
	{
		sizeLabel: '44EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '919728225294',
	},
	{
		sizeLabel: '66EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '397953657470',
	},
	{
		sizeLabel: '46EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '399427646132',
	},
	{
		sizeLabel: '68EXTRAEXTRA (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049506779239',
	},
	{
		sizeLabel: '48EXTRAEXTRA (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '839355612360',
	},
	{
		sizeLabel: '17 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '862427422263',
	},
	{
		sizeLabel: '19 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '962547717332',
	},
	{
		sizeLabel: '20 (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550519172093',
	},
	{
		sizeLabel: '2-85B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202556272315',
	},
	{
		sizeLabel: '2-85C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351573090820',
	},
	{
		sizeLabel: '2-85D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '661748476228',
	},
	{
		sizeLabel: '2-85E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512693272016',
	},
	{
		sizeLabel: '2-85F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169689232440',
	},
	{
		sizeLabel: '2-85G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922339953296',
	},
	{
		sizeLabel: '3-90B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632611928354',
	},
	{
		sizeLabel: '3-90C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122477099220',
	},
	{
		sizeLabel: '3-90D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '551775160943',
	},
	{
		sizeLabel: '3-90E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '046835473889',
	},
	{
		sizeLabel: '3-90F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060281080536',
	},
	{
		sizeLabel: '3-90G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '127012201073',
	},
	{
		sizeLabel: '4-95B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174778571748',
	},
	{
		sizeLabel: '4-95C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885338894881',
	},
	{
		sizeLabel: '4-95D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '051781826473',
	},
	{
		sizeLabel: '4-95E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '533113366184',
	},
	{
		sizeLabel: '4-95F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '855868445939',
	},
	{
		sizeLabel: '4-95G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840435261225',
	},
	{
		sizeLabel: '5-100B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '793008669205',
	},
	{
		sizeLabel: '5-100C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866658829453',
	},
	{
		sizeLabel: '5-100D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225989945856',
	},
	{
		sizeLabel: '5-100E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '699712348129',
	},
	{
		sizeLabel: '5-100F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '172564831744',
	},
	{
		sizeLabel: '5-100G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196924662692',
	},
	{
		sizeLabel: '6-100B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990104746774',
	},
	{
		sizeLabel: '6-100C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508722504027',
	},
	{
		sizeLabel: '6-100D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970347916148',
	},
	{
		sizeLabel: '6-100E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841821501664',
	},
	{
		sizeLabel: '6-100F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183295936780',
	},
	{
		sizeLabel: '6-100G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '770898692026',
	},
	{
		sizeLabel: '7-105B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '425457087576',
	},
	{
		sizeLabel: '7-105C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319037087613',
	},
	{
		sizeLabel: '7-105D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822252432183',
	},
	{
		sizeLabel: '7-105E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000494809091',
	},
	{
		sizeLabel: '7-105F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797847634873',
	},
	{
		sizeLabel: '7-105G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '886729491837',
	},
	{
		sizeLabel: '8-110B',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187846895035',
	},
	{
		sizeLabel: '8-110C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728954477334',
	},
	{
		sizeLabel: '8-110D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '407649411562',
	},
	{
		sizeLabel: '8-110E',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021276175900',
	},
	{
		sizeLabel: '8-110F',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '619958728422',
	},
	{
		sizeLabel: '8-110G',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832741442678',
	},
	{
		sizeLabel: '50B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '149514566096',
	},
	{
		sizeLabel: '50C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321834168974',
	},
	{
		sizeLabel: '50D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '826942316403',
	},
	{
		sizeLabel: '50E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '794322161132',
	},
	{
		sizeLabel: '50F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '243062825335',
	},
	{
		sizeLabel: '50G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '781349825596',
	},
	{
		sizeLabel: '52B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '524218801271',
	},
	{
		sizeLabel: '52C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '949658638511',
	},
	{
		sizeLabel: '52D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828110274153',
	},
	{
		sizeLabel: '52E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '439552911944',
	},
	{
		sizeLabel: '52F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '484568130968',
	},
	{
		sizeLabel: '52G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116530797521',
	},
	{
		sizeLabel: '52H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329402130411',
	},
	{
		sizeLabel: '54B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '291469783743',
	},
	{
		sizeLabel: '54C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '068279685197',
	},
	{
		sizeLabel: '54D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598214094026',
	},
	{
		sizeLabel: '54E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766429568819',
	},
	{
		sizeLabel: '54F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922644011646',
	},
	{
		sizeLabel: '54G (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '994138878430',
	},
	{
		sizeLabel: '56B (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140037239572',
	},
	{
		sizeLabel: '56C (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197679074991',
	},
	{
		sizeLabel: '56D (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '310208185855',
	},
	{
		sizeLabel: '56E (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251049313938',
	},
	{
		sizeLabel: '56F (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372435775801',
	},
	{
		sizeLabel: '22 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574122419820',
	},
	{
		sizeLabel: '23 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837865727930',
	},
	{
		sizeLabel: '24 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '294163095877',
	},
	{
		sizeLabel: '25 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '684416068670',
	},
	{
		sizeLabel: '26 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887955694713',
	},
	{
		sizeLabel: '27 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755030446108',
	},
	{
		sizeLabel: '28 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742812844417',
	},
	{
		sizeLabel: '29 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '556282852753',
	},
	{
		sizeLabel: '30 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504372861827',
	},
	{
		sizeLabel: '31 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '554510073072',
	},
	{
		sizeLabel: '32 ½',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689960348344',
	},
	{
		sizeLabel: '61+',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122843608595',
	},
	{
		sizeLabel: '46-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365442934007',
	},
	{
		sizeLabel: '46-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '449622641592',
	},
	{
		sizeLabel: '48-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305306584391',
	},
	{
		sizeLabel: '48-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '487796248189',
	},
	{
		sizeLabel: '50-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758748271516',
	},
	{
		sizeLabel: '50-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '506165880330',
	},
	{
		sizeLabel: '52-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '111350015223',
	},
	{
		sizeLabel: '52-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '748226940943',
	},
	{
		sizeLabel: '54-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563170327165',
	},
	{
		sizeLabel: '54-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286500029118',
	},
	{
		sizeLabel: '56-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807793866668',
	},
	{
		sizeLabel: '56-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '335239795106',
	},
	{
		sizeLabel: '58-30 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '913283401968',
	},
	{
		sizeLabel: '58-32 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609763614791',
	},
	{
		sizeLabel: '58-34 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915199168496',
	},
	{
		sizeLabel: '58-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '977556264081',
	},
	{
		sizeLabel: '31-32-38',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483530921456',
	},
	{
		sizeLabel: '44-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '057747251260',
	},
	{
		sizeLabel: '46-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '382908784673',
	},
	{
		sizeLabel: '48-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '711946169542',
	},
	{
		sizeLabel: '50-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988477669188',
	},
	{
		sizeLabel: '52-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '112273754121',
	},
	{
		sizeLabel: '54-28',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '540339783125',
	},
	{
		sizeLabel: '32SHORT (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '352074194557',
	},
	{
		sizeLabel: '32REGULAR (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '756410971452',
	},
	{
		sizeLabel: '32LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930846649095',
	},
	{
		sizeLabel: '32EXTRA LONG (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729685431019',
	},
	{
		sizeLabel: '2-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '526508369373',
	},
	{
		sizeLabel: '6-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520155971011',
	},
	{
		sizeLabel: '34-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276360691993',
	},
	{
		sizeLabel: '38-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '023054612434',
	},
	{
		sizeLabel: '32-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '267357045558',
	},
	{
		sizeLabel: '38-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '257742443024',
	},
	{
		sizeLabel: '8-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '842242553476',
	},
	{
		sizeLabel: '36-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605793672879',
	},
	{
		sizeLabel: '40-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102581447669',
	},
	{
		sizeLabel: '34-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727421344019',
	},
	{
		sizeLabel: '40-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '260167990516',
	},
	{
		sizeLabel: '4-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '521424718079',
	},
	{
		sizeLabel: '8-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '897929455806',
	},
	{
		sizeLabel: '36-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763735766060',
	},
	{
		sizeLabel: '40-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '629048929466',
	},
	{
		sizeLabel: '34-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835952040565',
	},
	{
		sizeLabel: '40-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230493240140',
	},
	{
		sizeLabel: '4-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '653942627743',
	},
	{
		sizeLabel: '8-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819189410105',
	},
	{
		sizeLabel: '36-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327994941808',
	},
	{
		sizeLabel: '40-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668278190657',
	},
	{
		sizeLabel: '34-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236519904668',
	},
	{
		sizeLabel: '40-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '298852651981',
	},
	{
		sizeLabel: '6-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802348949145',
	},
	{
		sizeLabel: '10-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305502552873',
	},
	{
		sizeLabel: '38-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309204426875',
	},
	{
		sizeLabel: '42-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '924229050249',
	},
	{
		sizeLabel: '36-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '682044043743',
	},
	{
		sizeLabel: '42-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '432204989022',
	},
	{
		sizeLabel: '6-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '013153198545',
	},
	{
		sizeLabel: '10-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '800212162343',
	},
	{
		sizeLabel: '38-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '372533660026',
	},
	{
		sizeLabel: '42-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '174883531338',
	},
	{
		sizeLabel: '36-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '864681495099',
	},
	{
		sizeLabel: '42-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '947980187375',
	},
	{
		sizeLabel: '6-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683316160681',
	},
	{
		sizeLabel: '10-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729559945137',
	},
	{
		sizeLabel: '38-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '687363869486',
	},
	{
		sizeLabel: '42-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170557277248',
	},
	{
		sizeLabel: '36-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '468737711585',
	},
	{
		sizeLabel: '42-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567043419071',
	},
	{
		sizeLabel: '8-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '448344263318',
	},
	{
		sizeLabel: '12-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818269062095',
	},
	{
		sizeLabel: '40-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '664708024922',
	},
	{
		sizeLabel: '44-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '418979550649',
	},
	{
		sizeLabel: '38-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '179354107056',
	},
	{
		sizeLabel: '44-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700307381344',
	},
	{
		sizeLabel: '8-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171482933978',
	},
	{
		sizeLabel: '12-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490437645018',
	},
	{
		sizeLabel: '40-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016992244512',
	},
	{
		sizeLabel: '44-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '792750029553',
	},
	{
		sizeLabel: '38-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '489287610329',
	},
	{
		sizeLabel: '44-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807069698418',
	},
	{
		sizeLabel: '8-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965639410339',
	},
	{
		sizeLabel: '12-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658696366224',
	},
	{
		sizeLabel: '40-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '328589271472',
	},
	{
		sizeLabel: '44-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141996200151',
	},
	{
		sizeLabel: '38-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036131670562',
	},
	{
		sizeLabel: '44-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '960987849639',
	},
	{
		sizeLabel: '10-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '923031129354',
	},
	{
		sizeLabel: '14-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '191021119104',
	},
	{
		sizeLabel: '42-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '778751745424',
	},
	{
		sizeLabel: '46-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '146280481720',
	},
	{
		sizeLabel: '40-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '592306810670',
	},
	{
		sizeLabel: '46-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '776090611044',
	},
	{
		sizeLabel: '10-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116662038740',
	},
	{
		sizeLabel: '14-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018522036839',
	},
	{
		sizeLabel: '42-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519847349587',
	},
	{
		sizeLabel: '46-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '833856814459',
	},
	{
		sizeLabel: '40-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908385143053',
	},
	{
		sizeLabel: '46-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '933924215649',
	},
	{
		sizeLabel: '10-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547979855407',
	},
	{
		sizeLabel: '14-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '272213710824',
	},
	{
		sizeLabel: '42-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394814145577',
	},
	{
		sizeLabel: '46-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637372634900',
	},
	{
		sizeLabel: '40-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '409993723485',
	},
	{
		sizeLabel: '46-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286697421819',
	},
	{
		sizeLabel: '12-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '145462148802',
	},
	{
		sizeLabel: '16-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '722705394128',
	},
	{
		sizeLabel: '44-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '329895797387',
	},
	{
		sizeLabel: '48-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877523417768',
	},
	{
		sizeLabel: '42-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '361040359782',
	},
	{
		sizeLabel: '48-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622217512712',
	},
	{
		sizeLabel: '12-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '729399795268',
	},
	{
		sizeLabel: '16-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921804225690',
	},
	{
		sizeLabel: '44-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471933395224',
	},
	{
		sizeLabel: '48-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '141185881779',
	},
	{
		sizeLabel: '42-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '042295175779',
	},
	{
		sizeLabel: '48-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483812726450',
	},
	{
		sizeLabel: '12-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '660279319140',
	},
	{
		sizeLabel: '16-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '314187531825',
	},
	{
		sizeLabel: '44-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746218083693',
	},
	{
		sizeLabel: '48-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278234651318',
	},
	{
		sizeLabel: '42-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915577937987',
	},
	{
		sizeLabel: '48-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435052792076',
	},
	{
		sizeLabel: '14-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485973136485',
	},
	{
		sizeLabel: '18-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '797826543112',
	},
	{
		sizeLabel: '46-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '197923815212',
	},
	{
		sizeLabel: '50-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '840273980011',
	},
	{
		sizeLabel: '44-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '388109084753',
	},
	{
		sizeLabel: '50-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814401066410',
	},
	{
		sizeLabel: '30-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123266213904',
	},
	{
		sizeLabel: '46-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674598419952',
	},
	{
		sizeLabel: '32-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '827225273115',
	},
	{
		sizeLabel: '32-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '523909093923',
	},
	{
		sizeLabel: '48-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '358851724015',
	},
	{
		sizeLabel: '32-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '360460986654',
	},
	{
		sizeLabel: '48-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742039594671',
	},
	{
		sizeLabel: '32-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363439826871',
	},
	{
		sizeLabel: '48-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255127611542',
	},
	{
		sizeLabel: '34-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733827505801',
	},
	{
		sizeLabel: '50-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863756796086',
	},
	{
		sizeLabel: '50-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011455303348',
	},
	{
		sizeLabel: '50-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '880087820108',
	},
	{
		sizeLabel: '34-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704700845596',
	},
	{
		sizeLabel: '50-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012849454330',
	},
	{
		sizeLabel: '34-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '422142107051',
	},
	{
		sizeLabel: '50-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '603330810275',
	},
	{
		sizeLabel: '50-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866958362244',
	},
	{
		sizeLabel: '50-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '469856107704',
	},
	{
		sizeLabel: '36-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914740191708',
	},
	{
		sizeLabel: '36-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '366854290276',
	},
	{
		sizeLabel: '52-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '161354508451',
	},
	{
		sizeLabel: '52-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038216441246',
	},
	{
		sizeLabel: '52-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981781801497',
	},
	{
		sizeLabel: '36-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '488063003985',
	},
	{
		sizeLabel: '52-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027254263138',
	},
	{
		sizeLabel: '52-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '674666668451',
	},
	{
		sizeLabel: '52-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '961561408428',
	},
	{
		sizeLabel: '36-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '041249424111',
	},
	{
		sizeLabel: '52-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773148951246',
	},
	{
		sizeLabel: '52-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '943610717764',
	},
	{
		sizeLabel: '52-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '715336740136',
	},
	{
		sizeLabel: '38-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '641251150999',
	},
	{
		sizeLabel: '38-L (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '623139275516',
	},
	{
		sizeLabel: '46-L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686078977141',
	},
	{
		sizeLabel: '54-L (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '763121670116',
	},
	{
		sizeLabel: '54-L (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '456269993881',
	},
	{
		sizeLabel: '54-L (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '503888726786',
	},
	{
		sizeLabel: '38-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184917172510',
	},
	{
		sizeLabel: '54-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123364143548',
	},
	{
		sizeLabel: '54-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '914293049775',
	},
	{
		sizeLabel: '54-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814877551055',
	},
	{
		sizeLabel: '38-S (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019898363726',
	},
	{
		sizeLabel: '46-S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '971785531200',
	},
	{
		sizeLabel: '54-S (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '432994418481',
	},
	{
		sizeLabel: '54-S (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '823394143900',
	},
	{
		sizeLabel: '54-S (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '755280495613',
	},
	{
		sizeLabel: '40-R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300577524499',
	},
	{
		sizeLabel: '40-R (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129297121728',
	},
	{
		sizeLabel: '48-R (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259819053778',
	},
	{
		sizeLabel: '56-R (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '841843530959',
	},
	{
		sizeLabel: '56-R (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '597695205250',
	},
	{
		sizeLabel: '56-R (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341885858760',
	},
	{
		sizeLabel: '5 ½-7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '952465251080',
	},
	{
		sizeLabel: '7 ½-10 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '371709389171',
	},
	{
		sizeLabel: 'M44',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853136904696',
	},
	{
		sizeLabel: 'M46',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '010436061023',
	},
	{
		sizeLabel: 'L48',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '799585886718',
	},
	{
		sizeLabel: 'L50',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '144457041152',
	},
	{
		sizeLabel: '32 ½ (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '236448276013',
	},
	{
		sizeLabel: '34 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '571033404193',
	},
	{
		sizeLabel: '35 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '463453813233',
	},
	{
		sizeLabel: '35 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109243063066',
	},
	{
		sizeLabel: '36 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846113382582',
	},
	{
		sizeLabel: '37 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '558879168949',
	},
	{
		sizeLabel: '37 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957014777320',
	},
	{
		sizeLabel: '38 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394209431949',
	},
	{
		sizeLabel: '39 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704425575210',
	},
	{
		sizeLabel: '39 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450361670415',
	},
	{
		sizeLabel: '40 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '287121951645',
	},
	{
		sizeLabel: '41 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746849188477',
	},
	{
		sizeLabel: '41 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '671801413021',
	},
	{
		sizeLabel: '42 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '103777345957',
	},
	{
		sizeLabel: '43 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945309869017',
	},
	{
		sizeLabel: '43 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '455090260496',
	},
	{
		sizeLabel: '44 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672153962801',
	},
	{
		sizeLabel: '45 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726831671389',
	},
	{
		sizeLabel: '45 ½ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '744847791149',
	},
	{
		sizeLabel: '84 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '602241926812',
	},
	{
		sizeLabel: '87 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '624924734184',
	},
	{
		sizeLabel: '90 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '981055302956',
	},
	{
		sizeLabel: '93 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '251512916001',
	},
	{
		sizeLabel: '96 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '398619062354',
	},
	{
		sizeLabel: '99 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861905006394',
	},
	{
		sizeLabel: '102 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410806570697',
	},
	{
		sizeLabel: '105 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928977608852',
	},
	{
		sizeLabel: '41 ½-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '879100579507',
	},
	{
		sizeLabel: '46 ½-47 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390313363539',
	},
	{
		sizeLabel: '30-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '863308632856',
	},
	{
		sizeLabel: '31-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '187592781809',
	},
	{
		sizeLabel: '33-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '868405763545',
	},
	{
		sizeLabel: '34-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '689515108833',
	},
	{
		sizeLabel: '38-XXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '529532562054',
	},
	{
		sizeLabel: '24-XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741193921635',
	},
	{
		sizeLabel: '25-XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225352154596',
	},
	{
		sizeLabel: '26-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534274351279',
	},
	{
		sizeLabel: '27-S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '204996089231',
	},
	{
		sizeLabel: '28-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704617865690',
	},
	{
		sizeLabel: '29-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '437768383163',
	},
	{
		sizeLabel: '30-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '273589899075',
	},
	{
		sizeLabel: '31-L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565438520827',
	},
	{
		sizeLabel: '32-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '375376756069',
	},
	{
		sizeLabel: '7.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '284678018528',
	},
	{
		sizeLabel: '8.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '853656249772',
	},
	{
		sizeLabel: '26.25 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '615203583023',
	},
	{
		sizeLabel: '9.25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '029825264288',
	},
	{
		sizeLabel: '3-6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544858761623',
	},
	{
		sizeLabel: '8-10 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '741769486889',
	},
	{
		sizeLabel: '8D-DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '865540846967',
	},
	{
		sizeLabel: '8DD-E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '693344283124',
	},
	{
		sizeLabel: '8E-F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472050318265',
	},
	{
		sizeLabel: '10D-DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '446941996034',
	},
	{
		sizeLabel: '10DD-E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '303788187241',
	},
	{
		sizeLabel: '10E-F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108771673144',
	},
	{
		sizeLabel: '12D-DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170292675603',
	},
	{
		sizeLabel: '12DD-E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '514450557861',
	},
	{
		sizeLabel: '12E-F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654997326800',
	},
	{
		sizeLabel: '14D-DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '705417178441',
	},
	{
		sizeLabel: '14DD-E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297145849744',
	},
	{
		sizeLabel: '14E-F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '262825192347',
	},
	{
		sizeLabel: '16D-DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887348547274',
	},
	{
		sizeLabel: '16DD-E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '343833164134',
	},
	{
		sizeLabel: '16E-F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '297378548700',
	},
	{
		sizeLabel: '18D-DD (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '915937737380',
	},
	{
		sizeLabel: '18DD-E (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '970699328380',
	},
	{
		sizeLabel: '18E-F (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '211955979236',
	},
	{
		sizeLabel: '6A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899736599387',
	},
	{
		sizeLabel: '6D (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '534096035659',
	},
	{
		sizeLabel: '62-64',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '394909810047',
	},
	{
		sizeLabel: '66-68',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '747594119422',
	},
	{
		sizeLabel: '13 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '575779088587',
	},
	{
		sizeLabel: '14 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171553591915',
	},
	{
		sizeLabel: 'SSG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '667475762078',
	},
	{
		sizeLabel: 'XE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775212214302',
	},
	{
		sizeLabel: '36I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '530479028098',
	},
	{
		sizeLabel: '36J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '027801031188',
	},
	{
		sizeLabel: '38I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159078478408',
	},
	{
		sizeLabel: '38J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '892837918751',
	},
	{
		sizeLabel: '40I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '918812888760',
	},
	{
		sizeLabel: '40J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '953737902628',
	},
	{
		sizeLabel: '42I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312904672666',
	},
	{
		sizeLabel: '42J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '616651531716',
	},
	{
		sizeLabel: '44I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147471267331',
	},
	{
		sizeLabel: '44J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '810649236791',
	},
	{
		sizeLabel: '46I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039126385680',
	},
	{
		sizeLabel: '46J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '871033796359',
	},
	{
		sizeLabel: '48I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '680289722343',
	},
	{
		sizeLabel: '48J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '873922702930',
	},
	{
		sizeLabel: '50I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '632569836667',
	},
	{
		sizeLabel: '50J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379825440562',
	},
	{
		sizeLabel: '52I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '450773600019',
	},
	{
		sizeLabel: '52J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683244445691',
	},
	{
		sizeLabel: '54H (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '019389769965',
	},
	{
		sizeLabel: '54I (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '766419219198',
	},
	{
		sizeLabel: '54J (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331088773987',
	},
	{
		sizeLabel: '150-72A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '147754540659',
	},
	{
		sizeLabel: '150-54A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752347272305',
	},
	{
		sizeLabel: '160-62A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '021072977337',
	},
	{
		sizeLabel: '165-66A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704892437020',
	},
	{
		sizeLabel: '170-70A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '950721803954',
	},
	{
		sizeLabel: '1 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771421934615',
	},
	{
		sizeLabel: '2 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '244723020989',
	},
	{
		sizeLabel: '8 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '568149270039',
	},
	{
		sizeLabel: '21 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '403629952155',
	},
	{
		sizeLabel: '21 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '870711430498',
	},
	{
		sizeLabel: '32-38 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184438376004',
	},
	{
		sizeLabel: '7-13 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035210359248',
	},
	{
		sizeLabel: '42-46 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337081001169',
	},
	{
		sizeLabel: '46-50 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '598463900462',
	},
	{
		sizeLabel: '15-19 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '384199513619',
	},
	{
		sizeLabel: '42-46 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '296632743269',
	},
	{
		sizeLabel: '18-22 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '588646173972',
	},
	{
		sizeLabel: '22-26 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '337906125298',
	},
	{
		sizeLabel: '27-29 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '566330022568',
	},
	{
		sizeLabel: '34-44 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '762321602701',
	},
	{
		sizeLabel: '32-42 (DE)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '928417834858',
	},
	{
		sizeLabel: '38-48 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832079859064',
	},
	{
		sizeLabel: '7-17 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732472833361',
	},
	{
		sizeLabel: '34-44 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721973585047',
	},
	{
		sizeLabel: '48-52 (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457133726978',
	},
	{
		sizeLabel: '21-27 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550475974410',
	},
	{
		sizeLabel: '48-52 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '528964907405',
	},
	{
		sizeLabel: '0AA (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '165174716069',
	},
	{
		sizeLabel: '30M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '818546921172',
	},
	{
		sizeLabel: '32M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483715926557',
	},
	{
		sizeLabel: '34M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '196337684586',
	},
	{
		sizeLabel: '36M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '276555033813',
	},
	{
		sizeLabel: '38M (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408161650261',
	},
	{
		sizeLabel: '1-2X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '047804246021',
	},
	{
		sizeLabel: '3-4X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189217199014',
	},
	{
		sizeLabel: '5-6X',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '858302601968',
	},
	{
		sizeLabel: '2.8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '167531108075',
	},
	{
		sizeLabel: '4.8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '737216512548',
	},
	{
		sizeLabel: '3.2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406608451133',
	},
	{
		sizeLabel: '5.2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438784971196',
	},
	{
		sizeLabel: '3.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095072215418',
	},
	{
		sizeLabel: '5.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034087918917',
	},
	{
		sizeLabel: '4.4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '552059340905',
	},
	{
		sizeLabel: '6.4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039397975730',
	},
	{
		sizeLabel: '4.8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594538162516',
	},
	{
		sizeLabel: '6.8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '171177172540',
	},
	{
		sizeLabel: '5.2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '760554741251',
	},
	{
		sizeLabel: '7.2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '108995218783',
	},
	{
		sizeLabel: '5.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '030062053039',
	},
	{
		sizeLabel: '7.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '945231906550',
	},
	{
		sizeLabel: '5.9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '589017981035',
	},
	{
		sizeLabel: '7.9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908938126791',
	},
	{
		sizeLabel: '6.3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '396320401617',
	},
	{
		sizeLabel: '8.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '306307354465',
	},
	{
		sizeLabel: '6.7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '490944519008',
	},
	{
		sizeLabel: '8.7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '543696240801',
	},
	{
		sizeLabel: '7.1 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '837259810731',
	},
	{
		sizeLabel: '9.1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '626717675752',
	},
	{
		sizeLabel: '7.9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '307706691464',
	},
	{
		sizeLabel: '9.9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '912056898470',
	},
	{
		sizeLabel: '8.3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '493733697123',
	},
	{
		sizeLabel: '10.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784887911385',
	},
	{
		sizeLabel: '8.7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982629065401',
	},
	{
		sizeLabel: '10.7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '290538138351',
	},
	{
		sizeLabel: '3.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573106601928',
	},
	{
		sizeLabel: '4.1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '957059909139',
	},
	{
		sizeLabel: '4.9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968739480935',
	},
	{
		sizeLabel: '5.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300587806629',
	},
	{
		sizeLabel: '5.7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '131093598310',
	},
	{
		sizeLabel: '6.1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975262748750',
	},
	{
		sizeLabel: '8.4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991642927542',
	},
	{
		sizeLabel: '8.8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '565427452915',
	},
	{
		sizeLabel: '9.2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102000745716',
	},
	{
		sizeLabel: '9.1 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116116668716',
	},
	{
		sizeLabel: '9.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '547185036989',
	},
	{
		sizeLabel: '9.9 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '845027768475',
	},
	{
		sizeLabel: '10.4 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '922266266944',
	},
	{
		sizeLabel: '10.3 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '034102510039',
	},
	{
		sizeLabel: '10.8 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '573514733378',
	},
	{
		sizeLabel: '10.7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '131902079674',
	},
	{
		sizeLabel: '11.2 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '017554344545',
	},
	{
		sizeLabel: '11.1 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '278051676919',
	},
	{
		sizeLabel: '11.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '620351508333',
	},
	{
		sizeLabel: '11.4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '185249701633',
	},
	{
		sizeLabel: '11.9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474437878091',
	},
	{
		sizeLabel: '11.8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '177699820812',
	},
	{
		sizeLabel: '12.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '494858153441',
	},
	{
		sizeLabel: '12.2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '726739403422',
	},
	{
		sizeLabel: '12.7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '852386218730',
	},
	{
		sizeLabel: '12.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126005389716',
	},
	{
		sizeLabel: '13.1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '440454771059',
	},
	{
		sizeLabel: '13.4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099186886018',
	},
	{
		sizeLabel: '13.9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '324155014568',
	},
	{
		sizeLabel: '13.8 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '392881381458',
	},
	{
		sizeLabel: '14.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '866589739157',
	},
	{
		sizeLabel: '14.2 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453492326388',
	},
	{
		sizeLabel: '14.7 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '594311505232',
	},
	{
		sizeLabel: '14.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '248919431410',
	},
	{
		sizeLabel: '15.1 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '393077607999',
	},
	{
		sizeLabel: '15.4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '713477176535',
	},
	{
		sizeLabel: '15.9 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804175209460',
	},
	{
		sizeLabel: '16.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '054861410452',
	},
	{
		sizeLabel: 'S FULL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052947310387',
	},
	{
		sizeLabel: 'M FULL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318363747561',
	},
	{
		sizeLabel: 'L FULL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '437395263881',
	},
	{
		sizeLabel: 'S KING',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319368066505',
	},
	{
		sizeLabel: 'M KING SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987049513234',
	},
	{
		sizeLabel: 'M KING',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '438866801935',
	},
	{
		sizeLabel: 'L 12-13 FOOT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '501482446621',
	},
	{
		sizeLabel: 'L KING SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617178123518',
	},
	{
		sizeLabel: 'L KING',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903608760921',
	},
	{
		sizeLabel: 'L LONG 9-11',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '478715948250',
	},
	{
		sizeLabel: 'L LONG 12-13',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '201218069351',
	},
	{
		sizeLabel: 'XL KING',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '784388433022',
	},
	{
		sizeLabel: '1L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '921362954794',
	},
	{
		sizeLabel: '1 (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '758671319584',
	},
	{
		sizeLabel: '1-2-S-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697654777169',
	},
	{
		sizeLabel: '5-MAXI',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '606227324700',
	},
	{
		sizeLabel: '3XL T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '362531251672',
	},
	{
		sizeLabel: '32T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '319218667024',
	},
	{
		sizeLabel: '34T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '270565350636',
	},
	{
		sizeLabel: '36T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385875533031',
	},
	{
		sizeLabel: '38T',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '011002715017',
	},
	{
		sizeLabel: 'XSM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '351473077938',
	},
	{
		sizeLabel: 'SML',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320579532427',
	},
	{
		sizeLabel: 'LRG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '289924989701',
	},
	{
		sizeLabel: '12 ½ (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '901062766857',
	},
	{
		sizeLabel: '13 (MX)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435792026741',
	},
	{
		sizeLabel: '3 (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '368702827659',
	},
	{
		sizeLabel: '4 (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '411001266798',
	},
	{
		sizeLabel: '5 (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '240586629350',
	},
	{
		sizeLabel: '6 (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '819838721340',
	},
	{
		sizeLabel: '7 (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '625814455373',
	},
	{
		sizeLabel: '8 (AT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122821816663',
	},
	{
		sizeLabel: 'LXS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '477014367400',
	},
	{
		sizeLabel: '6 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '595527039749',
	},
	{
		sizeLabel: '7 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '063932147786',
	},
	{
		sizeLabel: 'MM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '408170291201',
	},
	{
		sizeLabel: 'MXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '259669198923',
	},
	{
		sizeLabel: 'MXXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '390237027702',
	},
	{
		sizeLabel: 'M3XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '071587780213',
	},
	{
		sizeLabel: 'M4XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '381783843943',
	},
	{
		sizeLabel: 'WXS SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '655845442100',
	},
	{
		sizeLabel: 'WXS REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '874036980485',
	},
	{
		sizeLabel: 'WXS LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '822286374882',
	},
	{
		sizeLabel: 'SW SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764248808226',
	},
	{
		sizeLabel: 'SW REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '218965072065',
	},
	{
		sizeLabel: 'SW LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '001250777144',
	},
	{
		sizeLabel: 'MW SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '250648916178',
	},
	{
		sizeLabel: 'MW REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121144398155',
	},
	{
		sizeLabel: 'MW LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049693413279',
	},
	{
		sizeLabel: 'WL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '998446410498',
	},
	{
		sizeLabel: 'WL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '807700820530',
	},
	{
		sizeLabel: 'WL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '200679112377',
	},
	{
		sizeLabel: 'WXL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700758541506',
	},
	{
		sizeLabel: 'WXL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '173679049583',
	},
	{
		sizeLabel: 'WXL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '931388666685',
	},
	{
		sizeLabel: 'W2XL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996165792423',
	},
	{
		sizeLabel: 'W2XL REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '773320125589',
	},
	{
		sizeLabel: 'W2XL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515201092194',
	},
	{
		sizeLabel: '20-24 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '052567736062',
	},
	{
		sizeLabel: '25-28 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '771709236341',
	},
	{
		sizeLabel: '3.25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '087533155198',
	},
	{
		sizeLabel: '5.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965124409275',
	},
	{
		sizeLabel: '4.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '806287214884',
	},
	{
		sizeLabel: '7.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '984654759731',
	},
	{
		sizeLabel: '8.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '302111109182',
	},
	{
		sizeLabel: '4.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '151570305616',
	},
	{
		sizeLabel: '9.3 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '305300917424',
	},
	{
		sizeLabel: '9.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467361269958',
	},
	{
		sizeLabel: '10.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '189574109847',
	},
	{
		sizeLabel: '11.25 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '124514590156',
	},
	{
		sizeLabel: '12.25 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '520134386309',
	},
	{
		sizeLabel: '11.6 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '909363819613',
	},
	{
		sizeLabel: '12.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231199807918',
	},
	{
		sizeLabel: '12.75 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683352020326',
	},
	{
		sizeLabel: '13.75 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '163134433197',
	},
	{
		sizeLabel: '1-4 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '385476694085',
	},
	{
		sizeLabel: '33-37 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '742713643959',
	},
	{
		sizeLabel: '2-5 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '128645997029',
	},
	{
		sizeLabel: '38-40 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137463667194',
	},
	{
		sizeLabel: '42-44 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '367670056773',
	},
	{
		sizeLabel: '6.6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '980373919540',
	},
	{
		sizeLabel: '56-60 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '431001534432',
	},
	{
		sizeLabel: '11 ¼ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000300390534',
	},
	{
		sizeLabel: '4 ½ (CA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576226106255',
	},
	{
		sizeLabel: '34-34 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '814631454896',
	},
	{
		sizeLabel: '35-35 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '515479546769',
	},
	{
		sizeLabel: '40-40 ½ (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '550982517590',
	},
	{
		sizeLabel: '4L',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246280650944',
	},
	{
		sizeLabel: 'FREE',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '472905910737',
	},
	{
		sizeLabel: '32 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '470123529612',
	},
	{
		sizeLabel: 'XS (44)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '364223997892',
	},
	{
		sizeLabel: 'S (46)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '733023047048',
	},
	{
		sizeLabel: 'M (48)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832738742286',
	},
	{
		sizeLabel: 'L (50)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138366005103',
	},
	{
		sizeLabel: 'XXL (54)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '183250679355',
	},
	{
		sizeLabel: 'LL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '318584647801',
	},
	{
		sizeLabel: 'PP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '299059226429',
	},
	{
		sizeLabel: 'PS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '987015799070',
	},
	{
		sizeLabel: 'PM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889881065716',
	},
	{
		sizeLabel: 'PL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '725949750458',
	},
	{
		sizeLabel: 'PXL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775857397061',
	},
	{
		sizeLabel: 'XP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '803208985598',
	},
	{
		sizeLabel: '1XP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '621917203449',
	},
	{
		sizeLabel: '2XP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '457306433996',
	},
	{
		sizeLabel: '3XP',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '098305861996',
	},
	{
		sizeLabel: '0P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '170773469995',
	},
	{
		sizeLabel: '2P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '825565864029',
	},
	{
		sizeLabel: '4P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710807374555',
	},
	{
		sizeLabel: '6P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965203204091',
	},
	{
		sizeLabel: '8P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '281467489638',
	},
	{
		sizeLabel: '10P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '152314187173',
	},
	{
		sizeLabel: '12P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116029718494',
	},
	{
		sizeLabel: '14P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '605688835468',
	},
	{
		sizeLabel: '16P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '391980951499',
	},
	{
		sizeLabel: '18P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '574896208327',
	},
	{
		sizeLabel: '20P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '769763024065',
	},
	{
		sizeLabel: '22P',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '429599742063',
	},
	{
		sizeLabel: '41 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223290045047',
	},
	{
		sizeLabel: '215-76 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '861984778158',
	},
	{
		sizeLabel: '235-80 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '638320984050',
	},
	{
		sizeLabel: '245-82 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '095770628778',
	},
	{
		sizeLabel: '255-84 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '230896084069',
	},
	{
		sizeLabel: '265-86 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727137673224',
	},
	{
		sizeLabel: '245-91 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '223310354779',
	},
	{
		sizeLabel: '255-94 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '424484692296',
	},
	{
		sizeLabel: '265-97 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '739988409421',
	},
	{
		sizeLabel: '275-100 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '471724649048',
	},
	{
		sizeLabel: '285-102 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '435228472795',
	},
	{
		sizeLabel: '295-105 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008469569094',
	},
	{
		sizeLabel: '305-107 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '442649909207',
	},
	{
		sizeLabel: '315-109 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '920045400387',
	},
	{
		sizeLabel: '40R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '685375209729',
	},
	{
		sizeLabel: '24 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '406748529604',
	},
	{
		sizeLabel: '24 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622882014976',
	},
	{
		sizeLabel: '1X SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '184003534700',
	},
	{
		sizeLabel: '1X REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '637814737223',
	},
	{
		sizeLabel: '1X LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '288588594928',
	},
	{
		sizeLabel: '2X SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '617800276005',
	},
	{
		sizeLabel: '2X REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992451045136',
	},
	{
		sizeLabel: '2X LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '142848028610',
	},
	{
		sizeLabel: '3X SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '315086924537',
	},
	{
		sizeLabel: '3X REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '519194569131',
	},
	{
		sizeLabel: '3X LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '785291725845',
	},
	{
		sizeLabel: '4X SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '838044787516',
	},
	{
		sizeLabel: '4X REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '475627342538',
	},
	{
		sizeLabel: '4X LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '804051959321',
	},
	{
		sizeLabel: '5X SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '202186998026',
	},
	{
		sizeLabel: '5X REGULAR',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '507198574548',
	},
	{
		sizeLabel: '5X LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707659975946',
	},
	{
		sizeLabel: '30 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '707042476460',
	},
	{
		sizeLabel: '30 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '062240411427',
	},
	{
		sizeLabel: '32 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '479884234675',
	},
	{
		sizeLabel: '32 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '832747646158',
	},
	{
		sizeLabel: '34 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '064529414303',
	},
	{
		sizeLabel: '34 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '732100246164',
	},
	{
		sizeLabel: '36 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464291746254',
	},
	{
		sizeLabel: '36 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '762841863645',
	},
	{
		sizeLabel: '38 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '786924948608',
	},
	{
		sizeLabel: '38 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '686685053888',
	},
	{
		sizeLabel: '40 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279835161674',
	},
	{
		sizeLabel: '40 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '222862737030',
	},
	{
		sizeLabel: '42 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '208467736047',
	},
	{
		sizeLabel: '42 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121656876552',
	},
	{
		sizeLabel: '44 REGULAR (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '116308310102',
	},
	{
		sizeLabel: '44 LONG (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '067302116029',
	},
	{
		sizeLabel: '230-235 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379379259854',
	},
	{
		sizeLabel: '36-37 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '548289596495',
	},
	{
		sizeLabel: '38-39 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '416732823565',
	},
	{
		sizeLabel: '255-260 (KR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '053366448279',
	},
	{
		sizeLabel: '8-12 OZ.',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '081925359805',
	},
	{
		sizeLabel: '12-14 OZ.',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '474708733483',
	},
	{
		sizeLabel: '14-16 OZ.',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '012831063912',
	},
	{
		sizeLabel: '16-18 OZ.',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '789430088866',
	},
	{
		sizeLabel: '40 ½-41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '158244693460',
	},
	{
		sizeLabel: '42 ½-43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '654531103349',
	},
	{
		sizeLabel: '45 ½-46 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '099047922760',
	},
	{
		sizeLabel: '47 ½-48 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '076351149606',
	},
	{
		sizeLabel: '48-48 ½ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '835208556011',
	},
	{
		sizeLabel: '1XLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '340327355118',
	},
	{
		sizeLabel: '4XLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '126798750601',
	},
	{
		sizeLabel: '5XLB',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '331297161263',
	},
	{
		sizeLabel: '02-06',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '988392859812',
	},
	{
		sizeLabel: '37-39',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '670285027633',
	},
	{
		sizeLabel: '12 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '662599167093',
	},
	{
		sizeLabel: '14 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '805639911518',
	},
	{
		sizeLabel: '16 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '969270079821',
	},
	{
		sizeLabel: '18 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '068967584334',
	},
	{
		sizeLabel: '20 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975769179611',
	},
	{
		sizeLabel: '22 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '467542431934',
	},
	{
		sizeLabel: '24 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991934688659',
	},
	{
		sizeLabel: '9 ½-10 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '102538486078',
	},
	{
		sizeLabel: '10 ½-11 ½ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885144835875',
	},
	{
		sizeLabel: 'S-5-7 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '679283697470',
	},
	{
		sizeLabel: 'M-9 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212129551296',
	},
	{
		sizeLabel: 'L-9-11 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '525399700018',
	},
	{
		sizeLabel: 'XXL-15 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '537376789418',
	},
	{
		sizeLabel: 'L-XL-13 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '014687243526',
	},
	{
		sizeLabel: '34-XXS (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '633545607255',
	},
	{
		sizeLabel: '36-XS (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '938147675288',
	},
	{
		sizeLabel: '38-S (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '354805617224',
	},
	{
		sizeLabel: '40-M (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '496929614857',
	},
	{
		sizeLabel: '42-L (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '775538763387',
	},
	{
		sizeLabel: '44-XL (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049464353916',
	},
	{
		sizeLabel: 'EG (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '793887692796',
	},
	{
		sizeLabel: 'EE (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '885606848133',
	},
	{
		sizeLabel: 'ES (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '169046997831',
	},
	{
		sizeLabel: 'EEG (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '123623228329',
	},
	{
		sizeLabel: 'ONESIZE (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '436668315917',
	},
	{
		sizeLabel: 'G1 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522471040682',
	},
	{
		sizeLabel: 'G2 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '312773488346',
	},
	{
		sizeLabel: 'G3 (BR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '000537701774',
	},
	{
		sizeLabel: '185-116A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '710000165802',
	},
	{
		sizeLabel: '190-120A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '959636900798',
	},
	{
		sizeLabel: '1C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '647026324834',
	},
	{
		sizeLabel: '1D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '363337237607',
	},
	{
		sizeLabel: '2D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '591419759623',
	},
	{
		sizeLabel: '3D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '347805517195',
	},
	{
		sizeLabel: '4D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '829177341980',
	},
	{
		sizeLabel: '5D',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '042945386004',
	},
	{
		sizeLabel: '330 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '668815102877',
	},
	{
		sizeLabel: '340 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '815615283604',
	},
	{
		sizeLabel: '210 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '304084393300',
	},
	{
		sizeLabel: '215 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877314038841',
	},
	{
		sizeLabel: '335 (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '887257670366',
	},
	{
		sizeLabel: '34-36 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379682203050',
	},
	{
		sizeLabel: '17-19 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '754795241281',
	},
	{
		sizeLabel: 'XS-SM',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '538810839529',
	},
	{
		sizeLabel: 'MD-LG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578678351785',
	},
	{
		sizeLabel: '6 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611025007695',
	},
	{
		sizeLabel: '8 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '209396278326',
	},
	{
		sizeLabel: '10 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '154016348875',
	},
	{
		sizeLabel: '12 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '557536658010',
	},
	{
		sizeLabel: '14 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '115956082082',
	},
	{
		sizeLabel: '4-7 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '460335251978',
	},
	{
		sizeLabel: '37-41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '893393665776',
	},
	{
		sizeLabel: '8-11 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341543707948',
	},
	{
		sizeLabel: '47+ (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '975060451975',
	},
	{
		sizeLabel: '100DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '903246506475',
	},
	{
		sizeLabel: 'SM-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '622213826704',
	},
	{
		sizeLabel: 'MD-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '697505041664',
	},
	{
		sizeLabel: 'M-L-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '522607261661',
	},
	{
		sizeLabel: 'LG-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728688243805',
	},
	{
		sizeLabel: 'XL-C',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '009234927203',
	},
	{
		sizeLabel: '0Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '965909695724',
	},
	{
		sizeLabel: '1Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '612886601615',
	},
	{
		sizeLabel: '2Y',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181413618535',
	},
	{
		sizeLabel: '15 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '231115974731',
	},
	{
		sizeLabel: '43 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '026234654502',
	},
	{
		sizeLabel: '17 ¾ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134673848997',
	},
	{
		sizeLabel: '17 ¾ (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '336207579454',
	},
	{
		sizeLabel: '45 (JP)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '122637371223',
	},
	{
		sizeLabel: '150-56A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '504190797385',
	},
	{
		sizeLabel: '180-92B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '846203791327',
	},
	{
		sizeLabel: '190-100B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '453423708583',
	},
	{
		sizeLabel: '185-94A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '242448496153',
	},
	{
		sizeLabel: '190-104B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '559483380097',
	},
	{
		sizeLabel: '80 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '847901813904',
	},
	{
		sizeLabel: '105 (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '930471778905',
	},
	{
		sizeLabel: '13 ½-5 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '764437195898',
	},
	{
		sizeLabel: '31 ½-36 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '246215806706',
	},
	{
		sizeLabel: '1-6 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '658122915323',
	},
	{
		sizeLabel: '4-7 ½ (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '036049307187',
	},
	{
		sizeLabel: '36 ½-41 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '944377853754',
	},
	{
		sizeLabel: '6 ½-10 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '974635322396',
	},
	{
		sizeLabel: '38 ½-42 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '508745228596',
	},
	{
		sizeLabel: '8 ½-12 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '704729594572',
	},
	{
		sizeLabel: '42 ½-47 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '430410877046',
	},
	{
		sizeLabel: '9 ½-13 (US)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694982989148',
	},
	{
		sizeLabel: '39-43 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '341377678389',
	},
	{
		sizeLabel: 'XXXL SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '321684843264',
	},
	{
		sizeLabel: 'XXXL LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '055277439088',
	},
	{
		sizeLabel: 'XXSSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '410464197889',
	},
	{
		sizeLabel: '56SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '365205616129',
	},
	{
		sizeLabel: '58SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652297715722',
	},
	{
		sizeLabel: '60SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '049343799111',
	},
	{
		sizeLabel: '4XLSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '777190680433',
	},
	{
		sizeLabel: '62SHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '669382564427',
	},
	{
		sizeLabel: '5XLSHORT',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '181077249484',
	},
	{
		sizeLabel: 'XXSLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '140705157694',
	},
	{
		sizeLabel: '56LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '802417227279',
	},
	{
		sizeLabel: '58LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '079143491321',
	},
	{
		sizeLabel: '60LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '085306201068',
	},
	{
		sizeLabel: '4XLLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164499542632',
	},
	{
		sizeLabel: '62LONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '585995229896',
	},
	{
		sizeLabel: '5XLLONG',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '018194554544',
	},
	{
		sizeLabel: 'S-42-44',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '992479726696',
	},
	{
		sizeLabel: 'M-46-48',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '721002663901',
	},
	{
		sizeLabel: 'L-48-50',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '639567161420',
	},
	{
		sizeLabel: 'XL-52-54',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '483323254940',
	},
	{
		sizeLabel: 'XXL-54-56',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '130009593933',
	},
	{
		sizeLabel: 'XS (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996349907192',
	},
	{
		sizeLabel: 'S (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '350441198846',
	},
	{
		sizeLabel: 'M (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '279235014389',
	},
	{
		sizeLabel: 'L (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '795863925298',
	},
	{
		sizeLabel: 'XL (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '889458307360',
	},
	{
		sizeLabel: 'XXL (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881885452019',
	},
	{
		sizeLabel: 'XS (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '020025941082',
	},
	{
		sizeLabel: 'S (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '891430720528',
	},
	{
		sizeLabel: 'M (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '877546357513',
	},
	{
		sizeLabel: 'L (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '567384826664',
	},
	{
		sizeLabel: 'XL (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '237036167069',
	},
	{
		sizeLabel: '2XL (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '728064632856',
	},
	{
		sizeLabel: '3XL (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '008405858001',
	},
	{
		sizeLabel: '4XL (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '111729406062',
	},
	{
		sizeLabel: '5XL (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '544355447166',
	},
	{
		sizeLabel: '6XL (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '016425168537',
	},
	{
		sizeLabel: '30-31 (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '836840927380',
	},
	{
		sizeLabel: '35-36 (UA)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '129749799277',
	},
	{
		sizeLabel: '53 (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '159747660512',
	},
	{
		sizeLabel: 'W12',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '572783942688',
	},
	{
		sizeLabel: 'S-TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160653791489',
	},
	{
		sizeLabel: 'M-TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '074115458500',
	},
	{
		sizeLabel: 'L-TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576218031665',
	},
	{
		sizeLabel: 'XL-TALL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035160805808',
	},
	{
		sizeLabel: '100E-DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '227322387351',
	},
	{
		sizeLabel: '105E-DDD (EU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '904660828115',
	},
	{
		sizeLabel: '56-60 (RU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '212967082612',
	},
	{
		sizeLabel: '30A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '593116522239',
	},
	{
		sizeLabel: '32A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '609127492123',
	},
	{
		sizeLabel: '34A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '908179261863',
	},
	{
		sizeLabel: '36A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '286897609560',
	},
	{
		sizeLabel: '38A (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '500178976956',
	},
	{
		sizeLabel: '43-45',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '464184443488',
	},
	{
		sizeLabel: '4FF (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '300204180137',
	},
	{
		sizeLabel: 'XSA',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '035257576272',
	},
	{
		sizeLabel: 'SA',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '649859015536',
	},
	{
		sizeLabel: 'MA',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '578396109711',
	},
	{
		sizeLabel: 'LA',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '342161935360',
	},
	{
		sizeLabel: '42R',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659103008852',
	},
	{
		sizeLabel: '48 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '714199982946',
	},
	{
		sizeLabel: '50-52 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '069189929355',
	},
	{
		sizeLabel: '54 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '032141582069',
	},
	{
		sizeLabel: '56-58 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '563207864949',
	},
	{
		sizeLabel: '60 (NL)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '694175403801',
	},
	{
		sizeLabel: '4-XS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '875350081513',
	},
	{
		sizeLabel: '8-M',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '060867577467',
	},
	{
		sizeLabel: '12S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '148199717008',
	},
	{
		sizeLabel: '12-XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '296891417803',
	},
	{
		sizeLabel: '14S',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '518087790253',
	},
	{
		sizeLabel: '14-2XL',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '982175938065',
	},
	{
		sizeLabel: 'MLS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '881633674604',
	},
	{
		sizeLabel: '2XLS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '752831758436',
	},
	{
		sizeLabel: '3XLS',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '253220429322',
	},
	{
		sizeLabel: '190-100A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '119137660547',
	},
	{
		sizeLabel: '195-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '513814227344',
	},
	{
		sizeLabel: '185-84A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '736095485018',
	},
	{
		sizeLabel: '190-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917152571729',
	},
	{
		sizeLabel: 'XXS (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '302644677989',
	},
	{
		sizeLabel: 'XXS (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '555151665283',
	},
	{
		sizeLabel: '150-75A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '192938330802',
	},
	{
		sizeLabel: 'XXS (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '611273065272',
	},
	{
		sizeLabel: '165-85A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '872742981082',
	},
	{
		sizeLabel: '2XL (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '339018118317',
	},
	{
		sizeLabel: '166-88A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '968222710880',
	},
	{
		sizeLabel: '171-93A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '039422244919',
	},
	{
		sizeLabel: '177-98A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '700231408742',
	},
	{
		sizeLabel: '182-104A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '576228025197',
	},
	{
		sizeLabel: '187-114A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '327091685691',
	},
	{
		sizeLabel: '30A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '160153478209',
	},
	{
		sizeLabel: '30B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '134195701378',
	},
	{
		sizeLabel: '32A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '652763355206',
	},
	{
		sizeLabel: '32B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '917003699176',
	},
	{
		sizeLabel: '32C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '990685703599',
	},
	{
		sizeLabel: '32D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '217940687534',
	},
	{
		sizeLabel: '32E (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '138533054579',
	},
	{
		sizeLabel: '32F (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '899527983985',
	},
	{
		sizeLabel: '34A (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '225074836771',
	},
	{
		sizeLabel: '34B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '562286103190',
	},
	{
		sizeLabel: '34C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '727995850400',
	},
	{
		sizeLabel: '34D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '485826646380',
	},
	{
		sizeLabel: '34E (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '683312780368',
	},
	{
		sizeLabel: '34F (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '137983438842',
	},
	{
		sizeLabel: '36B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '089119847272',
	},
	{
		sizeLabel: '36C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '320888856301',
	},
	{
		sizeLabel: '36D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '762166778842',
	},
	{
		sizeLabel: '36E (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '672130774047',
	},
	{
		sizeLabel: '36F (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '746084733094',
	},
	{
		sizeLabel: '38B (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '121904792764',
	},
	{
		sizeLabel: '38C (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '608863034748',
	},
	{
		sizeLabel: '38D (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '546861765878',
	},
	{
		sizeLabel: '38E (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '512793132695',
	},
	{
		sizeLabel: '38F (CN)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '659762097489',
	},
	{
		sizeLabel: '2XL (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '505925081835',
	},
	{
		sizeLabel: '2XL (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '750883684532',
	},
	{
		sizeLabel: 'MAXI',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '996643087376',
	},
	{
		sizeLabel: '125B (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '255045293117',
	},
	{
		sizeLabel: '125C (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '038301629596',
	},
	{
		sizeLabel: '125D (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '828537561957',
	},
	{
		sizeLabel: '125E (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '673921932372',
	},
	{
		sizeLabel: '125F (ES)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '830558933275',
	},
	{
		sizeLabel: '15 ¾ (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '991676477600',
	},
	{
		sizeLabel: '50H (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '164516361670',
	},
	{
		sizeLabel: '61-62',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '709945028504',
	},
	{
		sizeLabel: 'SIZE 1',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '045744113303',
	},
	{
		sizeLabel: 'SIZE 2',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '379384434413',
	},
	{
		sizeLabel: 'SIZE 3',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '109416075975',
	},
	{
		sizeLabel: '6P (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '309529247064',
	},
	{
		sizeLabel: '34P (FR)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '133367208089',
	},
	{
		sizeLabel: '38P (IT)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '499817309993',
	},
	{
		sizeLabel: '6P (AU)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '333761152537',
	},
	{
		sizeLabel: '115 (GB)',
		sizeCategory: '',
		sizeCategoryValue: '',
		sizeSubcategory: '',
		sizeSubcategoryValue: '',
		sizeCode: '004435267572',
	},
];
